webpackJsonp([1],{

/***/ "++Pe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var initialState = function initialState() {
    return {
        previous: null
    };
};

var mutations = {
    SET_BREADCRUMB: function SET_BREADCRUMB(state, to) {
        state.previous = to;
    }
};

exports.default = {
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "+3eB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+98L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Mtz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    methods: {

        /**
         * Searches for any holidays during the given date
         * @param  {Moment} date
         * @return {Array}      array of holiday objects
         */
        holidaysForDate: function holidaysForDate(date) {
            return this.holidays.filter(function (h) {
                return h.startdate.isSameOrBefore(date) && h.enddate.isSameOrAfter(date);
            });
        },

        /**
         * Makes sure the given period is adjusted for the current holidays
         * Adjusts the start date and the duration of each of its blocks
         * @param  {Period} period
         */
        holidayShift: function holidayShift(period) {
            var _this = this;

            period.start = this.holidayShiftDate(period.start);

            period.blocks.reduce(function (date, block, i, arr) {

                // greedily include holidays in block (i.e. blocks always start *after* a holiday)
                // except for the lastblock, which should stop before a holiday
                var isLastBlock = i === arr.length - 1;

                block.duration = _this.holidayShiftDuration(date, block.duration, !isLastBlock);

                // use date in next iteration
                return date.clone().add(block.duration, 'weeks');
            }, period.start);
        },

        /**
         * Checks for holidays during the given start+duration combination
         * Extends the duration such that it includes the duration of the found holidays
         * @param  {Moment} startDate start date to check
         * @param  {Number} duration  weeks to check
         * @param  {Boolean} trailing  flag to check trailing part of duration (greedy add holidays) or the leading part (stop before holiday)
         * @return {Number}           the adjusted duration (in weeks)
         */
        holidayShiftDuration: function holidayShiftDuration(startDate, duration, trailing) {

            var start = trailing ? 1 : 0;
            var end = trailing ? duration : duration - 1;

            var shiftedDuration = duration;
            for (var i = start; i <= end; i++) {
                var date = startDate.clone().add(i, 'weeks');
                var shiftedDate = this.holidayShiftDate(date);
                var diff = shiftedDate.diff(date, 'weeks');
                shiftedDuration += diff;
                i += diff;
            }

            return shiftedDuration;
        },

        /**
         * Checks for holidays for the given date and moves the date to after the holidays
         * @param  {Moment} date      date to check
         * @return {Moment}           adjusted date after all holidays
         */
        holidayShiftDate: function holidayShiftDate(date) {
            return this.holidaysForDate(date).reduce(function (longest, h) {
                var end = h.enddate.clone().add(1, 'week').startOf('week');
                return _moment2.default.max(end, longest);
            }, date);
        },

        fetchHolidays: function fetchHolidays(schoolId) {
            var _this2 = this;

            return _resources2.default.getHolidays(schoolId).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (result) {
                _this2.holidays = (result.holidays || []).map(function (h) {
                    h.startdate = _moment2.default.unix(h.start);
                    h.enddate = _moment2.default.unix(h.end);
                    return h;
                });
            }).catch(function (err) {
                _analytics2.default.exception(err);
            });
        }

    }
};

/***/ }),

/***/ "+Tcm":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('dropzone', {
    ref: "dropzone",
    attrs: {
      "url": _vm.url,
      "maxNumberOfFiles": 10,
      "value": _vm.value
    },
    on: {
      "input": function (v) { return _vm.$emit('input', v); },
      "success": _vm.addedImage,
      "removed": _vm.removedImage,
      "clicked": _vm.useImage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "+gMc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autoValidateMixin = __webpack_require__("HDu5");

var _autoValidateMixin2 = _interopRequireDefault(_autoValidateMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var next = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function (cb) {
    window.setTimeout(cb, 1000 / 60);
};

exports.default = {
    components: { PrimaryButton: _PrimaryButton2.default },
    mixins: [_autoValidateMixin2.default],
    data: function data() {
        return {
            opts: null,
            startedAt: null
        };
    },

    computed: {
        slots: function slots() {
            return this.partial.data.slots;
        },
        isRunning: function isRunning() {
            return this.opts != null;
        }
    },

    methods: {
        flush: function flush() {
            return Promise.resolve();
        },

        start: function start() {
            var _this = this;

            if (this.isRunning) {
                return;
            }

            this.opts = this.slots.map(function (data, i) {

                var slot = _this.$refs.slots[i];
                var choice = Math.floor(Math.random() * data.items.length);

                var slotHeight = 140;

                var opts = {
                    el: slot.querySelector('.slot__wrap'),
                    finalPos: choice * slotHeight - Math.random() * 15 - 20,
                    startOffset: 2000 + Math.random() * 500 + i * 500,
                    height: data.items.length * slotHeight,
                    duration: 3000 + i * 700, // milliseconds
                    isFinished: false
                };

                return opts;
            });

            var audio = new Audio('/audio/slot-machine.mp3');
            var promise = audio.play();

            if (promise != null) {
                promise.catch(function (error) {
                    // Auto-play was prevented
                    console.log('No permission to play audio', error);
                });
            }

            next(this.animate);
        },

        animate: function animate(timestamp) {

            if (this.startedAt == null) {
                this.startedAt = timestamp;
            }

            var timeDiff = timestamp - this.startedAt;

            this.opts.forEach(function (opt) {

                if (opt.isFinished) {
                    return;
                }

                var timeRemaining = Math.max(opt.duration - timeDiff, 0);
                var power = 3;
                var offset = Math.pow(timeRemaining, power) / Math.pow(opt.duration, power) * opt.startOffset;

                // negative, such that slots move from top to bottom
                var pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);

                opt.el.style.transform = 'translateY(' + pos + 'px)';

                if (timeDiff > opt.duration) {
                    opt.isFinished = true;
                }
            });

            if (this.opts.every(function (o) {
                return o.isFinished;
            })) {
                this.opts = null;
                this.startedAt = null;
            } else {
                next(this.animate);
            }
        }

    }

};

/***/ }),

/***/ "+uEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/JNg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transformers = __webpack_require__("j0ZK");

exports.default = {
    name: 'TeacherFeedbackPresenter',

    props: {
        feedback: {},
        minimal: {
            type: Boolean,
            default: false
        }
    },

    components: {},

    computed: {
        remarks: function remarks() {
            var _this = this;

            return this.feedback.remarks == null ? null : this.feedback.remarks.map(function (t) {
                return _this.$store.state.feedback.remarks[t];
            });
        },
        compliments: function compliments() {
            var _this2 = this;

            return this.feedback.compliments == null ? null : this.feedback.compliments.map(function (t) {
                return _this2.$store.state.feedback.compliments[t];
            });
        },
        teacher: function teacher() {
            var _this3 = this;

            return this.feedback.teacher.map(function (t) {
                return _this3.$store.state.users.storage[t];
            })[0];
        },

        heading: function heading() {
            return this.minimal ? 'h3' : 'h2';
        }
    },

    methods: {
        username: _transformers.username
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "/M4R":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.partial.data.html)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "/baE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _momentTimezone = __webpack_require__("dDTU");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

__webpack_require__("3K28");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Don't import 'moment-timezone' since that will load all data
var data = ['Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5'];

// Set global moment locale
_momentTimezone2.default.locale('nl');
_momentTimezone2.default.tz.add(data);

_momentTimezone2.default.tz.setDefault('Europe/Amsterdam');

exports.default = _momentTimezone2.default;

/***/ }),

/***/ "/cSv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "primary-button",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "href": _vm.route.path
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('span', {
    class: {
      hidden: _vm.loading
    }
  }, [_vm._t("default")], 2), (_vm.loading) ? _c('loading', {
    attrs: {
      "mini": true,
      "alt": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0RUa":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("x/SM")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ZCQM"),
  /* template */
  __webpack_require__("yJP+"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0g7W":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('sidebar', {
    staticClass: "sidebar--student",
    attrs: {
      "user": _vm.user,
      "disableUserMenu": _vm.isInspecting,
      "showOptions": false,
      "isLoading": _vm.loading
    }
  }, [_c('accordion', {
    staticClass: "accordion--workspace",
    attrs: {
      "collections": _vm.groupTerms,
      "initialExpanded": _vm.expandedGroupTerm,
      "isLoading": _vm.isLoadingGroupTerm
    },
    on: {
      "expanded": function($event) {
        _vm.expandedGroupTerm = $event.id
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(groupTerm) {
        return [(groupTerm.id != -1) ? _c('timeline', {
          attrs: {
            "items": _vm.progressions,
            "isActive": _vm.isAssignmentActive
          },
          on: {
            "click": _vm.viewAssignment
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(progress) {
              return [_c('assignment', {
                attrs: {
                  "progress": progress,
                  "isActive": _vm.isAssignmentActive(progress)
                }
              })]
            }
          }])
        }, [_c('template', {
          slot: "empty"
        }, [(groupTerm.isFirst) ? _c('span', [_vm._v("Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan. ")]) : _vm._e(), _vm._v("Kies een opdracht om aan je werkmap toe te voegen.\n                ")])], 2) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "0sK3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _vueMultiselect = __webpack_require__("RUzx");

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Diligence = __webpack_require__("YyG+");

var _Diligence2 = _interopRequireDefault(_Diligence);

var _Badges = __webpack_require__("8jme");

var _Badges2 = _interopRequireDefault(_Badges);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _getters = __webpack_require__("olIF");

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FEEDBACK STORAGE OUTLINE
// put vuex stored feedback into data
// watch data change
// -> storeFeedback() -> syncFeedback()
// ---> dbsync() // debounced api call + store to vuex
// ---> flush if new feedback (send to api as fast as possible)
// ---> store to vuex if not new (we know the id)


/**
 * Debounced api sync, waits for previous sync before starting the next
 * Defined outside of vue object to be able to call flush/cancel
 */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var dbsync = (0, _helpers.debounceSync)(function (state, progress, feedback) {

    // checks at the time of execution if the oldValue (thus the id) is known
    // note that not more than one of these functions is executed at the same time (guarenteed by debounceSync)
    // therefore the 'post' api action is executed only once (unless multiple browsers etc. etc.)
    var oldValue = progress.feedback == null ? null : state.feedback.storage[progress.feedback[0]];

    return oldValue == null ? _resources2.default.addFeedback(progress.id, feedback.content, feedback.compliments, feedback.remarks) : _resources2.default.patchFeedback(oldValue.id, feedback.content, feedback.compliments, feedback.remarks);
}, 6000, { maxWait: 60000 });

exports.default = {
    name: 'TeacherFeedback',
    props: {
        progress: {},
        assignment: {},
        group: {},
        reviewee: {},
        isDemo: {
            type: Boolean,
            default: false
        },
        returnLink: {
            type: Object,
            required: true
        }

    },
    mixins: [_notificationsMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Badges: _Badges2.default, Loading: _Loading2.default, Multiselect: _vueMultiselect2.default, Diligence: _Diligence2.default },
    data: function data() {
        return {
            loading: false,
            feedback: {
                content: '',
                compliments: [],
                remarks: []
            },
            diligence: null
        };
    },

    vuex: {
        getters: {
            getGroupTermsForGroup: _getters.getGroupTermsForGroup
        },
        actions: {
            showReflectiontips: function showReflectiontips(_ref, assignment) {
                var dispatch = _ref.dispatch;

                _analytics2.default.event('reflectiontips', 'show', assignment.id);
                dispatch('SHOW_MODAL', 'Reflectiontips');
            },

            syncFeedback: function syncFeedback(_ref2, progress, feedback, isDemo, teacher) {
                var dispatch = _ref2.dispatch,
                    state = _ref2.state;


                var oldValue = progress.feedback == null ? null : state.feedback.storage[progress.feedback[0]];

                if (isDemo) {
                    // fake store feedback to vuex
                    var id = oldValue == null ? (0, _helpers.guid)() : oldValue.id;

                    dispatch('ADD_FEEDBACK', [Object.assign({}, { id: id, teacher: [teacher.id] }, feedback)]);
                    dispatch('ADD_FEEDBACK_TO_PROGRESS', progress.id, id);

                    return Promise.resolve();
                }

                // schedule sync to api
                var result = dbsync(state, progress, feedback).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_FEEDBACK', result.feedback);
                    dispatch('ADD_FEEDBACK_TO_PROGRESS', progress.id, result.feedback[0].id);
                });

                // flush if new feedback (send to api as fast as possible)
                // store to vuex if not new (we know the id)
                if (oldValue == null) {
                    dbsync.flush();
                } else {
                    dispatch('ADD_FEEDBACK', [Object.assign({}, { id: oldValue.id }, feedback)]);
                }

                return result;
            },
            retakeProgress: function retakeProgress(_ref3, progress) {
                var dispatch = _ref3.dispatch;

                return _resources2.default.retakeProgress(progress.id).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return dispatch('ADD_PROGRESS', result.progress);
                });
            }
        }
    },

    computed: {
        storedFeedback: function storedFeedback() {
            if (this.progress.feedback == null || this.progress.feedback.length === 0) {
                return null;
            }

            return this.$store.state.feedback.storage[this.progress.feedback[0]];
        },
        remarks: function remarks() {
            var _this = this;

            return this.assignment.remarks.map(function (t) {
                return _this.$store.state.feedback.remarks[t];
            });
        },
        compliments: function compliments() {
            var _this2 = this;

            return this.assignment.compliments.map(function (t) {
                return _this2.$store.state.feedback.compliments[t];
            });
        },

        loggedInUser: function loggedInUser() {
            return this.$store.state.users.current;
        },

        hasFeedbackFromOtherTeacher: function hasFeedbackFromOtherTeacher() {

            // if feedback is empty, no other teacher has created feedback yet
            if (this.storedFeedback == null || this.storedFeedback.teacher.length === 0) {
                return false;
            }

            return this.storedFeedback.teacher[0] !== this.loggedInUser.id;
        },

        shouldShowReflectiontips: function shouldShowReflectiontips() {
            return this.assignment.reflectiontips === true;
        }

    },

    methods: {

        periodIdForAssignment: function periodIdForAssignment(assignment) {
            var _this3 = this;

            var groupPeriod = this.getGroupTermsForGroup(this.group.id).reduce(function (list, t) {
                return list.concat(t.groupPeriods);
            }, []).map(function (id) {
                return _this3.$store.state.groups.periods[id];
            }).find(function (gp) {
                return gp.groupAssignments.map(function (id) {
                    return _this3.$store.state.groups.assignments[id];
                }).find(function (ga) {
                    return ga.assignment[0] === assignment.id;
                });
            });

            if (groupPeriod == null) {
                return null;
            }

            return groupPeriod.id;
        },

        setFeedbackFromStore: function setFeedbackFromStore() {
            var _this4 = this;

            if (this.storedFeedback != null) {

                this.feedback.content = this.storedFeedback.content;
                this.feedback.remarks = this.storedFeedback.remarks.map(function (r) {
                    return _this4.$store.state.feedback.remarks[r];
                });
                this.feedback.compliments = this.storedFeedback.compliments.map(function (r) {
                    return _this4.$store.state.feedback.compliments[r];
                });
            }
        },

        convertFeedbackForApi: function convertFeedbackForApi(feedback) {

            return {
                content: feedback.content,
                compliments: feedback.compliments.map(function (c) {
                    return c.id;
                }),
                remarks: feedback.remarks.map(function (r) {
                    return r.id;
                })
            };
        },

        storeFeedback: function storeFeedback(newValue) {
            var _this5 = this;

            this.syncFeedback(this.progress, this.convertFeedbackForApi(newValue), this.isDemo, this.loggedInUser).catch(function (err) {
                _analytics2.default.exception('Can\'t store feedback', err);
                _this5.$warn('Kan feedback niet opslaan');
            });
        },

        retakeAssignment: function retakeAssignment() {
            var _this6 = this;

            this.$alert('Weet je zeker dat ' + this.reviewee.firstname + ' deze opdracht moet overdoen?', [{ name: 'Annuleren' }, { name: 'Overdoen', primary: true, action: function action() {

                    _analytics2.default.event('assignment', 'retake', _this6.progress.assignment);
                    _this6.retakeProgress(_this6.progress).catch(function (err) {
                        _analytics2.default.exception('Can\'t retake assignment', err);
                        _this6.$error('De opdracht kan niet worden overgedaan');
                    });
                } }]);
        }

    },

    created: function created() {
        this.setFeedbackFromStore();
        this.$watch('feedback', this.storeFeedback, { deep: true });
    },

    beforeDestroy: function beforeDestroy() {
        dbsync.flush();
    }

};

/***/ }),

/***/ "0x2l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stepMixin = __webpack_require__("Ce1c");

var _stepMixin2 = _interopRequireDefault(_stepMixin);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _auth = __webpack_require__("JOmw");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _HtmlPartial = __webpack_require__("U+/7");

var _HtmlPartial2 = _interopRequireDefault(_HtmlPartial);

var _QuestionPartial = __webpack_require__("1XA/");

var _QuestionPartial2 = _interopRequireDefault(_QuestionPartial);

var _VideoPartial = __webpack_require__("sgep");

var _VideoPartial2 = _interopRequireDefault(_VideoPartial);

var _ImagePartial = __webpack_require__("OfR3");

var _ImagePartial2 = _interopRequireDefault(_ImagePartial);

var _UploadPartial = __webpack_require__("tqcc");

var _UploadPartial2 = _interopRequireDefault(_UploadPartial);

var _ReflectionPartial = __webpack_require__("gyY9");

var _ReflectionPartial2 = _interopRequireDefault(_ReflectionPartial);

var _SlotMachinePartial = __webpack_require__("Gl2H");

var _SlotMachinePartial2 = _interopRequireDefault(_SlotMachinePartial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'AssignmentStep',
    mixins: [_stepMixin2.default, _notificationsMixin2.default],
    components: { HtmlPartial: _HtmlPartial2.default, QuestionPartial: _QuestionPartial2.default, VideoPartial: _VideoPartial2.default, ImagePartial: _ImagePartial2.default, UploadPartial: _UploadPartial2.default, ReflectionPartial: _ReflectionPartial2.default, SlotMachinePartial: _SlotMachinePartial2.default },
    data: function data() {
        return {
            stepLoaded: false,
            // flushing promise
            flushing: null,
            loading: false
        };
    },
    vuex: {
        getters: {},
        actions: {
            completeStep: function completeStep(_ref, progress, step) {
                var dispatch = _ref.dispatch;


                // TODO: name change `completeStep`
                return _resources2.default.viewedStep(progress.id, step.precedence).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return dispatch('ADD_PROGRESS', result.progress);
                }).catch(function (err) {
                    return (0, _helpers.logreject)('COULD NOT COMPLETE STEP', err);
                });
            },
            submitStep: function submitStep(_ref2, progress, step) {
                var dispatch = _ref2.dispatch,
                    state = _ref2.state;


                return _resources2.default.submittedStep(progress.id, step.precedence).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return dispatch('ADD_PROGRESS', result.progress);
                }).then(function () {
                    var allSubmissionIds = Object.keys(state.submissions.storage).map(function (id) {
                        return state.submissions.storage[id];
                    }).filter(function (s) {
                        return s.progress == progress.id;
                    }).map(function (s) {
                        return s.id;
                    });
                    dispatch('FREEZE_SUBMISSIONS', allSubmissionIds);
                }).catch(function (err) {
                    return (0, _helpers.logreject)('COULD NOT SUBMIT STEP', err);
                });
            },
            finishAssignment: function finishAssignment(_ref3, progress) {
                var dispatch = _ref3.dispatch,
                    state = _ref3.state;


                _analytics2.default.event('assignment', 'finish', progress.assignment);
                return _resources2.default.finishedAssignment(progress.id).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return dispatch('ADD_PROGRESS', result.progress);
                }).then(function () {
                    var allSubmissionIds = Object.keys(state.submissions.storage).map(function (id) {
                        return state.submissions.storage[id];
                    }).filter(function (s) {
                        return s.progress == progress.id;
                    }).map(function (s) {
                        return s.id;
                    });
                    dispatch('FREEZE_SUBMISSIONS', allSubmissionIds);
                }).catch(function (err) {
                    return (0, _helpers.logreject)('COULD NOT FINISH ASSIGNMENT', err);
                });
            },
            showTeachertips: function showTeachertips(_ref4, currentStep) {
                var dispatch = _ref4.dispatch;

                _analytics2.default.event('teachertips', 'show', currentStep.id);
                dispatch('SHOW_MODAL', 'Teachertips', { step: currentStep });
            }
        }
    },
    computed: {
        // one-based index of step for the current assignment
        currentStepIndex: function currentStepIndex() {
            return parseInt(this.$route.params.stepIdx, 10);
        },
        currentStep: function currentStep() {
            return this.steps[this.currentStepIndex - 1];
        },
        previousStep: function previousStep() {
            var previousStepIndex = this.currentStepIndex - 1;

            if (previousStepIndex < 0) {
                return null;
            }

            return this.steps[previousStepIndex - 1];
        },
        partials: function partials() {
            var _this = this;

            // may not be loaded yet
            if (this.currentStep.partials === undefined) {
                return [];
            }

            return this.currentStep.partials.map(function (id) {
                return _this.$store.state.partials.storage[id];
            });
        },
        prevStepLink: function prevStepLink() {
            var prevStepIndex = this.currentStepIndex - 1;
            return { name: 'assignment.step', params: { assignmentId: this.assignment.id, stepIdx: prevStepIndex } };
        },
        nextStepLink: function nextStepLink() {
            var nextStepIndex = this.currentStepIndex + 1;

            if (nextStepIndex > this.assignment.steps.length) {
                var name = this.progress.finished == null ? 'assignment.done' : 'assignment.overview';
                return { name: name, params: { assignmentId: this.assignment.id } };
            }

            return { name: 'assignment.step', params: { assignmentId: this.assignment.id, stepIdx: nextStepIndex } };
        },
        readonly: function readonly() {
            return this.isTeacher || this.isFrozen && !this.isRetaking;
        },
        isCompleted: function isCompleted() {
            return this.progress.step >= this.currentStep.precedence;
        },
        isFrozen: function isFrozen() {
            return this.progress.frozen >= this.currentStep.precedence;
        },
        isRetaking: function isRetaking() {
            return this.progress.isRetaking;
        },
        isFinished: function isFinished() {
            return this.isProgressFinished(this.progress);
        },
        isValid: function isValid() {
            return this.validateStep(this.currentStep, false); // don't check confirm yet
        },
        isLastStep: function isLastStep() {
            return this.currentStepIndex >= this.assignment.steps.length;
        },
        canGoNext: function canGoNext() {
            return this.isValid;
        },
        mustConfirm: function mustConfirm() {
            return this.confirmable && !this.isFrozen || this.isRetaking && this.isLastStep;
        },
        confirmable: function confirmable() {
            return this.currentStep.confirm;
        },
        buttonText: function buttonText() {
            return this.isLastStep && !this.readonly ? 'Opsturen' : 'Verder';
        },
        isTeacher: function isTeacher() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        },
        shouldShowTeacherTips: function shouldShowTeacherTips() {
            return this.isTeacher && this.currentStep.teachertips === true;
        },
        canViewStep: function canViewStep() {
            if (this.currentStep == null) {
                console.error('Step not found');
                return false;
            }

            if (!this.isCompleted && this.previousStep && !this.isStepCompleted(this.previousStep)) {
                console.error('Previous step not completed');
                return false;
            }

            return true;
        }
    },
    methods: {
        flushAllSubmissions: function flushAllSubmissions() {
            if (this.$refs.partials == null) {
                return Promise.resolve();
            }

            return Promise.all(this.$refs.partials.map(function (p) {
                return p.flush();
            }));
        },

        complete: function complete(e, next) {
            var _this2 = this;

            if (this.stealthMode) {
                return;
            }

            e.preventDefault();

            if (!this.isValid) {
                return;
            }

            var sync = function sync() {
                _this2.flushing = _this2.flushAllSubmissions().then(function () {
                    if (_this2.isLastStep && (!_this2.isFinished || _this2.isRetaking)) {
                        return _this2.finishAssignment(_this2.progress);
                    }

                    if (_this2.mustConfirm && !_this2.isFinished) {
                        return _this2.submitStep(_this2.progress, _this2.currentStep);
                    }

                    if (!_this2.isCompleted) {
                        return _this2.completeStep(_this2.progress, _this2.currentStep);
                    }
                }).then(next);

                _this2.flushing.catch(function (err) {
                    _this2.loading = false;
                    _analytics2.default.exception('Can\'t submit step', err, { step: _this2.currentStep.id });
                    _this2.$warn('Kan de oefening niet opsturen');
                }).then(function () {
                    return _this2.flushing = null;
                });
            };

            this.loading = true;

            if (this.mustConfirm) {

                var title = 'Werk inleveren?';
                var message = 'Weet je zeker dat je verder wilt gaan? Hierna kun je jouw tot nu toe ingeleverde werk niet meer aanpassen!';

                this.$alert({ title: title, message: message }, [{ name: 'Annuleren', action: function action() {
                        return _this2.loading = false;
                    } }, { name: 'Werk inleveren', action: sync, primary: true }]);
            } else {
                sync();
            }
        },

        checkRoute: function checkRoute(from) {

            if (!this.canViewStep) {
                if (from != null) {
                    this.$router.back();
                } else {
                    this.autoRedirectStep(this.progress);
                }
            }
        },

        makeSureSubmissionsAreSubmitted: function makeSureSubmissionsAreSubmitted(next) {
            var _this3 = this;

            this.loading = true;

            // flushes all debounced submissions before going to the next step
            var flushing = this.flushing || this.flushAllSubmissions();

            flushing.catch(function () {}).then(function () {
                return _this3.flushing = null;
            });

            flushing.then(next, function (err) {
                _this3.loading = false;
                _analytics2.default.exception('Can\'t flush submissions', err, { step: _this3.currentStep.id });

                _this3.$alert({ title: 'Kan werk niet opslaan!', message: 'Jouw gemaakte werk kan op dit moment niet worden opgeslagen. Je kunt dit bericht annuleren en het later opnieuw proberen, of doorgaan en je gemaakte werk gaat verloren.' }, [{ name: 'Annuleren', action: function action() {
                        return next(false);
                    } }, { name: 'Ongedaan maken & doorgaan', danger: true, action: next }]);
            });
        }
    },
    created: function created() {
        this.checkRoute();
    },
    watch: {
        '$route': function $route(to, from) {
            this.checkRoute(from);
        }
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        to.params._immediate === true ? next() : this.makeSureSubmissionsAreSubmitted(next);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        to.params._immediate === true ? next() : this.makeSureSubmissionsAreSubmitted(next);
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "12Ju":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
    name: 'EmailConfirm',
    mixins: [_notificationsMixin2.default],
    components: { Loading: _Loading2.default },
    props: [],

    beforeRouteEnter: function beforeRouteEnter(to, from, next) {

        if (!to.params.token) {
            undefined.$warn('E-mail bevestigingslink is niet geldig');
            return next({ name: 'register' });
        }

        next();
    },

    created: function created() {
        var _this = this;

        _resources2.default.confirmUserEmail(this.$route.params.token).then(function () {
            _this.$success('Jouw e-mailadres is aangepast');
        }).catch(function (e) {
            _this.$warn('E-mail bevestigingslink is niet geldig');
            _analytics2.default.exception('Could not store new email', e, { token: _this.$route.params.token });
        }).then(function () {
            _this.$router.push({ name: 'root' });
        });
    }

};

/***/ }),

/***/ "1Dk2":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    ref: "dropzone",
    staticClass: "dropzone",
    class: {
      'dropzone--single': _vm.maxNumberOfFiles === 1
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "1F/N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},

    props: {
        progress: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data: function data() {
        return {
            isLoading: false
        };
    },

    vuex: {
        actions: {
            patchBadge: function patchBadge(_ref, progress, badge) {
                var dispatch = _ref.dispatch;


                return _resources2.default.patchBadge(progress.id, badge).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    var badge = (result.badges || [])[0];
                    dispatch('ADD_BADGES', result.badges || []);
                    dispatch('ADD_PROGRESS', result.progress || []);
                    return badge;
                });
            },
            fakeBadge: function fakeBadge(_ref2, progress, badge) {
                var dispatch = _ref2.dispatch;


                var fake = {
                    id: 'fake-' + progress.id,
                    tag: badge
                };

                dispatch('ADD_BADGES', [fake]);
                dispatch('ADD_BADGE_TO_PROGRESS', progress.id, fake.id);
            }
        }
    },

    computed: {
        badges: function badges() {
            return [{
                type: 'idea',
                name: 'Ideevorming',
                color: 'blue'
            }, {
                type: 'design',
                name: 'Vormgeving',
                color: 'red'
            }, {
                type: 'technique',
                name: 'Materiaal & techniek',
                color: 'yellow'
            }, {
                type: 'artappreciation',
                name: 'Kunstbeschouwing',
                color: 'green'
            }, {
                type: 'reflection',
                name: 'Reflectie',
                color: 'purple'
            }];
        },
        selectedBadge: function selectedBadge() {
            if (this.disabled || this.progress.badge == null) {
                return null;
            }
            return this.$store.state.badges.storage[this.progress.badge[0]].type;
        }
    },

    methods: {
        selectBadge: function selectBadge(badge) {
            var _this = this;

            if (this.disabled) {
                return;
            }

            var newVal = badge.type === this.selectedBadge ? null : badge.type;

            if (this.isDemo) {
                return this.fakeBadge(this.progress, newVal);
            }

            this.isLoading = true;
            this.patchBadge(this.progress, newVal).catch(function (err) {
                _analytics2.default.exception('Could not store badge', err);
            }).then(function () {
                _this.isLoading = false;
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "1Kfu":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('loading')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "1XA/":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("9cUp")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("84f7"),
  /* template */
  __webpack_require__("VsKO"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "1im0":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "modal-image full-width",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "1s9c":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('sidebar', {
    attrs: {
      "user": _vm.user,
      "isFloating": true
    }
  }), _c('router-view', {
    staticClass: "page-view"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "1w05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2BqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Buy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ForgotPassword',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: [],
    data: function data() {
        return {
            email: '',
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validateFields()) {

                this.loading = true;

                _resources2.default.forgotPassword(this.email).then(function () {

                    _this.$success('Er is een e-mail verzonden naar het opgegeven adres.');
                    _this.$router.push({ name: 'login' });
                }).catch(function (response) {
                    return _this.handleErrorResponse(response, 'Wachtwoord reset aanvraag is mislukt.');
                }).then(function () {
                    return _this.loading = false;
                });
            } else {
                this.$warn('Het ingevoerde e-mailadres is onjuist.', { id: 'validation' });
            }
        },
        validateFields: function validateFields() {
            return this.validateEmail(this.email);
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2HFh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GroupSubmissions = __webpack_require__("r5Ke");

var _GroupSubmissions2 = _interopRequireDefault(_GroupSubmissions);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _auth = __webpack_require__("JOmw");

var _stepMixin = __webpack_require__("Ce1c");

var _stepMixin2 = _interopRequireDefault(_stepMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Group',
    components: { GroupSubmissions: _GroupSubmissions2.default, PrimaryButton: _PrimaryButton2.default },
    mixins: [_stepMixin2.default],

    props: {
        assignment: {},
        group: {},
        isInspecting: {
            type: Boolean,
            default: false
        },
        returnLink: {
            type: Object,
            required: true
        }
    },

    vuex: {
        actions: {

            showReflectiontips: function showReflectiontips(_ref, assignment) {
                var dispatch = _ref.dispatch;

                _analytics2.default.event('reflectiontips', 'show', assignment.id);
                dispatch('SHOW_MODAL', 'Reflectiontips');
            }

        }
    },

    computed: {

        isTeacher: function isTeacher() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        },

        shouldShowReflectiontips: function shouldShowReflectiontips() {
            return this.isTeacher && this.assignment.reflectiontips === true;
        },

        canViewStep: function canViewStep() {
            return this.isProgressFinished(this.progress);
        },

        prevStepLink: function prevStepLink() {
            if (this.isInspecting) {
                return { name: 'assignment.step', params: { stepIdx: this.assignment.steps.length } };
            }
            return { name: 'assignment.overview' };
        }

    },
    methods: {
        checkRoute: function checkRoute() {

            if (!this.canViewStep) {
                this.autoRedirectStep(this.progress);
            }
        }
    },
    created: function created() {
        this.checkRoute();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2INl":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic error-page"
  }, [_c('h1', [_vm._v("Oeps, pagina niet gevonden!")]), _c('p', [_vm._v("Ga terug naar "), _c('router-link', {
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("de startpagina")]), _vm._v(" en probeer het opnieuw.")], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "2WB3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    vuex: {
        actions: {
            __notify: function __notify(_ref, notification) {
                var dispatch = _ref.dispatch;


                if (notification.text instanceof Array) {

                    switch (notification.text.length) {
                        case 0:
                            return;
                        case 1:
                            notification.text = notification.text[0];
                            break;
                        default:
                            // Multiple messages, don't auto hide notification
                            notification = Object.assign({ timeout: false }, notification);
                            break;
                    }
                }

                // merge defaults
                notification = Object.assign({
                    type: 'info',
                    timeout: 4000,
                    id: Math.random().toString(36).substr(2, 5)
                }, notification);

                dispatch('ADD_NOTIFICATION', notification);
            },
            __hideNotificationId: function __hideNotificationId(_ref2, id) {
                var dispatch = _ref2.dispatch;
                return dispatch('REMOVE_NOTIFICATION', { id: id });
            }
        }
    },
    methods: {
        $error: function $error(text) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.__notify(Object.assign({
                text: text,
                type: 'error'
            }, options));
        },
        $warn: function $warn(text) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.__notify(Object.assign({
                text: text,
                type: 'warn'
            }, options));
        },
        $success: function $success(text) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.__notify(Object.assign({
                text: text,
                type: 'success'
            }, options));
        },
        $info: function $info(text) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.__notify(Object.assign({
                text: text,
                type: 'info'
            }, options));
        },
        $hideNotification: function $hideNotification(id) {
            this.__hideNotificationId(id);
        },
        $demoSuccessNotification: function $demoSuccessNotification() {
            this.$success('De gegevens zijn aangepast. Wijzigingen gemaakt met het demo-account zullen echter niet worden verwerkt.');
        }
    }
};

/***/ }),

/***/ "2omD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "aggregate"
  }, [_vm._l((_vm.students), function(student) {
    return _c('table', {
      staticClass: "aggregate__student"
    }, [_c('thead', [_c('tr', {
      staticClass: "aggregate__header aggregate__header--print"
    }, [_c('th', [_c('h4', {
      staticClass: "tag"
    }, [_vm._v("Kiempunt overzicht klas " + _vm._s(_vm.group.name) + " - " + _vm._s(_vm.username(student)) + " - " + _vm._s(_vm.currentDate))])])])]), _c('tbody', [_c('tr', {
      staticClass: "aggregate__header aggregate__header--title"
    }, [_c('th', [_c('hr'), _c('h1', [_vm._v(_vm._s(_vm.username(student)))])])]), _vm._l((_vm.assignments), function(assignment) {
      return _c('tr', {
        staticClass: "aggregate__assignment"
      }, [_c('td', [_c('div', {
        staticClass: "aggregate__assignment-wrap"
      }, [_c('h2', [_vm._v(_vm._s(assignment.title))]), _c('assignment-progress', {
        attrs: {
          "progress": _vm.progressForStudentAndAssignment(student, assignment, _vm.group)
        }
      })], 1)])])
    })], 2)])
  }), _c('img', {
    staticClass: "dummy-image",
    attrs: {
      "src": ""
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "329f":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("pxSe")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("66y6"),
  /* template */
  __webpack_require__("LFug"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3IWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_SUBMISSIONS: function ADD_SUBMISSIONS(state, submissions) {
        (0, _helpers.setObjects)(submissions, state.storage);
    },
    SET_SUBMISSION: function SET_SUBMISSION(state, submission) {
        (0, _helpers.setObjects)([submission], state.storage);
    },
    FREEZE_SUBMISSIONS: function FREEZE_SUBMISSIONS(state, ids) {
        ids.forEach(function (id) {
            return state.storage[id].isFrozen = true;
        });
    },
    UPDATE_SUBMISSION: function UPDATE_SUBMISSION(state, id, data) {
        state.storage[id].data = data;
    },
    REMOVE_SUBMISSION: function REMOVE_SUBMISSION(state, id) {
        _vue2.default.delete(state.storage, id);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "3fRB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var initialState = function initialState() {
    return {
        user: false
    };
};

var mutations = {
    LOADING_USER: function LOADING_USER(state) {
        state.user = true;
    },
    FINISHED_LOADING_USER: function FINISHED_LOADING_USER(state) {
        state.user = false;
    }
};

exports.default = {
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "3tqh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DefinitionParser = __webpack_require__("NJBc");

var _DefinitionParser2 = _interopRequireDefault(_DefinitionParser);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        assignment: {
            required: true
        }
    },

    components: { DefinitionParser: _DefinitionParser2.default },

    data: function data() {
        return {
            predecessors: [],
            successors: []
        };
    },

    computed: {
        goals: function goals() {
            return this.assignment.goals;
        }
    },

    created: function created() {
        var _this = this;

        _resources2.default.getAssignmentSequence(this.assignment.id).then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            var assignments = result.assignments || [];
            var current = assignments.find(function (a) {
                return a.id == _this.assignment.id;
            });
            _this.predecessors = current.predecessors.map(function (id) {
                return assignments.find(function (a) {
                    return a.id == id;
                });
            }).filter(function (a) {
                return a != null;
            });
            _this.successors = current.successors.map(function (id) {
                return assignments.find(function (a) {
                    return a.id == id;
                });
            }).filter(function (a) {
                return a != null;
            });
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "3u6l":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "user-menu"
  }, [(_vm.show) ? _c('div', {
    staticClass: "user-menu__overlay overlay",
    on: {
      "click": _vm.hide
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "popover"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "user-menu__popover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewSettings($event)
      }
    }
  }, [_vm._v("Instellingen")]), (_vm.isAdmin) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleAppAdmin($event)
      }
    }
  }, [_vm._v(_vm._s(this.isAdminActive ? 'Naar app' : 'Naar admin'))]) : _vm._e(), _c('router-link', {
    attrs: {
      "to": _vm.logout.to
    }
  }, [_vm._v(_vm._s(_vm.logout.text))])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "3yyy":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("a2R8")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("0sK3"),
  /* template */
  __webpack_require__("Sqyl"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "4U3r":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('accordion', {
    attrs: {
      "collections": _vm.groupTerms,
      "initialExpanded": _vm.expandedGroupTerm
    },
    on: {
      "expanded": _vm.showGroupTerm
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(groupTerm) {
        return [_c('timeline', {
          attrs: {
            "items": _vm.timelineItems,
            "isActive": _vm.isPeriodActive,
            "isMarked": _vm.isPeriodCurrent
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(data) {
              return [_c('period', {
                attrs: {
                  "groupPeriod": data.groupPeriod,
                  "start": data.start,
                  "end": data.end,
                  "isDemo": _vm.isDemo
                }
              })]
            }
          }])
        })]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ "4cvB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Timeline = __webpack_require__("XYq3");

var _Timeline2 = _interopRequireDefault(_Timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Timeline: _Timeline2.default },
    props: {
        collection: {
            type: Object
        },
        isExpanded: {
            type: Boolean,
            default: false
        },
        isExpanding: {
            type: Boolean,
            default: false
        },
        isActive: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        toggleExpand: function toggleExpand() {
            var event = this.isExpanded ? 'collapse' : 'expand';
            this.$emit(event, this.collection);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "4dtJ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._l((_vm.revisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.revisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('p', {
      staticClass: "revision__container submission submission--answer"
    }, [_vm._v(_vm._s(revision.submission))])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "4l/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NLI":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("LnBY")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("6onQ"),
  /* template */
  __webpack_require__("zO49"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5OKo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5OlO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _sprite = __webpack_require__("6LO8");

var _sprite2 = _interopRequireDefault(_sprite);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Diligence',
    props: {
        progress: {},
        isDemo: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        showOnlySelected: {
            type: Boolean,
            default: false
        }
    },

    mixins: [_notificationsMixin2.default],
    components: {},

    data: function data() {
        return {
            isUpdating: false,
            diligence: null
        };
    },

    vuex: {
        actions: {
            patchDiligence: function patchDiligence(_ref, progress, diligence) {
                var dispatch = _ref.dispatch;


                return _resources2.default.patchDiligence(progress.id, diligence).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    var diligence = result.diligence[0];
                    dispatch('ADD_DILIGENCE', result.diligence || []);
                    dispatch('ADD_PROGRESS', result.progress || []);
                    return diligence;
                });
            },
            fakeDiligence: function fakeDiligence(_ref2, progress, diligence) {
                var dispatch = _ref2.dispatch;


                var fake = {
                    id: 'fake-' + progress.id,
                    tag: diligence
                };

                dispatch('ADD_DILIGENCE', [fake]);
                dispatch('ADD_DILIGENCE_TO_PROGRESS', progress.id, fake.id);
            }
        }
    },

    computed: {

        options: function options() {

            return [{
                tag: 'sufficient',
                text: 'Je hebt de opdracht met aandacht gemaakt.',
                value: 'sufficient'
            }, {
                tag: 'poor',
                text: 'Je hebt de opdracht met weinig aandacht gemaakt.',
                subtext: '(Als je de opdracht niet begrijpt, of als je het doel van de opdracht niet begrijpt, vraag het dan aan een klasgenoot of je docent of geef je op voor een werkbespreking.)',
                value: 'poor'
            }, {
                tag: 'fail',
                text: 'Je hebt de opdracht niet met aandacht gemaakt.',
                subtext: '(Neem contact op met je docent.)',
                value: 'fail'
            }];
        },

        visibleOptions: function visibleOptions() {
            var _this = this;

            if (this.showOnlySelected) {
                return this.options.filter(function (o) {
                    return o.tag === _this.diligence;
                });
            }

            return this.options;
        },

        spriteImage: function spriteImage() {
            return (0, _sprite2.default)('sprite-main@2x.png');
        }

    },

    methods: {

        iconClass: function iconClass(option) {

            var cls = 'diligence__icon--' + option.tag;
            if (this.diligence === option.value) {
                cls += ' active';
            }

            return cls;
        },

        store: function store(newVal, oldVal) {
            var _this2 = this;

            if (this.readonly || this.isUpdating) {
                return;
            }

            this.$emit('input', this.diligence);

            if (this.isDemo) {
                return this.fakeDiligence(this.progress, newVal);
            }

            this.isUpdating = true;

            this.patchDiligence(this.progress, newVal).catch(function (err) {
                _analytics2.default.exception('Could not store diligence', err);
                _this2.diligence = oldVal;
            }).then(function () {
                _this2.isUpdating = false;
            });
        },

        setDiligence: function setDiligence() {
            this.diligence = this.progress.diligence == null ? null : this.$store.state.diligence.storage[this.progress.diligence[0]].tag;
            this.$emit('input', this.diligence);
        }

    },

    created: function created() {
        this.setDiligence();
        this.$watch('diligence', this.store);
        this.$watch('progress.diligence', this.setDiligence);
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "5a7i":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("aXX8")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("gNNc"),
  /* template */
  __webpack_require__("nFoP"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5ehd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * localStorage / sessionStorage fallback
 * (ie <= 8 / Safari private browsing)
 */

var TEST_KEY = '__TEST_KEY__';
var TEST_DATA = '1234';

/**
 * Checks if the current browser has *Storage
 * @param  String  name
 * @return Boolean
 */
function isStorageAvailable(name) {
    try {
        var storage = window[name];
        storage.setItem(TEST_KEY, TEST_DATA);
        var result = storage.getItem(TEST_KEY);
        storage.removeItem(TEST_KEY);
        return result === TEST_DATA;
    } catch (e) {
        return false;
    }
}

/**
 * Gives the requested storage or in-memory fallback
 * @param  String name
 * @return Storage
 */
function getStorage(name) {
    if (isStorageAvailable(name)) {
        return window[name];
    }

    return new MemoryStorage();
}

/**
 * Simple in-memory storage mock
 */

var MemoryStorage = function () {
    function MemoryStorage() {
        _classCallCheck(this, MemoryStorage);

        this._data = {};
    }

    _createClass(MemoryStorage, [{
        key: 'getItem',
        value: function getItem(key) {
            return this._data.hasOwnProperty(key) ? this._data[key] : undefined;
        }
    }, {
        key: 'setItem',
        value: function setItem(key, value) {
            return this._data[key] = String(value);
        }
    }, {
        key: 'removeItem',
        value: function removeItem(key) {
            return delete this._data[key];
        }
    }, {
        key: 'clear',
        value: function clear() {
            return this._data = {};
        }
    }]);

    return MemoryStorage;
}();

exports.default = {
    local: getStorage('localStorage'),
    session: getStorage('sessionStorage')
};

/***/ }),

/***/ "5hKk":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    staticClass: "component-school-groups includes-header"
  }, [_c('header', {
    staticClass: "page-header school-groups-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.school.name))]), (_vm.groups.length) ? _c('p', [_vm._v("Aan welke klassen geef je les?"), _c('br'), _vm._v(" Maak een nieuwe klas aan met de "), _c('strong', [_vm._v("(+)")]), _vm._v(" knop")]) : _c('p', [_vm._v("Er zijn nog geen klassen aangemaakt voor deze school. Maak een nieuwe klas aan met de "), _c('strong', [_vm._v("(+)")]), _vm._v(" knop")]), _c('hr')]), (_vm.groups.length) ? _c('ul', {
    staticClass: "school-groups"
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "school-groups__item",
      on: {
        "click": function($event) {
          _vm.addGroup(group, $event)
        }
      }
    }, [_c('h2', {
      staticClass: "group-name",
      class: {
        active: _vm.isTeachingGroup(group)
      }
    }, [_vm._v(_vm._s(group.name))])])
  })) : _vm._e(), _c('a', {
    staticClass: "button-rounded button-create button-create-group",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createGroup($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--add"
  }), _vm._v("Nieuwe klas")])])
},staticRenderFns: []}

/***/ }),

/***/ "5pXN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

var _cloneDeep2 = __webpack_require__("kvU2");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _interactjs = __webpack_require__("0E+G");

var _interactjs2 = _interopRequireDefault(_interactjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'WeekPlanning',
    mixins: [],
    components: {},

    props: {

        value: {
            type: Array
        },

        minWeeksInPast: {
            type: Number,
            default: 3
        },

        minWeeksInFuture: {
            type: Number,
            default: 52
        },

        maxWeeksInFuture: {
            type: Number,
            default: 52
        },

        allowEditInPast: {
            type: Boolean,
            default: false
        },

        allowEditInCurrentWeek: {
            type: Boolean,
            default: false
        },

        allowPeriodOverlap: {
            type: Boolean,
            default: false
        },

        minBlockDuration: {
            type: Number,
            default: 1
        },

        maxBlockDuration: {
            type: Number,
            default: 52
        },

        allowMovingSelectedPeriods: {
            type: Boolean,
            default: true
        },

        resetSelected: {
            type: Boolean,
            default: false
        },

        relativeToPeriods: {
            type: Boolean,
            default: true
        },

        classForWeek: {
            type: Function
        },

        labelForWeek: {
            type: Function
        }

    },

    data: function data() {
        return {
            periods: (0, _cloneDeep3.default)(this.value),
            selectedPeriod: null,

            displayedWeeks: []
        };
    },

    watch: {
        value: {
            handler: function handler(newVal) {
                this.periods = (0, _cloneDeep3.default)(newVal);
                this.autoResolveOverlap();
                if (this.selectedPeriod != null && this.scheduledPeriods.length - 1 < this.selectedPeriod) {
                    this.selectedPeriod = null;
                }
            },
            deep: true
        },
        weeksToDisplay: function weeksToDisplay() {
            this.recomputeWeeks();
        }
    },

    computed: {

        // makes sure first period is visible
        start: function start() {
            var regularStart = this.dateForCurrentWeek().subtract(this.minWeeksInPast, 'weeks');
            return this.firstPeriod != null && this.firstPeriod.start.isBefore(regularStart) ? this.roundToWeek(this.firstPeriod.start) : regularStart;
        },

        // makes sure last period is visible + padding to certain max
        end: function end() {
            var lastScheduledWeek = this.lastPeriod != null ? this.lastPeriod.start.clone().add(this.periodDuration(this.lastPeriod), 'weeks') : this.dateForCurrentWeek();
            var firstScheduledWeek = this.firstPeriod != null && (this.firstPeriod.start.isBefore(this.dateForCurrentWeek()) || this.relativeToPeriods) ? this.roundToWeek(this.firstPeriod.start) : this.dateForCurrentWeek().clone().add(this.allowEditInCurrentWeek ? 0 : 1, 'weeks');

            // minimally shown
            var a = _moment2.default.max(firstScheduledWeek.clone().add(this.minWeeksInFuture, 'weeks'), lastScheduledWeek);

            // try to pad to maxWeeks
            var b = _moment2.default.min(lastScheduledWeek.clone().add(10, 'weeks'), firstScheduledWeek.clone().add(this.maxWeeksInFuture, 'weeks'));

            return _moment2.default.max(a, b);
        },

        weeksInPast: function weeksInPast() {
            return this.dateForCurrentWeek().diff(this.start, 'weeks');
        },

        daysInWeek: function daysInWeek() {
            return 7;
        },

        weeksToDisplay: function weeksToDisplay() {
            return this.end.diff(this.start, 'weeks');
        },

        scheduledPeriods: function scheduledPeriods() {
            return this.periods.filter(function (p) {
                return p.start != null;
            });
        },

        firstPeriod: function firstPeriod() {
            return this.scheduledPeriods[0];
        },

        firstPeriodDiff: function firstPeriodDiff() {
            if (this.firstPeriod == null) {
                return 0;
            }

            return this.firstPeriod.start.diff(this.start, 'weeks');
        },

        lastPeriod: function lastPeriod() {
            return this.scheduledPeriods[this.scheduledPeriods.length - 1];
        },

        finalizedDate: function finalizedDate() {
            return this.allowEditInCurrentWeek ? this.dateForCurrentWeek() : (0, _moment2.default)();
        },

        displayedDaysInWeek: function displayedDaysInWeek() {
            var arr = [];
            for (var i = 0; i < this.daysInWeek; i++) {
                arr.push(this.displayDay(i + 1));
            }
            return arr;
        }

    },

    methods: {

        recomputeWeeks: function recomputeWeeks() {
            var _this = this;

            // expensive method, caches all weeks data
            var arr = [];
            for (var i = 0; i < this.weeksToDisplay; i++) {

                var createNew = function createNew(idx) {
                    var days = [];
                    for (var j = 0; j < _this.daysInWeek; j++) {
                        days.push(_this.classDay(j + 1, idx));
                    }

                    return {
                        index: idx,
                        cls: _this.classWeek(idx),
                        number: _this.displayWeekNumber(idx),
                        dates: _this.displayWeekDates(idx),
                        label: _this.displayWeekLabel(idx),
                        days: days
                    };
                };

                var week = this.displayedWeeks[i] || createNew(i + 1);
                week.relativeNumber = this.displayRelativeWeekNumber(i + 1);

                arr[i] = week;
            }

            this.displayedWeeks = arr;
        },

        /** Display **/

        /**
         * @param  {Int} day 1-based day of week
         */
        displayDay: function displayDay(day) {
            return this.dateForDay(day).format('dd');
        },

        /**
         * @param  {Int} week 1-based week from start
         */
        displayWeekNumber: function displayWeekNumber(week) {
            var date = this.dateForWeek(week);
            return 'wk ' + date.format('w');
        },

        displayWeekDates: function displayWeekDates(week) {
            var date = this.dateForWeek(week);
            return date.format('D MMM') + ' - ' + date.add(6, 'days').format('D MMM');
        },

        displayWeekLabel: function displayWeekLabel(week) {
            return this.labelForWeek == null ? '' : this.labelForWeek(this.dateForWeek(week));
        },

        displayRelativeWeekNumber: function displayRelativeWeekNumber(week) {

            var format = function format(number) {
                return number > 0 ? number : '-';
            };

            if (this.relativeToPeriods && this.firstPeriod != null) {

                var diff = week - this.firstPeriodDiff;
                return format(diff);
            }

            var weekFromNow = week - this.weeksInPast - (this.allowEditInCurrentWeek ? 0 : 1);
            return format(weekFromNow);
        },

        displayPeriodTitle: function displayPeriodTitle(period) {
            return 'Periode ' + period.title + '. Versleep om te verplaatsen naar een andere week.';
        },

        displayBlockTitle: function displayBlockTitle(period, block) {
            return period.title + ', blok ' + block.title + '. Versleep om te verlengen/verkorten.';
        },

        /**
         * @param  {Int} day  1-based day of week
         * @param  {Int} week 1-based week from start
         * @return {Array}      array of css class strings
         */
        classDay: function classDay(day, week) {

            var classes = [this.dateForDay(day).locale('en').format('dddd').toLowerCase()];

            if (week <= this.weeksInPast) {
                classes.push('past');
            } else if (week === this.weeksInPast + 1) {

                var currentDay = (0, _moment2.default)().weekday();
                if (currentDay > day - 1) {
                    classes.push('past');
                } else if (currentDay === day - 1) {
                    classes.push('current');
                }
            } else {
                classes.push('future');
            }

            // prefix BEM element
            return classes.map(function (c) {
                return 'planner__day--' + c;
            });
        },

        classWeek: function classWeek(week) {
            return this.classForWeek == null ? '' : this.classForWeek(this.dateForWeek(week));
        },

        /** Helpers **/

        /**
         * @param  {Int} day 1-based day of week
         */
        dateForDay: function dateForDay(day) {
            // monday always first day of the week
            return (0, _moment2.default)().isoWeekday(day).startOf('day');
        },

        dateForCurrentWeek: function dateForCurrentWeek() {
            return this.roundToWeek((0, _moment2.default)());
        },

        roundToWeek: function roundToWeek(date) {
            return date.clone().startOf('week');
        },

        /**
         * @returns {Int} 1-based week since start
         */
        weekForDate: function weekForDate(date) {
            return date.diff(this.start, 'weeks') + 1;
        },

        dateForWeek: function dateForWeek(week) {
            return this.start.clone().add(week - 1, 'weeks');
        },

        periodDuration: function periodDuration(period) {
            if (!period.enabled) {
                return 0;
            }
            return period.blocks.reduce(function (sum, b) {
                return sum + b.duration;
            }, 0);
        },

        isFinalized: function isFinalized(period) {
            return period.start.isBefore(this.finalizedDate);
        },

        isBlockFinalized: function isBlockFinalized(period, block) {
            var endDate = this.blockEndDate(period, block);
            return endDate.isBefore(this.finalizedDate);
        },

        blockEndDate: function blockEndDate(period, block) {
            var blockIndex = period.blocks.indexOf(block);
            var blocksDuration = period.blocks.slice(0, blockIndex + 1).reduce(function (sum, el) {
                return sum + el.duration;
            }, 0);
            return period.start.clone().add(blocksDuration, 'weeks');
        },

        /**
         * @param  {Int} day 1-based week since start
         */
        canMoveToWeek: function canMoveToWeek(period, week) {
            if (this.allowEditInPast) {
                return true;
            }

            var finalizedWeek = this.weeksInPast + (this.allowEditInCurrentWeek ? 0 : 1);

            return period.start.isSameOrAfter(this.finalizedDate) && week > finalizedWeek;
        },

        canExtend: function canExtend(period, block, weeks) {
            if (this.allowEditInPast) {
                return true;
            }

            var blockEndDate = this.blockEndDate(period, block);

            if (blockEndDate.isSameOrBefore(this.finalizedDate)) {
                return false;
            }

            var newBlockDate = blockEndDate.clone().add(weeks, 'weeks');
            if (newBlockDate.isSameOrBefore(this.finalizedDate)) {
                return false;
            }

            return true;
        },

        canEnable: function canEnable(period) {
            return this.canMoveToWeek(period, this.weekForDate(period.start));
        },

        /** Events **/

        clickedWeek: function clickedWeek(e, week) {

            if (this.allowMovingSelectedPeriods && this.selectedPeriod != null) {

                this.moveToWeek(this.periods[this.selectedPeriod], week);

                if (this.resetSelected) {
                    this.selectedPeriod = null;
                }
            }

            var date = this.start.clone().add(week - 1, 'weeks');
            this.$emit('clickedDate', date);
        },

        clickedPeriod: function clickedPeriod(e, period) {
            var clickedPeriod = this.periods.indexOf(period);
            if (this.allowMovingSelectedPeriods) {
                this.selectedPeriod = clickedPeriod === this.selectedPeriod && this.resetSelected ? null : clickedPeriod;
            }
            this.$emit('clickedPeriod', this.selectedPeriod);
        },

        onPeriodMove: function onPeriodMove(event) {
            var period = this.periods[event.target.dataset.periodIndex];
            var movement = Math.round(event.dy / 45);
            if (movement !== 0) {
                this.moveWeeks(period, movement);
            }
        },

        onBlockMove: function onBlockMove(event) {
            var period = this.periods[event.target.dataset.periodIndex];
            var block = period.blocks[event.target.dataset.blockIndex];
            var movement = Math.round(event.dy / 45);
            if (movement !== 0) {
                this.extend(period, block, movement);
            }
        },

        /** Period manipulation **/

        moveToWeek: function moveToWeek(period, week) {

            if (!this.canMoveToWeek(period, week)) {
                return;
            }

            var newStart = this.start.clone().add(week - 1, 'weeks');
            period.start = newStart;
            this.updated();
        },

        moveWeeks: function moveWeeks(period, weeks) {
            var newStart = period.start.clone().add(weeks, 'weeks');

            if (!this.canMoveToWeek(period, this.weekForDate(newStart))) {
                return;
            }

            period.start = newStart;
            this.updated();
        },

        extend: function extend(period, block, weeks) {
            if (!this.canExtend(period, block, weeks)) {
                return;
            }

            block.duration = Math.max(this.minBlockDuration, Math.min(block.duration + weeks, this.maxBlockDuration));
            this.updated();
        },

        togglePeriodEnabled: function togglePeriodEnabled(period) {
            if (!this.canEnable(period)) {
                return;
            }
            period.enabled = !period.enabled;
            this.updated();
        },

        updated: function updated() {
            this.autoResolveOverlap();
            this.$emit('input', (0, _cloneDeep3.default)(this.periods));
        },

        autoResolveOverlap: function autoResolveOverlap() {
            this.resolveOverlap();
            this.resolveMaxWeeks();
        },

        resolveOverlap: function resolveOverlap() {

            if (!this.allowPeriodOverlap && this.periods.length > 1) {

                var previousPeriod = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.periods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var thisPeriod = _step.value;


                        if (previousPeriod != null && previousPeriod.start != null && thisPeriod.start != null) {

                            var previousEndDate = previousPeriod.start.clone().add(this.periodDuration(previousPeriod), 'weeks');

                            if (thisPeriod.start.isBefore(previousEndDate)) {
                                thisPeriod.start = previousEndDate;
                            }
                        }

                        previousPeriod = thisPeriod;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },

        resolveMaxWeeks: function resolveMaxWeeks() {
            var _this2 = this;

            for (var i = this.periods.length - 1; i >= 0; i--) {

                var thisPeriod = this.periods[i];
                var nextPeriodsDuration = this.periods.slice(i + 1).reduce(function (sum, p) {
                    return sum + _this2.periodDuration(p);
                }, 0);

                if (thisPeriod.start != null) {

                    var week = thisPeriod.start.clone().add(this.periodDuration(thisPeriod), 'weeks').diff(this.start, 'weeks');

                    var weeksInPast = this.relativeToPeriods ? this.firstPeriod.start.diff(this.start, 'weeks') : this.weeksInPast;
                    var overEnd = week + nextPeriodsDuration - weeksInPast - this.maxWeeksInFuture;

                    if (overEnd > 0) {
                        thisPeriod.start = thisPeriod.start.clone().subtract(overEnd, 'weeks');
                    }
                }
            }
        },

        /** Styling **/

        styleForPeriod: function styleForPeriod(period) {
            return {
                transform: 'translateY(' + Math.floor(period.start.diff(this.start, 'weeks')) * 45 + 'px' + ')'
            };
        },

        styleForBlock: function styleForBlock(block) {
            return {
                height: block.duration * 45 + 'px'
            };
        }

    },

    created: function created() {

        this.recomputeWeeks();
        this.autoResolveOverlap();

        (0, _interactjs2.default)('.planner__period').draggable({
            autoScroll: true,
            snap: {
                targets: [_interactjs2.default.createSnapGrid({ x: 0, y: 45, range: Infinity })],
                relativePoints: [{ x: 0, y: 0 }],
                offset: { x: 0, y: 0 }
            },
            restrict: { restriction: 'parent' },
            onmove: this.onPeriodMove,
            axis: 'y'
        }).allowFrom('.planner__period-title');

        (0, _interactjs2.default)('.planner__block').draggable({
            autoScroll: true,
            snap: {
                targets: [_interactjs2.default.createSnapGrid({ x: 0, y: 45, range: Infinity })],
                relativePoints: [{ x: 0, y: 0 }],
                offset: { x: 0, y: 0 }
            },
            restrict: { restriction: '.periods' },
            onmove: this.onBlockMove,
            axis: 'y'
        });
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "5qiO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldRetake && !_vm.isInspectingStudent) ? _c('div', {
    staticClass: "note note--warning note--large"
  }, [_vm._m(0), _vm._m(1), _c('primary-button', {
    staticClass: "primary-button--no-margin",
    attrs: {
      "link": {
        name: 'assignment.step',
        params: {
          stepIdx: 1
        }
      }
    }
  }, [_vm._v("Begin opdracht")])], 1) : _vm._e(), (_vm.hasDiligence) ? _c('div', {
    staticClass: "note note--info note--large"
  }, [_c('diligence', {
    attrs: {
      "progress": _vm.progress,
      "readonly": true
    }
  })], 1) : _vm._e(), _c('h1', {
    staticClass: "banner"
  }, [(!_vm.isInspectingStudent) ? _c('span', [_vm._v("Dit heb jij gemaakt")]) : _c('span', [_vm._v("Dit heeft " + _vm._s(_vm.user.firstname) + " gemaakt")])]), _vm._l((_vm.regularInputPartials), function(partial) {
    return _c(partial.type, {
      key: partial.id,
      tag: "component",
      attrs: {
        "submissions": partial.submissions,
        "title": partial.title,
        "showVersions": true
      }
    })
  }), (_vm.isInspectingStudent && _vm.reflectingInputPartials.length) ? [_c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Feedback van " + _vm._s(_vm.user.firstname))])]), _vm._l((_vm.reflectingInputPartials), function(partial) {
    return _c(partial.type, {
      key: partial.id,
      tag: "component",
      attrs: {
        "submissions": partial.submissions,
        "title": partial.title,
        "showVersions": true
      }
    })
  }), (_vm.reflectionPartials.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflection(_vm.reflectionPartials[0], _vm.progress)
      }
    }
  }, [_vm._v("Bekijk het werk waar " + _vm._s(_vm.user.firstname) + " feedback op heeft gegeven")]) : _vm._e()] : _vm._e(), (_vm.reflections || _vm.hasFeedback) ? _c('h1', {
    staticClass: "banner"
  }, [(!_vm.isInspectingStudent) ? _c('span', [_vm._v("Feedback")]) : _c('span', [_vm._v("Feedback voor " + _vm._s(_vm.user.firstname))])]) : _vm._e(), _vm._l((_vm.reflections), function(reflection) {
    return _c('div', {
      staticClass: "reflection"
    }, [_c('h1', [_c('small', [_vm._v("Van:")]), _vm._v(" " + _vm._s(_vm.userForReflection(reflection).firstname))]), _c('h2', [_vm._v(_vm._s(_vm.title(_vm.partialForReflection(reflection))))]), _c('p', {
      staticClass: "preformatted"
    }, [_vm._v(_vm._s(reflection.data))])])
  }), (_vm.hasFeedback) ? _c('teacher-feedback', {
    attrs: {
      "feedback": _vm.feedback
    }
  }) : _vm._e(), (!_vm.isInspectingStudent) ? _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group
    }
  }) : _vm._e()], 2), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": {
        name: 'assignment.step',
        params: {
          stepIdx: _vm.assignment.steps.length
        }
      }
    }
  }, [_vm._v("Vorige stap")]), (!_vm.isInspectingStudent) ? _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Opnieuw inleveren")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', [_vm._v("\n            Je moet deze opdracht opnieuw inleveren door de stappen nog een keer te doorlopen. Je hiervoor ingeleverde werk blijft zichtbaar.\n            "), _c('strong', [_vm._v("Let goed op de feedback die je hebt gekregen!")])])
}]}

/***/ }),

/***/ "64w4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: {
      isTouchEnabled: _vm.isTouch
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.isDemo) ? _c('demo-message') : _vm._e(), _c('notifications'), _c('modal'), _c('alerter', {
    ref: "alerter"
  }), (_vm.loading) ? _c('loading') : _vm._e(), _c('router-view', {
    staticClass: "scrollable",
    class: {
      'is-demo': _vm.isDemo
    },
    attrs: {
      "id": "main-view"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "66y6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//

exports.default = {
    props: {
        group: {}
    },

    computed: {
        registerLink: function registerLink() {
            return document.location.host + '/registreren';
        }
    }

};

/***/ }),

/***/ "6IEm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6LO8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (name) {
    return '/build/img/' + _revManifest2.default[name];
};

var _revManifest = __webpack_require__("wGR8");

var _revManifest2 = _interopRequireDefault(_revManifest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "6O0U":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ixh7")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("FzPO"),
  /* template */
  __webpack_require__("Ukaq"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6onQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'SidebarPeriod',
    props: {
        groupPeriod: {},
        start: {},
        end: {},
        isDemo: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            loading: false
        };
    },
    computed: {
        assignments: function assignments() {
            var _this = this;

            return this.groupPeriod.groupAssignments.map(function (id) {
                return _this.$store.state.groups.assignments[id];
            }).filter(function (ga) {
                return !ga.optional;
            }).map(function (ga) {
                return _this.$store.state.assignments.storage[ga.assignment[0]];
            });
        },
        period: function period() {
            return this.$store.state.periods.storage[this.groupPeriod.period[0]];
        },
        periodDates: function periodDates() {
            // '1 november - 14 november'
            return this.start.format('D MMMM') + ' - ' + this.end.format('D MMMM');
        }
    },
    methods: {
        goToPeriod: function goToPeriod(e) {
            e.preventDefault();
            this.$router.push({ name: 'group.period', params: { periodId: this.groupPeriod.id } });
        },
        goToAssignment: function goToAssignment(e, assignment) {
            e.preventDefault();
            // prevents goToPeriod() from running
            e.stopPropagation();

            if (this.isDisabledAssignment(assignment)) {
                return this.goToPeriod(e);
            }

            this.$router.push({ name: 'group.assignment', params: { assignmentId: assignment.id, periodId: this.groupPeriod.id } });
        },
        isActiveAssignment: function isActiveAssignment(assignment) {
            return this.$route.params.assignmentId == assignment.id;
        },
        isDisabledAssignment: function isDisabledAssignment(assignment) {
            return this.isDemo && !assignment.demo;
        }
    }
};

/***/ }),

/***/ "6rWd":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("IqPv")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("rOkJ"),
  /* template */
  __webpack_require__("ihE0"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "7Lht":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _getters = __webpack_require__("olIF");

var _helpers = __webpack_require__("x3kM");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _autoGlossaryMixin = __webpack_require__("MSI/");

var _autoGlossaryMixin2 = _interopRequireDefault(_autoGlossaryMixin);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        step: {}
    },
    mixins: [_notificationsMixin2.default, _autoGlossaryMixin2.default],
    components: { Loading: _Loading2.default },
    vuex: {
        getters: {
            getCurrentAssignment: _getters.getCurrentAssignment
        },
        actions: {
            addTeachertips: function addTeachertips(_ref, teachertips) {
                var dispatch = _ref.dispatch;
                return dispatch('ADD_TEACHERTIPS', teachertips);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.teachertips == null) {

            _resources2.default.getTeachertips(this.step.id).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (data) {
                _this.addTeachertips(data.teachertips);
            }).catch(function (e) {
                _analytics2.default.exception('Can\'t find teacher tips', e, { step: _this.step.id });
                _this.$warn('Kan tips niet vinden.');
                _this.close();
            });
        }
    },
    methods: {
        close: function close() {
            this.$emit('close');
        }
    },
    computed: {
        teachertips: function teachertips() {
            return this.$store.state.steps.teachertips[this.step.id];
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "7afl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupSettingsAssignments',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Loading: _Loading2.default },
    props: {
        group: {},
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            isSaving: false,
            isLoading: true,

            terms: [],
            groupAssignments: []
        };
    },

    vuex: {
        actions: {
            setOptional: function setOptional(_ref, groupId, data) {
                var dispatch = _ref.dispatch;

                return _resources2.default.patchAssignmentsForGroup(groupId, data).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    var ga = result.groupassignments || [];
                    dispatch('ADD_GROUP_ASSIGNMENTS', ga);
                    return ga;
                });
            }
        }
    },

    computed: {

        optionalAssignments: function optionalAssignments() {
            return this.groupAssignments.filter(function (ga) {
                return ga.optional;
            }).map(function (ga) {
                return ga.assignment[0];
            });
        }

    },

    methods: {

        submit: function submit(e) {
            e.preventDefault();
            this.save().catch(function () {});
        },

        save: function save() {
            var _this = this;

            if (this.isDemo) {
                this.$demoSuccessNotification();
                this.$emit('saved');
                return Promise.resolve();
            }

            this.isSaving = true;

            var optionalAssignments = this.groupAssignments.filter(function (ga) {
                return ga.optional;
            }).map(function (ga) {
                return ga.id;
            });
            var p = this.setOptional(this.group.id, optionalAssignments).then(function () {
                _this.$emit('saved');
                _this.$success(_this.isCreating ? 'De klas is aangemaakt' : 'De opdrachten zijn aangepast');
            }).catch(function (err) {
                _analytics2.default.exception('Can\'t update assignments', err);
                _this.$error('Aanpassen opdrachten mislukt');
                return Promise.reject(err);
            });

            // finally
            p.catch(function () {}).then(function () {
                return _this.isSaving = false;
            });
            return p;
        },

        isOptional: function isOptional(assignment) {
            return this.optionalAssignments.indexOf(assignment.id) !== -1;
        },

        toggleAssignment: function toggleAssignment(assignment) {
            var groupAssignment = this.groupAssignments.find(function (ga) {
                return ga.assignment[0] == assignment.id;
            });
            groupAssignment.optional = !groupAssignment.optional;
            this.$emit('changed');
        },

        hasError: function hasError(period) {
            var _this2 = this;

            return period.assignments.filter(function (a) {
                return _this2.optionalAssignments.indexOf(a.id) === -1;
            }).length === 0;
        },

        fetchPlanning: function fetchPlanning(groupId) {
            var _this3 = this;

            return _resources2.default.getPlanning(groupId).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (result) {
                _this3.groupAssignments = result.groupassignments;

                // hydrated planning
                // term.periods.assignments
                _this3.terms = result.groupterms.map(function (gt) {
                    var term = result.terms.find(function (t) {
                        return t.id == gt.term[0];
                    });
                    term.periods = gt.groupPeriods.map(function (id) {
                        var gp = result.groupperiods.find(function (gp) {
                            return gp.id == id;
                        });
                        var period = result.periods.find(function (p) {
                            return p.id == gp.period[0];
                        });
                        period.assignments = gp.groupAssignments.map(function (id) {
                            var ga = result.groupassignments.find(function (ga) {
                                return ga.id == id;
                            });
                            return result.assignments.find(function (a) {
                                return a.id == ga.assignment[0];
                            });
                        });
                        return period;
                    });
                    return term;
                });
            }).catch(function (err) {
                _analytics2.default.exception('Can\'t load assignments', err);
                _this3.$error('Kan opdrachten niet laden');
            });
        }

    },

    created: function created() {
        var _this4 = this;

        this.fetchPlanning(this.group.id).then(function () {
            return _this4.isLoading = false;
        });
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "7kkF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _Progress = __webpack_require__("O6gY");

var _Progress2 = _interopRequireDefault(_Progress);

var _vueImagesLoaded = __webpack_require__("iPd/");

var _vueImagesLoaded2 = _interopRequireDefault(_vueImagesLoaded);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _transformers = __webpack_require__("j0ZK");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'StudentsAggregate',
    components: { Loading: _Loading2.default, AssignmentProgress: _Progress2.default },

    directives: {
        imagesLoaded: _vueImagesLoaded2.default
    },

    props: {
        group: {},
        students: {},
        assignments: {}
    },

    data: function data() {
        return {
            loading: false
        };
    },

    vuex: {
        actions: {
            loadProgress: function loadProgress(_ref, group) {
                var dispatch = _ref.dispatch;

                return _resources2.default.getProgressForGroup(group.id, true).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_PROGRESS', result.progress || []);
                    dispatch('ADD_DILIGENCE', result.diligence || []);
                    dispatch('ADD_USERS', result.users || []);
                    dispatch('ADD_FEEDBACK', result.feedback || []);
                    dispatch('ADD_COMPLIMENTS', result.compliments || []);
                    dispatch('ADD_REMARKS', result.remarks || []);
                    dispatch('ADD_DILIGENCE', result.diligence || []);
                    dispatch('ADD_SUBMISSIONS', result.submissions || []);
                });
            }
        }
    },

    computed: {

        currentDate: function currentDate() {
            return (0, _transformers.date)(new Date());
        }

    },

    methods: {

        username: _transformers.username,

        progressForStudentAndAssignment: function progressForStudentAndAssignment(student, assignment, group) {
            var _this = this;

            return Object.keys(this.$store.state.progress.storage).map(function (id) {
                return _this.$store.state.progress.storage[id];
            }).find(function (progress) {
                return progress.finished && progress.user == student.id && progress.assignment == assignment.id && progress.group == group.id;
            });
        },

        loaded: function loaded() {
            this.$emit('load');
        }

    },

    created: function created() {
        var _this2 = this;

        this.loading = true;

        this.loadProgress(this.group, true).catch(function (err) {
            return _analytics2.default.exception('Could not load students progress', err);
        }).then(function () {
            return _this2.loading = false;
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "84f7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        partial: {},
        progress: {},
        readonly: {
            type: Boolean,
            default: false
        }
    },

    vuex: {
        actions: {
            setValidation: _actions.setValidation,
            setSubmission: _actions.setSubmission
        }
    },

    computed: {
        answer: {
            get: function get() {
                var sub = this.submissions.filter(function (s) {
                    return !s.isFrozen;
                })
                // newest first
                .sort(function (a, b) {
                    return b.updatedAt - a.updatedAt;
                });

                return this.getSubmissionValue(sub[0]);
            },
            set: function set(newValue) {
                this.store(newValue);
            }
        },

        submissions: function submissions() {
            var _this = this;

            return Object.keys(this.$store.state.submissions.storage).map(function (id) {
                return _this.$store.state.submissions.storage[id];
            }).filter(function (submission) {
                return submission.progress === _this.progress.id && submission.partial === _this.partial.id;
            });
        },

        frozenRevisions: function frozenRevisions() {
            var _this2 = this;

            return this.submissions.filter(function (s) {
                return s.isFrozen;
            }).map(function (s) {
                return {
                    title: 'versie ' + (s.revision + 1),
                    submission: _this2.getSubmissionValue(s)
                };
            });
        }

    },
    methods: {
        store: function store(value) {
            var _this3 = this;

            if (value == null) {
                _analytics2.default.exception('Null value answer', { partial: this.partial.id });
                return;
            }

            var revision = this.frozenRevisions.length;

            this.setSubmission(this.partial, this.progress, revision, value).then(function () {
                return _this3.validate();
            }).catch(function (err) {
                _analytics2.default.exception('Can\'t set submission', err, { partial: _this3.partial.id, data: value });
            });

            this.validate();
        },

        getSubmissionValue: function getSubmissionValue(submission) {
            if (submission == null) {
                return '';
            }
            return typeof submission.data === 'string' ? submission.data : '[ Werk niet herkend ]';
        },

        flush: function flush() {
            return (0, _actions.flushSyncSubmission)(this.partial);
        },

        validate: function validate() {

            var minlength = this.partial.data.minlength == undefined ? 1 : this.partial.data.minlength;
            var validated = this.answer.trim().length >= minlength;

            if (validated != this.partial.validated) {
                this.setValidation(this.partial.id, validated);
            }
        }
    },

    created: function created() {
        this.validate();
    }
};

/***/ }),

/***/ "8SU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Register',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: [],

    data: function data() {
        return {
            email: '',
            code: '',
            loading: false,
            requested: false,
            errors: [],
            errorFields: [],
            forgot: false,
            history: [],
            terms: false
        };
    },

    vuex: {
        actions: {

            showTerms: function showTerms(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'legal', { type: 'terms', title: 'Algemene voorwaarden' });
            },

            showPrivacy: function showPrivacy(_ref2) {
                var dispatch = _ref2.dispatch;

                dispatch('SHOW_MODAL', 'legal', { type: 'privacy', title: 'Privacyverklaring' });
            }

        }
    },

    methods: {

        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate() && !this.throttled(this.email)) {

                this.loading = true;

                _resources2.default.registrationRequest(this.email, this.code, this.terms).then(function () {
                    _this.requested = true;
                    _this.throttleHit(_this.email);
                }).catch(function (response) {
                    if (response.status === 409) {
                        _this.forgot = true;
                        _this.addFieldError('email');
                        _this.$warn('Dit e-mailadres is al geregistreerd.');
                    } else {
                        _this.handleErrorResponse(response, 'Registratie is mislukt.');
                    }
                }).then(function () {
                    return _this.loading = false;
                });
            }
        },

        retry: function retry(e) {
            e.preventDefault();
            this.email = '', this.requested = false;
        },

        validateFields: function validateFields() {
            this.validateCode(this.code);
            this.validateEmail(this.email);
            // this.validateTerms(this.terms)
        },

        throttled: function throttled(email) {
            var previous = this.history[email];

            if (previous == null) {
                return false;
            }

            if (Date.now() - previous.first > 5 * 60 * 1000) {
                delete this.history[email];
                return false;
            }

            this.$alert({ title: 'Al geregistreerd', message: 'Binnen enkele minuten ontvang je een activatiemail. Kijk ook bij "Ongewenste mail" (spam) en controleer of je "' + this.email + '" goed hebt gespeld.' }, [{ name: 'Oké' }]);
            _analytics2.default.event('register', 'dupe', this.code.substr(0, 2).padEnd(5, '*'));

            return true;
        },

        throttleHit: function throttleHit(email) {
            this.history[email] = {
                first: Date.now()
            };
        }

    }

};

/***/ }),

/***/ "8ZaV":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("wTqg")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9XUI"),
  /* template */
  __webpack_require__("DXVi"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8gYt":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Fnp/")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("GB29"),
  /* template */
  __webpack_require__("/cSv"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8jme":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("wVh7")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("1F/N"),
  /* template */
  __webpack_require__("r4bP"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8mrf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        current: null,
        storage: {}
    };
};

var mutations = {
    SHOW_DEFINITION: function SHOW_DEFINITION(state, definition) {
        state.current = definition;
    },
    HIDE_DEFINITION: function HIDE_DEFINITION(state) {
        state.current = null;
    },
    ADD_DEFINITIONS: function ADD_DEFINITIONS(state, definitions) {
        (0, _helpers.setObjects)(definitions, state.storage);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "8nkQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8o5J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Notification = __webpack_require__("UCVt");

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Notification: _Notification2.default },
    vuex: {
        getters: {
            notifications: function notifications(state) {
                return state.notifications.all.slice(0, 5).reverse();
            }
        },
        actions: {
            removeNotification: function removeNotification(_ref, notification) {
                var dispatch = _ref.dispatch;
                return dispatch('REMOVE_NOTIFICATION', notification);
            }
        }
    }
}; //
//
//
//
//
//
//
//

// http://forum.vuejs.org/topic/2122/resusable-global-notification-popups-with-vue-the-store-pattern-foundation-and-animate-css/4

/***/ }),

/***/ "9A6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    components: {},
    props: {
        collectionName: {
            type: String,
            default: 'items'
        },
        items: {
            type: Array,
            default: []
        },
        isActive: {
            type: Function,
            default: function _default() {
                return false;
            }
        },
        isMarked: {
            type: Function,
            default: function _default() {
                return false;
            }
        }
    },

    methods: {
        open: function open(item) {
            if (item.link) {
                this.$router.push(item.link);
            } else {
                this.$emit('click', item);
            }
        }
    }
};

/***/ }),

/***/ "9XUI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _Route = __webpack_require__("CKNE");

var _Route2 = _interopRequireDefault(_Route);

var _auth = __webpack_require__("JOmw");

var _getters = __webpack_require__("olIF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'Period',
    components: { AssignmentRoute: _Route2.default, Loading: _Loading2.default },
    props: {
        user: {},
        group: {},
        loading: {
            type: Boolean,
            default: false
        },
        isInspectingStudent: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        },
        ignoreProgress: {
            type: Boolean,
            default: false
        }
    },
    vuex: {
        getters: {
            getTermForPeriod: _getters.getTermForPeriod,
            getProgressForUser: _getters.getProgressForUser,
            getCurrentGroupPeriodForGroup: _getters.getCurrentGroupPeriodForGroup,
            getGroupTermsForGroup: _getters.getGroupTermsForGroup
        },
        actions: {
            showTerm: function showTerm(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'Term');
            }
        }
    },
    methods: {
        progress: function progress(assignment) {
            return this.userProgressions.find(function (p) {
                return p.assignment === assignment.id;
            });
        },
        assignmentsForPeriods: function assignmentsForPeriods(groupPeriods, includeOptional) {
            var _this = this;

            return groupPeriods.map(function (id) {
                return _this.$store.state.groups.periods[id];
            }) // map id to period
            .reduce(function (list, p) {
                return list.concat(p.groupAssignments);
            }, []) // flatmap to groupAssignmentsIds
            .map(function (id) {
                return _this.$store.state.groups.assignments[id];
            }) // map id to GroupAssignment
            .filter(function (ga) {
                return !ga.optional || includeOptional;
            }).map(function (ga) {
                return _this.$store.state.assignments.storage[ga.assignment[0]];
            }); // map id to assignment
        }
    },
    computed: {
        isCurrent: function isCurrent() {
            var current = this.getCurrentGroupPeriodForGroup(this.group.id);
            return current != null && current.id === this.groupPeriod.id;
        },
        term: function term() {
            if (this.groupTerm == null) {
                return null;
            }
            return this.$store.state.terms.storage[this.groupTerm.term[0]];
        },
        period: function period() {
            if (this.groupPeriod == null) {
                return null;
            }
            var id = this.groupPeriod.period[0];
            return this.$store.state.periods.storage[id];
        },
        groupTerm: function groupTerm() {
            var _this2 = this;

            if (this.groupPeriod == null) {
                return null;
            }
            var groupTerms = this.getGroupTermsForGroup(this.group.id);
            return groupTerms.find(function (t) {
                return t.groupPeriods.indexOf(_this2.groupPeriod.id) !== -1;
            });
        },
        groupPeriod: function groupPeriod() {
            if (this.$route.params.periodId == null) {
                return this.getCurrentGroupPeriodForGroup(this.group.id);
            }

            return this.$store.state.groups.periods[this.$route.params.periodId];
        },
        previousGroupPeriods: function previousGroupPeriods() {
            if (this.groupPeriod == null) {
                return [];
            }
            // note that groupPeriods must be sorted!
            var periodIndex = this.groupTerm.groupPeriods.indexOf(this.groupPeriod.id);
            return this.groupTerm.groupPeriods.slice(0, periodIndex);
        },

        assignments: function assignments() {
            var _this3 = this;

            return this.period == null ? [] : this.groupPeriod.groupAssignments.map(function (id) {
                return _this3.$store.state.groups.assignments[id];
            }).filter(function (ga) {
                return !ga.optional;
            }).map(function (ga) {
                return _this3.$store.state.assignments.storage[ga.assignment[0]];
            });
        },
        overdueAssignments: function overdueAssignments() {
            var _this4 = this;

            return this.assignmentsForPeriods(this.previousGroupPeriods).filter(function (assignment) {
                // only pick assignments that have not been finished
                var progress = _this4.progress(assignment);
                return progress == null || progress.finished == null;
            });
        },
        retakeAssignments: function retakeAssignments() {
            var _this5 = this;

            return this.assignmentsForPeriods(this.previousGroupPeriods).filter(function (assignment) {
                return (_this5.progress(assignment) || {}).isRetaking;
            });
        },

        userProgressions: function userProgressions() {
            var _this6 = this;

            return this.getProgressForUser(this.user.id).filter(function (p) {
                return p.group === _this6.group.id;
            });
        },

        salutation: function salutation() {
            return this.isTeacher || !this.isCurrent ? this.term == null ? '' : this.term.title : 'Hallo ' + this.user.firstname;
        },
        subheading: function subheading() {
            return this.isTeacher || !this.isCurrent ? this.period == null ? '' : this.period.title : '';
        },
        isTeacher: function isTeacher() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        },
        viewedTermIntro: function viewedTermIntro() {
            return this.$store.state.terms.viewed;
        },
        intro: function intro() {
            return this.period != null ? this.period.intro : 'Er zijn geen nieuwe opdrachten voor jou beschikbaar.';
        },
        shouldShowTermintro: function shouldShowTermintro() {
            if (this.viewedTermIntro || this.groupTerm == null || this.isTeacher || this.loading || !this.isCurrent) {
                return false;
            }

            var startedAssignments = this.assignmentsForPeriods(this.groupTerm.groupPeriods, true).map(this.progress).filter(function (p) {
                return p != null;
            });

            return startedAssignments.length === 0;
        }
    },

    watch: {
        shouldShowTermintro: {
            handler: function handler(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.showTerm();
                }
            },
            immediate: true
        }
    }
};

/***/ }),

/***/ "9cUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9m/f":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("UuCl")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Rb2s"),
  /* template */
  __webpack_require__("Qnuz"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "9mrJ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ACiL")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("pMfq"),
  /* template */
  __webpack_require__("O3kh"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ACiL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AG4v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transformers = __webpack_require__("j0ZK");

exports.default = {
    props: {
        title: {},
        submissions: {},
        showVersions: {
            type: Boolean,
            default: false
        }
    },
    computed: {

        revisions: function revisions() {
            var _this = this;

            var revisions = this.submissions.map(function (s) {
                return {
                    title: 'versie ' + (s.revision + 1),
                    submission: _this.getSubmissionValue(s)
                };
            }).sort((0, _transformers.sorter)('revision'));

            return this.showVersions ? revisions : revisions.slice(-1);
        }

    },
    methods: {

        getSubmissionValue: function getSubmissionValue(submission) {
            if (submission == null) {
                return '';
            }
            return typeof submission.data === 'string' ? submission.data : '[ Werk niet herkend ]';
        }

    }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "AOO4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SidebarHeader = __webpack_require__("o1oS");

var _SidebarHeader2 = _interopRequireDefault(_SidebarHeader);

var _Timeline = __webpack_require__("XYq3");

var _Timeline2 = _interopRequireDefault(_Timeline);

var _transformers = __webpack_require__("j0ZK");

var _scroll = __webpack_require__("KPQb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    components: { SidebarHeader: _SidebarHeader2.default, Timeline: _Timeline2.default },
    props: {
        user: {},
        collectionPrefix: {
            type: String,
            default: ''
        },
        collectionName: {
            type: String,
            default: ''
        },
        collectionLink: {
            default: function _default() {
                return {};
            }
        },
        addLink: {},
        backLink: {},
        backLinkTitle: {
            type: String,
            default: 'Dashboard'
        },
        showOptions: {
            type: Boolean,
            default: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        disableUserMenu: {
            type: Boolean,
            default: false
        },

        isFloating: {
            type: Boolean,
            default: false
        },

        // convenience for Timeline
        items: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        isActive: {
            type: Function,
            default: function _default() {
                return false;
            }
        },
        isCollectionActive: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            offsetTop: 0
        };
    },

    vuex: {
        actions: {
            showDisclaimer: function showDisclaimer(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'legal', { type: 'disclaimer', title: 'Disclaimer' });
            }
        }
    },

    computed: {
        collectionNameExcerpt: function collectionNameExcerpt() {
            return (0, _transformers.excerpt)(this.collectionName, 20);
        },

        currentYear: function currentYear() {
            return new Date().getFullYear();
        }
    },

    directives: {
        scroller: _scroll.vueScrollDirective
    },

    mounted: function mounted() {
        // make sure sidebar top is aligned with parent
        var mainView = document.getElementById('main-view');
        if (mainView) {
            this.offsetTop = mainView.offsetTop;
        }
    }

};

/***/ }),

/***/ "Acpn":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "diligence",
    class: _vm.readonly ? 'diligence--readonly' : 'diligence--editable'
  }, _vm._l((_vm.visibleOptions), function(option) {
    return _c('div', {
      staticClass: "input-group diligence__item",
      class: {
        'diligence__item--active': _vm.diligence === option.value
      }
    }, [(!_vm.readonly) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.diligence),
        expression: "diligence"
      }],
      staticClass: "diligence__radio",
      attrs: {
        "type": "radio",
        "id": option.tag + _vm._uid
      },
      domProps: {
        "value": option.tag,
        "checked": _vm._q(_vm.diligence, option.tag)
      },
      on: {
        "__c": function($event) {
          _vm.diligence = option.tag
        }
      }
    }) : _vm._e(), _c('label', {
      staticClass: "diligence__label",
      attrs: {
        "for": option.tag + _vm._uid
      }
    }, [_c('span', {
      staticClass: "diligence__icon diligence__icon--inline",
      class: _vm.iconClass(option)
    }, [_c('img', {
      staticClass: "inline-icon",
      attrs: {
        "src": _vm.spriteImage,
        "draggable": "false"
      }
    })]), _vm._v("\n            " + _vm._s(option.text) + " "), _c('em', [_vm._v(_vm._s(option.subtext))])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ "AyOA":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "definitions"
  }, [(_vm.definitionTag) ? _c('div', [(!_vm.definition) ? _c('loading') : _vm._e(), (_vm.definition) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.definition.title))]), _c('div', {
    staticClass: "definitions-content",
    domProps: {
      "innerHTML": _vm._s(_vm.definition.content)
    }
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "B1wW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9bh":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "term-page"
  }, [(this.term) ? _c('div', {
    staticClass: "term-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.term.title))]), _c('p', [_vm._v(_vm._s(_vm.term.intro))]), _c('primary-button', {
    on: {
      "clicked": _vm.close
    }
  }, [_vm._v("Verder")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "BA8R":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("UfM8")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8o5J"),
  /* template */
  __webpack_require__("BgA6"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BEXD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__("JOmw");

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Login',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        otherLinks: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            email: '',
            password: '',
            remember: true,
            loading: false,
            errors: [],
            errorFields: [],
            hasInvalidCredentials: false
        };
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {

        if (to.query.account === 'demo') {

            (0, _auth.login)('demo@kiempunt.nl', 'demo').then(function () {
                return next({ name: 'root', replace: true });
            }).catch(function () {
                return next(function (vm) {
                    vm.$warn('Het demo account is op dit moment niet beschikbaar, probeer het later nog eens.');
                });
            });
        } else {
            // if user can authenticate => redirect immediately to dashboard
            (0, _auth.checkAuthentication)().then(function () {
                return next({ name: 'root', replace: true });
            }).catch(function () {
                return next();
            });
        }
    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validateFields()) {

                this.loading = true;

                (0, _auth.login)(this.email, this.password, this.remember).then(function () {
                    return _this.$router.push({ name: 'root' });
                }).catch(function (response) {
                    if (response.status === 401) {
                        _this.invalidCredentials();
                    } else {
                        _this.handleErrorResponse(response, 'Inloggen is mislukt.');
                    }
                    return new Promise(function (resolve) {
                        setTimeout(resolve, 2000);
                    });
                }).then(function () {
                    return _this.loading = false;
                });
            } else {
                this.invalidCredentials();
            }
        },

        validateFields: function validateFields() {
            return this.validateEmail(this.email) && this.validatePasswordLength(this.password);
        },

        invalidCredentials: function invalidCredentials() {
            var _this2 = this;

            this.$warn('Het ingevoerde e-mailadres of wachtwoord is onjuist.', { id: 'validation' });
            this.hasInvalidCredentials = true;
            setTimeout(function () {
                return _this2.hasInvalidCredentials = false;
            }, 1500);
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "BF9z":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('h1', [_vm._v("Klaar!")]), _c('celebration', {
    attrs: {
      "type": _vm.termCelebration
    }
  }), _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group
    }
  }), _c('assignment-feedback', {
    attrs: {
      "assignment": _vm.assignment
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": {
        name: 'assignment.step',
        params: {
          stepIdx: _vm.assignment.steps.length
        }
      }
    }
  }, [_vm._v("Vorige stap")]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ "BOO5":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading || _vm.isLoadingProgress) ? _c('loading') : _c('div', {
    staticClass: "students-overview"
  }, [_c('header', {
    staticClass: "page-header page-header--students"
  }, [_c('a', {
    staticClass: "tag button-timid left button--show-planning print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupSettings(_vm.group)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--settings-dark"
  }), _vm._v(" Planning aanpassen")]), _c('h1', [_vm._v("klas " + _vm._s(_vm.group.name))]), _c('hr')]), _c('div', {
    staticClass: "page-content print-hide"
  }, [_c('term-nav', {
    attrs: {
      "terms": _vm.terms,
      "currentGroupTermId": _vm.currentGroupTerm.id,
      "selectedGroupTermId": _vm.groupTerm.id
    }
  }), (_vm.students.length === 0 && !_vm.group.archived) ? _c('empty-group-message', {
    attrs: {
      "group": _vm.group
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "progress-overview"
  }, [_c('table', {
    staticClass: "table-header-rotated"
  }, [_c('thead', {
    staticClass: "table__header--rotated"
  }, [_c('tr', [_c('th', {
    staticClass: "table__col--first"
  }), _vm._l((_vm.assignmentCols), function(assignment) {
    return _c('th', {
      staticClass: "table__col-header table__col-header--rotated"
    }, [_c('div', {
      staticClass: "table__col-header-wrap"
    }, [_c('router-link', {
      staticClass: "table__col-header-inner table__link tag",
      class: {
        'period-end': assignment.lastInPeriod
      },
      attrs: {
        "to": {
          name: 'assignment.group',
          params: {
            periodId: assignment.periodId,
            assignmentId: assignment.id
          }
        }
      }
    }, [_vm._v(_vm._s(assignment.title))])], 1)])
  })], 2)]), _c('tbody', [_vm._l((_vm.studentProgress), function(student) {
    return _c('tr', {
      staticClass: "table__row"
    }, [_c('th', {
      staticClass: "table__row-header"
    }, [_c('router-link', {
      staticClass: "table__header-inner table__link tag",
      attrs: {
        "to": {
          name: 'students.period',
          params: {
            periodId: _vm.currentGroupPeriod.id,
            studentId: student.id
          }
        }
      }
    }, [_vm._v(_vm._s(student.name))])], 1), _vm._l((_vm.assignmentCols), function(assignment, i) {
      return _c('td', {
        class: {
          'cell--period-end': assignment.lastInPeriod, 'cell--important': student.progressions[i].isImportant
        }
      }, [_c('a', {
        staticClass: "table__cell-wrap",
        class: 'table__cell-wrap--' + student.progressions[i].tag,
        attrs: {
          "href": "#",
          "title": _vm.translation(student.progressions[i].tag)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.viewProgress(student.progressions[i])
          }
        }
      }, [_c('div', {
        staticClass: "progress__icon",
        class: 'progress__icon--' + student.progressions[i].tag
      }, [_c('img', {
        staticClass: "inline-icon",
        attrs: {
          "src": _vm.spriteImage,
          "draggable": "false"
        }
      })]), (student.progressions[i].isRetaking || student.progressions[i].hasNew) ? _c('span', {
        staticClass: "progress__attention-icon print-hide",
        class: {
          'progress__attention-icon--retaking': student.progressions[i].isRetaking,
            'progress__attention-icon--retaking-done': student.progressions[i].isRetakingDone,
        }
      }) : _vm._e()])])
    })], 2)
  }), (_vm.students.length === 0) ? _vm._l((3), function(i) {
    return _c('tr', {
      staticClass: "table__row"
    }, [_c('th', {
      staticClass: "table__row-header"
    }, [_c('span', {
      staticClass: "table__header-inner table__link tag"
    }, [_vm._v("Voorbeeld leerling " + _vm._s(i))])]), _vm._l((_vm.assignmentCols), function(assignment, i) {
      return _c('td', {
        class: {
          'cell--period-end': assignment.lastInPeriod
        }
      }, [_c('div', {
        staticClass: "table__cell-wrap"
      }, [_c('div', {
        staticClass: "progress__icon"
      })])])
    })], 2)
  }) : _vm._e()], 2)])]), (_vm.students.length) ? [_c('a', {
    staticClass: "tag button-timid button--show-aggregate print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAggregate($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--print-dark"
  }), _vm._v(" Voortgang en beoordelingen klas " + _vm._s(_vm.group.name) + " afdrukken "), (_vm.aggregateVisible) ? _c('loading', {
    attrs: {
      "mini": true,
      "inline": true
    }
  }) : _vm._e()], 1), (_vm.aggregateVisible) ? _c('aggregate', {
    staticClass: "aggregate--print-only",
    attrs: {
      "group": _vm.group,
      "students": _vm.students,
      "assignments": _vm.assignments
    },
    on: {
      "load": _vm.printPage
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "BWHz":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("1w05")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iCnv"),
  /* template */
  __webpack_require__("vW+O"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BfIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BgA6":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition-group', {
    staticClass: "notifications",
    attrs: {
      "tag": "div",
      "name": "notification-transition"
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('notification', {
      key: notification.id,
      attrs: {
        "notification": notification
      },
      on: {
        "close-notification": _vm.removeNotification
      }
    })
  }))
},staticRenderFns: []}

/***/ }),

/***/ "CKNE":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Mb7x")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("x20n"),
  /* template */
  __webpack_require__("NC+L"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Ce1c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _stealthMixin = __webpack_require__("KjtG");

var _stealthMixin2 = _interopRequireDefault(_stealthMixin);

var _redirectMixin = __webpack_require__("bSel");

var _redirectMixin2 = _interopRequireDefault(_redirectMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_stealthMixin2.default, _redirectMixin2.default],
    props: ['assignment', 'steps', 'progress'],
    components: { PrimaryButton: _PrimaryButton2.default },
    methods: {

        /**
         * Checks if a step is validated
         * i.e. the user viewed it and filled in all questions/uploads
         *
         * @param  {Step} step
         * @param  {Boolean} checkConfirm=true if this step should be confirmed, use this flag to skip the confirm check. False = skip confirm check
         * @return {Boolean} true if validated, false otherwise
         */
        validateStep: function validateStep(step) {
            var _this = this;

            var checkConfirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            // if the previous step has not been completed, this step cannot be valid
            if (this.progress.step < step.precedence - 1) {
                return false;
            }

            // if the step is frozen it must be validated
            if (this.progress.frozen >= step.precedence) {
                return true;
            }

            // if step should be confirmed and it is not frozen, then it's not validated
            if (step.confirm && checkConfirm && this.progress.frozen < step.precedence) {
                return false;
            }

            // if this step has been completed, this step is valid
            if (this.isStepCompleted(step)) {
                return true;
            }

            // check if all partials are validated
            var partials = step.partials.map(function (id) {
                return _this.$store.state.partials.storage[id];
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = partials[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var p = _step.value;


                    if (p.validated !== true) {
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        },

        isStepCompleted: function isStepCompleted(step) {
            return this.progress.step >= step.precedence;
        }

    }
};

/***/ }),

/***/ "Cfwm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cmgu":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("5OKo")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Gu4V"),
  /* template */
  __webpack_require__("WpLC"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "CzE/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_PERIODS: function ADD_PERIODS(state, periods) {
        (0, _helpers.setObjects)(periods, state.storage, { assignments: [] });
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "D1fQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D2kb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DBjH":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Z6iq")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("GAF/"),
  /* template */
  __webpack_require__("UifB"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "DT6f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_BADGES: function ADD_BADGES(state, badge) {
        (0, _helpers.setObjects)(badge, state.storage, {});
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "DXVi":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading || _vm.term == null) ? _c('loading') : _c('div', {
    staticClass: "page--period"
  }, [_c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v(_vm._s(_vm.salutation) + " "), _c('small', [_vm._v(_vm._s(_vm.subheading))])]), _c('p', [_vm._v(_vm._s(_vm.intro))]), (!_vm.isCurrent && !_vm.isTeacher) ? _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" vraag eerst even aan je docent of je vast aan deze opdrachten mag werken. Ga naar "), _c('router-link', {
    attrs: {
      "to": {
        name: 'period'
      }
    }
  }, [_vm._v("jouw opdrachtenlijst")]), _vm._v(" om de opdrachten van de huidige periode te bekijken.\n        ")], 1) : _vm._e(), _c('hr')]), (_vm.assignments.length) ? _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Welke wil je het eerst maken?")])]) : _vm._e(), _c('transition-group', {
    staticClass: "assignments",
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "progress": _vm.progress(assignment),
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "ignoreProgress": _vm.ignoreProgress,
        "disable": _vm.isDemo && !assignment.demo
      }
    })
  })), (_vm.retakeAssignments.length > 0 && !_vm.ignoreProgress && _vm.isCurrent) ? _c('div', {
    staticClass: "assignments"
  }, [_c('hr'), _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opnieuw inleveren")])]), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.retakeAssignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "disable": _vm.isDemo && !assignment.demo,
        "progress": _vm.progress(assignment)
      }
    })
  }))], 1) : _vm._e(), (_vm.overdueAssignments.length > 0 && !_vm.ignoreProgress && _vm.isCurrent) ? _c('div', {
    staticClass: "assignments"
  }, [_c('hr'), _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Nog niet afgemaakt")])]), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.overdueAssignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "disable": _vm.isDemo && !assignment.demo,
        "progress": _vm.progress(assignment)
      }
    })
  }))], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "DYnL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dt/U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getters = __webpack_require__("olIF");

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'Groups',
    mixins: [_notificationsMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Loading: _Loading2.default },

    data: function data() {
        return {
            loading: false
        };
    },

    vuex: {
        getters: {
            getCurrentGroupPeriodIdForGroup: _getters.getCurrentGroupPeriodIdForGroup,
            groups: function groups(state) {
                return state.users.current.groups.map(function (id) {
                    return state.groups.storage[id];
                }).sort(function (a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
            },

            school: function school(state) {
                return state.users.current.schools.map(function (id) {
                    return state.schools.storage[id];
                })[0];
            }
        },
        actions: {

            showSchoolGroups: function showSchoolGroups(_ref) {
                var dispatch = _ref.dispatch;


                dispatch('SHOW_MODAL', 'schoolGroups');
            },

            fetchGroupsForTeacher: function fetchGroupsForTeacher(_ref2, id) {
                var dispatch = _ref2.dispatch;


                return _resources2.default.getGroupsForTeacher(id).then(function (response) {

                    var result = (0, _helpers.transform)(response.body);
                    var groups = result.groups || [];

                    dispatch('ADD_GROUPS', groups);
                    dispatch('SET_CURRENT_USER_GROUPS', groups.map(function (g) {
                        return g.id;
                    }));

                    return groups;
                }).catch(function (error) {
                    return (0, _helpers.logreject)('Could not fetch groups', error);
                });
            },

            showGroupSettings: function showGroupSettings(_ref3, group) {
                var dispatch = _ref3.dispatch;

                dispatch('SHOW_MODAL', 'GroupSettings', { group: group });
            }

        }
    },

    computed: {

        salutation: function salutation() {
            var d = new Date();
            var h = d.getHours();

            if (h < 12) return 'Goedemorgen';
            if (h < 18) return 'Goedemiddag';
            if (h < 24) return 'Goedenavond';
        },

        isActive: function isActive() {
            return this.school && !this.school.archived;
        }

    },

    methods: {

        isFinished: function isFinished(group) {
            return !group.archived && group.finished;
        },

        archiveAt: function archiveAt(group) {
            var date = (0, _moment2.default)(group.archive_at * 1000);
            return date.format('D MMMM') + ' (' + date.fromNow() + ')';
        }

    },

    created: function created() {
        var _this = this;

        if (this.groups.some(function (g) {
            return g == null;
        })) {

            this.loading = true;

            this.fetchGroupsForTeacher(this.$store.state.users.current.id).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                _analytics2.default.exception('Can\'t load groups', err);
                _this.$error('Kan klassen niet laden.');
            });
        }
    }
};

/***/ }),

/***/ "E64q":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("+98L")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("OU78"),
  /* template */
  __webpack_require__("ekR1"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "EKLQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ELb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteSubmission = exports.flushSyncSubmission = exports.setSubmission = exports.setValidation = exports.storeUserResponse = exports.fetchUser = exports.fetchGroupTerm = exports.fetchAssignment = exports.reset = undefined;

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Resets all modules
 */
// Vuex actions
var reset = exports.reset = function reset(_ref) {
    var dispatch = _ref.dispatch;

    dispatch('RESET_ALL');
};

var fetchAssignment = exports.fetchAssignment = function fetchAssignment(_ref2, id, includeUserProgress) {
    var dispatch = _ref2.dispatch,
        state = _ref2.state;


    var cached = state.assignments.storage[id];

    if (cached !== undefined && cached.loaded === true && includeUserProgress == null) {

        // check not really necessary: does not trigger getters
        if (state.assignments.currentId !== cached.id) {
            dispatch('SET_CURRENT_ASSIGNMENT', cached);
        }

        return Promise.resolve(cached);
    }

    return _resources2.default.getAssignment(id, includeUserProgress).then(function (response) {

        var result = (0, _helpers.transform)(response.body);

        // mark assignments as fully loaded
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = result.assignments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var r = _step.value;

                r.loaded = true;
            }

            // TODO: should check if all resources are received
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        dispatch('ADD_ASSIGNMENTS', result.assignments || []);
        dispatch('ADD_STEPS', result.steps || []);
        dispatch('ADD_PARTIALS', result.partials || []);

        storeProgress({ dispatch: dispatch }, result);

        dispatch('ADD_USERS', result.users || []);

        dispatch('SET_CURRENT_ASSIGNMENT', result.assignments[0]);

        return result.assignments[0];
    }).catch(function (error) {
        return (0, _helpers.logreject)('Could not fetch assignments', error);
    });
};

/**
 * Fetches the term data for the given group term id
 * checks if the given periodId is included in the response
 * If not => fetch the term data for the given periodId as well
 *
 * @param  {String} id                  Id of the requested GroupTerm
 * @param  {String} includeUserProgress user id of progress to include in response
 * @param  {String} GroupPeriodId            GroupPeriod that must be included in the data
 * @return {Promise}                    Retrieved term objects
 */
var fetchGroupTerm = exports.fetchGroupTerm = function fetchGroupTerm(_ref3, id, includeUserProgress, groupPeriodId) {
    var dispatch = _ref3.dispatch,
        state = _ref3.state;


    var storeResources = function storeResources(response) {

        var result = (0, _helpers.transform)(response.body);

        dispatch('ADD_GROUP_TERMS', result.groupterms || []);
        dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
        dispatch('ADD_GROUP_ASSIGNMENTS', result.groupassignments || []);

        dispatch('ADD_TERMS', result.terms || []);
        dispatch('ADD_PERIODS', result.periods || []);

        dispatch('ADD_ASSIGNMENTS', result.assignments || []);
        dispatch('ADD_STEPS', result.steps || []);

        if (includeUserProgress != null) {
            storeProgress({ dispatch: dispatch }, result);
        }

        return result;
    };

    return _resources2.default.getTerm(id, includeUserProgress).then(storeResources).then(function (result) {

        // check if we loaded the period as well, otherwise fetch the corresponding term
        var loadedGroupPeriods = result.groupperiods.map(function (p) {
            return p.id;
        });

        // TODO: change to separate fetchGroupPeriod ?
        if (groupPeriodId != null && loadedGroupPeriods.indexOf(groupPeriodId) === -1) {
            return _resources2.default.getTermForPeriod(groupPeriodId, includeUserProgress).then(storeResources);
        }

        return result;
    }).catch(function (error) {
        return (0, _helpers.logreject)('Could not fetch term', error);
    });
};

var fetchUser = exports.fetchUser = function fetchUser(_ref4, id, includeEssentials, beforeFetchHook) {
    var dispatch = _ref4.dispatch,
        state = _ref4.state;


    if (id == null) {
        return Promise.reject('No user id provided');
    }

    // first check if the user is already fetched
    var cached = state.users.storage[id];
    if (cached != null) {
        return Promise.resolve(cached);
    }

    if (beforeFetchHook) {
        beforeFetchHook();
    }

    return _resources2.default.getUser(id, includeEssentials).then(function (response) {
        return storeUserResponse({ dispatch: dispatch }, response, includeEssentials);
    }).catch(function (error) {
        return (0, _helpers.logreject)('Could not fetch user', error);
    });
};

var storeUserResponse = exports.storeUserResponse = function storeUserResponse(_ref5, response, includedEssentials) {
    var dispatch = _ref5.dispatch;


    var result = (0, _helpers.transform)(response.body);
    var user = result.users[0];
    dispatch('SET_CURRENT_USER', user);
    dispatch('ADD_USERS', result.users || []);

    if (includedEssentials) {
        dispatch('ADD_SCHOOLS', result.schools || []);

        dispatch('ADD_GROUPS', result.groups || []);
        dispatch('ADD_GROUP_TERMS', result.groupterms || []);
        dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
        dispatch('ADD_GROUP_ASSIGNMENTS', result.groupassignments || []);

        dispatch('ADD_TERMS', result.terms || []);
        dispatch('ADD_PERIODS', result.periods || []);

        // below only for student
        dispatch('ADD_ASSIGNMENTS', result.assignments || []);
        dispatch('ADD_STEPS', result.steps || []);

        storeProgress({ dispatch: dispatch }, result);
    }

    return user;
};

var storeProgress = function storeProgress(_ref6, result) {
    var dispatch = _ref6.dispatch;


    dispatch('ADD_PROGRESS', result.progress || []);
    dispatch('ADD_SUBMISSIONS', result.submissions || []);

    dispatch('ADD_FEEDBACK', result.feedback || []);
    dispatch('ADD_REMARKS', result.remarks || []);
    dispatch('ADD_COMPLIMENTS', result.compliments || []);
    dispatch('ADD_DILIGENCE', result.diligence || []);
    dispatch('ADD_BADGES', result.badges || []);
};

var setValidation = exports.setValidation = function setValidation(_ref7, partialId, validated) {
    var dispatch = _ref7.dispatch;

    dispatch('VALIDATE_PARTIAL', partialId, validated);
};

/**
 * Stores data to vuex, then calls debounced sync to API
 *
 * @param {Vuex}
 * @param {Object} partial
 * @param {Object} progress
 * @param {Object} data     submission data
 */
var setSubmission = exports.setSubmission = function setSubmission(_ref8, partial, progress, revision, data) {
    var dispatch = _ref8.dispatch,
        state = _ref8.state;


    var oldVal = getExistingSubmission({ state: state }, partial, progress, revision);

    if (oldVal == null) {
        addTempSubmission({ dispatch: dispatch }, partial, progress, revision, data);
    } else {
        dispatch('UPDATE_SUBMISSION', oldVal.id, data);
    }

    return syncSubmission({ dispatch: dispatch, state: state }, partial, progress, revision, data);
};

var syncSubmission = (0, _helpers.debounceSyncMem)(function (_ref9, partial, progress, revision, data) {
    var dispatch = _ref9.dispatch,
        state = _ref9.state;


    var oldVal = getExistingSubmission({ state: state }, partial, progress, revision);

    if (oldVal == null || oldVal._temp) {

        return _resources2.default.addSubmission(data, partial.id).then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            var newSubmission = result.submissions[0];

            // might be updated in the mean time, oldVal is reactive
            newSubmission.data = oldVal.data;

            dispatch('SET_SUBMISSION', newSubmission);
            dispatch('SWAP_SUBMISSION_ID', partial.id, oldVal.id, newSubmission.id);
            dispatch('REMOVE_SUBMISSION', oldVal.id);

            if (partial.primary) {
                dispatch('ADD_PRIMARY_SUBMISSION_TO_PROGRESS', progress.id, newSubmission.id);
                dispatch('REMOVE_PRIMARY_SUBMISSION_FROM_PROGRESS', progress.id, oldVal.id);
            }
        });
    }

    return _resources2.default.patchSubmission(oldVal).then(function (response) {
        return (0, _helpers.transform)(response.body);
    }).then(function (result) {
        var newSubmission = result.submissions[0];

        // might be updated in the mean time, oldVal is reactive
        newSubmission.data = oldVal.data;

        dispatch('SET_SUBMISSION', newSubmission);
    });
}, function (_, partial) {
    return partial.id;
} /*resolver*/, 6000 /*delay*/, { maxWait: 60000 });

/**
 * Directly flush submission for given partial
 * If flush fails, retry last sync and immediately flush again
 *
 * @param  {Object} partial
 * @return {Promise}
 */
var flushSyncSubmission = exports.flushSyncSubmission = function flushSyncSubmission(partial) {
    return syncSubmission.flush(null, partial).catch(function () {
        syncSubmission.retry(null, partial);
        return syncSubmission.flush(null, partial);
    });
};

var getExistingSubmission = function getExistingSubmission(_ref10, partial, progress, revision) {
    var state = _ref10.state;

    return partial.submissions.map(function (id) {
        return state.submissions.storage[id];
    }).find(function (s) {
        return s.progress == progress.id && s.revision === revision;
    });
};

var addTempSubmission = function addTempSubmission(_ref11, partial, progress, revision, data) {
    var dispatch = _ref11.dispatch;


    // create temporary submission with fake id
    var submission = {
        id: (0, _helpers.guid)(),
        data: data,
        progress: progress.id,
        partial: partial.id,
        isFrozen: false,
        revision: revision,
        _temp: true
    };

    dispatch('SET_SUBMISSION', submission);
    dispatch('ADD_SUBMISSION_TO_PARTIAL', partial.id, submission.id);

    if (partial.primary) {
        dispatch('ADD_PRIMARY_SUBMISSION_TO_PROGRESS', progress.id, submission.id);
    }

    return submission;
};

var deleteSubmission = exports.deleteSubmission = function deleteSubmission(_ref12, partial, submissionId, progress) {
    var dispatch = _ref12.dispatch;


    return _resources2.default.deleteSubmission(submissionId).then(function (response) {

        dispatch('REMOVE_SUBMISSION_FROM_PARTIAL', partial.id, submissionId);
        dispatch('REMOVE_SUBMISSION', submissionId);
        if (partial.primary) {
            dispatch('REMOVE_PRIMARY_SUBMISSION_FROM_PROGRESS', progress.id, submissionId);
        }

        return response;
    }, function (error) {
        return (0, _helpers.logreject)('Could not delete submission', error);
    });
};

/***/ }),

/***/ "EP3o":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("XcyR")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("bEj+"),
  /* template */
  __webpack_require__("1im0"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "EUj2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Collection = __webpack_require__("YoMJ");

var _Collection2 = _interopRequireDefault(_Collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Collection: _Collection2.default },
    props: {
        collections: {
            type: Array,
            default: []
        },
        initialExpanded: {},
        isLoading: {
            type: Boolean,
            default: false
        },
        hideCollapsed: {
            type: Boolean,
            default: true
        }
    },

    data: function data() {
        return {
            expandedCollection: null,
            isExpanding: false
        };
    },

    computed: {
        visibleCollections: function visibleCollections() {
            var _this = this;

            if (this.expandedCollection != null && this.hideCollapsed) {
                return this.collections.filter(function (c) {
                    return c.id == _this.expandedCollection;
                });
            }
            return this.collections;
        }
    },

    methods: {
        expand: function expand(collection) {
            if (collection.link != null) {
                this.$router.push(collection.link);
                if (collection.isExpandable === false) {
                    return;
                }
            }
            this.expandedCollection = collection.id;
            if (this.hideCollapsed && this.collections.length > 1) {
                this.isExpanding = true;
            }
            this.$emit('expanded', collection);
        },
        collapse: function collapse() {
            this.expandedCollection = null;
        },

        expandingEnded: function expandingEnded() {
            this.isExpanding = false;
        },

        isActive: function isActive(collection) {
            return collection.isExpandable === false && collection.link != null && this.$route.name === collection.link.name;
        }
    },

    watch: {
        initialExpanded: {
            handler: function handler(newVal) {
                this.expandedCollection = newVal;
            },
            immediate: true
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "EokX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EzKL":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_c('header', {
    staticClass: "page-header settings-header"
  }, [(!_vm.inModal) ? _c('router-link', {
    staticClass: "back tag button-timid left",
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("x Sluiten")]) : _vm._e(), _c('h1', [_vm._v("Instellingen")]), _c('p', [_vm._v("Hier kun je jouw gegevens aanpassen.")])], 1), _c('div', {
    staticClass: "settings-links tag"
  }, [_c('a', {
    class: {
      'is-active': _vm.personalActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPersonal($event)
      }
    }
  }, [_vm._v("Naam")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.emailActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewEmail($event)
      }
    }
  }, [_vm._v("E-mail")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.passwordActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPassword($event)
      }
    }
  }, [_vm._v("Wachtwoord")]), (_vm.isGroupAvailable) ? [_vm._v("| "), _c('a', {
    class: {
      'is-active': _vm.groupActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewGroup($event)
      }
    }
  }, [_vm._v("Klas")])] : _vm._e()], 2), (!_vm.inModal) ? _c('router-view', {
    staticClass: "page-content",
    attrs: {
      "user": _vm.user
    }
  }) : _c(_vm.view, {
    tag: "component",
    staticClass: "settings-modal-content",
    attrs: {
      "user": _vm.user
    },
    on: {
      "done": _vm.done
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "EzjG":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ZAX4")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("XRG2"),
  /* template */
  __webpack_require__("iAAw"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "F/CF":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(!this.minimal) ? _c('h1', [_c('small', [_vm._v("Van:")]), _vm._v(" " + _vm._s(_vm.username(_vm.teacher)))]) : _vm._e(), (_vm.compliments.length) ? _c('div', {
    staticClass: "feedback-compliments"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Dit heb je goed gedaan")]), _c('ul', _vm._l((_vm.compliments), function(compliment) {
    return _c('li', [_vm._v(_vm._s(compliment.content))])
  }))], 1) : _vm._e(), (_vm.remarks.length) ? _c('div', {
    staticClass: "feedback-remarks"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Besteed hier nog wat aandacht aan")]), _c('ul', _vm._l((_vm.remarks), function(remark) {
    return _c('li', [_vm._v(_vm._s(remark.content))])
  }))], 1) : _vm._e(), (_vm.feedback.content) ? _c('div', {
    staticClass: "feedback-comments"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Opmerkingen")]), _c('p', {
    staticClass: "preformatted"
  }, [_vm._v(_vm._s(_vm.feedback.content))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "FBjV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Sidebar = __webpack_require__("cHIS");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Accordion = __webpack_require__("sPnI");

var _Accordion2 = _interopRequireDefault(_Accordion);

var _Timeline = __webpack_require__("XYq3");

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Assignment = __webpack_require__("QbGP");

var _Assignment2 = _interopRequireDefault(_Assignment);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _getters = __webpack_require__("olIF");

var _actions = __webpack_require__("ELb+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    mixins: [_notificationsMixin2.default],

    components: { Sidebar: _Sidebar2.default, Accordion: _Accordion2.default, Timeline: _Timeline2.default, Assignment: _Assignment2.default },

    props: {
        user: {},
        group: {},
        loading: {
            type: Boolean,
            default: false
        },
        hideUnfinished: {
            type: Boolean,
            default: false
        },
        isInspecting: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            isLoadingGroupTerm: false,
            expandedGroupTerm: null
        };
    },

    vuex: {
        getters: {
            getGroupTermsForGroup: _getters.getGroupTermsForGroup,
            getProgressForUserAndGroupTerm: _getters.getProgressForUserAndGroupTerm
        },
        actions: {
            fetchGroupTerm: _actions.fetchGroupTerm
        }
    },

    computed: {

        groupTerms: function groupTerms() {
            var _this = this;

            var overview = {
                id: -1,
                title: 'Overzicht',
                isFirst: false,
                isExpandable: false,
                link: { name: 'student.overview' }
            };

            var terms = this.getGroupTermsForGroup(this.group.id).map(function (gt, index) {
                var term = _this.$store.state.terms.storage[gt.term[0]];
                return {
                    id: gt.id,
                    title: index + 1 + '. ' + term.title,
                    isFirst: index === 0,
                    link: { name: _this.isInspecting ? 'students.period' : 'student.period', params: { sidebar: true } }
                };
            });

            return this.isInspecting ? terms : [overview].concat(terms);
        },

        progressions: function progressions() {
            if (this.expandedGroupTerm == null || this.expandedGroupTerm === -1) {
                return [];
            }

            return this.getProgressForUserAndGroupTerm(this.user.id, this.expandedGroupTerm, this.group.id).filter(this.isProgressVisible).sort(function (a, b) {
                // note that this is sorted in reverse, newest first
                if (a.started > b.started) {
                    return -1;
                }
                if (a.started < b.started) {
                    return 1;
                }
                return 0;
            });
        },

        currentGroupTermId: function currentGroupTermId() {
            return this.$route.name === 'student.overview' ? null : this.group.currentGroupTerm[0];
        }

    },

    methods: {

        assignmentForProgress: function assignmentForProgress(progress) {
            return this.$store.state.assignments.storage[progress.assignment];
        },

        viewAssignment: function viewAssignment(progress) {
            this.$router.push({ name: 'assignment', params: { assignmentId: this.assignmentForProgress(progress).id } });
        },

        isAssignmentActive: function isAssignmentActive(progress) {
            return progress.assignment === this.$route.params.assignmentId;
        },

        isProgressVisible: function isProgressVisible(progress) {
            return !(progress.finished == null && this.hideUnfinished);
        },

        loadGroupTerm: function loadGroupTerm(id) {
            var _this2 = this;

            this.isLoadingGroupTerm = true;

            var includeProgress = this.user == null ? null : this.user.id;

            this.fetchGroupTerm(id, includeProgress).catch(function (err) {
                _analytics2.default.exception('Can\'t load term', err);
                _this2.$error('Kan periode niet laden.');
            }).then(function () {
                return _this2.isLoadingGroupTerm = false;
            });
        },

        setExpandedGroupTerm: function setExpandedGroupTerm() {
            var _this3 = this;

            var route = this.$route;

            if (route.params.sidebar === true) {
                // internally generated, so expecting an `expanded` event from accordion
                return;
            }

            if (route.name === 'student.overview') {
                this.expandedGroupTerm = null;
                return;
            }

            if (route.params.periodId != null) {
                var gt = this.group.groupTerms.map(function (id) {
                    return _this3.$store.state.groups.terms[id];
                }).find(function (gt) {
                    return gt.groupPeriods.indexOf(route.params.periodId) !== -1;
                });

                if (gt != null) {
                    this.expandedGroupTerm = gt.id;
                    return;
                }
            }

            // note that groupPeriods don't contain groupAssignment info on init
            // so deeplinking to an assignment will expand currentGroupTerm instead
            if (route.params.assignmentId != null) {
                var _gt = this.group.groupTerms.map(function (id) {
                    return _this3.$store.state.groups.terms[id];
                }).find(function (gt) {
                    return gt.groupPeriods.map(function (id) {
                        return _this3.$store.state.groups.periods[id];
                    }).find(function (gp) {
                        return gp.groupAssignments.indexOf(route.params.assignmentId) !== -1;
                    });
                });

                if (_gt != null) {
                    this.expandedGroupTerm = _gt.id;
                    return;
                }
            }

            // fallback current term
            if (this.expandedGroupTerm == null || route.name === 'student.period') {
                this.expandedGroupTerm = this.currentGroupTermId;
            }
        }

    },

    watch: {
        expandedGroupTerm: {
            handler: function handler(id, previous) {
                // teacher loads first data in GroupManager,
                // if switching to different id load here
                if (id != null && (previous != null || !this.isInspecting)) {
                    this.loadGroupTerm(id);
                }
            },
            immediate: true
        },

        group: function group() {
            // when user changes group
            this.setExpandedGroupTerm();
        },

        '$route': {
            handler: function handler() {
                this.setExpandedGroupTerm();
            },
            immediate: true
        }
    }

};

/***/ }),

/***/ "FU/g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    props: ['assignment'],
    data: function data() {
        return {
            remarks: undefined,
            questions: [{
                name: 'enjoyment',
                options: [{
                    tag: 'fun',
                    text: 'Leuk',
                    value: 10
                }, {
                    tag: 'ok',
                    text: 'Oke',
                    value: 0
                }, {
                    tag: 'stupid',
                    text: 'Stom',
                    value: -10
                }],
                chosen: null
            }, {
                name: 'effort',
                options: [{
                    tag: 'effortless',
                    text: 'Weinig werk',
                    value: 10
                }, {
                    tag: 'enough',
                    text: 'Genoeg',
                    value: 0
                }, {
                    tag: 'demanding',
                    text: 'Veel werk',
                    value: -10
                }],
                chosen: null
            }, {
                name: 'difficulty',
                options: [{
                    tag: 'easy',
                    text: 'Makkelijk',
                    value: 10
                }, {
                    tag: 'normal',
                    text: 'Normaal',
                    value: 0
                }, {
                    tag: 'hard',
                    text: 'Moeilijk',
                    value: -10
                }],
                chosen: null
            }, {
                name: 'clarity',
                options: [{
                    tag: 'clear',
                    text: 'Duidelijk',
                    value: 10
                }, {
                    tag: 'unclear',
                    text: 'Onduidelijk',
                    value: -10
                }],
                chosen: null
            }]
        };
    },
    methods: {
        saveFeedback: function saveFeedback() {
            var feedback = this.questions.reduce(function (sum, el) {
                sum[el.name] = el.chosen;
                return sum;
            }, {});
            feedback.remarks = this.remarks;
            _resources2.default.giveFeedback(this.assignment.id, feedback);
        },
        iconClass: function iconClass(option, question) {

            var cls = 'icon-' + option.tag;
            if (question.chosen === option.value) {
                cls += ' active';
            }

            return cls;
        }
    },
    created: function created() {
        this.debouncedFeedbackSave = (0, _helpers.debounceSync)(this.saveFeedback, 6000, { maxWait: 60000 });
        this.$watch('questions', this.debouncedFeedbackSave, { deep: true });
        this.$watch('remarks', this.debouncedFeedbackSave);
    },
    beforeDestroy: function beforeDestroy() {
        this.debouncedFeedbackSave.flush();
    }
};

/***/ }),

/***/ "Fnp/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FzPO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _helpers = __webpack_require__("x3kM");

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupSettingsGeneral',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        group: {
            required: false },
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        },
        isCreated: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            new_name: null,
            new_level: null,
            availableLevels: [],
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    vuex: {
        actions: {
            createGroup: function createGroup(_ref, school, name, level) {
                var dispatch = _ref.dispatch;

                return _resources2.default.addGroup(school.id, name, level).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_TERMS', result.terms || []);
                    dispatch('ADD_PERIODS', result.periods || []);
                    dispatch('ADD_GROUP_TERMS', result.groupterms || []);
                    dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
                    dispatch('ADD_GROUPS', result.groups || []);
                    dispatch('APPEND_GROUP_TO_SCHOOL', result.groups[0], school.id);
                    return result.groups[0];
                });
            },
            addGroupToTeacher: function addGroupToTeacher(_ref2, teacherId, groupId) {
                var dispatch = _ref2.dispatch;

                return _resources2.default.addGroupToTeacher(teacherId, groupId).then(function (response) {
                    var result = (0, _helpers.transform)(response.body);
                    var groups = result.groups || [];
                    dispatch('SET_CURRENT_USER_GROUPS', groups.map(function (g) {
                        return g.id;
                    }));

                    return groups;
                });
            },
            removeGroupFromTeacher: function removeGroupFromTeacher(_ref3, teacherId, groupId) {
                var dispatch = _ref3.dispatch;

                return _resources2.default.removeGroupFromTeacher(teacherId, groupId).then(function (response) {
                    var result = (0, _helpers.transform)(response.body);
                    var groups = result.groups || [];
                    dispatch('SET_CURRENT_USER_GROUPS', groups.map(function (g) {
                        return g.id;
                    }));

                    return groups;
                });
            },
            updateGroup: function updateGroup(_ref4, group, name) {
                var dispatch = _ref4.dispatch;

                return _resources2.default.patchGroup(group.id, { name: name }).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_GROUPS', result.groups || []);
                    return result.groups || [];
                });
            }
        }
    },
    computed: {

        name: {
            get: function get() {
                if (this.new_name != null) {
                    return this.new_name;
                }
                return this.group == null ? null : this.group.name;
            },
            set: function set(value) {
                this.new_name = value;
                this.$emit('changed');
            }
        },
        level: {
            get: function get() {
                if (this.new_level != null) {
                    return this.new_level;
                }
                return this.group == null ? null : this.group.level;
            },
            set: function set(value) {
                if (value != this.level) {
                    this.new_level = value;
                    this.$emit('changed');
                }
            }
        }
    },
    methods: {
        submit: function submit(e) {
            e.preventDefault();
            this.save().catch(function () {});
        },
        save: function save() {
            var _this = this;

            if (!this.validate()) {
                return Promise.reject();
            }

            if (this.isDemo) {
                this.$demoSuccessNotification();
                this.$emit('saved');
                return Promise.resolve();
            }

            this.loading = true;

            if (this.isCreating && !this.isCreated) {

                var p = this.createGroup(this.school, this.name, this.level).then(function (group) {
                    return _this.addGroupToTeacher(_this.$store.state.users.current.id, group.id).then(function () {
                        return _this.$emit('saved', group);
                    });
                }).catch(function (response) {
                    _this.handleErrorResponse(response, 'Klas aanmaken is mislukt');
                    return Promise.reject(response);
                });

                // finally
                p.catch(function () {}).then(function () {
                    return _this.loading = false;
                });
                return p;
            } else {

                var _p = this.updateGroup(this.group, this.name).then(function () {
                    return _this.$emit('saved');
                }).then(function () {
                    return _this.$success('De instellingen van de klas zijn aangepast');
                }).catch(function (response) {
                    _this.handleErrorResponse(response, 'Klas aanpassen is mislukt');
                    return Promise.reject(response);
                });

                // finally
                _p.catch(function () {}).then(function () {
                    return _this.loading = false;
                });
                return _p;
            }
        },
        validateFields: function validateFields() {
            this.validateGroupName(this.name);
            this.validateLevel(this.level);
        },

        validateGroupName: function validateGroupName(name) {
            if (name == null || name.length < 1) {
                this.addError('name', 'De klasnaam is niet ingevuld');
                return false;
            }

            return true;
        },
        validateLevel: function validateLevel(level) {
            if (this.availableLevels.map(function (g) {
                return g.id;
            }).indexOf(level) === -1) {
                this.addError('level', 'Het niveau is niet correct ingevuld');
                return false;
            }

            return true;
        },

        detachGroup: function detachGroup() {
            var _this2 = this;

            this.$alert('Weet je zeker dat je klas ' + this.group.name + ' wilt verwijderen van jouw overzicht?', [{ name: 'Annuleren' }, { name: 'Verwijderen', danger: true, action: function action() {
                    if (_this2.isDemo) {
                        _this2.$demoSuccessNotification();
                        return;
                    }

                    _this2.removeGroupFromTeacher(_this2.$store.state.users.current.id, _this2.group.id).then(function () {
                        _this2.$emit('saved');
                        _this2.$emit('done');
                    });
                } }]);
        }

    },

    created: function created() {
        var _this3 = this;

        var request = this.isCreating ? _resources2.default.getLevelsForSchool(this.school.id) : _resources2.default.getLevelsForGroup(this.group.id);

        request.then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            var levels = result.levels || [];
            var years = result.years || [];
            _this3.availableLevels = levels.map(function (l) {
                l.year = years.find(function (y) {
                    return y.id == l.year[0];
                }).name;
                return l;
            });
        });
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "G1JX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6Uf":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--sidebar"
  }, [_c('achievement'), _c('sidebar-workspace', {
    attrs: {
      "user": _vm.loggedInUser,
      "group": _vm.currentGroup,
      "loadingUserProgress": false
    }
  }), _c('div', {
    staticClass: "page-wrap"
  }, [_c('transition', {
    attrs: {
      "name": "view-transition",
      "mode": "out-in"
    },
    on: {
      "after-leave": _vm.afterPageViewLeave
    }
  }, [_c('router-view', {
    key: _vm.viewKey,
    staticClass: "page-view",
    attrs: {
      "loading": false,
      "user": _vm.loggedInUser,
      "group": _vm.currentGroup
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "GAF/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    props: {
        title: {},
        submissions: {},
        mini: {
            type: Boolean,
            default: false
        },
        showVersions: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        revisions: function revisions() {

            return this.submissions.reduce(function (revs, sub) {

                if (revs[sub.revision] == null) {
                    revs[sub.revision] = { title: 'versie ' + (sub.revision + 1), submissions: [] };
                }

                revs[sub.revision].submissions.push(sub);
                return revs;
            }, []).filter(function (r) {
                return r != null;
            });
        }
    },

    vuex: {
        actions: {
            showImage: function showImage(_ref, image) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_IMAGE', image);
                dispatch('SHOW_MODAL', 'ImageContainer');
            }
        }
    }
};

/***/ }),

/***/ "GB29":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Primary-Button',
    components: { Loading: _Loading2.default },
    props: {
        link: {
            default: function _default() {
                return { path: '#' };
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            default: false
        }
    },
    computed: {
        route: function route() {
            return this.$router.match(this.link, this.$route);
        }
    },
    methods: {
        clicked: function clicked(e) {
            var _this = this;

            if (this.disabled || this.loading) {
                e.preventDefault();
                e.stopPropagation();
            } else {
                // captures link, such that it does not change during event
                var link = this.link;
                var next = function next() {
                    return _this.$router.push(link);
                };

                // allow parent to call next() async, must preventDefault on e
                // else next() is called here
                this.$emit('clicked', e, next);
                if (!e.defaultPrevented) {
                    e.preventDefault();
                    next();
                }
            }
        }
    }

}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "GMyW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--sidebar"
  }, [_c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }, [_c('p', {
    staticClass: "sidebar__empty small"
  }, [_vm._v("\n        Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan.\n      ")])]), _c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "page-view"
  }, [_c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v("Hallo " + _vm._s(_vm.user.firstname))]), _c('p', [_vm._v("Welkom bij Kiempunt! De komende tijd krijg je hier verschillende opdrachten voor het vak beeldende vorming te zien. Maar voor het zover is vul je eerst je klascode in, zodat je samen met je klasgenootjes de opdrachten kunt maken.")]), _c('hr')]), _c('div', {
    staticClass: "page-content"
  }, [_vm._m(0), _c('group', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _c('hr', {
    staticClass: "flipped"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Aanmelden bij jouw klas")])])
}]}

/***/ }),

/***/ "GR5N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.retry = retry;

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Retries the given request
*
* @param request
* @return Promise
*/
function retry(request) {
    if (request == null) {
        return;
    }

    var method = request.method.toLowerCase();
    var opts = {
        retry: (request.retry || 10) - 1, // counts down
        params: request.params
    };

    console.log('RETRY', request.url, request.body, opts);

    if (['post', 'put', 'patch'].includes(method)) {
        return _vue2.default.http[method](request.url, request.body, opts);
    }

    return _vue2.default.http[method](request.url, opts);
}

/***/ }),

/***/ "GZmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ge9X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {},
        terms: {},
        periods: {},
        assignments: {}
    };
};

var mutations = {
    ADD_GROUPS: function ADD_GROUPS(state, groups) {
        (0, _helpers.setObjects)(groups, state.storage, { students: [], groupTerms: [] });
    },
    SET_STUDENTS_FOR_GROUP: function SET_STUDENTS_FOR_GROUP(state, students, groupId) {
        state.storage[groupId].students = students;
    },
    SET_GROUP_TERMS_FOR_GROUP: function SET_GROUP_TERMS_FOR_GROUP(state, groupId, groupTerms) {
        state.storage[groupId].groupTerms = groupTerms.map(function (t) {
            return t.id;
        });
    },
    ADD_GROUP_TERMS: function ADD_GROUP_TERMS(state, groupTerms) {
        (0, _helpers.setObjects)(groupTerms, state.terms, { groupPeriods: [] });
    },
    ADD_GROUP_PERIODS: function ADD_GROUP_PERIODS(state, groupPeriods) {
        (0, _helpers.setObjects)(groupPeriods, state.periods, { assignments: [], groupAssignments: [] });
    },
    ADD_GROUP_ASSIGNMENTS: function ADD_GROUP_ASSIGNMENTS(state, groupAssignments) {
        (0, _helpers.setObjects)(groupAssignments, state.assignments);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "Gl2H":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("vWFZ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("+gMc"),
  /* template */
  __webpack_require__("Mq8A"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Gtwz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gu4V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _auth = __webpack_require__("JOmw");

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'ResetPassword',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: [],
    data: function data() {
        return {
            email: '',
            password: '',
            passwordConfirmation: '',
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    computed: {
        token: function token() {
            return this.$route.params.resetToken;
        }
    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate()) {

                this.loading = true;

                _resources2.default.resetPassword(this.token, this.email, this.password, this.passwordConfirmation).then(function () {
                    return (0, _auth.login)(_this.email, _this.password).then(function () {
                        _this.$success('Je wachtwoord is aangepast.', { id: 'validation' });
                        _this.$router.push({ name: 'root' });
                    });
                }).catch(function (response) {
                    return _this.handleErrorResponse(response, 'Wachtwoord reset is mislukt.');
                }).then(function () {
                    return _this.loading = false;
                });
            }
        },
        validateFields: function validateFields() {
            this.validateEmail(this.email);
            this.validatePasswordLength(this.password);
            this.validatePasswordEqual(this.password, this.passwordConfirmation);
        }

    }

};

/***/ }),

/***/ "GuYm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        current: null, /*{
                       firstname: 'Floor',
                       middlename: 'van',
                       lastname: 'Steeg',
                       }*/
        storage: {}
    };
};

var mutations = {
    SET_CURRENT_USER: function SET_CURRENT_USER(state, user) {
        (0, _helpers.setObjects)([user], state.storage, { groups: [] }); // makes sure properties are merged
        // TODO: replace with just id, then let getter resolve user object
        state.current = state.storage[user.id];
    },
    SET_CURRENT_USER_GROUPS: function SET_CURRENT_USER_GROUPS(state, groups) {
        state.current.groups = groups;
    },
    ADD_USERS: function ADD_USERS(state, users) {
        (0, _helpers.setObjects)(users, state.storage, { groups: [] });
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "HBXz":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("pXuu")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("N2JW"),
  /* template */
  __webpack_require__("B9bh"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "HDu5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

exports.default = {
    props: {
        partial: {},
        readonly: {
            type: Boolean,
            default: false
        }
    },
    vuex: {
        actions: {
            setValidation: _actions.setValidation
        }
    },

    created: function created() {
        if (!this.readonly) {
            this.setValidation(this.partial.id, true);
        }
    }
};

/***/ }),

/***/ "HIb7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hbgz":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("aDNW")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("zm7V"),
  /* template */
  __webpack_require__("VUOn"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Hg2t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Group = __webpack_require__("E64q");

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupArchived',
    props: {
        inModal: {
            type: Boolean,
            default: false
        },
        user: {}
    },
    components: { Group: _Group2.default },

    computed: {},

    methods: {

        done: function done() {
            this.$emit('close');
        }

    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "I430":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SidebarTeacher = __webpack_require__("h2O9");

var _SidebarTeacher2 = _interopRequireDefault(_SidebarTeacher);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _actions = __webpack_require__("ELb+");

var _getters = __webpack_require__("olIF");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _auth = __webpack_require__("JOmw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupManager',
    components: { SidebarTeacher: _SidebarTeacher2.default, Loading: _Loading2.default },
    mixins: [_notificationsMixin2.default],

    data: function data() {
        return {
            isLoadingGroupData: true,
            isLoadingUserProgress: false
        };
    },

    vuex: {
        getters: {
            getGroupIdForCurrentUser: _getters.getGroupIdForCurrentUser,
            getGroup: _getters.getGroup,
            getCurrentGroupTermForGroup: _getters.getCurrentGroupTermForGroup
        },
        actions: {
            fetchGroup: function fetchGroup(_ref, id) {
                var dispatch = _ref.dispatch;

                return _resources2.default.getGroup(id).then(function (response) {

                    var result = (0, _helpers.transform)(response.body);
                    dispatch('ADD_TERMS', result.terms || []);
                    dispatch('ADD_PERIODS', result.periods || []);
                    dispatch('ADD_GROUPS', result.groups || []);
                    dispatch('ADD_GROUP_TERMS', result.groupterms || []);
                    dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
                }).catch(function (error) {
                    return (0, _helpers.logreject)('Could not fetch students', error);
                });
            },
            fetchGroupTerm: _actions.fetchGroupTerm,
            fetchStudentsForGroup: function fetchStudentsForGroup(_ref2, id) {
                var dispatch = _ref2.dispatch;


                return _resources2.default.getStudentsForGroup(id).then(function (response) {

                    var result = (0, _helpers.transform)(response.body);
                    var students = result.users || [];

                    dispatch('ADD_USERS', students);
                    dispatch('SET_STUDENTS_FOR_GROUP', students.map(function (s) {
                        return s.id;
                    }), id);

                    return students;
                }).catch(function (error) {
                    return (0, _helpers.logreject)('Could not fetch students', error);
                });
            },
            showGroupArchivedModal: function showGroupArchivedModal(_ref3, user) {
                var dispatch = _ref3.dispatch;

                dispatch('SHOW_MODAL', 'GroupArchived', { user: user });
            }
        }
    },

    computed: {

        viewKey: function viewKey() {

            var key = this.$route.name.split('.').slice(0, 2).join('.');

            if (this.$route.params.groupId != null) key += '-group-' + this.$route.params.groupId;
            if (this.$route.params.periodId != null) key += '-period-' + this.$route.params.periodId;
            if (this.$route.params.assignmentId != null) key += '-assignment-' + this.$route.params.assignmentId;
            if (this.$route.params.studentId != null) key += '-student-' + this.$route.params.studentId;

            return key;
        },

        currentGroup: function currentGroup() {
            return this.getGroup(this.$route.params.groupId);
        },

        groupTermId: function groupTermId() {
            var _this = this;

            if (this.$route.params.groupTermId != null) {
                return this.$route.params.groupTermId;
            }

            if (this.$route.params.periodId != null) {
                return this.currentGroup.groupTerms.map(function (id) {
                    return _this.$store.state.groups.terms[id];
                }).find(function (gt) {
                    return gt.groupPeriods.indexOf(_this.$route.params.periodId) !== -1;
                }).id;
            }

            return this.currentGroup == null ? null : this.currentGroup.currentGroupTerm == null ? null : this.currentGroup.currentGroupTerm[0];
        },

        groupTerm: function groupTerm() {
            return this.$store.state.groups.terms[this.groupTermId];
        },

        loggedInUser: function loggedInUser() {
            return this.$store.state.users.current;
        },

        viewingUser: function viewingUser() {
            return this.$route.params.studentId != null ? this.$store.state.users.storage[this.$route.params.studentId] : this.loggedInUser;
        },

        isInspectingStudent: function isInspectingStudent() {
            return this.viewingUser == null ? false : this.loggedInUser.id !== this.viewingUser.id;
        },

        ignoreProgress: function ignoreProgress() {
            return !this.isInspectingStudent;
        },

        isDemo: function isDemo() {
            return (0, _auth.isDemo)(this.loggedInUser);
        }

    },

    methods: {
        loadInitialData: function loadInitialData(route) {
            var _this2 = this;

            // check if the group is already loaded
            // (Should have been included in user essentials)
            var loadGroup = this.currentGroup == null ? this.fetchGroup(route.params.groupId) : Promise.resolve();

            this.isLoadingGroupData = true;

            return loadGroup.then(function () {

                return Promise.all([_this2.loadStudentsData(), _this2.loadTermData(_this2.groupTermId, route.params.studentId, route.params.periodId)]);
            }).catch(function () {
                return _this2.$router.replace({ name: 'root' });
            }).then(function () {
                return _this2.isLoadingGroupData = false;
            });
        },
        loadTermData: function loadTermData(groupTermId, studentId, periodId) {
            var _this3 = this;

            return this.fetchGroupTerm(groupTermId, studentId, periodId).catch(function (err) {
                if (err.status === 404) {
                    _this3.$warn('Er zijn nog geen opdrachten voor jou gevonden, probeer het later nog eens.');
                } else {
                    _analytics2.default.exception('Can\'t load term', err);
                }
                return Promise.reject(err);
            });
        },
        loadStudentsData: function loadStudentsData() {
            var _this4 = this;

            return this.fetchStudentsForGroup(this.currentGroup.id).catch(function (err) {
                _analytics2.default.exception('Can\'t load students for group ', err);
                _this4.$error('Kan leerlingen niet laden.');
                return Promise.reject(err);
            });
        },
        afterPageViewLeave: function afterPageViewLeave() {
            document.getElementById('main-view').scrollTop = 0;
        }
    },

    created: function created() {
        var _this5 = this;

        if (!(0, _auth.canTeach)(this.loggedInUser)) {
            this.$router.replace({ name: 'root' });
            return;
        }

        this.loadInitialData(this.$route).then(function () {
            // route to overview if no students are registered yet
            if (_this5.$route.name === 'students.overview' && _this5.$route.params.groupTermId == null && _this5.currentGroup.students.length === 0) {
                _this5.$router.replace({ name: 'group.overview' });
            }
        });
    },

    watch: {
        // not immediate because initial data loaded on created
        groupTermId: function groupTermId(newVal, oldVal) {
            var _this6 = this;

            if (newVal !== oldVal) {
                // TODO: CACHE?
                this.isLoadingUserProgress = true;
                this.loadTermData(this.groupTermId, this.$route.params.studentId).catch(function () {
                    return _this6.$router.replace({ name: 'root' });
                }).then(function () {
                    return _this6.isLoadingUserProgress = false;
                });
            }
        },

        '$route': function $route(to, from) {
            var _this7 = this;

            // TODO: load only user progres, not term data
            var studentSwitch = to.params.studentId != null && to.params.studentId != from.params.studentId;

            if (studentSwitch) {
                this.isLoadingUserProgress = true;
                this.loadTermData(this.groupTermId, to.params.studentId).catch(function () {
                    return _this7.$router.replace({ name: 'root' });
                }).then(function () {
                    return _this7.isLoadingUserProgress = false;
                });
            }
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "I6u0":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("KXlc")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ywaP"),
  /* template */
  __webpack_require__("G6Uf"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "IO41":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-step"
  }, [(_vm.canViewStep) ? [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldShowTeacherTips) ? _c('a', {
    staticClass: "button-rounded button-rounded--teachertips ",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTeachertips(_vm.currentStep)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--info"
  }), _vm._v("Tips")]) : _vm._e(), _vm._l((_vm.partials), function(partial) {
    return _c(partial.type + 'Partial', {
      key: partial.id,
      ref: "partials",
      refInFor: true,
      tag: "component",
      attrs: {
        "partial": partial,
        "readonly": _vm.readonly,
        "step": _vm.currentStep,
        "progress": _vm.progress
      }
    })
  })], 2), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), (_vm.currentStepIndex > 1) ? _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": _vm.prevStepLink
    }
  }, [_vm._v("Vorige stap")]) : _vm._e(), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.nextStepLink,
      "disabled": !_vm.canGoNext,
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.complete
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "Io5y":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("b/oB")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("QJis"),
  /* template */
  __webpack_require__("zVE9"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "IoFZ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("DYnL")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("y46E"),
  /* template */
  __webpack_require__("wyNJ"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Ipr1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IqPv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J2kX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _Sidebar = __webpack_require__("cHIS");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _Group = __webpack_require__("E64q");

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Lobby',
    mixins: [_notificationsMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Loading: _Loading2.default, Sidebar: _Sidebar2.default, Group: _Group2.default },

    data: function data() {
        return {
            loading: false
        };
    },

    vuex: {
        getters: {},
        actions: {}
    },

    computed: {
        user: function user() {
            return this.$store.state.users.current;
        }
    },

    methods: {},

    created: function created() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "JOmw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkAuthentication = checkAuthentication;
exports.checkAuthorization = checkAuthorization;
exports.canTeach = canTeach;
exports.isTeacher = isTeacher;
exports.isDemo = isDemo;
exports.isStudent = isStudent;
exports.isAdmin = isAdmin;
exports.getUserId = getUserId;
exports.receivedTokens = receivedTokens;
exports.login = login;
exports.logout = logout;
exports.getAccessToken = getAccessToken;
exports.setAuthorizationHeader = setAuthorizationHeader;
exports.retryAfterAuthFail = retryAfterAuthFail;

var _jwtDecode = __webpack_require__("ytdl");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _helpers = __webpack_require__("GR5N");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _storage = __webpack_require__("5ehd");

var _storage2 = _interopRequireDefault(_storage);

var _helpers2 = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stores the current authentication request Promise
 * @type Promise
 */
var authenticating = null;

/**
 * Store the current access token refresh timer
 * @type {[type]}
 */
var authTimer = null;

/**
 * Used to initialize the authentication refresh process
 */
function checkAuthentication() {

    return authenticate().then(function () {
        if (authTimer == null) {
            updateRefreshTimer();
        }
        return getUserId();
    });
}

/**
 * Check user authorization for the given route
 * @param  {Vue-route object} route
 * @param  {User object} user
 * @param  {bool} adminRequired
 * @return Boolean
 */
function checkAuthorization(route, user, adminRequired) {

    if (user == null) {
        return false;
    }

    if (isAdmin(user)) {
        return true;
    } else if (adminRequired) {
        return false;
    }

    if (route.params.groupId != null && user.groups.indexOf(route.params.groupId) < 0) {
        // no permission to view this group
        return false;
    }

    if (canTeach(user) && route.name.split('.')[0] === 'student') {
        return false;
    }

    return true;
}

function canTeach(user) {
    return isTeacher(user) || isDemo(user) || isAdmin(user);
}

function isTeacher(user) {
    return user.role === 'teacher';
}

function isDemo(user) {
    return user.role === 'demo';
}

function isStudent(user) {
    return user.role === 'student' || user.role === 'demostudent';
}

function isAdmin(user) {
    return user.role === 'admin';
}

/**
 * Gets the currently logged in user id
 * @return Int
 */
function getUserId() {
    var tokenString = getAccessToken() || getRefreshToken();
    if (tokenString == null) {
        return null;
    }

    var token = (0, _jwtDecode2.default)(tokenString);
    return token.sub;
}

/**
 * Stores the given tokens
 * @param  [TokenAPIData] tokens
 */
function receivedTokens(tokens) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

        for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var token = _step.value;


            var jwtToken = (0, _jwtDecode2.default)(token.id);

            // check if the token is access or refresh
            if ('rfc' in jwtToken) {
                setAccessToken(token.id);
                updateRefreshTimer();
            } else {
                setRefreshToken(token.id);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

/**
 * Login with the given credentials
 * @param  {String} email
 * @param  {String} password
 * @param  {Boolean} remember true if a 30-day refresh token should be received
 * @return {Promise}
 */
function login(email, password, remember) {

    // make sure there are no old tokens lying around
    removeTokens();

    return _resources2.default.login(email, password, remember).then(function (response) {
        return (0, _helpers2.transform)(response.body);
    }).then(function (result) {
        if (result.tokens) {
            receivedTokens(result.tokens);
        }
    });
}

/**
 * Blacklists and destroys currently available tokens
 * @return Resolving Promise
 */
function logout() {
    var accessToken = getAccessToken();
    var refreshToken = getRefreshToken();

    clearTimeout(authTimer);

    if (accessToken != null || refreshToken != null) {
        return _resources2.default.logout(refreshToken).catch(function () {}).then(function () {
            return removeTokens();
        });
    }

    return Promise.resolve();
}

/**
 * Get the access token from storage
 * @return String
 */
function getAccessToken() {
    return _storage2.default.local.getItem('accessToken');
}

/**
 * Store the access token to storage
 */
function setAccessToken(token) {
    _storage2.default.local.setItem('accessToken', token);
    _storage2.default.local.setItem('accessTokenReceived', (0, _helpers2.timestamp)());
}

/**
 * Get the timestamp when we stored the last access token
 * @return String timestamp
 */
function getLastAccessTokenReceived() {
    return _storage2.default.local.getItem('accessTokenReceived');
}

/**
 * Get the refresh token from storage
 * @return String
 */
function getRefreshToken() {
    return _storage2.default.local.getItem('refreshToken');
}

/**
 * Store the refresh token to storage
 */
function setRefreshToken(token) {
    _storage2.default.local.setItem('refreshToken', token);
}

/**
 * Removes all token data from storage
 */
function removeTokens() {
    _storage2.default.local.removeItem('accessToken');
    _storage2.default.local.removeItem('refreshToken');
    _storage2.default.local.removeItem('accessTokenReceived');
}

/**
 * Helper to add an authorization header to a request
 * @param Request
 */
function setAuthorizationHeader(request) {

    var accessToken = getAccessToken();
    if (!request.headers.has('Authorization') && accessToken !== null) {
        request.headers.set('Authorization', 'Bearer ' + accessToken);
    }
}

/**
 * Checks the current tokens if the user can login
 * @return Promise
 */
function authenticate() {

    var accessToken = getAccessToken();

    if (accessToken != null) {

        var remaining = timeRemaining(accessToken);
        if (remaining >= -5) {
            // There is an access token available, not guaranteed to be valid
            return Promise.resolve();
        }
    }

    return singletonGetAccessTokenWithRefreshToken();
}

/**
 * Retries the given request after authentication
 * @param  request
 * @return Promise
 */
function retryAfterAuthFail(request) {

    console.log('Retry after auth fail', request);

    // Login requests cannot be retried, wrong credentials is wrong credentials
    // Refresh request cannot be retried, because it would cause a deadlock (promise returning itself on failure), unless it's stealthy (i.e. called by timer)
    if (request && (request.url === 'auth/login' || request.url === 'auth/refresh')) {
        return request.stealth ? singletonGetAccessTokenWithRefreshToken() : Promise.reject('Auth requests cannot be retried');
    }

    return singletonGetAccessTokenWithRefreshToken().then(function () {
        return (0, _helpers.retry)(request);
    });
}

/**
 * Calculates the duration for which the given token is valid
 * @param  JwtToken
 * @return Int duration in seconds
 */
function timeValid(token) {
    var timeValid = token.exp - token.iat;
    return timeValid - 60; // trim 60 seconds to be safe
}

/**
 * Calculates the remaining time an access token is valid
 * @param  String token
 * @return Int remaining seconds
 */
function timeRemaining(token) {

    var jwtToken = (0, _jwtDecode2.default)(token);
    var tokenReceivedAt = getLastAccessTokenReceived();
    var validFor = timeValid(jwtToken);

    if (tokenReceivedAt == null) {
        return validFor;
    }

    var receivedAt = parseInt(tokenReceivedAt, 10);
    var currentTime = (0, _helpers2.timestamp)();
    return receivedAt + validFor - currentTime;
}

/**
 * Updates the refresh timer based on the stored access token
 */
function updateRefreshTimer() {

    var token = getAccessToken();
    var timeout = timeRemaining(token);

    console.log('Setting new refresh timer', timeout);

    clearTimeout(authTimer);
    authTimer = setTimeout(function () {

        var stealth = true;
        refresh(token, stealth).catch(function () {
            return console.error('Could not refresh token');
        });
        authTimer = null;
    }, timeout * 1000);
}

/**
 * Tries to auto authenticate if a refresh token is available
 * If there is already an auto authenticate request running, that's returned instead
 * @return Promise
 */
function singletonGetAccessTokenWithRefreshToken() {

    // Check if another request is already authenticating
    if (authenticating != null) {

        console.log('Waiting for previous authentication');
        return authenticating;
    }

    authenticating = getAccessTokenWithRefreshToken();

    authenticating.catch(function () {}).then(function () {
        authenticating = null;
    });

    return authenticating;
}

/**
 * Requests a new Access Token with the stored Refresh Token (if exists)
 * @return Promise
 */
function getAccessTokenWithRefreshToken() {

    var refreshToken = getRefreshToken();
    if (refreshToken == null) {
        return Promise.reject('Refresh token not found');
    }

    console.log('Found refresh token...');
    return refresh(refreshToken);
}

/**
 * Gets a new Access Token, authenticated with the given token (which must be still valid)
 * @param  token  a valid token to authenticate (can be access or refresh)
 * @param  boolean stealth  true if the refresh api call is a stealthy access token request by automatic timer
 * @return Promise
 */
function refresh(token, stealth) {

    return _resources2.default.getAccessToken(token, stealth).then(function (response) {

        var result = (0, _helpers2.transform)(response.body);
        receivedTokens(result.tokens);

        return response;
    });
}

/***/ }),

/***/ "JOx0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stepMixin = __webpack_require__("Ce1c");

var _stepMixin2 = _interopRequireDefault(_stepMixin);

var _GroupSubmissions = __webpack_require__("r5Ke");

var _GroupSubmissions2 = _interopRequireDefault(_GroupSubmissions);

var _AssignmentFeedbackPartial = __webpack_require__("tWtg");

var _AssignmentFeedbackPartial2 = _interopRequireDefault(_AssignmentFeedbackPartial);

var _Celebration = __webpack_require__("WFFm");

var _Celebration2 = _interopRequireDefault(_Celebration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Done',
    mixins: [_stepMixin2.default],
    props: {
        group: {},
        returnLink: {
            type: Object,
            required: true
        }
    },
    components: { GroupSubmissions: _GroupSubmissions2.default, AssignmentFeedback: _AssignmentFeedbackPartial2.default, Celebration: _Celebration2.default },
    data: function data() {
        return {
            loading: false
        };
    },
    computed: {
        previousStep: function previousStep() {
            var previousStepIndex = this.steps.length - 1;

            if (previousStepIndex < 0) {
                return null;
            }

            return this.steps[previousStepIndex];
        },
        canViewStep: function canViewStep() {
            return this.isProgressFinished(this.progress);
        },
        termCelebration: function termCelebration() {
            var currentGroupTerm = this.group.currentGroupTerm ? this.group.currentGroupTerm[0] : 0;
            var termIndex = this.group.groupTerms.indexOf(currentGroupTerm);
            return termIndex % 2 == 0 ? 'confetti' : 'fireworks';
        }
    },
    methods: {
        checkRoute: function checkRoute() {

            if (!this.canViewStep) {
                this.autoRedirectStep(this.progress);
            }
        }
    },
    created: function created() {
        this.checkRoute();
    }
};

/***/ }),

/***/ "KBgp":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("YhPF")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iOrq"),
  /* template */
  __webpack_require__("4U3r"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "KJNZ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('nav', {
    staticClass: "term-nav"
  }, [_c('div', {
    staticClass: "term-nav__wrap"
  }, [_c('router-link', {
    staticClass: "term-nav__item tag",
    class: {
      'term-nav__item--active': _vm.selectedGroupTermId == null
    },
    attrs: {
      "to": {
        name: 'group.overview'
      }
    }
  }, [_vm._v("Overzicht")]), _vm._l((_vm.terms), function(term, index) {
    return _c('router-link', {
      key: 'term-link-' + term.groupTermId,
      staticClass: "term-nav__item tag",
      class: {
        'term-nav__item--active': _vm.selectedGroupTermId == term.groupTermId, 'term-nav__item--current': _vm.currentGroupTermId == term.groupTermId
      },
      attrs: {
        "to": {
          name: 'students.overview',
          params: {
            groupTermId: term.groupTermId
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(index + 1) + ". " + _vm._s(term.title) + "\n    ")])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "KKz7":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("MBxh")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7kkF"),
  /* template */
  __webpack_require__("2omD"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "KPQb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Fixes elastic bounce on document if user scrolls while scrollable child div is already scrolled to top/bottom
 * The document won't scroll, since the overflowing child div will always have room to scroll
 * @param: {string}  id of overflowing element, e.g. 'scroller'
 *
 * inspiration from: http://stackoverflow.com/questions/10238084/ios-safari-how-to-disable-overscroll-but-allow-scrollable-divs-to-scroll-norma
 * but those solutions do not seem to work on iPad 2 iOS 9
 * This solution simply checks the scroll event and always keeps 1 pixel to scroll on top and bottom
 * Only triggers on touchstart, on first touch it might not work because the device is too slow
 */
var enableElasticBounce = exports.enableElasticBounce = function enableElasticBounce(el) {

    var adjustScroll = function adjustScroll() {

        if (el.scrollTop === 0) {
            el.scrollTop = 1;
        } else if (el.scrollHeight === el.scrollTop + el.offsetHeight) {
            el.scrollTop -= 1;
        }
    };

    var starter = function starter() {

        if (!el || scrollables.indexOf(el) != -1) {
            return; // already enabled
        }

        adjustScroll();
        el.addEventListener('scroll', adjustScroll);
        window.removeEventListener('touchstart', starter);
    };

    if (detectedTouch()) {
        starter();
    } else {
        window.addEventListener('touchstart', starter);
    }
};

var disableElasticBounce = exports.disableElasticBounce = function disableElasticBounce(el) {
    var idx = scrollables.indexOf(el);
    if (idx !== -1) {
        scrollables.splice(idx, 1);
    }
};

var vueScrollDirective = exports.vueScrollDirective = {
    inserted: function inserted(el) {
        enableElasticBounce(el);
    },

    unbind: function unbind(el) {
        disableElasticBounce(el);
    }
};

var scrollables = [];

function detectedTouch() {
    return 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
}

/***/ }),

/***/ "KRDm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KWYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'SettingsPassword',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        user: {}
    },
    data: function data() {
        return {
            old_password: null,
            new_password: null,
            new_passwordConfirmation: null,
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    vuex: {
        getters: {
            isDemo: function isDemo(state) {
                return state.users.current.role === 'demo';
            }
        }
    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate()) {

                if (this.isDemo) {
                    this.$demoSuccessNotification();
                    this.reset();
                    return;
                }

                this.loading = true;

                _resources2.default.editUserPassword(this.user.id, this.old_password, this.new_password, this.new_passwordConfirmation).then(function () {
                    return _this.$success('Je wachtwoord is aangepast.', { id: 'validation' });
                }).catch(function (response) {
                    if (response.status === 403) {
                        _this.addError('old_password', 'Je huidige wachtwoord klopt niet.');
                        _this.showErrors();
                    } else {
                        _this.handleErrorResponse(response, 'Aanpassen wachtwoord is mislukt.');
                    }
                }).then(this.reset);
            }
        },

        reset: function reset() {
            this.old_password = null;
            this.new_password = null;
            this.new_passwordConfirmation = null;
            this.loading = false;
        },

        validateFields: function validateFields() {
            this.validatePasswordLength(this.new_password);
            this.validatePasswordEqual(this.new_password, this.new_passwordConfirmation);
        }

    }

};

/***/ }),

/***/ "KXlc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KjtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__("JOmw");

exports.default = {
    computed: {
        stealthMode: function stealthMode() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        }
    }
};

/***/ }),

/***/ "L7d7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _UserMenu = __webpack_require__("gxlJ");

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _transformers = __webpack_require__("j0ZK");

var _auth = __webpack_require__("JOmw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        user: {
            type: Object,
            required: true
        },
        disableMenu: {
            type: Boolean,
            default: false
        }
    },

    components: { UserMenu: _UserMenu2.default },

    data: function data() {
        return {
            isUserMenuVisible: false
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            return (0, _auth.isAdmin)(this.user);
        },

        isWorkspace: function isWorkspace() {
            return (0, _auth.isStudent)(this.user);
        },

        isDemo: function isDemo() {
            return (0, _auth.isDemo)(this.user);
        }

    },

    methods: {
        name: function name(user) {
            if (this.isWorkspace) {
                return user.firstname;
            }
            return (0, _transformers.username)(user);
        },
        toggleUserMenu: function toggleUserMenu() {
            this.isUserMenuVisible = !this.isUserMenuVisible;
        },
        hideUserMenu: function hideUserMenu() {
            this.isUserMenuVisible = false;
        },
        showCurrentPeriod: function showCurrentPeriod() {
            this.$router.push({ name: 'period' });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "LDP5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _helpers = __webpack_require__("x3kM");

var _Question = __webpack_require__("haHN");

var _Question2 = _interopRequireDefault(_Question);

var _Upload = __webpack_require__("DBjH");

var _Upload2 = _interopRequireDefault(_Upload);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { Loading: _Loading2.default, QuestionPresenter: _Question2.default, UploadPresenter: _Upload2.default },
    props: {
        isExcerpt: {
            type: Boolean,
            default: true
        },
        isInspecting: {
            type: Boolean,
            default: false
        },
        assignment: {},
        group: {}
    },

    data: function data() {
        return {
            loading: false,
            submissions: [],
            users: []
        };
    },

    methods: {
        type: function type(submission) {

            if (submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null) {
                return 'Upload';
            }

            return 'Question';
        }
    },

    mounted: function mounted() {
        var _this = this;

        var limit = this.isExcerpt ? 3 : null;

        return _resources2.default.getGroupSubmissions(this.group.id, this.assignment.id, limit).then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {

            if (result.submissions == null) {
                return;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var submission = _step.value;


                    var user = _this.users.find(function (user) {
                        return user.id == submission.user[0];
                    });
                    if (user == null) {
                        user = result.users.find(function (user) {
                            return user.id === submission.user[0];
                        });
                        user.submissions = [];
                        _this.users.push(user);
                    }

                    _this.submissions.push(submission);
                    user.submissions.push(submission);

                    // set hasFeedback flag
                    if (result.progress != null) {
                        var progress = result.progress.find(function (p) {
                            return p.id === submission.progress[0];
                        });
                        if (progress.feedback && progress.feedback.length) {
                            var feedback = result.feedback.find(function (f) {
                                return f.id === progress.feedback[0];
                            });
                            user.hasFeedback = feedback.content || feedback.remarks.length || feedback.compliments.length;
                        }
                        user.isRetaking = progress.isRetaking;
                        user.diligence = progress.diligence != null ? _this.$store.state.diligence.storage[progress.diligence[0]] : null;
                    }
                };

                for (var _iterator = result.submissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }).catch(function (err) {
            _analytics2.default.exception('Could not fetch group submissions', err);
        });
    }
};

/***/ }),

/***/ "LFug":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--promo"
  }, [_vm._v("Er hebben zich nog geen leerlingen aangemeld voor deze klas. Leerlingen kunnen zich registreren via "), _c('strong', [_c('a', {
    attrs: {
      "href": '//' + _vm.registerLink
    }
  }, [_vm._v(_vm._s(_vm.registerLink))])]), _vm._v(" met code "), _c('strong', [_vm._v(_vm._s(_vm.group.code))])])
},staticRenderFns: []}

/***/ }),

/***/ "LnBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M4nG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _getters = __webpack_require__("olIF");

var _helpers = __webpack_require__("x3kM");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: [],
    mixins: [_notificationsMixin2.default],
    components: { Loading: _Loading2.default },

    vuex: {
        getters: {
            getCurrentAssignment: _getters.getCurrentAssignment
        },
        actions: {
            addReflectiontips: function addReflectiontips(_ref, reflectiontips) {
                var dispatch = _ref.dispatch;
                return dispatch('ADD_REFLECTIONTIPS', reflectiontips);
            }
        }
    },

    mounted: function mounted() {
        var _this = this;

        if (this.reflectiontips == null) {

            _resources2.default.getReflectiontips(this.getCurrentAssignment.id).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (data) {
                _this.addReflectiontips(data.reflectiontips);
            }).catch(function (e) {
                _analytics2.default.exception('Can\'t find reflection tips', e, { assignment: _this.getCurrentAssignment.id });
                _this.$warn('Kan tips niet vinden.');
                _this.close();
            });
        }
    },

    methods: {
        close: function close() {
            this.$emit('close');
        }
    },

    computed: {
        reflectiontips: function reflectiontips() {
            return this.$store.state.assignments.reflectiontips[this.getCurrentAssignment.id];
        }
    }

};

/***/ }),

/***/ "MBxh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MSI/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Replaces accented (latin) characters in a string
 * Wrapped in self-invoking anonymous function to make sure the regex is only created once
 *
 * @param {String} string to transform
 * @return {String} transformed string without accented (latin) characters
 */
var replaceAccents = function () {

    var charmap = { // https://github.com/dodo/node-slug/blob/master/slug.js
        'à': 'a', 'á': 'a',
        'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
        'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
        'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
        'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
        'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ß': 'ss'
    };
    var needles = Object.keys(charmap).join('|');
    var regex = new RegExp(needles, 'g');

    return function (haystack) {
        return haystack.replace(regex, function (match) {
            return charmap[match];
        });
    };
}();

/**
 * Automatically binds click event handler on ready
 * If definition tags need to be transformed, call processDefinitions( el )
 */
exports.default = {
    vuex: {
        actions: {
            showDefinition: function showDefinition(_ref, definitionTag) {
                var dispatch = _ref.dispatch;

                _analytics2.default.event('definition', 'show', definitionTag);
                dispatch('SHOW_DEFINITION', definitionTag);
                dispatch('SHOW_MODAL', 'Glossary');
            }
        }
    },
    mounted: function mounted() {
        this.$nextTick(this.bindClick);
    },
    methods: {

        /**
         * Binds a click handler to this component's element
         * which checks if the clicked (child) element is a definition
         * then it opens the definition popover
         */
        bindClick: function bindClick() {
            var _this = this;

            this.$el.onclick = function (e) {

                // check if user clicked on definition link

                e = e || event;
                var anchor = _this.findParentElement('a', e.target || e.srcElement);

                if (anchor && anchor.dataset.definition != undefined) {
                    e.preventDefault();
                    e.stopPropagation();

                    var tag = anchor.dataset.definition || _this.slugify(anchor.innerText);
                    _this.showDefinition(tag);
                }
            };
        },

        /**
         * Find first parent element (including self) with tagName [tagname]
         * @param  {String} tagname to search for (e.g. 'a')
         * @param  {DomElement} el  deepest child to start searching
          * @return {DomElement|null} null if not found, else the found DomElement
         */
        findParentElement: function findParentElement(tagname, el) {
            while (el) {
                if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
                    return el;
                }
                el = el.parentNode;
            }
            return null;
        },

        /**
         * Runs the html replacer for definitions
         * @param  {DomElement} el  the element to parse
         */
        processDefinitions: function processDefinitions(el) {
            this.htmlReplace(el, this.definitionReplacer);
        },

        /**
         * Transforms content into url-safe slug
         * @param  {String} content  the text to transform
         * @return {String} url-safe string
         */
        slugify: function slugify(content) {

            var newContent = content.toLowerCase().trim().replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
            .replace(/-$/, ''); // Remove trailing dash

            return replaceAccents(newContent);
        },

        /**
         * Finds all definitions marked: "#(definition)" or "#[Definition Text](definition-tag)"
         * and replaces them with an html string
         *
         * @param  {String} content The text of an html element
         * @return {String|False} false if no definition found, a replacement otherwise
         */
        definitionReplacer: function definitionReplacer(content) {
            var replaced = false;
            var newContent = content.replace(/\#(\[([^\[\]]*)\])?\(([^\(\)]*)\)/g, function (match, _, p2, p3) {
                replaced = true;
                // if custom text is not set, then leave data-definition empty: will be tagified when clicked on
                return '<a href="#" data-definition="' + (p2 ? p3 : '') + '">' + (p2 || p3) + '</a>';
            });

            return replaced ? newContent : false;
        },

        /**
         * Walks recursively through node and runs the given replaces on each textNode
         *
         * @param  {DomElement} node    The node to start searching
         * @param  {(String) => (String|False)} replacer  function that searches the text
         */
        htmlReplace: function htmlReplace(node, replacer) {

            var nodes = node.childNodes;

            for (var i = 0; i < nodes.length; i++) {

                var n = nodes[i];

                if (n.nodeType == n.TEXT_NODE) {

                    var found = replacer(n.textContent);
                    if (found === false) {
                        continue;
                    }

                    var replacementNode = document.createElement('span');
                    replacementNode.innerHTML = found;
                    n.parentNode.insertBefore(replacementNode, n);
                    n.parentNode.removeChild(n);
                } else {
                    // recursion
                    this.htmlReplace(n, replacer);
                }
            }
        }

    }

};

/***/ }),

/***/ "Mb7x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mq8A":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "slot-machine",
    class: {
      'is-running': _vm.isRunning
    }
  }, [_c('div', {
    staticClass: "slot-machine__wrap"
  }, _vm._l((_vm.slots), function(slot) {
    return _c('div', {
      ref: "slots",
      refInFor: true,
      staticClass: "slot"
    }, [_c('h2', {
      staticClass: "slot__title"
    }, [_vm._v(_vm._s(slot.title))]), _c('div', {
      staticClass: "slot__window"
    }, [_c('div', {
      staticClass: "slot__wrap"
    }, [_vm._l((slot.items), function(opt) {
      return _c('div', {
        staticClass: "slot__item"
      }, [_c('span', [_vm._v(_vm._s(opt))])])
    }), _c('div', {
      staticClass: "slot__item slot__item--copy"
    }, [_c('span', [_vm._v(_vm._s(slot.items[0]))])])], 2)])])
  })), _c('primary-button', {
    staticClass: "slot-machine__lever",
    attrs: {
      "loading": _vm.opts
    },
    on: {
      "clicked": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Draaien!")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Mz4J":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("vRyo")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Xrab"),
  /* template */
  __webpack_require__("+Tcm"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "N+K9":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', [_vm._v("Wat vond je van deze opdracht?")]), _vm._l((_vm.questions), function(question) {
    return _c('div', {
      staticClass: "assignment-feedback",
      class: question.name
    }, _vm._l((question.options), function(option) {
      return _c('div', {
        staticClass: "input-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (question.chosen),
          expression: "question.chosen"
        }],
        staticClass: "feedback-radio",
        attrs: {
          "type": "radio",
          "id": option.tag
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(question.chosen, option.value)
        },
        on: {
          "__c": function($event) {
            question.chosen = option.value
          }
        }
      }), _c('label', {
        attrs: {
          "for": option.tag
        }
      }, [_c('span', {
        staticClass: "feedback-icon",
        class: _vm.iconClass(option, question)
      }), _c('br'), _vm._v("\n                " + _vm._s(option.text) + "\n            ")])])
    }))
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "assignment-feedback",
    attrs: {
      "placeholder": "Op- of aanmerkingen over deze opdracht"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "N0nv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isResponse = isResponse;

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Initializes Google analytics
 * @param  {String} id  analytics id without 'UA-', e.g.: '12345678-1'
 */
var init = function init(id) {

    window.ga = window.ga || function () {
        (window.ga.q = window.ga.q || []).push(arguments);
    };

    window.ga.l = +new Date();

    if (id === '') {
        console.log('Tracking disabled');
    } else {
        window.ga('set', 'forceSSL', true);
        window.ga('set', 'anonymizeIp', true);
        window.ga('create', 'UA-' + id, 'auto');
    }
};

var event = function event(category, action, label, value) {
    window.ga('send', 'event', category, action, label, value);
};

var pageview = function pageview(path) {
    if (path != null) {
        window.ga('set', 'page', path);
    }
    window.ga('send', 'pageview');
};

/**
 * Track application error
 * @param  {String} message description of error
 * @param  {Error} err     Error or extra data
 * @param  {Object} data    extra data
 */
var exception = function exception(message, err, data) {

    console.error(message, err);
    if (!shouldReport(err)) {
        return;
    }

    if (err instanceof Error) {
        _ravenJs2.default.captureException(err, { extra: Object.assign({ message: message }, data) });
    } else {
        var errorObj = formatException(err) || {};
        _ravenJs2.default.captureException(new Error(message), { extra: Object.assign(errorObj, data) });
    }
};

/**
 * Starts tracking user
 * @param  {String} id  id of the logged in user, null to reset
 */
var user = function user(id) {
    var context = id == null ? null : { id: id };
    _ravenJs2.default.setUserContext(context);
};

function shouldReport(err) {
    var responseStatusCodeBlacklist = [0, 1, 401, 403, 410, 422, 429];
    return !isResponse(err) || responseStatusCodeBlacklist.indexOf(err.status) === -1;
}

function isResponse(data) {
    return data != null && !(data instanceof Error) && data.status != null && data.url != null && (data.body !== undefined || data.response !== undefined);
}

function formatException(data) {
    if (isResponse(data)) {
        return { status: data.status, errors: data.body ? data.body.errors : data.response, url: data.url };
    }

    return data;
}

exports.default = {
    init: init,
    event: event,
    pageview: pageview,
    exception: exception,
    user: user
};

/***/ }),

/***/ "N2JW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _getters = __webpack_require__("olIF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'TermIntro',
    components: { PrimaryButton: _PrimaryButton2.default },
    props: [],
    vuex: {
        getters: {
            getGroup: _getters.getGroup,
            getGroupIdForCurrentUser: _getters.getGroupIdForCurrentUser,
            getCurrentTerm: _getters.getCurrentTerm
        },
        actions: {
            markViewed: function markViewed(_ref) {
                var dispatch = _ref.dispatch;
                return dispatch('MARK_TERM_VIEWED');
            }
        }
    },
    computed: {
        groupId: function groupId() {
            return this.$route.params.groupId == null ? this.getGroupIdForCurrentUser : this.$route.params.groupId;
        },
        term: function term() {
            return this.getCurrentTerm(this.groupId);
        }
    },
    methods: {
        close: function close(e) {
            e.preventDefault();
            this.$emit('close');
        }
    },
    created: function created() {
        this.markViewed();
        if (this.term == null) {
            this.$emit('close');
        }
    }
};

/***/ }),

/***/ "NC+L":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-route"
  }, [_c('router-link', {
    staticClass: "assignment-block-link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.assignment.image,
      "alt": _vm.assignment.title
    }
  }), _c('span', {
    staticClass: "assignment-icon",
    class: _vm.type_class
  }), _c('h2', [_vm._v(_vm._s(_vm.assignment.title))]), _c('p', [_vm._v(_vm._s(_vm.assignment.subtitle))])]), _c('div', {
    staticClass: "assignment__information"
  }, [_c('progress-bar', {
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "autolink": true,
      "mini": true
    }
  }), _c('span', {
    staticClass: "assignment__meta"
  }, [_c('span', {
    staticClass: "assignment__time tag"
  }, [_vm._v(_vm._s(_vm.assignment.time) + " minuten")]), _c('span', {
    staticClass: "assignment__group-size tag",
    class: _vm.groupSize.class,
    attrs: {
      "title": _vm.groupSize.title
    }
  }, [_vm._v(_vm._s(_vm.assignment.group_size))])])], 1), _c('primary-button', {
    attrs: {
      "link": _vm.link,
      "disabled": _vm.isDisabled
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "NJBc":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("T1ye")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("gGgV"),
  /* template */
  __webpack_require__("aWpe"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "NtfJ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("V81C")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Hg2t"),
  /* template */
  __webpack_require__("elzP"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "O/tW":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("kJvQ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("J2kX"),
  /* template */
  __webpack_require__("GMyW"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "O3kh":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [(_vm.isVerifying) ? _c('loading', {
    attrs: {
      "alt": true
    }
  }) : _c('div', {
    staticClass: "login"
  }, [_c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("De laatste stap!")]), _c('p', [_vm._v("Jouw account is bijna klaar. Vul nog even je naam in en het wachtwoord waarmee je de volgende keer kunt inloggen.")])]), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "label--disabled",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('hr'), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('firstname')
    }
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Voornaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "name": "firstname",
      "id": "firstname",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('infix')
    }
  }, [_c('label', {
    attrs: {
      "for": "infix"
    }
  }, [_vm._v("Tussenvoegsel "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— de / van / van 't / van den /  ...")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infix),
      expression: "infix"
    }],
    attrs: {
      "type": "text",
      "name": "infix",
      "id": "infix"
    },
    domProps: {
      "value": (_vm.infix)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.infix = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('lastname')
    }
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Achternaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    attrs: {
      "type": "text",
      "name": "lastname",
      "id": "lastname"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })]), _c('hr'), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— minimaal 8 tekens")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('passwordConfirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordConfirmation"
    }
  }, [_vm._v("Herhaal wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    attrs: {
      "type": "password",
      "name": "passwordConfirmation",
      "id": "passwordConfirmation"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "link": {
        name: 'root'
      },
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Naar de werkmap")])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "O5rX":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("EokX")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7afl"),
  /* template */
  __webpack_require__("sK5L"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "O6gY":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("d+Au")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("QSpI"),
  /* template */
  __webpack_require__("czDB"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "OJLX":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ZpEd")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("zXGb"),
  /* template */
  __webpack_require__("Owjm"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ORQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OU78":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _actions = __webpack_require__("ELb+");

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'SettingsGroup',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },

    props: {
        user: {}
    },

    data: function data() {
        return {
            code: null,
            loading: false,
            errors: [],
            errorFields: []
        };
    },

    vuex: {
        actions: {
            moveToGroup: function moveToGroup(_ref, user, code) {
                var dispatch = _ref.dispatch;

                return _resources2.default.moveToGroup(user.id, code).then(function (response) {
                    return (0, _actions.storeUserResponse)({ dispatch: dispatch }, response, true);
                });
            }

        }
    },

    computed: {
        group: function group() {
            var groupId = this.user.groups ? this.user.groups[0] : null;
            if (groupId == null) {
                return null;
            }

            return this.$store.state.groups.storage[groupId];
        }
    },

    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate()) {

                this.loading = true;

                this.moveToGroup(this.user, this.code).then(function () {
                    _this.$success('Welkom in klas ' + _this.group.name);
                    _this.$router.push({ name: 'root' });
                    _this.$emit('done');
                }).catch(function (response) {
                    _this.handleErrorResponse(response, 'Overplaatsen naar nieuwe klas is mislukt.');
                }).then(this.reset);
            }
        },

        reset: function reset() {
            this.code = null;
            this.loading = false;
        },

        validateFields: function validateFields() {
            this.validateCode(this.code);
        }

    }

};

/***/ }),

/***/ "OfR3":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("XqmB")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("duG/"),
  /* template */
  __webpack_require__("jgER"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Owah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Owjm":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "modal"
  }, [_c('transition', {
    attrs: {
      "name": "modal-transition"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "modal__wrap",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal__container",
    class: {
      'modal__container--image': _vm.component == 'ImageContainer'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation()
      }
    }
  }, [_c('div', {
    staticClass: "modal__content-wrap scrollable"
  }, [_c('a', {
    staticClass: "modal__button-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v("x")]), _c('div', {
    staticClass: "modal__content"
  }, [_vm._t("default", [_c(_vm.component, _vm._b({
    ref: "content",
    tag: "component",
    attrs: {
      "inModal": true
    },
    on: {
      "close": _vm.close
    }
  }, 'component', _vm.data, false))])], 2)]), _c('div', {
    staticClass: "modal__footer",
    attrs: {
      "id": "modal__footer"
    }
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "PSUo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PT2r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        viewed: false,
        storage: {}
    };
};

var mutations = {
    ADD_TERMS: function ADD_TERMS(state, terms) {
        (0, _helpers.setObjects)(terms, state.storage, { periods: [] });
    },
    MARK_TERM_VIEWED: function MARK_TERM_VIEWED(state) {
        state.viewed = true;
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "PZ9P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Sidebar = __webpack_require__("cHIS");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'BasicTemplate',
    components: { Sidebar: _Sidebar2.default },
    vuex: {
        getters: {
            user: function user(state) {
                return state.users.current;
            }
        }
    }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "PtN4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;
exports.stop = stop;
// https://codepen.io/jackrugile/pen/acAgx
// Copyright (c) 2019 by Jack Rugile (https://codepen.io/jackrugile/pen/acAgx)
// Tweaked by Kiempunt
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//

var Fireworks = function Fireworks(canvas, opts) {
    /*=============================================================================*/
    /* Utility
    /*=============================================================================*/
    var self = this;
    var rand = function rand(rMi, rMa) {
        return ~~(Math.random() * (rMa - rMi + 1) + rMi);
    };
    var requestAnimFrame = function () {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (a) {
            window.setTimeout(a, 1E3 / 60);
        };
    }();

    self.opts = opts || {};
    self.defaults = {
        particles: [],
        fireworks: [],
        fworkSpeed: 2,
        fworkAccel: 4,
        showShockwave: false,
        showTarget: true,
        partCount: 30,
        partSpeed: 5,
        partSpeedVariance: 10,
        partWind: 50,
        partFriction: 5,
        partGravity: 1,
        flickerDensity: 20,
        hueMin: 150,
        hueMax: 200,
        hueVariance: 30,
        lineWidth: 1,
        clearAlpha: 25
    };

    /*=============================================================================*/
    /* Initialize
    /*=============================================================================*/
    self.init = function () {
        self.dt = 0;
        self.oldTime = Date.now();
        self.canvas = canvas;
        self.isRunning = true;

        self.canvas.onselectstart = function () {
            return false;
        };

        var opts = Object.assign({}, self.defaults, self.opts);

        self.canvas.width = self.cw = window.innerWidth;
        self.canvas.height = self.ch = window.innerHeight;

        self.particles = opts.particles;
        self.partCount = opts.partCount;
        self.fireworks = opts.fireworks;
        self.mx = self.cw / 2;
        self.my = self.ch / 2;
        self.partSpeed = opts.partSpeed;
        self.partSpeedVariance = opts.partSpeedVariance;
        self.partWind = opts.partWind;
        self.partFriction = opts.partFriction;
        self.partGravity = opts.partGravity;
        self.hueMin = opts.hueMin;
        self.hueMax = opts.hueMax;
        self.fworkSpeed = opts.fworkSpeed;
        self.fworkAccel = opts.fworkAccel;
        self.hueVariance = opts.hueVariance;
        self.flickerDensity = opts.flickerDensity;
        self.showShockwave = opts.showShockwave;
        self.showTarget = opts.showTarget;
        self.clearAlpha = opts.clearAlpha;

        self.ctx = self.canvas.getContext('2d');
        self.ctx.lineCap = 'round';
        self.ctx.lineJoin = 'round';
        self.lineWidth = opts.lineWidth;
        // self.bindEvents();
        self.canvasLoop();

        self.canvas.onselectstart = function () {
            return false;
        };
    };

    /*=============================================================================*/
    /* Particle Constructor
    /*=============================================================================*/
    var Particle = function Particle(x, y, hue) {
        this.x = x;
        this.y = y;
        this.coordLast = [{ x: x, y: y }, { x: x, y: y }, { x: x, y: y }];
        this.angle = rand(0, 360);
        this.speed = rand(self.partSpeed - self.partSpeedVariance <= 0 ? 1 : self.partSpeed - self.partSpeedVariance, self.partSpeed + self.partSpeedVariance);
        this.friction = 1 - self.partFriction / 100;
        this.gravity = self.partGravity / 2;
        this.hue = rand(hue - self.hueVariance, hue + self.hueVariance);
        this.brightness = rand(50, 80);
        this.alpha = rand(40, 100) / 100;
        this.decay = rand(10, 50) / 1000;
        this.wind = (rand(0, self.partWind) - self.partWind / 2) / 25;
        this.lineWidth = self.lineWidth;
    };

    Particle.prototype.update = function (index) {
        var radians = this.angle * Math.PI / 180;
        var vx = Math.cos(radians) * this.speed;
        var vy = Math.sin(radians) * this.speed + this.gravity;
        this.speed *= this.friction;

        this.coordLast[2].x = this.coordLast[1].x;
        this.coordLast[2].y = this.coordLast[1].y;
        this.coordLast[1].x = this.coordLast[0].x;
        this.coordLast[1].y = this.coordLast[0].y;
        this.coordLast[0].x = this.x;
        this.coordLast[0].y = this.y;

        this.x += vx * self.dt;
        this.y += vy * self.dt;

        this.angle += this.wind;
        this.alpha -= this.decay;

        if (this.alpha < .05) {
            self.particles.splice(index, 1);
        }
    };

    Particle.prototype.draw = function () {
        var coordRand = rand(1, 3) - 1;
        self.ctx.beginPath();
        self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
        self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
        self.ctx.closePath();
        self.ctx.strokeStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + this.alpha + ')';
        self.ctx.stroke();

        if (self.flickerDensity > 0) {
            var inverseDensity = 50 - self.flickerDensity;
            if (rand(0, inverseDensity) === inverseDensity) {
                self.ctx.beginPath();
                self.ctx.arc(Math.round(this.x), Math.round(this.y), rand(this.lineWidth, this.lineWidth + 3) / 2, 0, Math.PI * 2, false);
                self.ctx.closePath();
                var randAlpha = rand(50, 100) / 100;
                self.ctx.fillStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + randAlpha + ')';
                self.ctx.fill();
            }
        }
    };

    /*=============================================================================*/
    /* Create Particles
    /*=============================================================================*/
    self.createParticles = function (x, y, hue) {
        var countdown = self.partCount;
        while (countdown--) {
            self.particles.push(new Particle(x, y, hue));
        }
    };

    /*=============================================================================*/
    /* Update Particles
    /*=============================================================================*/
    self.updateParticles = function () {
        var i = self.particles.length;
        while (i--) {
            var p = self.particles[i];
            p.update(i);
        }
    };

    /*=============================================================================*/
    /* Draw Particles
    /*=============================================================================*/
    self.drawParticles = function () {
        var i = self.particles.length;
        while (i--) {
            var p = self.particles[i];
            p.draw();
        }
    };

    /*=============================================================================*/
    /* Firework Constructor
    /*=============================================================================*/
    var Firework = function Firework(startX, startY, targetX, targetY) {
        this.x = startX;
        this.y = startY;
        this.startX = startX;
        this.startY = startY;
        this.hitX = false;
        this.hitY = false;
        this.coordLast = [{ x: startX, y: startY }, { x: startX, y: startY }, { x: startX, y: startY }];
        this.targetX = targetX;
        this.targetY = targetY;
        this.speed = self.fworkSpeed;
        this.angle = Math.atan2(targetY - startY, targetX - startX);
        this.shockwaveAngle = Math.atan2(targetY - startY, targetX - startX) + 90 * (Math.PI / 180);
        this.acceleration = self.fworkAccel / 100;
        this.hue = rand(self.hueMin, self.hueMax);
        this.brightness = rand(50, 80);
        this.alpha = rand(50, 100) / 100;
        this.lineWidth = self.lineWidth;
        this.targetRadius = 1;
    };

    Firework.prototype.update = function (index) {
        self.ctx.lineWidth = this.lineWidth;

        var vx = Math.cos(this.angle) * this.speed;
        var vy = Math.sin(this.angle) * this.speed;
        this.speed *= 1 + this.acceleration;
        this.coordLast[2].x = this.coordLast[1].x;
        this.coordLast[2].y = this.coordLast[1].y;
        this.coordLast[1].x = this.coordLast[0].x;
        this.coordLast[1].y = this.coordLast[0].y;
        this.coordLast[0].x = this.x;
        this.coordLast[0].y = this.y;

        if (self.showTarget) {
            if (this.targetRadius < 8) {
                this.targetRadius += .25 * self.dt;
            } else {
                this.targetRadius = 1 * self.dt;
            }
        }

        if (this.startX >= this.targetX) {
            if (this.x + vx <= this.targetX) {
                this.x = this.targetX;
                this.hitX = true;
            } else {
                this.x += vx * self.dt;
            }
        } else {
            if (this.x + vx >= this.targetX) {
                this.x = this.targetX;
                this.hitX = true;
            } else {
                this.x += vx * self.dt;
            }
        }

        if (this.startY >= this.targetY) {
            if (this.y + vy <= this.targetY) {
                this.y = this.targetY;
                this.hitY = true;
            } else {
                this.y += vy * self.dt;
            }
        } else {
            if (this.y + vy >= this.targetY) {
                this.y = this.targetY;
                this.hitY = true;
            } else {
                this.y += vy * self.dt;
            }
        }

        if (this.hitX && this.hitY) {
            self.createParticles(this.targetX, this.targetY, this.hue);
            self.fireworks.splice(index, 1);
        }
    };

    Firework.prototype.draw = function () {
        self.ctx.lineWidth = this.lineWidth;

        var coordRand = rand(1, 3) - 1;
        self.ctx.beginPath();
        self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
        self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
        self.ctx.closePath();
        self.ctx.strokeStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + this.alpha + ')';
        self.ctx.stroke();

        if (self.showTarget) {
            self.ctx.save();
            self.ctx.beginPath();
            self.ctx.arc(Math.round(this.targetX), Math.round(this.targetY), this.targetRadius, 0, Math.PI * 2, false);
            self.ctx.closePath();
            self.ctx.lineWidth = 1;
            self.ctx.stroke();
            self.ctx.restore();
        }

        if (self.showShockwave) {
            self.ctx.save();
            self.ctx.translate(Math.round(this.x), Math.round(this.y));
            self.ctx.rotate(this.shockwaveAngle);
            self.ctx.beginPath();
            self.ctx.arc(0, 0, 1 * (this.speed / 5), 0, Math.PI, true);
            self.ctx.strokeStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + rand(25, 60) / 100 + ')';
            self.ctx.lineWidth = this.lineWidth;
            self.ctx.stroke();
            self.ctx.restore();
        }
    };

    /*=============================================================================*/
    /* Create Fireworks
    /*=============================================================================*/
    self.createFireworks = function (startX, startY, targetX, targetY) {
        self.fireworks.push(new Firework(startX, startY, targetX, targetY));
    };

    /*=============================================================================*/
    /* Update Fireworks
    /*=============================================================================*/
    self.updateFireworks = function () {
        var i = self.fireworks.length;
        while (i--) {
            var f = self.fireworks[i];
            f.update(i);
        }
    };

    /*=============================================================================*/
    /* Draw Fireworks
    /*=============================================================================*/
    self.drawFireworks = function () {
        var i = self.fireworks.length;
        while (i--) {
            var f = self.fireworks[i];
            f.draw();
        }
    };

    /*=============================================================================*/
    /* Clear Canvas
    /*=============================================================================*/
    self.clear = function () {
        self.particles = [];
        self.fireworks = [];
        self.ctx.clearRect(0, 0, self.cw, self.ch);
    };

    /*=============================================================================*/
    /* Delta
    /*=============================================================================*/
    self.updateDelta = function () {
        var newTime = Date.now();
        self.dt = (newTime - self.oldTime) / 16;
        self.dt = self.dt > 5 ? 5 : self.dt;
        self.oldTime = newTime;
    };

    /*=============================================================================*/
    /* Main Loop
    /*=============================================================================*/
    self.canvasLoop = function () {
        if (self.isRunning) {
            requestAnimFrame(self.canvasLoop, self.canvas);
        }
        self.updateDelta();
        self.ctx.globalCompositeOperation = 'destination-out';
        self.ctx.fillStyle = 'rgba(0,0,0,' + self.clearAlpha / 100 + ')';
        self.ctx.fillRect(0, 0, self.cw, self.ch);
        self.ctx.globalCompositeOperation = 'lighter';
        self.updateFireworks();
        self.updateParticles();
        self.drawFireworks();
        self.drawParticles();
    };

    self.start = function (initialLaunchCount) {
        self.init();
        while (initialLaunchCount--) {
            var delay = initialLaunchCount * rand(150, 200);
            setTimeout(function () {
                self.fireworks.push(new Firework(self.cw / 2, self.ch, rand(self.cw / 4, self.cw * 3 / 4), rand(50, self.ch / 2) - 50));
            }, delay);
        }
    };

    self.stop = function () {
        self.running = false;
    };
};

var opts = {
    fworkSpeed: 3,
    fworkAccel: 4,
    showShockwave: false,
    showTarget: false,
    partCount: 200,
    partSpeed: 20,
    partSpeedVariance: 15,
    partWind: 6,
    partFriction: 12,
    partGravity: 0.5,
    flickerDensity: 42,
    hueMin: 0,
    hueMax: 60,
    hueVariance: 18,
    lineWidth: 3,
    clearAlpha: 20
};

var fw = void 0;
function start(el) {
    fw = new Fireworks(el, opts);
    fw.start(12);
}

function stop() {
    fw.stop();
}

/***/ }),

/***/ "PwNb":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("6IEm")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("FBjV"),
  /* template */
  __webpack_require__("0g7W"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "QBUL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'SchoolGroups',
    mixins: [_notificationsMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Loading: _Loading2.default },
    data: function data() {
        return {
            loading: false
        };
    },
    vuex: {
        getters: {
            schools: function schools(state) {
                return state.users.current.schools.map(function (id) {
                    return state.schools.storage[id];
                });
            }
        },
        actions: {

            fetchGroupsForSchool: function fetchGroupsForSchool(_ref, id) {
                var dispatch = _ref.dispatch;


                return _resources2.default.getGroupsForSchool(id).then(function (response) {

                    var result = (0, _helpers.transform)(response.body);
                    var groups = result.groups || [];

                    dispatch('ADD_GROUPS', groups);
                    dispatch('SET_GROUPS_FOR_SCHOOL', groups.map(function (g) {
                        return g.id;
                    }), id);

                    return groups;
                }).catch(function (error) {
                    return (0, _helpers.logreject)('Could not fetch groups', error);
                });
            },

            storeGroupToTeacher: function storeGroupToTeacher(_ref2, teacherId, groupId) {
                var dispatch = _ref2.dispatch;


                return _resources2.default.addGroupToTeacher(teacherId, groupId, true).then(function (response) {
                    var result = (0, _helpers.transform)(response.body);
                    var groups = result.groups || [];

                    dispatch('ADD_TERMS', result.terms || []);
                    dispatch('ADD_PERIODS', result.periods || []);
                    dispatch('ADD_GROUPS', groups);
                    dispatch('ADD_GROUP_TERMS', result.groupterms || []);
                    dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
                    dispatch('SET_CURRENT_USER_GROUPS', groups.map(function (g) {
                        return g.id;
                    }));
                });
            },

            createGroup: function createGroup(_ref3) {
                var dispatch = _ref3.dispatch;

                dispatch('SHOW_MODAL', 'GroupSettings');
            }

        }
    },
    methods: {
        addGroup: function addGroup(group, e) {
            var _this = this;

            e.stopPropagation();

            if (this.isTeachingGroup(group)) {
                this.$warn('Deze klas is al toegevoegd');
                return;
            }

            this.$alert('Weet je zeker dat je klas ' + group.name + ' wilt toevoegen aan jouw overzicht?', [{ name: 'Annuleren' }, { name: 'Toevoegen', primary: true, action: function action() {

                    _this.storeGroupToTeacher(_this.$store.state.users.current.id, group.id).then(function () {
                        _this.$success('Klas ' + group.name + ' toegevoegd');
                        _this.$emit('close');
                    }).catch(function (err) {
                        _analytics2.default.exception('Can\'t add group to teacher', err);
                        _this.$warn('Kan klas niet toevoegen');
                    });
                } }]);
        },
        isTeachingGroup: function isTeachingGroup(group) {
            return this.$store.state.users.current.groups.indexOf(group.id) !== -1;
        }
    },
    computed: {

        school: function school() {
            return this.schools[0];
        },
        groups: function groups() {
            var _this2 = this;

            return this.school.groups.map(function (id) {
                return _this2.$store.state.groups.storage[id];
            });
        }

    },
    created: function created() {
        var _this3 = this;

        this.loading = true;

        this.fetchGroupsForSchool(this.school.id).then(function () {
            return _this3.loading = false;
        }).then(function () {
            if (_this3.groups.length === 0) {
                _this3.createGroup();
            }
        }).catch(function (err) {
            _analytics2.default.exception('Can\'t load school groups', err);
            _this3.$error('Kan klassen niet laden.');
        });
    }
};

/***/ }),

/***/ "QCwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    computed: {
        isTouch: function isTouch() {
            return 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
        }
    }
};

/***/ }),

/***/ "QJis":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    props: {
        steps: {},
        progress: {},
        assignment: {},
        mini: {
            type: Boolean,
            default: false
        },
        autolink: {
            type: Boolean,
            default: false
        },
        currentStep: {
            default: null
        }
    },
    vuex: {
        getters: {},
        actions: {}
    },
    methods: {
        stepLink: function stepLink(step) {
            if (this.autolink) return { name: 'assignment', params: { assignmentId: this.assignment.id } };
            return { name: 'assignment.step', params: { assignmentId: this.assignment.id, stepIdx: step.precedence } };
        },
        isStepCompleted: function isStepCompleted(step) {
            if (this.progress == null) {
                return false;
            }
            return this.finished || this.progress.step >= step.precedence;
        }
    },
    computed: {
        progressSteps: function progressSteps() {
            var _this = this;

            return this.steps.map(function (s) {
                return {
                    link: _this.stepLink(s),
                    type: s.type,
                    isCompleted: _this.isStepCompleted(s),
                    isActive: _this.currentStep == s.precedence,
                    precedence: s.precedence
                };
            });
        },
        finished: function finished() {
            return this.progress == null ? false : this.progress.finished;
        },
        isDoneStepActive: function isDoneStepActive() {
            return typeof this.currentStep === 'string' ? this.currentStep.split('.').some(function (p) {
                return p === 'done' || p === 'overview';
            }) : false;
        },
        doneLink: function doneLink() {
            if (this.autolink) return { name: 'assignment', params: { assignmentId: this.assignment.id } };
            return { name: this.finished ? 'assignment.overview' : 'assignment.done', params: { assignmentId: this.assignment.id } };
        }
    }
};

/***/ }),

/***/ "QSpI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TeacherFeedback = __webpack_require__("z1et");

var _TeacherFeedback2 = _interopRequireDefault(_TeacherFeedback);

var _Diligence = __webpack_require__("YyG+");

var _Diligence2 = _interopRequireDefault(_Diligence);

var _Question = __webpack_require__("haHN");

var _Question2 = _interopRequireDefault(_Question);

var _Upload = __webpack_require__("DBjH");

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    components: { TeacherFeedback: _TeacherFeedback2.default, Diligence: _Diligence2.default, Question: _Question2.default, Upload: _Upload2.default },
    props: {
        progress: {}
    },

    computed: {

        submission: function submission() {
            return this.submissions[this.submissions.length - 1];
        },

        submissions: function submissions() {
            var _this = this;

            if (this.progress == null) {
                return [];
            }
            return this.progress.primarySubmissions.map(function (id) {
                return _this.$store.state.submissions.storage[id];
            }).filter(function (s) {
                return s != null;
            });
        }
    },

    methods: {

        typeOfSubmission: function typeOfSubmission(submission) {

            return submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null ? 'Upload' : 'Question';
        }
    }
};

/***/ }),

/***/ "QbGP":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Cfwm")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Z+EI"),
  /* template */
  __webpack_require__("UUci"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "QngU":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("D2kb")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("oDPp"),
  /* template */
  __webpack_require__("1Kfu"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Qnuz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-overview"
  }, [(_vm.isTeacher) ? [_c('header', {
    staticClass: "page-header"
  }, [_c('a', {
    staticClass: "tag button-timid left button--show-planning print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupSettings(_vm.group)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--settings-dark"
  }), _vm._v(" Planning aanpassen")]), _c('h1', [_vm._v("klas " + _vm._s(_vm.group.name))]), _c('hr')]), _c('div', {
    staticClass: "page-content"
  }, [_c('term-nav', {
    staticClass: "print-hide",
    attrs: {
      "terms": _vm.terms,
      "currentGroupTermId": _vm.currentGroupTerm.id
    }
  }), (_vm.group.students.length === 0 && !_vm.group.archived) ? _c('empty-group-message', {
    attrs: {
      "group": _vm.group
    }
  }) : _vm._e(), _c('p', {
    staticClass: "note note--info"
  }, [_vm._v("Dit is het overzicht van alle opdrachten voor " + _vm._s(_vm.group.name) + ", verdeeld in " + _vm._s(_vm.terms.length) + " periodes: "), _c('strong', [_vm._v(_vm._s(_vm.termNames))]), _vm._v(". Elke periode bestaat uit vier blokken met verschillende opdrachten.\n          In het linker menu kunt u de periodes en voortgang bekijken. Kies "), _c('strong', [_vm._v("klas " + _vm._s(_vm.group.name))]), _vm._v(" linksboven om direct naar de huidige periode te gaan.")])], 1)] : _c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v("Overzicht")]), _c('p', [_vm._v("Hier vind je een overzicht van alle opdrachten voor dit jaar. Wil je vast vooruitwerken? Vraag het eerst even aan je docent. Bekijk "), _c('router-link', {
    attrs: {
      "to": {
        name: 'period'
      }
    }
  }, [_vm._v("jouw opdrachtenlijst")]), _vm._v(" om aan de slag te gaan met de opdrachten van de huidige periode.")], 1), _c('hr')]), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "relative": true
    }
  }) : _vm._l((_vm.terms), function(term, index) {
    return _c('div', {
      staticClass: "assignment-overview__term"
    }, [_c('h1', {
      staticClass: "assignment-overview__term-title banner"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": _vm.isTeacher ? {
          name: 'students.overview',
          params: {
            groupTermId: term.groupTermId
          }
        } : {
          name: 'period',
          params: {
            periodId: term.periods[0].groupPeriodId
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(index + 1) + ". " + _vm._s(term.title) + "\n            ")])], 1)]), _vm._l((term.periods), function(period) {
      return _c('div', {
        staticClass: "assignment-overview__period"
      }, [_c('p', {
        staticClass: "assignment-overview__period-title tag"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'period',
            params: {
              periodId: period.groupPeriodId
            }
          }
        }
      }, [_vm._v(_vm._s(period.title))]), _c('br'), _c('span', {
        staticClass: "timid"
      }, [_vm._v(_vm._s(period.start) + " t/m " + _vm._s(period.end))])], 1), _vm._l((period.assignments), function(assignment) {
        return _c('div', {
          staticClass: "assignment-overview__assignment",
          class: {
            'assignment-overview__assignment--disabled': _vm.isDisabledAssignment(assignment)
          }
        }, [_c('router-link', {
          staticClass: "assignment-overview__link",
          attrs: {
            "to": {
              name: 'assignment',
              params: {
                assignmentId: assignment.id,
                periodId: _vm.isTeacher ? period.groupPeriodId : undefined /* necessary for teacher, but double redirects if present for student */
              }
            }
          }
        }, [_c('img', {
          staticClass: "assignment-overview__hero",
          attrs: {
            "src": assignment.image,
            "alt": assignment.title
          }
        }), _c('span', {
          staticClass: "assignment-icon",
          class: 'icon-' + assignment.type
        }), _c('h3', {
          staticClass: "assignment-overview__title"
        }, [_vm._v(_vm._s(assignment.title))]), _c('p', {
          staticClass: "assignment-overview__subtitle"
        }, [_vm._v(_vm._s(assignment.subtitle))])])], 1)
      })], 2)
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "QoH3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupSettingsInvite',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        group: {
            required: true
        },
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        registerLink: function registerLink() {
            return document.location.host + '/registreren';
        },

        exampleInvite: function exampleInvite() {
            return {
                title: 'Aanmelden bij Kiempunt',
                body: 'Hallo!\n\nVoor het vak beeldende vorming gaan we de komende tijd gebruikmaken van Kiempunt. In deze app krijg je een eigen werkmap waarin jouw gemaakte werken komen te staan.\n\nJe kunt alvast een nieuwe werkmap aanmaken door naar ' + this.registerLink + ' te gaan.\n\n Bij \'Uitnodigingscode\' vul je dan de code  ' + this.group.code + '  in. Zo kom je direct bij jouw klas ' + this.group.name + '.\n\n\nVeel succes!'
            };
        },

        inviteUrl: function inviteUrl() {
            return 'mailto:?subject=' + encodeURIComponent(this.exampleInvite.title) + '&body=' + encodeURIComponent(this.exampleInvite.body);
        }
    },

    methods: {
        done: function done(e) {
            e.preventDefault();
            this.$emit('done');
        },
        save: function save() {
            return Promise.resolve();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "R5Qg":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("q120")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("je1x"),
  /* template */
  __webpack_require__("lSE2"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Rb2s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

var _helpers = __webpack_require__("x3kM");

var _auth = __webpack_require__("JOmw");

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _EmptyGroupMessage = __webpack_require__("329f");

var _EmptyGroupMessage2 = _interopRequireDefault(_EmptyGroupMessage);

var _TermNav = __webpack_require__("aBjJ");

var _TermNav2 = _interopRequireDefault(_TermNav);

var _getters = __webpack_require__("olIF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { EmptyGroupMessage: _EmptyGroupMessage2.default, Loading: _Loading2.default, TermNav: _TermNav2.default },
    mixins: [_notificationsMixin2.default],

    props: {
        group: {},
        isDemo: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            isLoading: true
        };
    },

    vuex: {
        getters: {
            getCurrentGroupTermForGroup: _getters.getCurrentGroupTermForGroup
        },
        actions: {
            showGroupSettings: function showGroupSettings(_ref, group) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'GroupSettings', { group: group, landingPage: 'Planning' });
            },

            getPlanning: function getPlanning(_ref2, groupId) {
                var dispatch = _ref2.dispatch;

                return _resources2.default.getPlanning(groupId).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_GROUP_TERMS', result.groupterms || []);
                    dispatch('ADD_GROUP_PERIODS', result.groupperiods || []);
                    dispatch('ADD_GROUP_ASSIGNMENTS', result.groupassignments || []);

                    dispatch('ADD_TERMS', result.terms || []);
                    dispatch('ADD_PERIODS', result.periods || []);

                    dispatch('ADD_ASSIGNMENTS', result.assignments || []);
                    return result;
                });
            }
        }
    },

    computed: {
        isTeacher: function isTeacher() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        },

        terms: function terms() {
            // hydrated planning
            // term.periods.assignments
            var store = this.$store.state;
            return this.group.groupTerms.map(function (id) {
                return store.groups.terms[id];
            }).filter(function (gt) {
                return gt.term != null && gt.term.length > 0;
            }).map(function (gt) {
                var term = store.terms.storage[gt.term[0]];
                term.groupTermId = gt.id;
                var lastStart = (0, _moment2.default)(gt.start * 1000).format('D MMMM');
                term.periods = gt.groupPeriods.map(function (id) {
                    var gp = store.groups.periods[id];
                    var period = store.periods.storage[gp.period[0]];

                    period.groupPeriodId = id;
                    period.start = lastStart;
                    period.end = (0, _moment2.default)(gp.end * 1000).format('D MMMM');
                    lastStart = (0, _moment2.default)(gp.end * 1000).add(1, 'days').format('D MMMM');

                    period.assignments = gp.groupAssignments.map(function (id) {
                        return store.groups.assignments[id];
                    }).filter(function (ga) {
                        return !ga.optional;
                    }).map(function (ga) {
                        return store.assignments.storage[ga.assignment[0]];
                    });

                    return period;
                });
                return term;
            }).filter(function (t) {
                return t.periods.length > 0;
            });
        },

        termNames: function termNames() {
            var titles = this.terms.map(function (t) {
                return t.title;
            });

            if (titles.length < 2) {
                return titles[0];
            }

            return titles.slice(0, titles.length - 1).join(', ') + ' en ' + titles[titles.length - 1];
        },

        currentGroupTerm: function currentGroupTerm() {
            return this.getCurrentGroupTermForGroup(this.group.id);
        }
    },

    created: function created() {
        var _this = this;

        this.fetchPlanning(this.group.id).then(function () {
            return _this.isLoading = false;
        });
    },


    methods: {

        fetchPlanning: function fetchPlanning(groupId) {
            var _this2 = this;

            return this.getPlanning(groupId).catch(function (err) {
                _analytics2.default.exception('Can\'t load assignments', err);
                _this2.$error('Kan opdrachten niet laden');
            });
        },

        isDisabledAssignment: function isDisabledAssignment(assignment) {
            return this.isDemo && !assignment.demo;
        }

    }
};

/***/ }),

/***/ "S9HV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SaQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sb2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sqyl":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "teacher-feedback-wrap"
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "page-content teacher-feedback-container"
  }, [(_vm.shouldShowReflectiontips) ? _c('a', {
    staticClass: "button-rounded button-rounded--reflection button-rounded--teachertips",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflectiontips(_vm.assignment)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--reflection"
  }), _vm._v("Tips")]) : _vm._e(), _c('h2', {
    staticClass: "teacher-feedback__title"
  }, [_vm._v("Feedback")]), (_vm.compliments.length) ? _c('div', {
    staticClass: "input-group"
  }, [_c('h3', [_vm._v("Dit heb je goed gedaan")]), _c('multiselect', {
    attrs: {
      "options": _vm.compliments,
      "track-by": "id",
      "label": "content",
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "multiple": true,
      "hide-selected": true,
      "disabled": _vm.hasFeedbackFromOtherTeacher,
      "placeholder": "Kies (één of meer) tops..."
    },
    model: {
      value: (_vm.feedback.compliments),
      callback: function($$v) {
        _vm.feedback.compliments = $$v
      },
      expression: "feedback.compliments"
    }
  })], 1) : _vm._e(), (_vm.remarks.length) ? _c('div', {
    staticClass: "input-group"
  }, [_c('h3', [_vm._v("Besteed hier nog wat aandacht aan")]), _c('multiselect', {
    attrs: {
      "options": _vm.remarks,
      "track-by": "id",
      "label": "content",
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "multiple": true,
      "hide-selected": true,
      "disabled": _vm.hasFeedbackFromOtherTeacher,
      "placeholder": "Kies (één of meer) tips..."
    },
    model: {
      value: (_vm.feedback.remarks),
      callback: function($$v) {
        _vm.feedback.remarks = $$v
      },
      expression: "feedback.remarks"
    }
  })], 1) : _vm._e(), _c('h3', [_vm._v("Opmerkingen")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feedback.content),
      expression: "feedback.content"
    }],
    staticClass: "teacher-feedback",
    attrs: {
      "placeholder": "",
      "readonly": _vm.hasFeedbackFromOtherTeacher
    },
    domProps: {
      "value": (_vm.feedback.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.feedback.content = $event.target.value
      }
    }
  }), _c('h2', [_vm._v("Beoordeling")]), _c('Diligence', {
    attrs: {
      "progress": _vm.progress,
      "isDemo": _vm.isDemo
    },
    on: {
      "input": function($event) {
        _vm.diligence = $event
      }
    }
  }), (_vm.progress.isRetaking) ? _c('p', {
    staticClass: "note note--large note--warning"
  }, [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Deze opdracht wordt overgedaan.")]) : _c('p', [_c('a', {
    staticClass: "tag button-timid button--retake-assignment",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.retakeAssignment
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Laat " + _vm._s(_vm.reviewee.firstname) + " opdracht overdoen")])]), _c('Badges', {
    attrs: {
      "progress": _vm.progress,
      "isDemo": _vm.isDemo,
      "disabled": _vm.diligence !== 'sufficient'
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "show-group-submissions tag button-timid button-forward",
    attrs: {
      "to": {
        name: 'group.assignment.group',
        params: {
          periodId: _vm.periodIdForAssignment(_vm.assignment)
        }
      }
    }
  }, [_vm._v("Klasoverzicht " + _vm._s(_vm.assignment.title))]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ "Sueq":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("a8kc")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Dt/U"),
  /* template */
  __webpack_require__("sNcH"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "SzmP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        current: null,
        storage: {}
    };
};

var mutations = {
    SHOW_IMAGE: function SHOW_IMAGE(state, image) {
        state.current = image;
    },
    HIDE_IMAGE: function HIDE_IMAGE(state) {
        state.current = null;
    },
    ADD_IMAGES: function ADD_IMAGES(state, images) {
        (0, _helpers.setObjects)(images, state.storage);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "T1ye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T7Rh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_DILIGENCE: function ADD_DILIGENCE(state, diligence) {
        (0, _helpers.setObjects)(diligence, state.storage, {});
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "T85f":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("+uEr")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("PZ9P"),
  /* template */
  __webpack_require__("1s9c"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "TOWi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _concat2 = __webpack_require__("NxPG");

var _concat3 = _interopRequireDefault(_concat2);

var _uniq2 = __webpack_require__("WIDu");

var _uniq3 = _interopRequireDefault(_uniq2);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_SCHOOLS: function ADD_SCHOOLS(state, schools) {
        (0, _helpers.setObjects)(schools, state.storage, { groups: [], tickets: [] });
    },
    SET_GROUPS_FOR_SCHOOL: function SET_GROUPS_FOR_SCHOOL(state, groups, schoolId) {
        state.storage[schoolId].groups = groups;
    },
    APPEND_GROUP_TO_SCHOOL: function APPEND_GROUP_TO_SCHOOL(state, group, schoolId) {
        state.storage[schoolId].groups = (0, _uniq3.default)((0, _concat3.default)(state.storage[schoolId].groups, group.id));
    },
    ADD_SCHOOL_TICKET_TO_SCHOOL: function ADD_SCHOOL_TICKET_TO_SCHOOL(state, schoolId, schoolTicketId) {
        var school = state.storage[schoolId];

        if (school.tickets.indexOf(schoolTicketId) === -1) {
            school.tickets.push(schoolTicketId);
        }
    },
    RESET_SCHOOL_TICKETS: function RESET_SCHOOL_TICKETS(state, schoolId) {
        state.storage[schoolId].tickets = [];
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "TPCG":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("cr1P")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ZqZe"),
  /* template */
  __webpack_require__("2INl"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "U+/7":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("SaQA")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("c4sb"),
  /* template */
  __webpack_require__("/M4R"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "UCHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {},
        compliments: {},
        remarks: {}
    };
};

var mutations = {
    ADD_FEEDBACK: function ADD_FEEDBACK(state, feedbacks) {
        (0, _helpers.setObjects)(feedbacks, state.storage, {});
    },
    ADD_COMPLIMENTS: function ADD_COMPLIMENTS(state, compliments) {
        (0, _helpers.setObjects)(compliments, state.compliments, {});
    },
    ADD_REMARKS: function ADD_REMARKS(state, remarks) {
        (0, _helpers.setObjects)(remarks, state.remarks, {});
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "UCVt":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("+3eB")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("lTmj"),
  /* template */
  __webpack_require__("uVal"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "UE1J":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Welkom terug!")]), _c('p', [_vm._v("Vul je e-mailadres en wachtwoord in om je werkmap te openen\n                "), (_vm.otherLinks) ? [_c('br'), _c('strong', [_vm._v("Nog geen werkmap?")]), _vm._v(" Ga naar "), _c('router-link', {
    staticClass: "to-register",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("registreren")])] : _vm._e()], 2)]), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("Blijf 30 dagen ingelogd")])]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Inloggen")])], 1)]), (_vm.otherLinks) ? _c('div', {
    staticClass: "login__auth-other",
    class: {
      'auth-attention': _vm.hasInvalidCredentials
    }
  }, [_c('router-link', {
    staticClass: "to-register",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Registreren")]), _vm._v(" |\n                "), _c('router-link', {
    staticClass: "to-forgot-password",
    attrs: {
      "to": {
        name: 'forgot'
      }
    }
  }, [_vm._v("Wachtwoord vergeten")])], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ "UUci":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "timeline__hoverable"
  }, [_c('header', {
    staticClass: "timeline__header timeline__highlightable"
  }, [_c('h3', {
    staticClass: "timeline__title"
  }, [_vm._v("\n            " + _vm._s(_vm.assignment.title) + "\n            "), (_vm.hasFeedback) ? _c('span', {
    staticClass: "icon icon--inline icon--feedback",
    class: {
      'icon--feedback-dark': _vm.isActive
    },
    attrs: {
      "title": "Heeft feedback gekregen"
    }
  }) : _vm._e(), (_vm.shouldRetake) ? _c('span', {
    staticClass: "icon icon--inline icon--retake",
    class: {
      'icon--retake-dark': _vm.isActive
    },
    attrs: {
      "title": "Opdracht opnieuw inleveren"
    }
  }) : _vm._e(), (_vm.hasDiligence) ? _c('span', {
    staticClass: "diligence__icon diligence__icon--bg-replace diligence__icon--mini active",
    class: 'diligence__icon--' + _vm.diligence.tag,
    attrs: {
      "title": _vm.diligence.tag
    }
  }) : _vm._e()]), _c('span', {
    staticClass: "timeline__meta"
  }, [_c('span', {
    staticClass: "timeline__date"
  }, [_vm._v(_vm._s(_vm.date))]), (!_vm.progress.finished) ? _c('span', {
    staticClass: "timeline__progress"
  }, [_vm._v(" - stap " + _vm._s(_vm.progress.step + 1))]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "reveal"
    }
  }, [(_vm.preview) ? _c('p', {
    staticClass: "timeline__content timeline__content--submission"
  }, [(_vm.type == 'Image') ? _c('img', {
    staticClass: "timeline__thumbnail",
    attrs: {
      "src": _vm.preview.data.thumb
    }
  }) : _vm._e(), (_vm.type == 'Text') ? _c('span', {
    staticClass: "timeline__text"
  }, [_vm._v("“" + _vm._s(_vm.previewText) + "”")]) : _vm._e(), (_vm.hasBadge) ? _c('img', {
    staticClass: "timeline__badge",
    class: {
      'timeline__badge--right': _vm.type == 'Text'
    },
    attrs: {
      "src": ("/build/img/badges/badge-" + (_vm.badge.type) + "-color-128x.png")
    }
  }) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "UfM8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uht+":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.loading) ? _c('loading') : _vm._e(), (!_vm.loading && (_vm.submissions.length || !_vm.isExcerpt)) ? _c('div', {
    staticClass: "group-submissions-container",
    class: {
      excerpt: _vm.isExcerpt, full: !_vm.isExcerpt
    }
  }, [_c('h1', {
    staticClass: "banner"
  }, [(_vm.isInspecting) ? _c('span', [_vm._v("Dit hebben de leerlingen ingeleverd")]) : _c('span', [_vm._v("Dit hebben je klasgenoten gemaakt")])]), (_vm.submissions.length > 0) ? _c('div', [(_vm.isExcerpt) ? _c('div', [(_vm.type(_vm.submissions[0]) === 'Upload') ? _c('upload-presenter', {
    attrs: {
      "submissions": _vm.submissions,
      "mini": true
    }
  }) : _vm._l((_vm.submissions), function(submission) {
    return _c('question-presenter', {
      key: submission.id,
      attrs: {
        "submissions": [submission]
      }
    })
  }), (_vm.submissions.length >= 3) ? _c('router-link', {
    staticClass: "show-more-submissions button-timid button-forward",
    attrs: {
      "to": {
        name: 'assignment.group'
      }
    }
  }, [_vm._v("Meer")]) : _vm._e()], 2) : _c('div', _vm._l((_vm.users), function(user) {
    return _c('div', [_c('h4', [(_vm.isInspecting) ? _c('router-link', {
      staticClass: "show-student",
      attrs: {
        "to": {
          name: 'students.assignment.overview',
          params: {
            studentId: user.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(user.firstname) + " " + _vm._s(user.middlename) + " " + _vm._s(user.lastname) + " "), _c('br'), (user.hasFeedback) ? _c('span', {
      staticClass: "icon icon--inline icon--feedback-dark",
      attrs: {
        "title": "Heeft feedback gekregen"
      }
    }) : _vm._e(), (user.isRetaking) ? _c('span', {
      staticClass: "icon icon--inline icon--retake-dark",
      attrs: {
        "title": "Opdracht opnieuw inleveren"
      }
    }) : _vm._e(), (user.diligence) ? _c('span', {
      staticClass: "diligence__icon diligence__icon--bg-replace diligence__icon--mini active",
      class: 'diligence__icon--' + user.diligence.tag,
      attrs: {
        "title": user.diligence.tag
      }
    }) : _vm._e()]) : _c('span', [_vm._v(_vm._s(user.firstname) + " " + _vm._s(user.middlename) + " " + _vm._s(user.lastname))])], 1), (_vm.type(user.submissions[0]) === 'Upload') ? _c('upload-presenter', {
      attrs: {
        "submissions": user.submissions,
        "mini": true
      }
    }) : _vm._l((user.submissions), function(submission) {
      return _c('question-presenter', {
        key: submission.id,
        attrs: {
          "submissions": [submission]
        }
      })
    })], 2)
  }))]) : _c('p', [_vm._v("Er zijn nog geen ingeleverde opdrachten")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "UifB":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.mini) ? _c('div', {
    staticClass: "revision"
  }, [_c('div', {
    staticClass: "revision__container revision__container--upload"
  }, _vm._l((_vm.submissions), function(submission) {
    return _c('div', {
      staticClass: "submission submission--upload"
    }, [_c('a', {
      staticClass: "submission__thumb-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showImage(submission.data.medium)
        }
      }
    }, [_c('img', {
      staticClass: "submission__thumb",
      attrs: {
        "src": submission.data.thumb
      }
    })])])
  }))]) : _c('div', [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._l((_vm.revisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.showVersions && _vm.revisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title revision__title--no-container"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _vm._l((revision.submissions), function(submission) {
      return _c('a', {
        staticClass: "submission__image-link",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showImage(submission.data.medium)
          }
        }
      }, [_c('img', {
        staticClass: "submission__image",
        attrs: {
          "src": submission.data.medium
        }
      })])
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "Ukaq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Klas")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Bijvoorbeeld: AH1c"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('level')
    }
  }, [_c('label', {
    attrs: {
      "for": "level"
    }
  }, [_vm._v("Niveau")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.level),
      expression: "level"
    }],
    attrs: {
      "name": "level",
      "id": "level",
      "disabled": !_vm.isCreating || _vm.isCreated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.level = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Kies een niveau")]), _vm._l((_vm.availableLevels), function(level) {
    return _c('option', {
      domProps: {
        "value": level.id
      }
    }, [_vm._v("Jaar " + _vm._s(level.year))])
  })], 2)]), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    staticClass: "action-wrapper"
  }, [(!_vm.isCreating || _vm.isCreated) ? _c('a', {
    staticClass: "tag button-timid button-timid--warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.detachGroup($event)
      }
    }
  }, [_vm._v("Verwijder van mijn overzicht")]) : _vm._e(), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "UlZ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uqqx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UuCl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V81C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VPYc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUOn":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord bevestiging")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Opslaan")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "VsKO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.partial.data.title))]), (_vm.partial.data.example) ? _c('p', {
    staticClass: "example"
  }, [_vm._v(_vm._s(_vm.partial.data.example))]) : _vm._e(), _vm._l((_vm.frozenRevisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.progress.isRetaking || _vm.frozenRevisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('p', {
      staticClass: "revision__container submission submission--answer"
    }, [_vm._v(_vm._s(revision.submission))])])
  }), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    class: {
      story: _vm.partial.data.story
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }) : _vm._e(), (_vm.readonly && _vm.frozenRevisions.length === 0) ? _c('p', {
    staticClass: "revision__container revision__container--teacher"
  }, [_vm._v("In te vullen door leerling")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "Vw6N":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('old_password')
    }
  }, [_c('label', {
    attrs: {
      "for": "old-password"
    }
  }, [_vm._v("Huidig wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old_password),
      expression: "old_password"
    }],
    attrs: {
      "type": "password",
      "name": "old_password",
      "id": "old_password"
    },
    domProps: {
      "value": (_vm.old_password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.old_password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('passwordConfirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordConfirmation"
    }
  }, [_vm._v("Herhaal nieuw wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_passwordConfirmation),
      expression: "new_passwordConfirmation"
    }],
    attrs: {
      "type": "password",
      "name": "passwordConfirmation",
      "id": "passwordConfirmation"
    },
    domProps: {
      "value": (_vm.new_passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_passwordConfirmation = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Opslaan")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nieuw wachtwoord "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— minimaal 8 tekens")])])
}]}

/***/ }),

/***/ "WFFm":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("n/5Q")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xfBg"),
  /* template */
  __webpack_require__("mYC5"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WIlv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "goals"
  }, [(_vm.goals) ? _c('div', [_c('definition-parser', [_c('h1', [_vm._v("Dit ga je leren")]), _c('ul', {
    staticClass: "goals-content"
  }, _vm._l((_vm.goals), function(goal) {
    return _c('li', [_vm._v(_vm._s(goal))])
  }))])], 1) : _vm._e(), (_vm.successors.length || _vm.predecessors.length) ? _c('div', {
    staticClass: "assignment-seq"
  }, [_c('hr'), (_vm.successors.length) ? [_vm._m(0), _vm._l((_vm.successors), function(assignment) {
    return _c('router-link', {
      key: assignment.id,
      staticClass: "assignment-seq__related assignment-seq__related--successor",
      attrs: {
        "to": {
          name: 'assignment',
          params: {
            assignmentId: assignment.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('close')
        }
      }
    }, [_c('img', {
      staticClass: "assignment-seq__hero",
      attrs: {
        "src": assignment.image,
        "alt": assignment.title
      }
    }), _c('span', {
      staticClass: "assignment-seq__title tag"
    }, [_vm._v(_vm._s(assignment.title))])])
  })] : _vm._e(), (_vm.predecessors.length) ? [_vm._m(1), _vm._l((_vm.predecessors), function(assignment) {
    return _c('router-link', {
      key: assignment.id,
      staticClass: "assignment-seq__related assignment-seq__related--predecessor",
      attrs: {
        "to": {
          name: 'assignment',
          params: {
            assignmentId: assignment.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('close')
        }
      }
    }, [_c('img', {
      staticClass: "assignment-seq__hero",
      attrs: {
        "src": assignment.image,
        "alt": assignment.title
      }
    }), _c('span', {
      staticClass: "assignment-seq__title tag"
    }, [_vm._v(_vm._s(assignment.title))])])
  })] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opdracht bereidt voor op:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opdracht valt terug op:")])])
}]}

/***/ }),

/***/ "WM40":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("wNLN")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("regp"),
  /* template */
  __webpack_require__("BOO5"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WlIq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_PARTIALS: function ADD_PARTIALS(state, partials) {
        (0, _helpers.setObjects)(partials, state.storage, { validated: false, submissions: [] });
    },
    VALIDATE_PARTIAL: function VALIDATE_PARTIAL(state, partialId, validated) {
        state.storage[partialId].validated = validated;
    },
    ADD_SUBMISSION_TO_PARTIAL: function ADD_SUBMISSION_TO_PARTIAL(state, partialId, submissionId) {
        var partial = state.storage[partialId];

        if (partial.submissions.indexOf(submissionId) === -1) {
            partial.submissions.push(submissionId);
        }
    },
    REMOVE_SUBMISSION_FROM_PARTIAL: function REMOVE_SUBMISSION_FROM_PARTIAL(state, partialId, submissionId) {

        var partial = state.storage[partialId];
        var index = partial.submissions.indexOf(submissionId);

        if (index !== -1) {
            partial.submissions.splice(index, 1);
        }
    },
    SWAP_SUBMISSION_ID: function SWAP_SUBMISSION_ID(state, partialId, oldId, newId) {

        var partial = state.storage[partialId];
        var index = partial.submissions.indexOf(oldId);

        if (index !== -1) {
            partial.submissions.splice(index, 1, newId);
        }
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "WpLC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('passwordConfirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordConfirmation"
    }
  }, [_vm._v("Herhaal wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    attrs: {
      "type": "password",
      "name": "passwordConfirmation",
      "id": "passwordConfirmation"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Verstuur")])], 1)]), _c('div', {
    staticClass: "login__auth-other"
  }, [_c('router-link', {
    staticClass: "to-login",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Terug naar inloggen")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Reset je wachtwoord")]), _c('p', [_vm._v("Voer de onderstaande velden in om je wachtwoord te veranderen.")])])
}]}

/***/ }),

/***/ "X/KW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        terms: {
            type: Array,
            required: true
        },
        selectedGroupTermId: {
            type: String,
            required: false,
            default: null
        },
        currentGroupTermId: {
            type: String,
            required: false,
            default: null
        }
    }
};

/***/ }),

/***/ "X0RP":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("B1wW")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2HFh"),
  /* template */
  __webpack_require__("fBeb"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XRG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Timeline = __webpack_require__("XYq3");

var _Timeline2 = _interopRequireDefault(_Timeline);

var _transformers = __webpack_require__("j0ZK");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    props: {
        group: {}
    },

    components: { Timeline: _Timeline2.default },

    computed: {
        students: function students() {
            var _this = this;

            return this.group.students.map(function (id) {
                return _this.$store.state.users.storage[id];
            });
        }
    },
    methods: {
        isStudentActive: function isStudentActive(student) {
            return this.$route.params.studentId === student.id;
        },
        viewStudent: function viewStudent(student) {
            this.$router.push({ name: 'students.period', params: { studentId: student.id } });
        },
        username: _transformers.username,
        initials: _transformers.initials
    }
};

/***/ }),

/***/ "XYq3":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("8nkQ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9A6d"),
  /* template */
  __webpack_require__("Yadj"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XZTz":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("BfIs")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BEXD"),
  /* template */
  __webpack_require__("UE1J"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XcyR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xrab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Dropzone = __webpack_require__("zQYW");

var _Dropzone2 = _interopRequireDefault(_Dropzone);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    props: {
        category: {
            type: String,
            required: true
        },
        value: {}
    },

    components: { Dropzone: _Dropzone2.default },

    vuex: {
        actions: {
            storeImage: function storeImage(_ref, data) {
                var dispatch = _ref.dispatch;

                dispatch('ADD_IMAGES', [data]);
            }
        }
    },

    methods: {

        addedImage: function addedImage(file, data) {
            this.storeImage(data);
            this.$emit('added', data);
        },

        removedImage: function removedImage(file, data) {
            var _this = this;

            _resources2.default.deleteImage(data.id).then(function () {
                return _this.$emit('removed', data);
            });
        },

        useImage: function useImage(file, data) {
            this.$emit('use', data);
        }

    },

    computed: {

        url: function url() {
            return this.$http.options.root + '/images/' + this.category;
        }

    }

};

/***/ }),

/***/ "Xudg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _User = __webpack_require__("5a7i");

var _User2 = _interopRequireDefault(_User);

var _Email = __webpack_require__("Hbgz");

var _Email2 = _interopRequireDefault(_Email);

var _Password = __webpack_require__("mz3s");

var _Password2 = _interopRequireDefault(_Password);

var _Group = __webpack_require__("E64q");

var _Group2 = _interopRequireDefault(_Group);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _auth = __webpack_require__("JOmw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Settings',
    props: ['inModal'],
    components: { User: _User2.default, Password: _Password2.default, Group: _Group2.default, Email: _Email2.default },

    data: function data() {
        return {
            view: 'User'
        };
    },

    vuex: {
        getters: {
            user: function user(state) {
                return state.users.current;
            }
        }
    },

    computed: {
        personalActive: function personalActive() {
            return this.view === 'User' || this.$route.name === 'settings.user';
        },
        emailActive: function emailActive() {
            return this.view === 'Email' || this.$route.name === 'settings.email';
        },
        passwordActive: function passwordActive() {
            return this.view === 'Password' || this.$route.name === 'settings.password';
        },
        groupActive: function groupActive() {
            return this.view === 'Group' || this.$route.name === 'settings.group';
        },

        isGroupAvailable: function isGroupAvailable() {
            return (0, _auth.isStudent)(this.user);
        }
    },

    methods: {
        viewPersonal: function viewPersonal() {
            if (this.inModal) {
                this.view = 'User';
            } else {
                this.$router.push({ name: 'settings.user' });
            }
        },
        viewEmail: function viewEmail() {
            if (this.inModal) {
                this.view = 'Email';
            } else {
                this.$router.push({ name: 'settings.email' });
            }
        },
        viewPassword: function viewPassword() {
            if (this.inModal) {
                this.view = 'Password';
            } else {
                this.$router.push({ name: 'settings.password' });
            }
        },
        viewGroup: function viewGroup() {
            if (this.inModal) {
                this.view = 'Group';
            } else {
                this.$router.push({ name: 'settings.group' });
            }
        },

        done: function done() {
            this.$emit('close');
        }

    },

    created: function created() {
        _analytics2.default.event('user', 'settings', this.user.id);
    }
};

/***/ }),

/***/ "YOpM":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("gQQ7")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("I430"),
  /* template */
  __webpack_require__("guAv"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Yadj":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.items.length) ? _c('transition-group', {
    staticClass: "timeline",
    attrs: {
      "name": "insertion-top",
      "tag": "ol"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "timeline__item",
      class: {
        'is-active': _vm.isActive(item), 'is-marked': _vm.isMarked(item)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.open(item)
        }
      }
    }, [_vm._t("item", [_vm._v(_vm._s(item))], null, item)], 2)
  })) : _c('p', {
    staticClass: "sidebar__empty small"
  }, [_vm._t("empty", [_vm._v("Geen " + _vm._s(_vm.collectionName) + " gevonden")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "YhPF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YkV/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },

    vuex: {
        actions: {
            showSettings: function showSettings(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'Settings');
            }
        }
    },

    computed: {

        logout: function logout() {
            return this.isDemo ? { to: { name: 'logout', params: { _internal: true }, query: { next: 'web' } }, text: 'Terug naar website' } : { to: { name: 'logout', params: { _internal: true } }, text: 'Uitloggen' };
        },

        isAdminActive: function isAdminActive() {
            return window.location.pathname.substring(0, 6) == '/admin';
        }

    },

    methods: {

        hide: function hide(e) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('hide');
        },

        viewSettings: function viewSettings() {
            this.showSettings();
        },

        toggleAppAdmin: function toggleAppAdmin() {
            var location = this.isAdminActive ? '/app' : '/admin';
            return window.location.replace(location);
        }

    }

};

/***/ }),

/***/ "YknS":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_vm._l((_vm.frozenRevisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.progress.isRetaking || _vm.frozenRevisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('div', {
      staticClass: "revision__container revision__container--upload"
    }, _vm._l((revision.submissions), function(submission) {
      return _c('div', {
        staticClass: "submission submission--upload"
      }, [_c('a', {
        staticClass: "submission__thumb-link",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showImage(submission.data.medium)
          }
        }
      }, [_c('img', {
        staticClass: "submission__thumb",
        attrs: {
          "src": submission.data.thumb
        }
      })])])
    }))])
  }), (!_vm.readonly) ? _c('dropzone', {
    attrs: {
      "url": _vm.uploadUrl,
      "message": "Upload foto",
      "value": _vm.uploads,
      "extractResultFromResponse": _vm.extractResultFromUploadResponse,
      "maxNumberOfFiles": _vm.partial.data.max_files || 3
    },
    on: {
      "clicked": _vm.enlargeThumbnail,
      "success": _vm.storeSubmission,
      "removed": _vm.removeSubmission
    }
  }) : _vm._e(), (_vm.readonly && _vm.frozenRevisions.length === 0) ? _c('p', {
    staticClass: "revision__container revision__container--teacher"
  }, [_vm._v("Foto uploaden door leerling")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "YoMJ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("PSUo")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4cvB"),
  /* template */
  __webpack_require__("oTIl"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "YyG+":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Z5eA")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5OlO"),
  /* template */
  __webpack_require__("Acpn"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Yzb3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var initialState = function initialState() {
    return {
        all: []
    };
};

var removeNotification = function removeNotification(id, notifications) {
    if (id != null) {
        var index = notifications.map(function (notification) {
            return notification.id;
        }).indexOf(id);
        if (index >= 0) {
            notifications.splice(index, 1);
        }
    }
};

var mutations = {
    ADD_NOTIFICATION: function ADD_NOTIFICATION(state, notification) {
        removeNotification(notification.id, state.all);
        state.all.push(notification);
    },
    REMOVE_NOTIFICATION: function REMOVE_NOTIFICATION(state, notification) {
        removeNotification(notification.id, state.all);
        var index = state.all.indexOf(notification);
        if (index >= 0) {
            state.all.splice(index, 1);
        }
    }
};

exports.default = {
    // initialState, // prevent global reset of notifications, they're not personal
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "Z+EI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transformers = __webpack_require__("j0ZK");

exports.default = {
    props: {
        progress: {},
        isActive: {
            type: Boolean,
            default: false
        }
    },

    computed: {

        assignment: function assignment() {
            return this.$store.state.assignments.storage[this.progress.assignment];
        },

        preview: function preview() {
            if (this.progress.primarySubmissions == null || this.progress.primarySubmissions.length < 1) {
                return null;
            }
            return this.$store.state.submissions.storage[this.progress.primarySubmissions[this.progress.primarySubmissions.length - 1]];
        },

        type: function type() {
            if (this.preview == null) {
                return null;
            }

            if (this.preview.data instanceof Object && this.preview.data.medium != null && this.preview.data.thumb != null) {
                return 'Image';
            }

            return 'Text';
        },

        previewText: function previewText() {

            if (this.type !== 'Text') {
                return null;
            }

            return (0, _transformers.excerpt)(this.preview.data, 60);
        },

        hasFeedback: function hasFeedback() {
            if (!this.progress.feedback || !this.progress.feedback.length) {
                return false;
            }

            var feedback = this.$store.state.feedback.storage[this.progress.feedback[0]];
            return feedback.content || feedback.remarks.length || feedback.compliments.length;
        },

        hasDiligence: function hasDiligence() {
            return this.progress.diligence && this.progress.diligence.length;
        },

        diligence: function diligence() {
            if (!this.hasDiligence) {
                return null;
            }

            return this.$store.state.diligence.storage[this.progress.diligence[0]];
        },

        hasBadge: function hasBadge() {
            return this.progress.badge && this.progress.badge.length;
        },

        badge: function badge() {
            if (!this.hasBadge) {
                return null;
            }

            return this.$store.state.badges.storage[this.progress.badge[0]];
        },

        shouldRetake: function shouldRetake() {
            return this.progress.isRetaking;
        },

        date: function date() {
            return (0, _transformers.date)(this.progress.started);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Z+dW":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("o3+c")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5pXN"),
  /* template */
  __webpack_require__("gvNC"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Z5eA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z6iq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9Px":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("D1fQ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("QBUL"),
  /* template */
  __webpack_require__("5hKk"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ZAX4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZCQM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports.default = {
    name: 'Spinner',
    props: {
        mini: {
            type: Boolean,
            default: false
        },
        alt: {
            type: Boolean,
            default: false
        },
        relative: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        }
    }
};

/***/ }),

/***/ "ZpEd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZqZe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//

exports.default = {
    props: []
};

/***/ }),

/***/ "ZuEl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _stealthMixin = __webpack_require__("KjtG");

var _stealthMixin2 = _interopRequireDefault(_stealthMixin);

var _redirectMixin = __webpack_require__("bSel");

var _redirectMixin2 = _interopRequireDefault(_redirectMixin);

var _TeacherFeedback = __webpack_require__("3yyy");

var _TeacherFeedback2 = _interopRequireDefault(_TeacherFeedback);

var _Step = __webpack_require__("mWFA");

var _Step2 = _interopRequireDefault(_Step);

var _ProgressBar = __webpack_require__("Io5y");

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _getters = __webpack_require__("olIF");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Assignment',
    props: {
        assignmentId: {
            type: String,
            required: true
        },

        user: {},
        group: {},
        isInspectingStudent: {
            type: Boolean,
            default: false
        },
        isInspecting: {
            type: Boolean,
            default: false
        },
        ignoreProgress: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        }
    },
    mixins: [_notificationsMixin2.default, _stealthMixin2.default, _redirectMixin2.default],
    components: { AssignmentStep: _Step2.default, ProgressBar: _ProgressBar2.default, Loading: _Loading2.default, TeacherFeedback: _TeacherFeedback2.default },
    data: function data() {
        return {
            loading: false
        };
    },
    vuex: {
        getters: {
            getProgressForUserAssignmentGroup: _getters.getProgressForUserAssignmentGroup
        },
        actions: {
            fetchAssignment: _actions.fetchAssignment,
            resetCurrentAssignment: function resetCurrentAssignment(_ref) {
                var dispatch = _ref.dispatch;
                return dispatch('RESET_CURRENT_ASSIGNMENT');
            },
            startAssignment: function startAssignment(_ref2, assignment) {
                var dispatch = _ref2.dispatch,
                    state = _ref2.state;


                _analytics2.default.event('assignment', 'start', assignment.id);
                return _resources2.default.startedAssignment(assignment.id).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_PROGRESS', result.progress);
                    dispatch('ADD_PROGRESS_TO_ASSIGNMENT', assignment.id, result.progress[0].id);
                    return result;
                });
            },
            setFakeProgress: function setFakeProgress(_ref3, assignment, user, group) {
                var dispatch = _ref3.dispatch;


                var now = (0, _helpers.timestamp)();
                var id = (0, _helpers.guid)();

                var progress = {
                    'id': id,
                    'started': now,
                    'submitted': now,
                    'finished': null,
                    'step': assignment.steps.length,
                    'frozen': assignment.steps.length,
                    'assignment': assignment.id,
                    'user': user.id,
                    'group': group.id,
                    'fake': true
                };

                dispatch('ADD_PROGRESS', [progress]);
                dispatch('ADD_PROGRESS_TO_ASSIGNMENT', assignment.id, id);
            },
            showGoals: function showGoals(_ref4, assignment) {
                var dispatch = _ref4.dispatch;

                _analytics2.default.event('goals', 'show', assignment.id);
                dispatch('SHOW_MODAL', 'Goals', { assignment: assignment });
            }
        }
    },
    computed: {
        assignment: function assignment() {
            return this.$store.state.assignments.storage[this.assignmentId];
        },
        isStarted: function isStarted() {
            return this.progress != null && this.progress.started != null;
        },
        steps: function steps() {
            var _this = this;

            return this.assignment.steps.map(function (id) {
                return _this.$store.state.steps.storage[id];
            });
        },
        progress: function progress() {
            return this.getProgressForUserAssignmentGroup(this.user.id, this.assignment.id, this.group.id);
        },
        type_class: function type_class() {
            return 'icon-' + this.assignment.type;
        },
        currentStepIdx: function currentStepIdx() {
            if (this.$route.params.stepIdx == null) return this.$route.name;
            return this.$route.params.stepIdx;
        },
        isReviewing: function isReviewing() {
            // logged in user must teach the group, this prevents admins from accidentally giving feedback
            return this.isInspectingStudent && this.$store.state.users.current.groups.indexOf(this.group.id) !== -1;
        },
        returnLink: function returnLink() {
            var breadcrumb = this.$store.state.breadcrumbs.previous;
            if (breadcrumb) {
                return breadcrumb;
            }

            return this.isInspecting ? { route: { name: 'students.overview' }, name: 'Voortgang' } : { route: { name: 'period' }, name: 'Opdrachten' };
        }
    },
    methods: {
        startIfNecessary: function startIfNecessary() {

            if (this.ignoreProgress && !this.isStarted) {
                this.setFakeProgress(this.assignment, this.user, this.group);
                return Promise.resolve();
            }

            if (this.isStarted) {
                return Promise.resolve();
            }

            return this.startAssignment(this.assignment);
        },
        checkDisabled: function checkDisabled() {
            if (this.isInspectingStudent && (this.progress == null || this.progress.finished == null)) {
                return Promise.reject('Unfinished assignment is disabled');
            }

            if (this.isDemo && this.assignment.demo !== true) {
                return Promise.reject('Could not open demo assignment');
            }
        },
        checkRoute: function checkRoute() {

            var routeParts = this.$route.name.split('.');
            var step = routeParts[routeParts.length - 1];
            if (this.$route.params.stepIdx == null && step !== 'done' && step !== 'overview' && step !== 'group') {
                this.autoRedirectStep(this.progress);
            }
        },
        viewChange: function viewChange() {
            document.getElementById('main-view').scrollTop = 0;
        }
    },
    watch: {
        '$route': function $route() {
            this.checkRoute();
        }
    },
    created: function created() {
        var _this2 = this;

        this.loading = true;

        var includeUserProgress = this.ignoreProgress ? null : this.user.id;

        this.fetchAssignment(this.assignmentId, includeUserProgress).then(function () {
            return _this2.checkDisabled();
        }).then(function () {
            return _this2.startIfNecessary();
        }).then(function () {
            return _this2.loading = false;
        }).then(function () {
            return _this2.checkRoute();
        }).catch(function (err) {
            _analytics2.default.exception('Can\'t load assignment ', err);
            _this2.$error('Kan opdracht niet laden.');
            _this2.$router.replace({ name: 'period' });
        });
    },
    beforeDestroy: function beforeDestroy() {
        // Needs before destroy, otherwise assignment is reset after new assignment is set (when canReuse = false)
        this.resetCurrentAssignment();
    }

};

/***/ }),

/***/ "a2R8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a8kc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aBjJ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Sb2H")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("X/KW"),
  /* template */
  __webpack_require__("KJNZ"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "aDNW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aHZq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aKA1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;
exports.stop = stop;
var Confetti = function Confetti(canvas, opts) {
    // src: https://codepen.io/Gthibaud/pen/bNOZjd
    // https://codepen.io/jscottsmith/pen/VjPaLO
    this.gauss = gaussian(0.5, 0.2);

    this.context = canvas.getContext('2d');
    this.width = canvas.width = window.innerWidth;
    this.height = canvas.height = window.innerHeight;

    this.running = true;

    this.particle = [];
    this.particleCount = 200;
    this.gravity = 0.28;
    this.drag = 0.982;

    opts = opts || {};

    var colorPalletes = {
        default: ['#5b8da3', '#7db286', '#ffcc64', '#d7775d'],
        blue: ['#5b8da3', '#8cb0bf', '#adc6d1', '#2e4752', '#1b2a31', '#ffcc64'],
        green: ['#7db286', '#8fbd97', '#afd0b4', '#42704a', '#1c3020', '#ffcc64'],
        yellow: ['#ffcc64', '#ffd580', '#e69a00', '#b37800', '#805600'],
        red: ['#d7775d', '#dc8770', '#e6a999', '#8f3a23', '#662a19', '#ffcc64'],
        purple: ['#7e70a2', '#9d93b9', '#b9b2cd', '#51466c', '#231e2e', '#ffcc64']
    };

    this.colors = colorPalletes[opts.color || 'default'];
};

Confetti.prototype.init = function () {
    var _this = this;

    var _loop = function _loop() {

        var direction = _this.randomRange(-30, 30); // degrees
        var velocity = _this.randomRange(-52, -14);
        var context = _this.context;

        var self = _this;

        _this.particle.push({

            x: _this.width / 2,
            y: _this.height / 1.5,

            boxW: _this.randomRange(5, 20),
            boxH: _this.randomRange(5, 20),

            velX: Math.sin(convertToRadians(direction)) * velocity,
            velY: Math.cos(convertToRadians(direction)) * velocity,

            angle: convertToRadians(_this.randomRange(0, 360)),
            color: _this.colors[Math.floor(Math.random() * _this.colors.length)],
            anglespin: _this.randomRange(-0.2, 0.2),

            draw: function draw() {

                context.save();
                context.translate(this.x, this.y);
                context.rotate(this.angle);
                context.fillStyle = this.color;
                context.beginPath();
                context.fillRect(this.boxW / 2 * -1, this.boxH / 2 * -1, this.boxW, this.boxH);
                context.fill();
                context.closePath();
                context.restore();
            },

            update: function update() {

                this.angle += this.anglespin;

                this.velY *= self.drag;
                this.velY += self.gravity;

                this.x += this.velX;
                this.y += this.velY;

                if (this.y < 0) {
                    this.velY *= -0.2;
                    this.velX *= 0.9;
                }

                if (this.y > self.height) {
                    this.anglespin = 0;
                    this.y = self.height;
                    this.velY *= -0.2;
                    this.velX *= 0.9;
                }

                if (this.x > self.width || this.x < 0) {
                    this.velX *= -0.2;
                }
            }

        });
    };

    // create all particles
    for (var i = 0; i < this.particleCount; i++) {
        _loop();
    }
};

/**
 * Render the confetti
 */
Confetti.prototype.render = function () {

    this.context.clearRect(0, 0, this.width, this.height);

    for (var i = 0; i < this.particle.length; i++) {
        this.particle[i].draw();
        this.particle[i].update();
    }

    if (this.running) {
        requestAnimationFrame(this.render.bind(this));
    }
};

Confetti.prototype.stop = function () {
    this.running = false;
};

/**
 * Generate a random normal distributed number between min and max
 * @param  {float} min
 * @param  {float} max
 * @return {float} randomly generated number
 */
Confetti.prototype.randomRange = function (min, max) {
    return min + this.gauss() * (max - min);
};

/**
 * Convert degrees to radians
 * @param  {float} degrees
 * @return {float} angle in radians
 */
function convertToRadians(degree) {
    return degree * (Math.PI / 180);
}

/**
 * Creates function that returns normal distributed random number
 * @param  {float} mean
 * @param  {float} stdev
 * @return {() => float} function that returns random number when called
 */
function gaussian(mean, stdev) {

    var y2;
    var use_last = false;

    return function () {

        var y1;

        if (use_last) {

            y1 = y2;
            use_last = false;
        } else {

            var x1, x2, w;

            do {
                x1 = 2.0 * Math.random() - 1.0;
                x2 = 2.0 * Math.random() - 1.0;
                w = x1 * x1 + x2 * x2;
            } while (w >= 1.0);

            w = Math.sqrt(-2.0 * Math.log(w) / w);
            y1 = x1 * w;
            y2 = x2 * w;
            use_last = true;
        }

        return Math.abs(mean + stdev * y1);
    };
}

var cf = void 0;
function start(el, color) {
    cf = new Confetti(el, { color: color });
    cf.init();
    cf.render();
}

function stop() {
    cf.stop();
}

/***/ }),

/***/ "aWpe":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    ref: "content",
    staticClass: "definition-parser"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "aXX8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "az6Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b/oB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bEj+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//


exports.default = {
    methods: {
        close: function close() {
            this.$emit('close');
        }
    },
    computed: {
        image: function image() {
            return this.$store.state.images.current;
        }
    }
};

/***/ }),

/***/ "bGdJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

var _helpers = __webpack_require__("x3kM");

var _Dropzone = __webpack_require__("zQYW");

var _Dropzone2 = _interopRequireDefault(_Dropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Dropzone: _Dropzone2.default },
    props: {
        partial: {},
        progress: {},
        readonly: {
            type: Boolean,
            default: false
        }
    },
    vuex: {
        actions: {
            addSubmission: function addSubmission(_ref, submission, partial, progress) {
                var dispatch = _ref.dispatch;

                dispatch('SET_SUBMISSION', submission);
                dispatch('ADD_SUBMISSION_TO_PARTIAL', partial.id, submission.id);
                if (partial.primary) {
                    dispatch('ADD_PRIMARY_SUBMISSION_TO_PROGRESS', progress.id, submission.id);
                }
            },
            deleteSubmission: _actions.deleteSubmission,
            setValidation: _actions.setValidation,
            showImage: function showImage(_ref2, image) {
                var dispatch = _ref2.dispatch;

                dispatch('SHOW_IMAGE', image);
                dispatch('SHOW_MODAL', 'ImageContainer');
            }
        }
    },
    methods: {
        extractResultFromUploadResponse: function extractResultFromUploadResponse(response) {
            var result = (0, _helpers.transform)(response).submissions[0];
            return {
                id: result.id,
                thumb: result.data.thumb,
                submission: result
            };
        },

        flush: function flush() {
            // TODO: parent step needs to cancel/wait for currently uploading files
            return Promise.resolve();
        },

        storeSubmission: function storeSubmission(file, data) {
            this.addSubmission(data.submission, this.partial, this.progress);
            this.validate();
        },

        removeSubmission: function removeSubmission(file, data) {
            this.deleteSubmission(this.partial, data.submission.id, this.progress).then(this.validate);
        },

        validate: function validate() {

            var minlength = this.partial.data === null || this.partial.data.minlength == undefined ? 1 : this.partial.data.minlength;
            var validated = this.submissions.length >= minlength;

            if (validated != this.partial.validated) {
                this.setValidation(this.partial.id, validated);
            }
        },

        enlargeThumbnail: function enlargeThumbnail(file, data) {
            this.showImage(data.submission.data.medium);
        }

    },

    computed: {

        uploads: function uploads() {
            return this.submissions.map(function (submission) {
                return {
                    id: submission.id,
                    thumb: submission.data.thumb,
                    submission: submission
                };
            });
        },

        uploadUrl: function uploadUrl() {
            return this.$http.options.root + '/partials/' + this.partial.id + '/submissions';
        },

        submissions: function submissions() {
            return this.allSubmissions.filter(function (s) {
                return !s.isFrozen;
            });
        },

        allSubmissions: function allSubmissions() {
            var _this = this;

            return Object.keys(this.$store.state.submissions.storage).map(function (id) {
                return _this.$store.state.submissions.storage[id];
            }).filter(function (submission) {
                return submission.progress === _this.progress.id && submission.partial === _this.partial.id && submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null;
            });
        },

        frozenRevisions: function frozenRevisions() {

            return this.allSubmissions.reduce(function (revs, sub) {

                if (!sub.isFrozen) {
                    return revs;
                }

                if (revs[sub.revision] == null) {
                    revs[sub.revision] = { title: 'versie ' + (sub.revision + 1), submissions: [] };
                }

                revs[sub.revision].submissions.push(sub);
                return revs;
            }, []);
        }
    },

    created: function created() {
        if (!this.readonly) {
            this.validate();
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "bSel":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    methods: {
        /**
         * @param {Progress} progress
         * @return {Boolean} true if given assignment is completed, false otherwise
         */
        isProgressFinished: function isProgressFinished(progress) {
            return progress != null && (progress.finished != null || progress.fake);
        },

        /**
         * Automatically redirects to the last step available to the user
         * @param {Transition} transition, vue-router transition object
         * @param {Progress} progress
         */
        autoRedirectStep: function autoRedirectStep(progress) {

            if (progress == null) {
                console.error('No progress found');
                return this.$router.replace({ name: 'period' });
            }

            if (this.stealthMode) {

                // always redirect to the first step if teachers views assignment, don't worry about progress state
                if (progress.fake) {
                    this.$router.replace({ name: 'assignment.step', params: { assignmentId: progress.assignment, stepIdx: 1 } });
                } else {
                    this.$router.replace({ name: 'assignment.overview', params: { assignmentId: progress.assignment } });
                }

                return;
            }

            if (this.isProgressFinished(progress)) {
                this.$router.replace({ name: 'assignment.overview', params: { assignmentId: progress.assignment } });
            } else {
                // redirect to first step after last completed
                var assignment = this.$store.state.assignments.storage[progress.assignment];
                var stepIdx = Math.min(progress.step + 1, assignment.steps.length);
                this.$router.replace({ name: 'assignment.step', params: { assignmentId: progress.assignment, stepIdx: stepIdx } });
            }
        }
    }
};

/***/ }),

/***/ "bpQ3":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "login"
  }, [(_vm.isVerifying) ? _c('loading', {
    attrs: {
      "alt": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "c+iA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _collectVuelidateErrors = function _collectVuelidateErrors(obj) {
    return Object.keys(obj.$params).reduce(function (errors, field) {

        var newObj = obj[field];

        if ((typeof newObj === 'undefined' ? 'undefined' : _typeof(newObj)) === 'object') {

            if (newObj.$invalid) {
                return errors.concat(_collectVuelidateErrors(newObj));
            }
        } else if (newObj === false) {
            var params = obj.$params[field];
            var msg = params != null && params.msg ? params.msg : 'unknown error';
            errors.push(msg);
        }

        return errors;
    }, []);
};

exports.default = {

    methods: {
        handleErrorResponse: function handleErrorResponse(response, defaultMessage) {
            if (response.status === 422) {
                this.handleValidationErrorResponse(response);
            } else {
                _analytics2.default.exception(defaultMessage, response);
                this.$warn(defaultMessage);
            }
        },
        handleValidationErrorResponse: function handleValidationErrorResponse(response, defaultMessage) {
            var _this = this;

            if (response.status !== 422) {
                return; // not a validation error, should be handled by global error handlers
            }

            var errors = response.body.errors;

            if (errors != null) {
                errors.forEach(function (error) {
                    return _this.addFieldError(error.source);
                });
                errors = errors.map(function (error) {
                    return error.detail;
                }).filter(function (error) {
                    return error != null && error.length > 0;
                });
            }

            if (errors == null || errors.length === 0) {
                errors = defaultMessage || 'Er is iets mis gegaan';
            }

            this.$warn(errors, { id: 'validation' });
        },
        containsError: function containsError(field) {
            return this.errorFields.includes(field);
        },
        addError: function addError(field, message) {
            this.errors.push(message);
            this.addFieldError(field);
        },
        addFieldError: function addFieldError(field) {
            if (field != null && this.errorFields != null) {
                this.errorFields.push(field);
            }
        },
        validate: function validate() {

            this.errors = [];
            this.errorFields = [];

            // must be implemented  in component
            this.validateFields();
            this.showErrors();

            return this.errors.length === 0;
        },
        showErrors: function showErrors() {
            if (this.errors.length > 0) {
                this.$warn(this.errors, { id: 'validation' });
            } else {
                this.$hideNotification('validation');
            }
        },
        validateFields: function validateFields() {
            // implement in component
        },
        validatePasswordLength: function validatePasswordLength(password) {
            if (password == null || password.length < 8) {
                this.addError('password', 'Het wachtwoord moet minimaal 8 tekens bevatten');
                return false;
            }
            return true;
        },
        validatePasswordEqual: function validatePasswordEqual(password, passwordConfirmation) {
            if (password !== passwordConfirmation) {
                this.addError('passwordConfirmation', 'De wachtwoorden komen niet overeen');
                return false;
            }
            return true;
        },
        validateEmail: function validateEmail(email) {
            if (!/\S+@\S+/.test(email)) {
                this.addError('email', 'Het e-mailadres is ongeldig');
                return false;
            }
            return true;
        },
        validateCode: function validateCode(code) {
            if (code == null || code.length < 5) {
                this.addError('code', 'De klas code is onjuist');
                return false;
            }
            return true;
        },
        validateFirstName: function validateFirstName(name) {
            if (name == null || name.length < 1) {
                this.addError('firstname', 'Je voornaam is niet ingevuld');
                return false;
            }
            return true;
        },
        validateLastName: function validateLastName(name) {
            if (name == null || name.length < 1) {
                this.addError('lastname', 'Je achternaam is niet ingevuld');
                return false;
            }
            return true;
        },

        validateTerms: function validateTerms(value) {
            if (value == null || !value) {
                this.addError('terms', 'Je moet akkoord gaan met de voorwaarden');
                return false;
            }
            return true;
        },

        collectVuelidateErrors: function collectVuelidateErrors() {
            return _collectVuelidateErrors(this.$v);
        }

    },
    beforeDestroy: function beforeDestroy() {
        this.$hideNotification('validation');
    }
};

/***/ }),

/***/ "c4sb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autoValidateMixin = __webpack_require__("HDu5");

var _autoValidateMixin2 = _interopRequireDefault(_autoValidateMixin);

var _autoGlossaryMixin = __webpack_require__("MSI/");

var _autoGlossaryMixin2 = _interopRequireDefault(_autoGlossaryMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//

exports.default = {
    mixins: [_autoValidateMixin2.default, _autoGlossaryMixin2.default],

    methods: {
        flush: function flush() {
            return Promise.resolve();
        }
    }
};

/***/ }),

/***/ "cBIN":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("nuSn")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("gG7N"),
  /* template */
  __webpack_require__("f3MT"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cHIS":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Owah")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("AOO4"),
  /* template */
  __webpack_require__("msl+"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cn/v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__("kpqR");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _auth = __webpack_require__("JOmw");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default);

_vue2.default.http.options.root = '/api/v5';
// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true


/**
 * Track requests & response
 */
_vue2.default.http.interceptors.push(function (request, next) {

    var currentTime = function currentTime() {
        return window.performance ? window.performance.now() : Date.now();
    };

    console.log('----> API REQUEST', request);
    var start = currentTime();

    next(function (response) {

        var duration = Math.floor(currentTime() - start);
        console.log('<---- API RESPONSE', response, duration);

        if (response.status < 400) {

            _analytics2.default.event('api', response.status, response.url, duration);
        } else if (response.status === 401) {

            _analytics2.default.event('api', 'unauthenticated', response.url, duration);
        } else if (response.status === 403) {

            _analytics2.default.event('api', 'unauthorized', response.url, duration);
        } else if (response.status === 409) {

            _analytics2.default.event('api', 'conflict', response.url, duration);
        } else if (response.status === 410) {

            _analytics2.default.event('api', 'update', _vue2.default.http.options.root, duration);
        } else if (response.status === 422) {

            _analytics2.default.event('api', 'invalid', response.url, duration);
        } else if (response.status === 429) {

            _analytics2.default.event('api', 'throttle', response.url, duration);
        } else if (response.status === 503) {

            _analytics2.default.event('api', 'maintenance', response.url, duration);
        } else if (response.status >= 400) {

            _analytics2.default.exception('API response error', response);
        }
    });
});

/**
 * Handles new API versions
 */
_vue2.default.http.interceptors.push(function (request, next) {

    next(function (response) {

        if (response.status === 410) {
            setTimeout(function () {
                window.location.reload(true);
            }, 3000);
        }
    });
});

/**
 * Handles authentication
 */
_vue2.default.http.interceptors.push(function (request, next) {

    (0, _auth.setAuthorizationHeader)(request);

    next(function (response) {

        var authError = !response.ok && response.status === 401;
        var retriesLeft = request.retry === undefined || request.retry > 0;

        if (authError && retriesLeft) {
            // try to authenticate first, then retry original request. If anything fails, return the new response or original failed response
            return (0, _auth.retryAfterAuthFail)(request).catch(function (err) {
                return (0, _analytics.isResponse)(err) ? err : response;
            });
        }
    });
});

/**
 * Fail requests that take too long
 * Returns response with status code 1
 */
_vue2.default.http.interceptors.push(function (request, next) {

    var timeout = setTimeout(function () {
        request.abort();
        var response = request.respondWith('', { status: 1, statusText: 'Timeout' });
        next(response);
    }, 15000);

    next(function () {
        clearTimeout(timeout);
    });
});

exports.default = {
    getTerm: function getTerm(id, includeProgress) {
        return _vue2.default.http.get('groupterms/' + id, { params: { includeProgress: includeProgress } });
    },
    getTermForPeriod: function getTermForPeriod(id, includeProgress) {
        return _vue2.default.http.get('groupperiods/' + id + '/groupterms', { params: { includeProgress: includeProgress } });
    },
    getTerms: function getTerms() {
        return _vue2.default.http.get('terms');
    },
    getTermsForYear: function getTermsForYear(yearId) {
        return _vue2.default.http.get('years/' + yearId + '/terms');
    },
    getTermsForLevel: function getTermsForLevel(levelId) {
        return _vue2.default.http.get('levels/' + levelId + '/terms');
    },
    getAssignment: function getAssignment(id, includeProgress) {
        return _vue2.default.http.get('assignments/' + id, { params: { includeProgress: includeProgress, include: 'essentials' } });
    },
    getAssignmentSequence: function getAssignmentSequence(id) {
        return _vue2.default.http.get('assignments/' + id, { params: { include: 'predecessors,successors' } });
    },
    getUser: function getUser(id, includeEssentials) {
        return _vue2.default.http.get('users/' + id, { params: { include: includeEssentials ? 'essentials' : null } });
    },
    getDefinition: function getDefinition(tag) {
        return _vue2.default.http.get('definitions/' + tag);
    },
    getTeachertips: function getTeachertips(stepId) {
        return _vue2.default.http.get('steps/' + stepId + '/teachertips');
    },
    getReflectiontips: function getReflectiontips(assignmentId) {
        return _vue2.default.http.get('assignments/' + assignmentId + '/reflectiontips');
    },

    // progress
    startedAssignment: function startedAssignment(assignmentId) {
        return _vue2.default.http.post('progress', { assignment_id: assignmentId });
    },
    viewedStep: function viewedStep(progressId, stepIndex) {
        return _vue2.default.http.patch('progress/' + progressId + '/viewed', { step_index: stepIndex });
    },
    submittedStep: function submittedStep(progressId, stepIndex) {
        return _vue2.default.http.patch('progress/' + progressId + '/submitted', { step_index: stepIndex });
    },
    finishedAssignment: function finishedAssignment(progressId) {
        return _vue2.default.http.patch('progress/' + progressId + '/finished');
    },
    patchDiligence: function patchDiligence(progressId, diligence) {
        return _vue2.default.http.patch('progress/' + progressId + '/diligence', { diligence: diligence });
    },
    patchBadge: function patchBadge(progressId, badge) {
        return _vue2.default.http.patch('progress/' + progressId + '/badge', { badge: badge });
    },
    getProgressForGroup: function getProgressForGroup(groupId, includeFeedback) {
        return _vue2.default.http.get('groups/' + groupId + '/progress', { params: { include: includeFeedback ? 'feedback' : null } });
    },
    retakeProgress: function retakeProgress(progressId) {
        return _vue2.default.http.patch('progress/' + progressId, { isRetaking: true });
    },
    reviewedProgress: function reviewedProgress(progressId) {
        return _vue2.default.http.patch('progress/' + progressId, { isReviewed: true });
    },

    giveFeedback: function giveFeedback(assignmentId, feedback) {
        return _vue2.default.http.patch('assignments/' + assignmentId + '/feedback', feedback);
    },

    // submissions
    addSubmission: function addSubmission(submission, partialId) {
        return _vue2.default.http.post('partials/' + partialId + '/submissions', { payload: submission });
    },
    patchSubmission: function patchSubmission(submission) {
        return _vue2.default.http.patch('submissions/' + submission.id, submission);
    },
    deleteSubmission: function deleteSubmission(submissionId) {
        return _vue2.default.http.delete('submissions/' + submissionId);
    },
    getReflectionSubmission: function getReflectionSubmission(progressId) {
        return _vue2.default.http.get('progress/' + progressId + '/reflectables');
    },
    getFallbackReflectionSubmission: function getFallbackReflectionSubmission(assignmentId) {
        return _vue2.default.http.get('assignments/' + assignmentId + '/reflectables');
    },
    getGroupSubmissions: function getGroupSubmissions(groupId, assignmentId, limit) {
        return _vue2.default.http.get('groups/' + groupId + '/assignments/' + assignmentId + '/submissions', { params: { limit: limit } });
    },
    getReflections: function getReflections(progressId) {
        return _vue2.default.http.get('progress/' + progressId + '/reflections');
    },

    // auth
    getAccessToken: function getAccessToken(token, stealth) {
        return _vue2.default.http.get('auth/refresh', { headers: { Authorization: 'Bearer ' + token }, stealth: stealth, retry: 1 });
    },
    login: function login(email, password, remember) {
        return _vue2.default.http.post('auth/login', { email: email, password: password, remember: remember ? 'yes' : 'no' }, { retry: 1 });
    },
    logout: function logout(refreshToken) {
        return _vue2.default.http.post('auth/logout', { refreshtoken: refreshToken }, { retry: 1 });
    },
    registrationRequest: function registrationRequest(email, code, terms) {
        return _vue2.default.http.post('registration', { email: email, code: code, terms: terms });
    },
    registrationVerify: function registrationVerify(token) {
        return _vue2.default.http.post('registration/verify', { token: token });
    },
    register: function register(firstname, infix, lastname, password, passwordConfirmation, token) {
        return _vue2.default.http.post('users', { firstname: firstname, middlename: infix, lastname: lastname, password: password, password_confirmation: passwordConfirmation, token: token });
    },
    forgotPassword: function forgotPassword(email) {
        return _vue2.default.http.post('auth/forgotpassword', { email: email });
    },
    resetPassword: function resetPassword(token, email, password, passwordConfirmation) {
        return _vue2.default.http.post('auth/resetpassword', { token: token, email: email, password: password, password_confirmation: passwordConfirmation });
    },
    editUser: function editUser(id, firstname, infix, lastname) {
        return _vue2.default.http.patch('users/' + id, { firstname: firstname, middlename: infix, lastname: lastname });
    },
    editUserEmail: function editUserEmail(id, email, password) {
        return _vue2.default.http.patch('users/' + id, { email: email, password: password });
    },
    editUserPassword: function editUserPassword(id, oldPassword, newPassword, newPasswordConfirmation) {
        return _vue2.default.http.patch('users/' + id, { password: oldPassword, newPassword: newPassword, newPassword_confirmation: newPasswordConfirmation });
    },
    confirmUserEmail: function confirmUserEmail(token) {
        return _vue2.default.http.patch('users/email', { token: token });
    },

    getGroupsForTeacher: function getGroupsForTeacher(teacherId) {
        return _vue2.default.http.get('teachers/' + teacherId + '/groups');
    },
    getGroupsForSchool: function getGroupsForSchool(schoolId) {
        return _vue2.default.http.get('schools/' + schoolId + '/groups');
    },
    addGroupToTeacher: function addGroupToTeacher(teacherId, groupId, includeTerms) {
        return _vue2.default.http.post('teachers/' + teacherId + '/groups', { group_id: groupId }, { params: { include: includeTerms ? 'term.period' : null } });
    },
    removeGroupFromTeacher: function removeGroupFromTeacher(teacherId, groupId) {
        return _vue2.default.http.delete('teachers/' + teacherId + '/groups', { body: { group_id: groupId } });
    },
    getStudentsForGroup: function getStudentsForGroup(groupId) {
        return _vue2.default.http.get('groups/' + groupId + '/students');
    },

    getPlanning: function getPlanning(groupId) {
        return _vue2.default.http.get('groups/' + groupId + '/planning');
    },
    patchPlanning: function patchPlanning(groupId, data) {
        return _vue2.default.http.patch('groups/' + groupId + '/planning', { planning: data });
    },

    patchAssignmentsForGroup: function patchAssignmentsForGroup(groupId, optionalAssignments) {
        return _vue2.default.http.patch('groups/' + groupId + '/assignments', { optionalAssignments: optionalAssignments });
    },

    addFeedback: function addFeedback(progressId, feedback, compliments, remarks) {
        return _vue2.default.http.post('progress/' + progressId + '/feedback', { comments: feedback, compliments: compliments, remarks: remarks });
    },
    patchFeedback: function patchFeedback(feedbackId, feedback, compliments, remarks) {
        return _vue2.default.http.patch('feedback/' + feedbackId, { comments: feedback, compliments: compliments, remarks: remarks });
    },
    getFeedback: function getFeedback(progressId) {
        return _vue2.default.http.get('progress/' + progressId + '/feedback');
    },

    getHolidays: function getHolidays(schoolId) {
        return _vue2.default.http.get('schools/' + schoolId + '/holidays');
    },
    getLevelsForSchool: function getLevelsForSchool(schoolId) {
        return _vue2.default.http.get('schools/' + schoolId + '/levels');
    },
    getLevelsForGroup: function getLevelsForGroup(groupId) {
        return _vue2.default.http.get('groups/' + groupId + '/levels');
    },
    getLevels: function getLevels() {
        return _vue2.default.http.get('levels');
    },
    getYears: function getYears() {
        return _vue2.default.http.get('years');
    },

    getGroup: function getGroup(groupId) {
        return _vue2.default.http.get('groups/' + groupId);
    },
    addGroup: function addGroup(schoolId, name, level) {
        return _vue2.default.http.post('schools/' + schoolId + '/groups', { name: name, level: level });
    },
    patchGroup: function patchGroup(groupId, data) {
        return _vue2.default.http.patch('groups/' + groupId, data);
    },

    moveToGroup: function moveToGroup(userId, code) {
        return _vue2.default.http.patch('users/' + userId + '/group', { code: code });
    },

    // admin
    getMails: function getMails() {
        return _vue2.default.http.get('mails');
    },
    getMail: function getMail(id) {
        return _vue2.default.http.get('mails/' + id);
    },
    addMail: function addMail(data) {
        return _vue2.default.http.post('mails', data);
    },
    patchMail: function patchMail(id, data) {
        return _vue2.default.http.patch('mails/' + id, data);
    },
    testMail: function testMail(id) {
        return _vue2.default.http.get('mails/' + id + '/test');
    },

    getSubscribers: function getSubscribers() {
        return _vue2.default.http.get('subscribers');
    },
    addSubscriber: function addSubscriber(data) {
        return _vue2.default.http.post('subscribers', data);
    },
    deleteSubscriber: function deleteSubscriber(id) {
        return _vue2.default.http.delete('subscribers/' + id);
    },

    getArticles: function getArticles() {
        return _vue2.default.http.get('articles');
    },
    getArticle: function getArticle(id) {
        return _vue2.default.http.get('articles/' + id);
    },
    addArticle: function addArticle(data) {
        return _vue2.default.http.post('articles', data);
    },
    patchArticle: function patchArticle(id, data) {
        return _vue2.default.http.patch('articles/' + id, data);
    },
    deleteArticle: function deleteArticle(id) {
        return _vue2.default.http.delete('articles/' + id);
    },

    getSchools: function getSchools(includeMeta) {
        return _vue2.default.http.get('schools', { params: { include: includeMeta ? 'meta' : null } });
    },
    getSchool: function getSchool(id, includeTickets) {
        return _vue2.default.http.get('schools/' + id, { params: { include: includeTickets ? 'tickets' : null } });
    },
    addSchool: function addSchool(data) {
        return _vue2.default.http.post('schools', data);
    },
    patchSchool: function patchSchool(id, data) {
        return _vue2.default.http.patch('schools/' + id, data);
    },
    sendSchoolInvitation: function sendSchoolInvitation(id, type) {
        return _vue2.default.http.post('schools/' + id + '/invitation', { type: type });
    },

    reloadSchoolTickets: function reloadSchoolTickets(schoolId, type, amount) {
        return _vue2.default.http.patch('schools/' + schoolId + '/tickets/' + type, { amount: amount });
    },
    deleteSchoolTicket: function deleteSchoolTicket(schoolTicketId) {
        return _vue2.default.http.delete('schooltickets/' + schoolTicketId);
    },
    getTickets: function getTickets() {
        return _vue2.default.http.get('tickets');
    },

    deleteImage: function deleteImage(path) {
        return _vue2.default.http.delete('images/' + path);
    },

    getTicketActivitiesForSchool: function getTicketActivitiesForSchool(schoolId) {
        return _vue2.default.http.get('activities/subject/schools/' + schoolId + '/tickets');
    },
    getNotificationActivitiesForSchool: function getNotificationActivitiesForSchool(schoolId) {
        return _vue2.default.http.get('activities/subject/schools/' + schoolId + '/notifications');
    },

    getOrders: function getOrders() {
        return _vue2.default.http.get('activationorders');
    },
    addOrder: function addOrder(data) {
        return _vue2.default.http.post('activationorders', data);
    },
    getCodesForOrder: function getCodesForOrder(orderId) {
        return _vue2.default.http.get('activationorders/' + orderId + '/codes');
    },

    getLegalTerms: function getLegalTerms() {
        return _vue2.default.http.get('/voorwaarden?raw=true');
    },
    getLegalPrivacy: function getLegalPrivacy() {
        return _vue2.default.http.get('/privacy?raw=true');
    },
    getLegalDisclaimer: function getLegalDisclaimer() {
        return _vue2.default.http.get('/disclaimer?raw=true');
    }

};

/***/ }),

/***/ "cr1P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crAn":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("iZO2")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Xudg"),
  /* template */
  __webpack_require__("EzKL"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "czDB":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.progress != null) ? _c('div', {
    staticClass: "progress-wrap"
  }, [_c(_vm.typeOfSubmission(_vm.submission), {
    key: _vm.progress.id,
    tag: "component",
    staticClass: "progress-preview",
    attrs: {
      "submissions": [_vm.submission]
    }
  }), (_vm.progress.feedback || _vm.progress.diligence) ? _c('div', {
    staticClass: "progress-feedback"
  }, [(_vm.progress.feedback) ? [_c('teacher-feedback', {
    attrs: {
      "feedback": _vm.$store.state.feedback.storage[_vm.progress.feedback],
      "minimal": true
    }
  })] : _vm._e(), (_vm.progress.diligence) ? [_vm._m(0), _c('diligence', {
    attrs: {
      "progress": _vm.progress,
      "readonly": true,
      "showOnlySelected": true
    }
  })] : _vm._e()], 2) : _vm._e()], 1) : _c('span', [_vm._v("Geen voortgang")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h3', [_c('span', [_vm._v("Beoordeling")])])
}]}

/***/ }),

/***/ "d+Au":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dGP0":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("hjgJ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("JOx0"),
  /* template */
  __webpack_require__("BF9z"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "dGh2":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ORQc")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("3tqh"),
  /* template */
  __webpack_require__("WIlv"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "dajq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.isYoutube) ? _c('iframe', {
    staticClass: "partial-video",
    attrs: {
      "width": "576",
      "height": "324",
      "src": _vm.source,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), (_vm.isPrivate) ? _c('video', {
    ref: "videojs",
    staticClass: "partial-video video-js vjs-default-skin vjs-big-play-centered vjs-16-9",
    class: {
      nocontrol: !_vm.controllable
    },
    attrs: {
      "width": "576",
      "height": "324"
    }
  }, [_c('p', {
    staticClass: "vjs-no-js"
  }, [_vm._v("Deze video kan niet afgespeeld worden.")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "duG/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autoValidateMixin = __webpack_require__("HDu5");

var _autoValidateMixin2 = _interopRequireDefault(_autoValidateMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_autoValidateMixin2.default],

    data: function data() {
        return {
            currentIndex: 0
        };
    },

    computed: {
        images: function images() {
            if (this.partial.data == null) {
                return [];
            }

            if (Array.isArray(this.partial.data)) {
                return this.partial.data;
            }

            return [this.partial.data];
        },

        currentImage: function currentImage() {
            return this.images[this.currentIndex];
        }
    },

    methods: {
        previous: function previous() {
            this.currentIndex = this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1;
        },

        next: function next() {
            this.currentIndex = this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1;
        },

        flush: function flush() {
            return Promise.resolve();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ekR1":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [(_vm.group && _vm.group.archived) ? _c('p', [_vm._v("Voor volgend schooljaar kun je je aanmelden bij een nieuwe klas. Voer dan hieronder de uitnodigingscode in die je van jouw docent hebt gekregen.")]) : (_vm.group) ? _c('p', [_vm._v("Je zit nu in klas "), _c('strong', [_vm._v(_vm._s(_vm.group.name))]), _vm._v(".\n    Wil je naar een andere klas verhuizen? Voer dan hieronder de uitnodigingscode van de nieuwe klas in.")]) : _c('p', [_vm._v("Vul hieronder de uitnodigingscode van jouw klas in. Deze code krijg je van je docent.")]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('code')
    }
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Uitnodigingscode")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), (_vm.group) ? _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" je kunt nu nog je huidige werkmap bekijken. Zodra je naar een nieuwe klas verhuist krijg je ook een nieuwe werkmap.")]) : _vm._e(), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.group ? 'Verhuizen' : 'Aanmelden'))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "elzP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_vm._m(0), _c('group', {
    attrs: {
      "user": _vm.user,
      "finished": true
    },
    on: {
      "done": _vm.done
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "page-header settings-header settings-header--finished"
  }, [_c('img', {
    staticClass: "image--balloons",
    attrs: {
      "src": "/build/img/balloons.png",
      "srcset": "/build/img/balloons@2x.png 2x",
      "width": "135",
      "alt": "Ballonnen"
    }
  }), _c('h1', [_vm._v("Het jaar zit er weer op!")]), _c('hr')])
}]}

/***/ }),

/***/ "f3MT":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "announcement announcement--demo"
  }, [_c('router-link', {
    staticClass: "announcement__logo",
    attrs: {
      "to": {
        name: 'logout',
        params: {
          _internal: true
        },
        query: {
          next: 'web'
        }
      }
    }
  }, [_c('span', {
    staticClass: "announcement__icon"
  }), _c('span', {
    staticClass: "announcement__app-name"
  }, [_vm._v("Kiempunt")])]), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "announcement__inquiry"
  }, [_vm._v("Kiempunt uitproberen in de klas? "), _c('a', {
    staticClass: "button--inquiry button-timid button-forward ",
    attrs: {
      "href": "/proef/demo"
    }
  }, [_vm._v("Vraag gratis proefperiode aan")])])
}]}

/***/ }),

/***/ "fBeb":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldShowReflectiontips) ? _c('a', {
    staticClass: "button-rounded button-rounded--reflection button-rounded--teachertips",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflectiontips(_vm.assignment)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--reflection"
  }), _vm._v("reflection")]) : _vm._e(), _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group,
      "isExcerpt": false,
      "isInspecting": _vm.isInspecting
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": _vm.prevStepLink
    }
  }, [_vm._v("Vorige stap")]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ "feAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fg22":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _helpers = __webpack_require__("x3kM");

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: [],
    mixins: [_notificationsMixin2.default],
    components: { Loading: _Loading2.default },
    vuex: {
        getters: {
            definitionTag: function definitionTag(state) {
                return state.glossary.current;
            }
        },
        actions: {
            addDefinitions: function addDefinitions(_ref, definitions) {
                var dispatch = _ref.dispatch;
                return dispatch('ADD_DEFINITIONS', definitions);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.definition == null) {

            _resources2.default.getDefinition(this.definitionTag).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (data) {
                _this.addDefinitions(data.definitions);
            }).catch(function () {
                _this.$warn('Kan definitie niet vinden.');
                _this.close();
            });
        }
    },
    methods: {
        close: function close() {
            this.$emit('close');
        }
    },
    computed: {
        definition: function definition() {
            return this.$store.state.glossary.storage[this.definitionTag];
        }
    }
};

/***/ }),

/***/ "gDzj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gG7N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },

    components: { PrimaryButton: _PrimaryButton2.default }

}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "gGgV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autoGlossaryMixin = __webpack_require__("MSI/");

var _autoGlossaryMixin2 = _interopRequireDefault(_autoGlossaryMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_autoGlossaryMixin2.default],
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.processDefinitions(_this.$refs.content);
        });
    }
}; //
//
//
//
//

/***/ }),

/***/ "gNNc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _helpers = __webpack_require__("x3kM");

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SettingsUser',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        user: {}
    },
    data: function data() {
        return {
            new_firstname: null,
            new_infix: null,
            new_lastname: null,
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    vuex: {
        getters: {
            isDemo: function isDemo(state) {
                return state.users.current.role === 'demo';
            }
        },
        actions: {
            storeUser: function storeUser(_ref, user) {
                var dispatch = _ref.dispatch;
                return dispatch('SET_CURRENT_USER', user);
            }
        }
    },
    computed: {

        firstname: {
            get: function get() {
                return this.new_firstname == null ? this.user.firstname : this.new_firstname;
            },
            set: function set(value) {
                this.new_firstname = value;
            }
        },
        infix: {
            get: function get() {
                return this.new_infix == null ? this.user.middlename : this.new_infix;
            },
            set: function set(value) {
                this.new_infix = value;
            }
        },
        lastname: {
            get: function get() {
                return this.new_lastname == null ? this.user.lastname : this.new_lastname;
            },
            set: function set(value) {
                this.new_lastname = value;
            }
        }

    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate()) {

                if (this.isDemo) {
                    this.$demoSuccessNotification();
                    return;
                }

                this.loading = true;

                _resources2.default.editUser(this.user.id, this.firstname, this.infix, this.lastname).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return _this.storeUser(result.users[0]);
                }).then(function () {
                    _this.$success('Je gegevens zijn aangepast.', { id: 'validation' });
                }).catch(function (response) {
                    return _this.handleErrorResponse(response, 'Gegevens aanpassen is mislukt.');
                }).then(function () {
                    return _this.loading = false;
                });
            }
        },
        validateFields: function validateFields() {
            this.validateFirstName(this.firstname);
            this.validateLastName(this.lastname);
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "gQQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "guAv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.isLoadingGroupData) ? _c('loading') : _c('div', {
    staticClass: "template template--sidebar"
  }, [_c('sidebar-teacher', {
    attrs: {
      "user": _vm.loggedInUser,
      "group": _vm.currentGroup,
      "loadingUserProgress": _vm.isLoadingUserProgress,
      "isDemo": _vm.isDemo,
      "groupTerm": _vm.groupTerm
    }
  }), _c('div', {
    staticClass: "page-wrap",
    class: {
      'adjust-for-mini-sidebar': _vm.isInspectingStudent
    }
  }, [_c('transition', {
    attrs: {
      "name": "view-transition",
      "mode": "out-in"
    },
    on: {
      "after-leave": _vm.afterPageViewLeave
    }
  }, [_c('router-view', {
    key: _vm.viewKey,
    staticClass: "page-view",
    attrs: {
      "loading": _vm.isLoadingUserProgress,
      "user": _vm.viewingUser,
      "group": _vm.currentGroup,
      "isInspectingStudent": _vm.isInspectingStudent,
      "isInspecting": true,
      "ignoreProgress": _vm.ignoreProgress,
      "isDemo": _vm.isDemo
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "gvNC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "planner"
  }, [_c('div', {
    staticClass: "planner__periods-wrapper"
  }, _vm._l((_vm.periods), function(period, periodIndex) {
    return (period.start) ? _c('div', {
      staticClass: "planner__period",
      class: {
        'is-selected': periodIndex === _vm.selectedPeriod, 'is-enabled': period.enabled, 'is-disabled': !period.enabled, 'is-finalized': _vm.isFinalized(period)
      },
      style: (_vm.styleForPeriod(period)),
      attrs: {
        "data-period-index": periodIndex
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickedPeriod($event, period)
        }
      }
    }, [_c('div', {
      staticClass: "planner__period-header",
      class: {
        'is-disabled': !period.enabled
      },
      attrs: {
        "title": _vm.displayPeriodTitle(period)
      }
    }, [_c('span', {
      staticClass: "planner__period-title"
    }, [_vm._v(_vm._s(period.title))])]), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canEnable(period)),
        expression: "canEnable(period)"
      }],
      staticClass: "planner__enabler",
      class: {
        'is-disabled': !period.enabled
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.togglePeriodEnabled(period)
        }
      }
    }, [_vm._v(_vm._s(period.enabled ? 'disable' : 'enable'))]), _vm._l((period.blocks), function(block, blockIndex) {
      return _c('div', {
        staticClass: "planner__block",
        class: {
          'is-disabled': !period.enabled, 'is-finalized': _vm.isBlockFinalized(period, block)
        },
        style: (_vm.styleForBlock(block)),
        attrs: {
          "data-period-index": periodIndex,
          "data-block-index": blockIndex,
          "title": _vm.displayBlockTitle(period, block)
        }
      }, [_c('div', {
        staticClass: "planner__extend-handle"
      }, [_vm._v(" + - ")])])
    })], 2) : _vm._e()
  })), _c('div', {
    staticClass: "planner__calendar"
  }, [_c('div', {
    staticClass: "planner__header"
  }, [_c('div', {
    staticClass: "planner__week-relative-number"
  }, [_vm._v(" ")]), _vm._l((_vm.displayedDaysInWeek), function(day) {
    return _c('div', {
      staticClass: "planner__day planner__day--heading"
    }, [_vm._v(_vm._s(day))])
  })], 2), _vm._l((_vm.displayedWeeks), function(wk) {
    return _c('div', {
      staticClass: "planner__week",
      class: wk.cls
    }, [_c('div', {
      staticClass: "planner__week-relative-number"
    }, [_vm._v(_vm._s(wk.relativeNumber))]), _c('div', {
      staticClass: "planner__week-days-wrapper",
      attrs: {
        "title": wk.label
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickedWeek($event, wk)
        }
      }
    }, _vm._l((wk.days), function(day) {
      return _c('div', {
        staticClass: "planner__day",
        class: day
      })
    })), _c('div', {
      staticClass: "planner__week-number"
    }, [_vm._v(_vm._s(wk.number))]), _c('div', {
      staticClass: "planner__week-date"
    }, [_vm._v(_vm._s(wk.dates))])])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "gxKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gxlJ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("KRDm")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("YkV/"),
  /* template */
  __webpack_require__("3u6l"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "gy7S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("dhnc");

__webpack_require__("kLF+");

__webpack_require__("SCKt");

__webpack_require__("fB7P");

__webpack_require__("0K64");

/***/ }),

/***/ "gyY9":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("S9HV")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("tkiJ"),
  /* template */
  __webpack_require__("mXd4"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "h+NG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "sidebar__header",
    class: _vm.isWorkspace ? 'sidebar__header--student' : 'sidebar__header--teacher'
  }, [(_vm.isWorkspace) ? _c('h1', {
    staticClass: "sidebar__workspace-title",
    on: {
      "click": _vm.showCurrentPeriod
    }
  }, [_vm._v("Werkmap")]) : _vm._e(), (_vm.isWorkspace) ? _c('span', {
    staticClass: "sidebar__workspace-of"
  }, [_vm._v("van")]) : _vm._e(), _c('h3', {
    staticClass: "sidebar__user",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleUserMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "sidebar__user-button"
  }, [_c('span', {
    staticClass: "sidebar__user-icon"
  }), _c('span', {
    staticClass: "sidebar__user-name mini-hidden"
  }, [_vm._v(_vm._s(_vm.name(_vm.user)))])]), (!_vm.disableMenu) ? _c('user-menu', {
    attrs: {
      "show": _vm.isUserMenuVisible,
      "isDemo": _vm.isDemo,
      "isAdmin": _vm.isAdmin
    },
    on: {
      "hide": _vm.hideUserMenu
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "h1Gv":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('p', [_vm._v("Leerlingen kunnen zich aanmelden bij deze klas door de volgende "), _c('strong', [_vm._v("uitnodigingscode")]), _vm._v(" in te voeren op "), _c('a', {
    attrs: {
      "href": '//' + _vm.registerLink
    }
  }, [_vm._v(_vm._s(_vm.registerLink))]), _vm._v(":")]), _c('h1', {
    staticClass: "invite-code"
  }, [_vm._v(_vm._s(_vm.group.code))]), _vm._m(0), _vm._m(1), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    staticClass: "action-wrapper"
  }, [_c('a', {
    staticClass: "tag button-timid button-forward",
    attrs: {
      "href": _vm.inviteUrl
    }
  }, [_vm._v("Voorbeeld uitnodigingsmail")]), (_vm.isCreating) ? _c('primary-button', {
    on: {
      "clicked": _vm.done
    }
  }, [_vm._v("Klaar")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" deze code is hoofdlettergevoelig.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--info"
  }, [_vm._v("Wijs de leerlingen erop dat ze hun "), _c('strong', [_vm._v("e-mailadres goed invullen")]), _vm._v(", anders kunnen ze zich niet registreren!")])
}]}

/***/ }),

/***/ "h2O9":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("gxKL")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("rDG/"),
  /* template */
  __webpack_require__("hB1x"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hB1x":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sidebar__wrap sidebar__wrap--teacher"
  }, [_c('sidebar', {
    staticClass: "sidebar--teacher",
    class: _vm.mini ? 'sidebar--mini' : 'sidebar--expanded',
    attrs: {
      "user": _vm.user,
      "collectionPrefix": "klas",
      "collectionName": this.group.name,
      "collectionLink": {
        name: 'students.overview'
      },
      "backLink": {
        name: 'groups'
      },
      "backLinkTitle": "Klassen",
      "isCollectionActive": _vm.$route.name === 'students.overview'
    },
    on: {
      "viewCollectionInfo": _vm.openSettings
    }
  }, [(_vm.mini) ? _c('div', {
    staticClass: "sidebar__touch-block",
    on: {
      "!touchstart": function($event) {
        _vm.prevent($event)
      }
    }
  }) : _vm._e(), _c(_vm.contentComponent, {
    tag: "component",
    attrs: {
      "group": _vm.group,
      "groupTerm": _vm.groupTerm,
      "isDemo": _vm.isDemo
    }
  })], 1), (_vm.student != null) ? _c('sidebar-workspace', {
    attrs: {
      "user": _vm.student,
      "group": _vm.group,
      "loading": _vm.loadingUserProgress,
      "hideUnfinished": true,
      "isInspecting": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "haHN":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("4l/r")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("AG4v"),
  /* template */
  __webpack_require__("4dtJ"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hhDQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hjgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iAAw":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('timeline', {
    staticClass: "sidebar__content--students timeline--students",
    attrs: {
      "items": _vm.students,
      "isActive": _vm.isStudentActive
    },
    on: {
      "click": _vm.viewStudent
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(student) {
        return [_c('div', {
          staticClass: "timeline__hoverable"
        }, [_c('header', {
          staticClass: "timeline__header"
        }, [_c('h3', {
          staticClass: "timeline__title"
        }, [_c('span', {
          staticClass: "mini-visible"
        }, [_vm._v(_vm._s(_vm.initials(student)))]), _c('span', {
          staticClass: "mini-hidden"
        }, [_vm._v(_vm._s(_vm.username(student)))])])])])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n        Geen leerlingen gevonden\n    ")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "iCnv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { PrimaryButton: _PrimaryButton2.default },

    data: function data() {
        return {
            isVisible: false,
            title: '',
            message: '',
            actions: [],
            needsAttention: false
        };
    },

    methods: {
        ask: function ask(title, message, actions) {
            this.reset();
            title && (this.title = title);
            message && (this.message = message);
            actions && (this.actions = actions);
            this.isVisible = true;
        },
        fire: function fire(action) {
            action.action && action.action();
            this.reset();
        },
        reset: function reset() {
            this.isVisible = false;
            this.message = '';
            this.title = '';
            this.actions = [{ name: 'ok' }];
        },

        getAttention: function getAttention() {
            var _this = this;

            this.needsAttention = true;
            setTimeout(function () {
                return _this.needsAttention = false;
            }, 500);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "iOrq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Accordion = __webpack_require__("sPnI");

var _Accordion2 = _interopRequireDefault(_Accordion);

var _Timeline = __webpack_require__("XYq3");

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Period = __webpack_require__("5NLI");

var _Period2 = _interopRequireDefault(_Period);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _getters = __webpack_require__("olIF");

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    mixins: [_notificationsMixin2.default],

    components: { Accordion: _Accordion2.default, Timeline: _Timeline2.default, Period: _Period2.default },

    props: {
        group: {},
        groupTerm: {},
        isDemo: {
            type: Boolean,
            default: false
        }
    },

    vuex: {
        getters: {
            getGroupTermsForGroup: _getters.getGroupTermsForGroup,
            getProgressForUserAndGroupTerm: _getters.getProgressForUserAndGroupTerm
        }
    },

    computed: {

        expandedGroupTerm: function expandedGroupTerm() {
            return this.$route.name === 'group.overview' ? null : this.groupTerm.id;
        },

        timelineItems: function timelineItems() {
            var _this = this;

            return this.groupPeriods.map(function (gp, index) {
                return {
                    id: gp.id,
                    groupPeriod: gp,
                    start: _this.periodStart(index),
                    end: _this.periodEnd(index)
                };
            });
        },

        groupPeriods: function groupPeriods() {
            var _this2 = this;

            if (this.groupTerm == null) {
                return [];
            }

            return this.groupTerm.groupPeriods.map(function (id) {
                return _this2.$store.state.groups.periods[id];
            });
        },

        groupTerms: function groupTerms() {
            var _this3 = this;

            var overview = {
                id: -1,
                title: 'Overzicht',
                isFirst: false,
                isExpandable: false,
                link: { name: 'group.overview' }
            };

            var terms = this.getGroupTermsForGroup(this.group.id).filter(function (gt) {
                return gt.term != null && gt.term.length > 0;
            }).map(function (gt, index) {
                var term = _this3.$store.state.terms.storage[gt.term[0]];
                return {
                    id: gt.id,
                    title: index + 1 + '. ' + term.title,
                    isFirst: index === 0
                };
            });

            return [overview].concat(terms);
        },

        currentGroupTermId: function currentGroupTermId() {
            return this.group.currentGroupTerm[0];
        },

        currentGroupPeriodId: function currentGroupPeriodId() {
            var gt = this.$store.state.groups.terms[this.currentGroupTermId];
            return gt.currentGroupPeriod == null ? null : gt.currentGroupPeriod[0];
        }

    },

    methods: {

        viewPeriod: function viewPeriod(data) {
            this.$router.push({ name: 'group.period', params: { periodId: data.groupPeriod.id } });
        },

        isPeriodActive: function isPeriodActive(groupPeriod) {
            return this.$route.params.periodId === groupPeriod.id && this.$route.name === 'group.period';
        },

        isPeriodCurrent: function isPeriodCurrent(groupPeriod) {
            return this.currentGroupPeriodId === groupPeriod.id;
        },

        showGroupTerm: function showGroupTerm(groupTerm) {
            this.$router.push({ name: 'students.overview', params: { groupTermId: groupTerm.id } });
        },

        periodStart: function periodStart(index) {
            if (index === 0) {
                return (0, _moment2.default)(this.groupTerm.start * 1000);
            }

            return (0, _moment2.default)(this.groupPeriods[index - 1].end * 1000).add(1, 'days');
        },

        periodEnd: function periodEnd(index) {
            return (0, _moment2.default)(this.groupPeriods[index].end * 1000);
        }

    }

};

/***/ }),

/***/ "iZO2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ihE0":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "legal tight"
  }, [(!_vm.content) ? _c('loading') : _c('div', [(_vm.title) ? _c('h1', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "iouj":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("az6Q")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ZuEl"),
  /* template */
  __webpack_require__("zu0v"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ipBU":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("gDzj")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("QoH3"),
  /* template */
  __webpack_require__("h1Gv"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ixh7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j0ZK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.username = username;
exports.initial = initial;
exports.initials = initials;
exports.date = date;
exports.sorter = sorter;
exports.excerpt = excerpt;
function username(user) {
    var firstname = user.role === 'teacher' ? initial(user.firstname) : user.firstname;
    return firstname + ' ' + user.middlename + ' ' + user.lastname;
}

function initial(name) {
    return firstLetter(name) + '.';
}

function initials(user) {
    return [user.firstname, user.middlename, user.lastname].map(firstLetter).join('');
}

function firstLetter(name) {
    return name.charAt(0).toUpperCase();
}

function dateForTimestamp(timestamp, includeTime) {
    if (timestamp == null) {
        return '';
    }
    return date(new Date(timestamp * 1000), includeTime);
}

function date(date, includeTime) {
    if (date == null) {
        return '';
    }

    if (date === parseInt(date, 10)) {
        return dateForTimestamp(date, includeTime);
    }

    var format = date.getDate() + ' / ' + (date.getMonth() + 1) + ' / ' + date.getFullYear();

    return includeTime ? format + ' ' + time(date) : format;
}

function time(date) {
    var minutes = date.getMinutes();
    return date.getHours() + ':' + (minutes < 10 ? '0' : '') + minutes;
}

function sorter(key) {

    key = key || 'created_at';

    return function (a, b) {
        // note that this is sorted in reverse, newest first
        if (a[key] > b[key]) {
            return -1;
        }
        if (a[key] < b[key]) {
            return 1;
        }
        return 0;
    };
}

function excerpt(text, maxLength, tail) {

    tail = tail || '...';

    if (text.length <= maxLength) {
        return text;
    }

    return text.substring(0, maxLength - tail.length) + tail;
}

/***/ }),

/***/ "jJS5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _General = __webpack_require__("6O0U");

var _General2 = _interopRequireDefault(_General);

var _Planning = __webpack_require__("IoFZ");

var _Planning2 = _interopRequireDefault(_Planning);

var _Assignments = __webpack_require__("O5rX");

var _Assignments2 = _interopRequireDefault(_Assignments);

var _Invite = __webpack_require__("ipBU");

var _Invite2 = _interopRequireDefault(_Invite);

var _auth = __webpack_require__("JOmw");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'GroupSettings',
    props: {
        inModal: {
            type: Boolean,
            default: false
        },
        group: {},
        landingPage: {}
    },
    components: { General: _General2.default, Planning: _Planning2.default, Assignments: _Assignments2.default, Invite: _Invite2.default },

    data: function data() {
        return {
            view: 'General',
            createdGroupId: null
        };
    },

    vuex: {
        getters: {
            currentUser: function currentUser(state) {
                return state.users.current;
            },
            isDirty: function isDirty(state) {
                return state.modal.isDirty;
            }
        },
        actions: {
            dirtyModal: function dirtyModal(_ref, dirty) {
                var dispatch = _ref.dispatch,
                    state = _ref.state;

                if (state.modal.isDirty !== dirty) {
                    dispatch(dirty ? 'MODAL_DIRTY' : 'MODAL_CLEAN');
                }
            }
        }
    },

    computed: {
        isAdmin: function isAdmin() {
            return (0, _auth.isAdmin)(this.currentUser);
        },

        isDemo: function isDemo() {
            return (0, _auth.isDemo)(this.currentUser);
        },

        isGeneralActive: function isGeneralActive() {
            return this.view === 'General';
        },

        isPlanningActive: function isPlanningActive() {
            return this.view === 'Planning';
        },

        isAssignmentsActive: function isAssignmentsActive() {
            return this.view === 'Assignments';
        },

        isInviteActive: function isInviteActive() {
            return this.view === 'Invite';
        },

        isCreating: function isCreating() {
            return this.group == null;
        },

        isCreated: function isCreated() {
            return this.createdGroupId != null;
        },

        viewingGroup: function viewingGroup() {
            return this.group || this.$store.state.groups.storage[this.createdGroupId];
        },

        school: function school() {
            var id = this.$store.state.users.current.schools[0];
            return this.$store.state.schools.storage[id];
        }

    },

    methods: {
        viewGeneral: function viewGeneral() {
            var _this = this;

            this.confirmDirty().then(function () {
                return _this.view = 'General';
            }, function () {});
        },
        viewPlanning: function viewPlanning() {
            var _this2 = this;

            if (this.isCreating && !this.isCreated) {
                return;
            }
            this.confirmDirty().then(function () {
                return _this2.view = 'Planning';
            }, function () {});
        },
        viewAssignments: function viewAssignments() {
            var _this3 = this;

            if (this.isCreating && !this.isCreated) {
                return;
            }
            this.confirmDirty().then(function () {
                return _this3.view = 'Assignments';
            }, function () {});
        },
        viewInvite: function viewInvite() {
            var _this4 = this;

            if (this.isCreating && !this.isCreated) {
                return;
            }
            this.confirmDirty().then(function () {
                return _this4.view = 'Invite';
            }, function () {});
        },
        goToNextStep: function goToNextStep() {
            if (this.isGeneralActive) {
                return this.viewPlanning();
            }

            if (this.isPlanningActive) {
                return this.viewAssignments();
            }

            if (this.isAssignmentsActive) {
                return this.viewInvite();
            }
        },
        confirmDirty: function confirmDirty() {
            var _this5 = this;

            if (!this.isDirty) {
                return Promise.resolve();
            }

            var title = 'Wijzigingen opslaan?';
            var message = 'Wil je de gemaakte wijzigingen eerst opslaan? Als je ze ongedaan maakt gaan de wijzigingen verloren.';

            return new Promise(function (resolve, reject) {

                _this5.$alert({ title: title, message: message }, [{ name: 'Annuleren', action: reject }, { name: 'Ongedaan maken', danger: true, action: resolve }, { name: 'Opslaan', primary: true, action: function action() {
                        return _this5.$refs.step.save().then(resolve, reject);
                    } }]);
            }).then(function () {
                return _this5.dirtyModal(false);
            });
        },

        savedStep: function savedStep(group) {
            this.dirtyModal(false);

            if (group) {
                this.createdGroupId = group.id;
            }

            if (this.isCreating) {
                this.goToNextStep();
            }
        },

        done: function done() {
            this.$emit('close');
        }

    },

    created: function created() {
        if (this.isCreating) {
            _analytics2.default.event('group', 'create');
        } else {
            _analytics2.default.event('group', 'settings', this.group.id);
        }

        if (this.landingPage != null) {
            this.view = this.landingPage;
        }
    }
};

/***/ }),

/***/ "je1x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Celebration = __webpack_require__("WFFm");

var _Celebration2 = _interopRequireDefault(_Celebration);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function randomElement(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

exports.default = {
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },

    components: { Celebration: _Celebration2.default, PrimaryButton: _PrimaryButton2.default },

    vuex: {
        getters: {
            type: function type(state) {
                return state.achievements.type;
            }
        },
        actions: {
            closeAchievement: function closeAchievement(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('HIDE_ACHIEVEMENT');
            }
        }
    },

    methods: {
        close: function close() {
            this.closeAchievement();
            this.$emit('close');
        },

        encouragement: function encouragement() {
            return randomElement(['Super', 'Fantastisch', 'Geweldig', 'Sensationeel', 'Fameus', 'Grandioos', 'Buitengewoon', 'Puik', 'Formidabel']);
        },
        thanks: function thanks() {
            return randomElement(['Gaaf', 'Mieters', 'Te gek', 'Leuk', 'Tof', 'Cool']);
        }
    },

    watch: {
        isVisible: function isVisible(newValue) {
            if (newValue) {
                var audio = new Audio('/audio/applause.mp3');
                var promise = audio.play();
                if (promise != null) {
                    promise.catch(function (error) {
                        // Auto-play was prevented
                        console.log('No permission to play audio', error);
                    });
                }
            }
        }
    },

    computed: {
        isVisible: function isVisible() {
            return this.show && (!!this.badge || this.$slots.default);
        },
        badges: function badges() {
            return [{
                type: 'idea',
                name: 'Ideevorming',
                color: 'blue'
            }, {
                type: 'design',
                name: 'Vormgeving',
                color: 'red'
            }, {
                type: 'technique',
                name: 'Materiaal & techniek',
                color: 'yellow'
            }, {
                type: 'artappreciation',
                name: 'Kunstbeschouwing',
                color: 'green'
            }, {
                type: 'reflection',
                name: 'Reflectie',
                color: 'purple'
            }];
        },
        badge: function badge() {
            var _this = this;

            return this.badges.find(function (b) {
                return b.type === _this.type;
            });
        }
    }
};

/***/ }),

/***/ "jev0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgER":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.images.length == 1) ? _c('img', {
    staticClass: "partial-image",
    attrs: {
      "src": _vm.images[0],
      "alt": "image"
    }
  }) : (_vm.images.length > 1) ? _c('div', {
    staticClass: "slideshow"
  }, [_c('div', {
    staticClass: "slideshow__imagecontainer"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.currentImage,
    staticClass: "slideshow__image",
    attrs: {
      "src": _vm.currentImage
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next($event)
      }
    }
  })])], 1), _c('div', {
    staticClass: "slideshow__controls"
  }, [_c('a', {
    staticClass: "slideshow__previous",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previous($event)
      }
    }
  }, [_vm._v("prev")]), _c('span', {
    staticClass: "slideshow__indicator"
  }, [_vm._v(_vm._s(_vm.currentIndex + 1) + "/" + _vm._s(_vm.images.length))]), _c('a', {
    staticClass: "slideshow__next",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next($event)
      }
    }
  }, [_vm._v("next")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ "jkxs":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("2BqO")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("yeX9"),
  /* template */
  __webpack_require__("5qiO"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "k+CZ":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Ipr1")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("tXOP"),
  /* template */
  __webpack_require__("64w4"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "kJvQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kR54":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyBm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {},
        teachertips: {}
    };
};

var mutations = {
    ADD_STEPS: function ADD_STEPS(state, steps) {
        (0, _helpers.setObjects)(steps, state.storage);
    },
    ADD_TEACHERTIPS: function ADD_TEACHERTIPS(state, teachertips) {
        (0, _helpers.setObjects)(teachertips, state.teachertips);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "lSE2":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "achievement"
  }, [_c('transition', {
    attrs: {
      "name": "modal-transition"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "achievement__wrap",
    on: {
      "click": _vm.close
    }
  }, [_c('celebration', {
    attrs: {
      "color": _vm.badge.color
    }
  }), _c('div', {
    staticClass: "achievement__icon-wrap"
  }, [_c('img', {
    staticClass: "achievement__icon",
    attrs: {
      "src": ("/build/img/badges/badge-" + _vm.type + "-color-384x.png")
    }
  })]), _c('div', {
    staticClass: "achievement__container",
    on: {
      "click": function($event) {
        $event.stopPropagation()
      }
    }
  }, [_c('h2', {
    staticClass: "achievement__title"
  }, [_vm._v(_vm._s(_vm.encouragement()) + " gedaan!")]), _c('p', {
    staticClass: "achievement__description"
  }, [_vm._v("Je hebt een bekroning gekregen voor "), _c('strong', [_vm._v(_vm._s(_vm.badge.name))])]), _c('primary-button', {
    on: {
      "clicked": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.thanks()))])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "lTmj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    props: ['notification'],
    mounted: function mounted() {
        if (typeof this.notification.timeout === 'number' && this.notification.timeout > 0) {
            setTimeout(this.close, this.notification.timeout);
        }
    },
    computed: {
        isArray: function isArray() {
            return this.notification.text instanceof Array;
        }
    },
    methods: {
        close: function close() {
            this.$emit('close-notification', this.notification);
        }
    }
};

/***/ }),

/***/ "lqEK":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [(!_vm.requested) ? _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Hallo!")]), _vm._m(0)]) : _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Gelukt!")]), _c('p', [_vm._v("Activeer eerst je account om verder te gaan.")])]), (!_vm.requested) ? _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('code')
    }
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Uitnodigingscode")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), (_vm.forgot) ? _c('div', [_c('router-link', {
    staticClass: "to-forgot",
    attrs: {
      "to": {
        name: 'forgot'
      }
    }
  }, [_vm._v("Wachtwoord vergeten?")])], 1) : _vm._e(), _c('primary-button', {
    attrs: {
      "link": {
        name: 'root'
      },
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Registreren")])], 1)]), _c('div', {
    staticClass: "login__auth-other"
  }, [_vm._v("\n                Heb je al een werkmap? "), _c('router-link', {
    staticClass: "to-login",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)]) : _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('p', [_vm._v("Er is een mailtje verstuurd naar: "), _c('strong', [_vm._v(_vm._s(_vm.email))])]), _c('p'), _c('p', [_vm._v("Bekijk je mail en klik op de activatie knop om door te gaan.")]), _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Geen mailtje ontvangen?")]), _vm._v(" Check eerst je "), _c('em', [_vm._v("spam")]), _vm._v(" map, controleer of je je e-mailadres goed hebt ingevuld en "), _c('a', {
    staticClass: "to-register",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("probeer het opnieuw")]), _vm._v(".")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', [_vm._v("Vul je gegevens in om jouw eigen werkmap aan te maken."), _c('br'), _c('strong', [_vm._v("Let op:")]), _vm._v(" je kunt alleen registreren met jouw uitnodigingscode.")])
}]}

/***/ }),

/***/ "m42C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        storage: {}
    };
};

var mutations = {
    ADD_PROGRESS: function ADD_PROGRESS(state, progress) {
        (0, _helpers.setObjects)(progress, state.storage, { primarySubmissions: [], feedback: [], diligence: null, badge: null });
    },
    ADD_PRIMARY_SUBMISSION_TO_PROGRESS: function ADD_PRIMARY_SUBMISSION_TO_PROGRESS(state, progressId, submissionId) {
        state.storage[progressId].primarySubmissions.push(submissionId);
    },
    REMOVE_PRIMARY_SUBMISSION_FROM_PROGRESS: function REMOVE_PRIMARY_SUBMISSION_FROM_PROGRESS(state, progressId, submissionId) {
        var index = state.storage[progressId].primarySubmissions.indexOf(submissionId);
        state.storage[progressId].primarySubmissions.splice(index, 1);
    },
    ADD_FEEDBACK_TO_PROGRESS: function ADD_FEEDBACK_TO_PROGRESS(state, progressId, feedbackId) {
        state.storage[progressId].feedback = [feedbackId];
    },
    ADD_DILIGENCE_TO_PROGRESS: function ADD_DILIGENCE_TO_PROGRESS(state, progressId, diligenceId) {
        state.storage[progressId].diligence = [diligenceId];
    },
    ADD_BADGE_TO_PROGRESS: function ADD_BADGE_TO_PROGRESS(state, progressId, badgeId) {
        state.storage[progressId].badge = [badgeId];
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "mJuH":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Uqqx")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("jJS5"),
  /* template */
  __webpack_require__("sXQb"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mWFA":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("feAO")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("0x2l"),
  /* template */
  __webpack_require__("IO41"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mXd4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.loading) ? _c('loading') : (!_vm.submissions) ? _c('div', [_vm._v("\n        Nog geen reflectie beschikbaar.\n    ")]) : _c('div', [_c('h2', [_vm._v("Dit heeft een klasgenoot gemaakt:")]), (_vm.type === 'Upload') ? [_c('upload', {
    attrs: {
      "submissions": _vm.submissions
    }
  })] : _vm._l((_vm.submissions), function(submission) {
    return _c('question', {
      key: submission.id,
      attrs: {
        "submissions": [submission]
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "mYC5":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('canvas', {
    directives: [{
      name: "celebration",
      rawName: "v-celebration",
      value: ({
        type: _vm.type,
        color: _vm.color,
        delay: _vm.delay
      }),
      expression: "{ type, color, delay }"
    }],
    staticClass: "celebration"
  })])
},staticRenderFns: []}

/***/ }),

/***/ "mame":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mcjV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "msl+":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      'sidebar--floating': _vm.isFloating
    },
    style: ({
      'padding-top': _vm.offsetTop + 'px'
    })
  }, [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "alt": true
    }
  }) : [_c('sidebar-header', {
    attrs: {
      "user": _vm.user,
      "disableMenu": _vm.disableUserMenu
    }
  }), (_vm.showOptions) ? _c('div', {
    staticClass: "sidebar__options"
  }, [(_vm.backLink) ? _c('h2', {
    staticClass: "sidebar__tag",
    class: {
      'sidebar__tag--rounded': _vm.isFloating
    }
  }, [_c('router-link', {
    staticClass: "sidebar__back button-backward button-backward-primary",
    attrs: {
      "to": _vm.backLink
    }
  }, [_vm._v(_vm._s(_vm.backLinkTitle))]), (_vm.collectionName) ? _c('router-link', {
    staticClass: "sidebar__name",
    class: {
      'is-active': _vm.isCollectionActive
    },
    attrs: {
      "to": _vm.collectionLink
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        if (!$event.metaKey) { return null; }
        _vm.$emit('viewCollectionInfo')
      }
    }
  }, [(_vm.collectionPrefix) ? _c('span', {
    staticClass: "mini-hidden"
  }, [_vm._v(_vm._s(_vm.collectionPrefix))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.collectionNameExcerpt) + "\n                ")]) : _vm._e()], 1) : _vm._e(), (_vm.addLink) ? _c('h2', {
    staticClass: "sidebar__tag sidebar__tag--inverted sidebar__tag--multi",
    class: {
      'sidebar__tag--rounded': _vm.isFloating
    }
  }, [_c('router-link', {
    staticClass: "sidebar__add-new",
    attrs: {
      "to": _vm.addLink
    }
  }, [_c('span', {
    staticClass: "icon icon--add icon--inline"
  }), _vm._v(" Nieuw")])], 1) : _vm._e(), _vm._t("options")], 2) : _vm._e(), _c('div', {
    directives: [{
      name: "scroller",
      rawName: "v-scroller"
    }],
    staticClass: "sidebar__content scrollable",
    attrs: {
      "id": "sidebar-content"
    }
  }, [_vm._t("default", [(!_vm.isFloating) ? _c('timeline', {
    attrs: {
      "items": _vm.items,
      "isActive": _vm.isActive,
      "collectionName": _vm.collectionName
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._t("item", null, null, props)]
      }
    }])
  }) : _vm._e()])], 2), _c('div', {
    staticClass: "sidebar__copyright"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDisclaimer($event)
      }
    }
  }, [_vm._v("© " + _vm._s(_vm.currentYear) + " "), _c('span', {
    staticClass: "mini-hidden"
  }, [_vm._v("Kiempunt - disclaimer")])])])]], 2)
},staticRenderFns: []}

/***/ }),

/***/ "mz3s":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("HIb7")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("KWYY"),
  /* template */
  __webpack_require__("Vw6N"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "n/5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nDbn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var initialState = function initialState() {
    return {
        type: null,
        color: null
    };
};

var mutations = {
    SHOW_ACHIEVEMENT: function SHOW_ACHIEVEMENT(state, type, color) {
        state.type = type;
        state.color = color;
    },
    HIDE_ACHIEVEMENT: function HIDE_ACHIEVEMENT(state) {
        state.type = null;
        state.color = null;
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "nFoP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('firstname')
    }
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Voornaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "name": "firstname",
      "id": "firstname"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('infix')
    }
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infix),
      expression: "infix"
    }],
    attrs: {
      "type": "text",
      "name": "infix",
      "id": "infix"
    },
    domProps: {
      "value": (_vm.infix)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.infix = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('lastname')
    }
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Achternaam")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    attrs: {
      "type": "text",
      "name": "lastname",
      "id": "lastname"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Opslaan")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('label', {
    attrs: {
      "for": "infix"
    }
  }, [_vm._v("Tussenvoegsel "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— de / van / van 't / van den /  ...")])])
}]}

/***/ }),

/***/ "nuSn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o1oS":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("VPYc")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("L7d7"),
  /* template */
  __webpack_require__("h+NG"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "o3+c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o9Mb":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("mame")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7Lht"),
  /* template */
  __webpack_require__("swdy"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "oDPp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

var _auth = __webpack_require__("JOmw");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Logout',
    mixins: [_notificationsMixin2.default],
    components: { Loading: _Loading2.default },
    vuex: {
        actions: { reset: _actions.reset }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {

        // protect against outside links to logout
        if (to.params._internal !== true) {
            return next({ name: 'root' });
        }

        next(function (vm) {

            // reset vuex data
            vm.reset();

            _analytics2.default.user(null);

            // destroy tokens
            (0, _auth.logout)().then(function () {

                if (to.query.next === 'web') {
                    window.location.replace('/');
                } else {
                    vm.$router.replace({ name: 'login' });
                }
            });
        });
    }
}; //
//
//
//
//
//
//

/***/ }),

/***/ "oGel":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("mcjV")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("12Ju"),
  /* template */
  __webpack_require__("bpQ3"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "oTIl":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "accordion__collection"
  }, [(_vm.collection) ? _c('h2', {
    staticClass: "sidebar__tag"
  }, [_c('a', {
    staticClass: "button-collapse-primary",
    class: {
      'button-collapse': _vm.isExpanded, 'active': _vm.isExpanded || _vm.isActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleExpand($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.collection.title))])]) : _vm._e(), (_vm.isExpanded) ? [(_vm.isLoading || _vm.isExpanding) ? _c('div', {
    key: "accordion__loading",
    staticClass: "accordion__loading"
  }, [_c('loading', {
    attrs: {
      "alt": true,
      "mini": true
    }
  })], 1) : _c('div', {
    key: "accordion__content",
    staticClass: "accordion__content"
  }, [_vm._t("default")], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "olIF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getGroupTermsForGroup = exports.getGroupTermsForGroup = function getGroupTermsForGroup(state) {
    return function (groupId) {
        var group = getGroup(state)(groupId);
        return group.groupTerms.map(function (id) {
            return state.groups.terms[id];
        });
    };
};

var getCurrentGroupTermForGroup = exports.getCurrentGroupTermForGroup = function getCurrentGroupTermForGroup(state) {
    return function (groupId) {
        var group = getGroup(state)(groupId);
        if (group.currentGroupTerm == null) {
            return null;
        }
        return state.groups.terms[group.currentGroupTerm[0]];
    };
};

var getCurrentGroupPeriodForGroupTerm = exports.getCurrentGroupPeriodForGroupTerm = function getCurrentGroupPeriodForGroupTerm(state) {
    return function (groupTerm) {
        return state.groups.periods[getCurrentGroupPeriodIdForGroupTerm(groupTerm)];
    };
};

var getCurrentGroupPeriodIdForGroupTerm = function getCurrentGroupPeriodIdForGroupTerm(groupTerm) {
    // if no period is currently active, fallback to last period in current term
    return groupTerm.currentGroupPeriod == null ? groupTerm.groupPeriods[groupTerm.groupPeriods.length - 1] : groupTerm.currentGroupPeriod[0];
};

var getCurrentPeriodIdForGroup = exports.getCurrentPeriodIdForGroup = function getCurrentPeriodIdForGroup(state) {
    return function (groupId) {
        return getCurrentGroupPeriodForGroup(state)(groupId).period[0];
    };
};

var getCurrentGroupPeriodIdForGroup = exports.getCurrentGroupPeriodIdForGroup = function getCurrentGroupPeriodIdForGroup(state) {
    return function (groupId) {
        var groupTerm = getCurrentGroupTermForGroup(state)(groupId);
        if (groupTerm == null) {
            return null;
        }
        return getCurrentGroupPeriodIdForGroupTerm(groupTerm);
    };
};

var getCurrentGroupPeriodForGroup = exports.getCurrentGroupPeriodForGroup = function getCurrentGroupPeriodForGroup(state) {
    return function (groupId) {
        var groupTerm = getCurrentGroupTermForGroup(state)(groupId);
        if (groupTerm == null) {
            return null;
        }
        return getCurrentGroupPeriodForGroupTerm(state)(groupTerm);
    };
};

var getCurrentTermId = exports.getCurrentTermId = function getCurrentTermId(state) {
    return function (groupId) {
        var groupTerm = getCurrentGroupTermForGroup(state)(groupId);
        if (groupTerm == null) {
            return null;
        }
        return groupTerm.term[0];
    };
};

var getCurrentTerm = exports.getCurrentTerm = function getCurrentTerm(state) {
    return function (groupId) {
        var termId = getCurrentTermId(state)(groupId);
        return termId == null ? null : state.terms.storage[termId];
    };
};

var getGroup = exports.getGroup = function getGroup(state) {
    return function (id) {
        return state.groups.storage[id];
    };
};
var getGroupIdForCurrentUser = exports.getGroupIdForCurrentUser = function getGroupIdForCurrentUser(state) {
    return getCurrentUser(state).groups[0];
};
var getCurrentUser = exports.getCurrentUser = function getCurrentUser(state) {
    return state.users.current;
};

var getCurrentAssignment = exports.getCurrentAssignment = function getCurrentAssignment(state) {
    return state.assignments.storage[state.assignments.currentId];
};

var getTermForPeriod = exports.getTermForPeriod = function getTermForPeriod(state) {
    return function (periodId) {
        return Object.keys(state.terms.storage).map(function (id) {
            return state.terms.storage[id];
        }).find(function (t) {
            return t.periods.indexOf(periodId) !== -1;
        });
    };
};

var getProgressForUserAssignmentGroup = exports.getProgressForUserAssignmentGroup = function getProgressForUserAssignmentGroup(state) {
    return function (userId, assignmentId, groupId) {
        return getProgressForUser(state)(userId).find(function (progress) {
            return progress.assignment == assignmentId && progress.group == groupId;
        });
    };
};

var getProgressForUser = exports.getProgressForUser = function getProgressForUser(state) {
    return function (userId) {
        return Object.keys(state.progress.storage).map(function (id) {
            return state.progress.storage[id];
        }).filter(function (progress) {
            return progress.user == userId;
        });
    };
};

var getProgressForUserAndGroupTerm = exports.getProgressForUserAndGroupTerm = function getProgressForUserAndGroupTerm(state) {
    return function (userId, groupTermId, groupId) {
        var termAssignments = getAssignmentIdsForGroupTerm(state)(groupTermId);
        return getProgressForUser(state)(userId).filter(function (p) {
            return termAssignments.indexOf(p.assignment) !== -1 && p.group == groupId;
        });
    };
};

var getAssignmentIdsForGroupTerm = function getAssignmentIdsForGroupTerm(state) {
    return function (groupTermId, filterOptional) {
        return state.groups.terms[groupTermId].groupPeriods.map(function (gp) {
            return getAssignmentIdsForGroupPeriod(state)(gp, filterOptional);
        }).reduce(function (list, assignments) {
            return list.concat(assignments);
        }, []); // flatmap to AssignmentIds
    };
};

var getAssignmentIdsForGroupPeriod = function getAssignmentIdsForGroupPeriod(state) {
    return function (groupPeriodId, filterOptional) {
        return state.groups.periods[groupPeriodId].groupAssignments.map(function (id) {
            return state.groups.assignments[id];
        }) // map to GroupAssignment
        .filter(function (ga) {
            return !(filterOptional && ga.optional);
        }).map(function (ga) {
            return ga.assignment[0];
        }); // map to AssignmentId
    };
};

var getAssignmentsForGroupPeriod = exports.getAssignmentsForGroupPeriod = function getAssignmentsForGroupPeriod(state) {
    return function (groupPeriodId, filterOptional) {
        return getAssignmentIdsForGroupPeriod(state)(groupPeriodId, filterOptional).map(function (id) {
            return state.assignments.storage[id];
        });
    };
};

/***/ }),

/***/ "ozB2":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("UlZ+")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("M4nG"),
  /* template */
  __webpack_require__("skod"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "pLjf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autoValidateMixin = __webpack_require__("HDu5");

var _autoValidateMixin2 = _interopRequireDefault(_autoValidateMixin);

var _video = __webpack_require__("94rq");

var _video2 = _interopRequireDefault(_video);

var _videojsResolutionSwitcher = __webpack_require__("3FD3");

var _videojsResolutionSwitcher2 = _interopRequireDefault(_videojsResolutionSwitcher);

var _storage = __webpack_require__("5ehd");

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    mixins: [_autoValidateMixin2.default],
    data: function data() {
        return {
            videojsDestroy: function videojsDestroy() {}
        };
    },
    computed: {
        isYoutube: function isYoutube() {
            return this.partial.data.type === 'youtube';
        },
        isPrivate: function isPrivate() {
            return this.partial.data.type === 'private';
        },
        source: function source() {
            var append = '';
            var id = this.partial.data.id;
            if ('playlist' in this.partial.data) {
                id = this.partial.data.playlist[0];
                append += this.partial.data.playlist.slice(1).reduce(function (sum, el) {
                    return sum += ',' + el;
                }, '&playlist=');
            }

            return '//www.youtube-nocookie.com/embed/' + id + '?rel=0' + append;
        },
        controllable: function controllable() {
            return this.partial.data.controllable !== false;
        },
        volume: {
            get: function get() {
                return _storage2.default.local.getItem('videoVolume');
            },
            set: function set(val) {
                return _storage2.default.local.setItem('videoVolume', val);
            }
        },
        mute: {
            get: function get() {
                return _storage2.default.local.getItem('videoMute') === 'true';
            },
            set: function set(val) {
                return _storage2.default.local.setItem('videoMute', val);
            }
        }
    },

    methods: {

        flush: function flush() {
            return Promise.resolve();
        },

        initVideojs: function initVideojs(el) {
            var vm = this;

            var opts = {
                controls: true,
                // poster: 'myPoster.jpg',

                autoplay: false,
                preload: 'auto',
                language: 'nl',
                techOrder: ['html5'],
                controlBar: {
                    volumeMenuButton: {
                        inline: false
                    }
                },
                plugins: {
                    videoJsResolutionSwitcher: {
                        default: 'low'
                    }
                }
            };

            (0, _video2.default)(el, opts, function () {

                var player = this;

                player.updateSrc(vm.partial.data.sources);

                if (vm.volume != null) {
                    player.volume(vm.volume);
                }

                if (vm.mute != null) {
                    player.muted(vm.mute);
                }

                player.on('volumechange', function () {
                    vm.volume = player.volume();
                    vm.mute = player.muted();
                });

                if (!vm.controllable) {
                    player.controlBar.progressControl.seekBar.off('mousedown');
                    player.controlBar.progressControl.seekBar.off('touchstart');
                    player.controlBar.progressControl.seekBar.off('click');
                    player.controlBar.playToggle.off('click');
                    player.controlBar.playToggle.off('touchstart');
                    player.controlBar.playToggle.off('mousedown');
                }

                // set destroy handler when comonent is destroyed
                vm.videojsDestroy = function () {
                    return player.dispose();
                };
            });
        }
    },
    created: function created() {
        var _this = this;

        if (this.isPrivate) {
            this.$nextTick(function () {
                _this.initVideojs(_this.$refs.videojs);
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.videojsDestroy();
    }

};

/***/ }),

/***/ "pMfq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _auth = __webpack_require__("JOmw");

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _jwtDecode = __webpack_require__("ytdl");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _helpers = __webpack_require__("x3kM");

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'RegisterVerify',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _touchMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, Loading: _Loading2.default },
    props: [],

    data: function data() {
        return {
            firstname: '',
            infix: '',
            lastname: '',
            password: '',
            passwordConfirmation: '',
            email: '',
            loading: false,
            isVerifying: true,
            errors: [],
            errorFields: []
        };
    },

    beforeRouteEnter: function beforeRouteEnter(to, from, next) {

        if (!to.params.token) {
            return next({ name: 'register' });
        }

        next();
    },

    created: function created() {
        var _this = this;

        _resources2.default.registrationVerify(this.$route.params.token).then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            _this.token = result.tokens[0].id;
            var decoded = (0, _jwtDecode2.default)(_this.token);
            _this.email = decoded.sub;
            _this.isVerifying = false;
        }).catch(function () {
            _this.$warn('Deze activatie link is niet meer geldig');
            _this.$router.push({ name: 'root' });
        });
    },

    methods: {
        submit: function submit(e) {
            var _this2 = this;

            e.preventDefault();

            if (this.validate()) {

                this.loading = true;

                _resources2.default.register(this.firstname, this.infix, this.lastname, this.password, this.passwordConfirmation, this.token).then(function () {
                    return (0, _auth.login)(_this2.email, _this2.password).then(function () {
                        _this2.$success('Welkom ' + _this2.firstname, { id: 'validation' });
                        _this2.$router.push({ name: 'root' });
                    });
                }).catch(function (response) {
                    return _this2.handleErrorResponse(response, 'Registratie is mislukt.');
                }).then(function () {
                    return _this2.loading = false;
                });
            }
        },

        validateFields: function validateFields() {
            this.validateFirstName(this.firstname);
            this.validateLastName(this.lastname);
            this.validatePasswordLength(this.password);
            this.validatePasswordEqual(this.password, this.passwordConfirmation);
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "pXuu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pxSe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q120":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qW9c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = {

    install: function install(Vue, opts) {

        /**
         * Triggers the global alerter component (in Main.vue)
         * @param  {Object|string} message      e.g. 'Hello world' or { title: 'Hello', message: 'World' }
         * @param  {Arra} actions     e.g. [ { name: 'cancel' }, { name: 'ok', action: () => { alert('hi') }}]
         */
        Vue.prototype.$alert = function (message, actions) {

            var alerter = this.$root.$children[0].$refs.alerter;
            if (!alerter) {
                console.error('Can\'t find alerter');
            }

            var obj = message !== null && (typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object' ? message : { message: message };
            alerter.ask(obj.title, obj.message, actions);
        };
    }

};

/***/ }),

/***/ "qr67":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Verstuur")])], 1)]), _c('div', {
    staticClass: "login__auth-other"
  }, [_c('router-link', {
    staticClass: "to-login",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Terug naar inloggen")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Wachtwoord vergeten?")]), _c('p', [_vm._v("Geen probleem, wij e-mailen je een link om je wachtwoord te veranderen.")])])
}]}

/***/ }),

/***/ "qrTR":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("kR54")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8SU+"),
  /* template */
  __webpack_require__("lqEK"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "r4bP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "badges"
  }, [_c('h2', {
    staticClass: "badges__title"
  }, [_vm._v("Bekroningen")]), _vm._m(0), _c('div', {
    staticClass: "badges__list"
  }, _vm._l((_vm.badges), function(badge) {
    return _c('div', {
      key: badge.type,
      staticClass: "badges__item badge",
      class: [("badge--" + (badge.type)), {
        'badge--active': badge.type === _vm.selectedBadge && !_vm.isLoading,
        'badge--disabled': _vm.disabled
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectBadge(badge)
        }
      }
    }, [_c('div', {
      staticClass: "badge__icon"
    }), _c('p', {
      staticClass: "badge__type tag"
    }, [_vm._v(_vm._s(badge.name))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "tag badges__explanation"
  }, [_c('em', [_vm._v("Deel een bekroning uit als de leerling boven zichzelf uitstijgt (op zijn niveau) in een vaardigheid.")])])
}]}

/***/ }),

/***/ "r5Ke":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Gtwz")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LDP5"),
  /* template */
  __webpack_require__("Uht+"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "rDG/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Sidebar = __webpack_require__("cHIS");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _SidebarWorkspace = __webpack_require__("PwNb");

var _SidebarWorkspace2 = _interopRequireDefault(_SidebarWorkspace);

var _SidebarContentStudents = __webpack_require__("EzjG");

var _SidebarContentStudents2 = _interopRequireDefault(_SidebarContentStudents);

var _SidebarContentTerms = __webpack_require__("KBgp");

var _SidebarContentTerms2 = _interopRequireDefault(_SidebarContentTerms);

var _transformers = __webpack_require__("j0ZK");

var _auth = __webpack_require__("JOmw");

var _getters = __webpack_require__("olIF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Sidebar: _Sidebar2.default, SidebarWorkspace: _SidebarWorkspace2.default, SidebarContentStudents: _SidebarContentStudents2.default, SidebarContentTerms: _SidebarContentTerms2.default },
    props: {
        user: {
            type: Object
        },
        group: {},
        groupTerm: {},
        loadingUserProgress: {
            type: Boolean
        },
        isDemo: {
            type: Boolean
        }
    },

    vuex: {
        getters: {
            getCurrentGroupPeriodForGroup: _getters.getCurrentGroupPeriodForGroup
        },
        actions: {
            showGroupSettings: function showGroupSettings(_ref, group) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'GroupSettings', { group: group });
            }
        }

    },

    computed: {
        student: function student() {
            return this.$store.state.users.storage[this.$route.params.studentId];
        },
        mini: function mini() {
            return this.student != null;
        },
        contentComponent: function contentComponent() {
            return this.$route.params.studentId != null ? 'SidebarContentStudents' : 'SidebarContentTerms';
        },

        groupPeriod: function groupPeriod() {
            return this.getCurrentGroupPeriodForGroup(this.group.id);
        }

    },
    methods: {
        username: _transformers.username,
        prevent: function prevent(event) {
            // prevents triggering links when touching the mini sidebar to open it
            event.stopPropagation();
            event.preventDefault();
        },
        openSettings: function openSettings() {
            if ((0, _auth.isAdmin)(this.user)) {
                this.showGroupSettings(this.group);
            }
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "rOkJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [_notificationsMixin2.default],
    components: { Loading: _Loading2.default },
    data: function data() {
        return {
            content: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.request().then(function (res) {
            _this.content = res.data;
        }).catch(function () {
            _this.$warn('Kan pagina niet vinden.');
            _this.close();
        });
    },
    methods: {
        close: function close() {
            this.$emit('close');
        },

        request: function request() {
            if (this.type == 'privacy') {
                return _resources2.default.getLegalPrivacy();
            }

            if (this.type == 'disclaimer') {
                return _resources2.default.getLegalDisclaimer();
            }

            if (this.type == 'terms') {
                return _resources2.default.getLegalTerms();
            }
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "regp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getters = __webpack_require__("olIF");

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _transformers = __webpack_require__("j0ZK");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _sprite = __webpack_require__("6LO8");

var _sprite2 = _interopRequireDefault(_sprite);

var _EmptyGroupMessage = __webpack_require__("329f");

var _EmptyGroupMessage2 = _interopRequireDefault(_EmptyGroupMessage);

var _TermNav = __webpack_require__("aBjJ");

var _TermNav2 = _interopRequireDefault(_TermNav);

var _Aggregate = __webpack_require__("KKz7");

var _Aggregate2 = _interopRequireDefault(_Aggregate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'Students',
    props: {
        group: {},
        loading: {
            type: Boolean,
            default: false
        },
        groupTermId: {
            required: false
        }
    },
    components: { Loading: _Loading2.default, Aggregate: _Aggregate2.default, EmptyGroupMessage: _EmptyGroupMessage2.default, TermNav: _TermNav2.default },

    data: function data() {
        return {
            isLoadingProgress: true,
            aggregateVisible: false
        };
    },

    vuex: {
        getters: {
            getCurrentGroupTermForGroup: _getters.getCurrentGroupTermForGroup,
            getAssignmentsForGroupPeriod: _getters.getAssignmentsForGroupPeriod,
            getCurrentGroupPeriodForGroupTerm: _getters.getCurrentGroupPeriodForGroupTerm
        },
        actions: {
            loadProgress: function loadProgress(_ref, group) {
                var dispatch = _ref.dispatch;

                return _resources2.default.getProgressForGroup(group.id).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_PROGRESS', result.progress || []);
                    dispatch('ADD_DILIGENCE', result.diligence || []);
                    dispatch('ADD_BADGES', result.badges || []);
                });
            },
            showGroupSettings: function showGroupSettings(_ref2, group) {
                var dispatch = _ref2.dispatch;

                dispatch('SHOW_MODAL', 'GroupSettings', { group: group, landingPage: 'Planning' });
            }
        }
    },

    computed: {
        students: function students() {
            var _this = this;

            return this.group.students.map(function (id) {
                return _this.$store.state.users.storage[id];
            });
        },
        studentProgress: function studentProgress() {
            var _this2 = this;

            var assignments = this.assignments;
            return this.students.map(function (u) {
                return {
                    id: u.id,
                    name: (0, _transformers.username)(u),
                    progressions: assignments.map(function (a) {
                        var progress = _this2.progressForStudentAndAssignment(u, a);
                        return {
                            assignmentId: a.id,
                            studentId: u.id,
                            isRetaking: progress && progress.isRetaking,
                            isRetakingDone: progress && progress.finished != null && !progress.isReviewed && progress.diligence != null,
                            hasNew: progress && progress.finished != null && !progress.isReviewed,
                            canView: progress && progress.finished != null,
                            tag: _this2.tagForProgress(progress, a),
                            isImportant: progress && progress.badge != null
                        };
                    })
                };
            });
        },
        periodAssignments: function periodAssignments() {
            var _this3 = this;

            var filterOptionalAssignments = true;
            return this.groupTerm.groupPeriods.map(function (id) {
                return _this3.getAssignmentsForGroupPeriod(id, filterOptionalAssignments);
            });
        },
        assignments: function assignments() {
            return this.periodAssignments.reduce(function (list, assignments) {
                return list.concat(assignments);
            });
        },
        assignmentCols: function assignmentCols() {
            var _this4 = this;

            return this.periodAssignments.reduce(function (list, assignments, pIdx) {

                return list.concat(assignments.map(function (a, idx) {
                    return {
                        id: a.id,
                        title: a.title,
                        lastInPeriod: idx === assignments.length - 1,
                        periodId: _this4.groupTerm.groupPeriods[pIdx]
                    };
                }));
            }, []);
        },
        progressions: function progressions() {
            var _this5 = this;

            return Object.keys(this.$store.state.progress.storage).map(function (id) {
                return _this5.$store.state.progress.storage[id];
            }).filter(function (progress) {
                return progress.group == _this5.group.id;
            });
        },
        currentGroupTerm: function currentGroupTerm() {
            return this.getCurrentGroupTermForGroup(this.group.id);
        },
        groupTerm: function groupTerm() {
            if (this.groupTermId == null) {
                return this.currentGroupTerm;
            }
            return this.$store.state.groups.terms[this.groupTermId];
        },
        currentGroupPeriod: function currentGroupPeriod() {
            return this.getCurrentGroupPeriodForGroupTerm(this.currentGroupTerm);
        },
        previousGroupPeriods: function previousGroupPeriods() {
            var _this6 = this;

            return this.groupTerm.groupPeriods.map(function (id) {
                return _this6.$store.state.groups.periods[id];
            }).filter(function (el) {
                return el.finished || el.end < _this6.currentGroupPeriod.end;
            });
        },
        overdueAssignmentIds: function overdueAssignmentIds() {
            var _this7 = this;

            return this.previousGroupPeriods.reduce(function (assignments, gp) {
                return assignments.concat(gp.groupAssignments);
            }, []).map(function (id) {
                return _this7.$store.state.groups.assignments[id].assignment[0];
            });
        },

        spriteImage: function spriteImage() {
            return (0, _sprite2.default)('sprite-main@2x.png');
        },

        term: function term() {
            return this.$store.state.terms.storage[this.groupTerm.term[0]];
        },

        terms: function terms() {
            var _this8 = this;

            return this.group.groupTerms.map(function (id) {
                return _this8.$store.state.groups.terms[id];
            }).filter(function (gt) {
                return gt.term != null && gt.term.length > 0;
            }).map(function (gt) {
                var term = _this8.$store.state.terms.storage[gt.term[0]];
                return {
                    id: term.id,
                    title: term.title,
                    groupTermId: gt.id
                };
            });
        }

    },

    methods: {
        username: _transformers.username,
        progressForStudentAndAssignment: function progressForStudentAndAssignment(student, assignment) {
            return this.progressions.find(function (progress) {
                return progress.user == student.id && progress.assignment == assignment.id;
            });
        },
        tagForProgress: function tagForProgress(progress, assignment) {
            if (progress == null || progress.finished == null) {
                return this.isOverdue(assignment) ? 'overdue' : 'missing';
            }

            if (progress.badge != null) {
                return this.$store.state.badges.storage[progress.badge[0]].type;
            }

            if (progress.diligence == null) {
                return 'done';
            }

            return this.$store.state.diligence.storage[progress.diligence[0]].tag;
        },

        isOverdue: function isOverdue(assignment) {
            return this.overdueAssignmentIds.indexOf(assignment.id) !== -1;
        },

        viewProgress: function viewProgress(progression) {
            if (progression.canView) {
                this.$router.push({ name: 'students.assignment.overview', params: { assignmentId: progression.assignmentId, studentId: progression.studentId } });
            }
        },

        showAggregate: function showAggregate() {
            this.aggregateVisible = true;
        },

        printPage: function printPage() {
            var _this9 = this;

            _analytics2.default.event('group', 'print', this.group.id);

            var prevTitle = window.document.title;
            window.document.title = 'Kiempunt overzicht klas ' + this.group.name;

            this.$nextTick(function () {

                _this9.afterPrint(function () {
                    _this9.aggregateVisible = false;
                    window.document.title = prevTitle;
                });
                window.print();
            });
        },

        afterPrint: function afterPrint(cb) {

            var mediaQueryList = window.matchMedia('print');
            var after = function after(mql) {
                if (!mql.matches) {
                    cb();
                    mediaQueryList.removeListener(after);
                }
            };

            mediaQueryList.addListener(after);
        },

        loadData: function loadData() {
            var _this10 = this;

            if (this.groupTerm == null || this.group.groupTerms.indexOf(this.groupTerm.id) === -1) {
                this.$router.push({ name: 'students.overview', params: { groupTermId: this.currentGroupTerm.id } });
                return;
            }

            this.isLoadingProgress = true;

            this.loadProgress(this.group).catch(function (err) {
                return _analytics2.default.exception('Could not load students progress', err);
            }).then(function () {
                return _this10.isLoadingProgress = false;
            });
        },

        translation: function translation(tag) {
            var map = {
                'sufficient': 'Goede inzet',
                'ok': 'Voldoende inzet',
                'fail': 'Onvoldoende inzet',
                'done': 'Klaar, nog niet beoordeeld',

                'idea': 'Bekroning ideevorming',
                'design': 'Bekroning vormgeving',
                'technique': 'Bekroning materiaal & techniek',
                'artappreciation': 'Bekroning kunstbeschouwing',
                'reflection': 'Bekroning reflectie'
            };

            return map[tag] || tag;
        }
    },

    created: function created() {
        this.loadData();
    }

};

/***/ }),

/***/ "rrv1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__("JOmw");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _remove2 = __webpack_require__("afSG");

var _remove3 = _interopRequireDefault(_remove2);

var _helpers = __webpack_require__("x3kM");

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _dropzone = __webpack_require__("oLnp");

var _dropzone2 = _interopRequireDefault(_dropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//


_dropzone2.default.autoDiscover = false;

exports.default = {
    props: {
        maxNumberOfFiles: {
            type: Number,
            default: 3
        },
        url: {
            type: String,
            required: true
        },
        message: {
            type: String,
            default: 'Upload afbeelding'
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        },

        extractResultFromResponse: {
            type: Function,
            default: function _default(response) {
                return (0, _helpers.transform)(response).images[0];
            }
        },

        // array of objects { name: '', thumb: '', ...(custom props) }
        value: {}

    },

    mixins: [_notificationsMixin2.default],

    data: function data() {
        return {
            uploaded: [],
            isResetting: false
        };
    },

    methods: {
        register: function register(el) {
            var _this = this;

            this.currentDropzone = new _dropzone2.default(el, Object.assign(this.defaultConfig(), this.config));
            _dropzone2.default.confirm = function (question, accepted, rejected) {
                _this.$alert(question, [{ name: 'nee', action: rejected }, // rejected might not be defined, but alerter does not care :)
                { name: 'ja', action: accepted }]);
            };
        },

        defaultConfig: function defaultConfig() {
            var vm = this;
            return {
                url: this.url,
                paramName: 'image',
                acceptedFiles: 'image/*',
                maxFilesize: 6,
                addRemoveLinks: true,
                maxFiles: this.maxNumberOfFiles,

                // forceFallback: true, // TODO test fallback

                dictDefaultMessage: this.message,
                dictFallbackMessage: this.message,
                dictFallbackText: '',
                dictCancelUpload: 'Annuleren',
                dictCancelUploadConfirmation: 'Weet je zeker dat je de upload wilt annuleren?',
                dictRemoveFile: 'Verwijderen',
                dictRemoveFileConfirmation: 'Weet je zeker dat je deze foto wilt verwijderen?',

                dictInvalidFileType: 'Onjuist bestandsformaat, je kunt alleen jpg/png/gif uploaden!',
                dictFileTooBig: 'Helaas, deze foto is te groot ({{filesize}}MB). De foto mag maximaal {{maxFilesize}}MB zijn.',
                dictResponseError: 'Oeps, er is iets mis gegaan met de upload :( Probeer het nog eens.',
                dictMaxFilesExceeded: 'Dat zijn wel erg veel foto\'s! Je kunt er maximaal ' + this.maxNumberOfFiles + ' uploaden.',

                accept: function accept(file, done) {
                    done();
                },

                init: function init() {
                    // `this` refers to dropzone
                    vm.registerEvents(this);
                    vm.injectFiles(this);
                    vm.$emit('initialized', this);
                }

            };
        },

        registerEvents: function registerEvents(dz) {
            var _this2 = this;

            dz.on('addedfile', function (file) {

                file.previewElement.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var upload = _this2.uploaded.find(function (u) {
                        return u.file === file;
                    });
                    if (upload != null) {
                        _this2.$emit('clicked', file, upload.data);
                    }
                });
            });

            // Add token to authenticate user
            dz.on('sending', function (file, xhr) {
                _this2.$emit('sending', file, xhr);
                xhr.setRequestHeader('Authorization', 'Bearer ' + (0, _auth.getAccessToken)());
            });

            dz.on('success', function (file, response) {

                var result = _this2.extractResultFromResponse(response);

                _this2.uploaded.push({
                    file: file,
                    data: result
                });
                _this2.updated();
                _this2.$emit('success', file, result);
            });

            dz.on('error', function (file, error, xhr) {

                if (!file.accepted) {
                    _analytics2.default.event('dropzone', 'unaccepted', error);
                } else if (xhr != null) {

                    // make sure xhr object is detected as isResponse in analytics
                    xhr.url = _this2.url;
                    _analytics2.default.exception('Could not upload Dropzone file', xhr, { file: file.name, message: error });

                    if (xhr.status == 401) {
                        // notify auth, but don't retry anything
                        (0, _auth.retryAfterAuthFail)().catch(function (err) {
                            _analytics2.default.exception('Could not re-auth after upload fail', err, { file: file.name, message: error });
                            _this2.$error('Kan geen verbinding krijgen met de server. Probeer opnieuw in te loggen.', { id: 'auth' });
                        });
                    }

                    // friendly error (otherwise dropzone just displays the response '[object]')
                    var errorDisplay = file.previewElement.querySelectorAll('[data-dz-errormessage]')[0];
                    if (errorDisplay != null) {
                        errorDisplay.innerHTML = xhr.status == 422 ? JSON.parse(xhr.response).errors.map(function (e) {
                            return e.detail;
                        }).filter(function (e) {
                            return e != null && e.length > 0;
                        }).join(' ') : dz.options.dictResponseError;
                    }
                } else if (file.status !== 'canceled') {
                    _analytics2.default.exception('Could not upload Dropzone file', { error: error }, { file: file.name });
                }

                _this2.$emit('error', file, error);
            });

            dz.on('canceled', function (file) {
                _analytics2.default.event('dropzone', 'cancel', file.name);
            });

            dz.on('removedfile', function (file) {
                if (_this2.isResetting) {
                    return;
                }

                var removed = (0, _remove3.default)(_this2.uploaded, function (upload) {
                    return upload.file === file;
                });
                if (removed.length > 0) {
                    _analytics2.default.event('dropzone', 'remove', file.name);
                    _this2.updated();
                    _this2.$emit('removed', file, removed[0].data);
                }
            });

            // dz.on('maxfilesreached', () => {})

            // dz.on('complete', file => console.log('Completed uploading', file.name))
            // dz.on('addedfile', file => console.log('Added file', file.name))
            // dz.on('maxfilesexceeded', file => console.error('Max files exceeded'))
        },

        injectFiles: function injectFiles(dz) {
            var _this3 = this;

            var thumbsToAdd = this.value instanceof Array ? this.value : this.value ? [this.value] : [];
            thumbsToAdd.forEach(function (t) {
                return _this3.injectThumb(t, dz);
            });
        },

        injectThumb: function injectThumb(data, dz) {
            var mock = { name: data.name || data.id, size: 12345, type: 'image/jpeg', accepted: true, status: _dropzone2.default.SUCCESS };
            dz.files.push(mock);
            dz.emit('addedfile', mock);
            dz.emit('thumbnail', mock, data.thumb);
            dz.emit('complete', mock);

            this.uploaded.push({
                file: mock,
                data: data
            });
        },

        updated: function updated() {
            if (this.maxNumberOfFiles === 1) {
                var upload = this.uploaded[0];
                this.$emit('input', upload ? upload.data : null);
            } else {
                this.$emit('input', this.uploaded.map(function (u) {
                    return u.data;
                }));
            }
        },

        destroy: function destroy() {
            if (this.currentDropzone) {
                this.currentDropzone.disable(); // cancels current uploads
                this.isResetting = true;
                this.currentDropzone.destroy();
                this.isResetting = false;
            }
        },

        /**
         * Resets the Dropzone element
         */
        reset: function reset() {
            if (this.currentDropzone) {
                this.isResetting = true;
                this.currentDropzone.removeAllFiles(true);
                this.uploaded = [];
                this.injectFiles(this.currentDropzone);
                this.isResetting = false;
            }
        }

    },

    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.register(_this4.$refs.dropzone);
        });
    },

    beforeDestroy: function beforeDestroy() {
        this.destroy();
    }

};

/***/ }),

/***/ "sK5L":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.isLoading) ? _c('loading') : _c('div', [_c('p', [_vm._v("Standaard zijn alle onderstaande opdrachten beschikbaar voor de leerlingen.\n    U kunt tijd vrij maken voor eigen opdrachten door opdrachten hieronder uit te schakelen. Dit kan ook later aangepast worden.")]), _vm._l((_vm.terms), function(term) {
    return _c('div', {
      staticClass: "assignment-toggle__term"
    }, [_c('hr'), _c('h2', {
      staticClass: "assignment-toggle__term-title"
    }, [_vm._v(_vm._s(term.title))]), _vm._l((term.periods), function(period) {
      return _c('div', {
        staticClass: "assignment-toggle__period"
      }, [_c('p', {
        staticClass: "assignment-toggle__period-title tag",
        class: {
          'assignment-toggle__period-title--error': _vm.hasError(period)
        }
      }, [_vm._v(_vm._s(period.title))]), _vm._l((period.assignments), function(assignment) {
        return _c('div', {
          staticClass: "assignment-toggle",
          class: {
            'is-disabled': _vm.isOptional(assignment)
          }
        }, [_c('a', {
          staticClass: "assignment-toggle__link",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.toggleAssignment(assignment)
            }
          }
        }, [_c('img', {
          staticClass: "assignment-toggle__hero",
          attrs: {
            "src": assignment.image,
            "alt": assignment.title
          }
        }), _c('span', {
          staticClass: "assignment-icon",
          class: 'icon-' + assignment.type
        }), _c('h3', {
          staticClass: "assignment-toggle__title"
        }, [_vm._v(_vm._s(assignment.title))]), _c('p', {
          staticClass: "assignment-toggle__subtitle"
        }, [_vm._v(_vm._s(assignment.subtitle))]), _c('span', {
          staticClass: "time tag tag--timid"
        }, [_vm._v(_vm._s(assignment.time) + " minuten")])])])
      })], 2)
    })], 2)
  }), _c('primary-button', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    attrs: {
      "loading": _vm.isSaving
    },
    on: {
      "clicked": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "sNcH":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "component-groups"
  }, [_c('header', {
    staticClass: "page-header page-header--inverted groups-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.salutation))]), (!_vm.isActive) ? _c('p', [_vm._v("Deze school is gearchiveerd.")]) : (_vm.groups.length) ? _c('p', [_vm._v("Kies een klas om te beginnen")]) : _c('p', [_vm._v("Voeg een klas toe om te beginnen.")])]), _c('div', {
    staticClass: "groups-content"
  }, [(_vm.loading) ? _c('loading') : _vm._e(), (_vm.groups.length) ? _c('transition-group', {
    staticClass: "teacher-groups",
    attrs: {
      "name": "insertion-bottom",
      "appear": "",
      "tag": "ol"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "teacher-groups__item"
    }, [(_vm.isFinished(group)) ? _c('span', {
      staticClass: "group-message note note--warning"
    }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" Deze klas is klaar. Na " + _vm._s(_vm.archiveAt(group)) + " kunt u de werkmappen niet meer inzien.")]) : _vm._e(), _c('a', {
      staticClass: "button--settings",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showGroupSettings(group)
        }
      }
    }, [_vm._v("Instellingen")]), _c('h2', [_vm._v(_vm._s(group.name))]), _c('primary-button', {
      attrs: {
        "link": {
          name: 'students.overview',
          params: {
            groupId: group.id
          }
        }
      }
    }, [_vm._v("Bekijk")])], 1)
  })) : _vm._e(), (_vm.isActive) ? _c('a', {
    staticClass: "button-rounded button-add button-add-group",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSchoolGroups($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--add"
  }), _vm._v("Klas toevoegen")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "sPnI":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("jev0")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("EUj2"),
  /* template */
  __webpack_require__("zDmV"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "sV/x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("xZZD");

__webpack_require__("gy7S");

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue3 = __webpack_require__("6fN7");

var _vue4 = _interopRequireDefault(_vue3);

var _vueTransferDom = __webpack_require__("vXh7");

var _vueTransferDom2 = _interopRequireDefault(_vueTransferDom);

var _vueAlerter = __webpack_require__("qW9c");

var _vueAlerter2 = _interopRequireDefault(_vueAlerter);

var _store = __webpack_require__("zGxd");

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__("zUcP");

var _router2 = _interopRequireDefault(_router);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _Main = __webpack_require__("k+CZ");

var _Main2 = _interopRequireDefault(_Main);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// make sure tracking function is available before router starts
_analytics2.default.init(document.body.dataset.analyticsId);

// register global error handler
window.onerror = function (message, file, line, col, error) {
    _analytics2.default.exception('Uncaptured: ' + message + ' on ' + file + ':' + line + '-' + col, error);
};

if (true) {

    _ravenJs2.default.config(document.body.dataset.sentryDsn, {
        release: document.body.dataset.release
    }).addPlugin(_vue4.default, _vue2.default).install();
}

_vue2.default.use(_vueTransferDom2.default);
_vue2.default.use(_vueAlerter2.default);
_vue2.default.component('loading', _Loading2.default);

new _vue2.default({
    router: _router2.default,
    store: _store2.default,
    el: '#app',
    render: function render(h) {
        return h(_Main2.default);
    }
});

/***/ }),

/***/ "sXQb":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_c('header', {
    staticClass: "page-header settings-header"
  }, [(!_vm.inModal) ? _c('router-link', {
    staticClass: "back tag button-timid left",
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("x Sluiten")]) : _vm._e(), (_vm.viewingGroup) ? [_c('h1', [_vm._v("Klas " + _vm._s(_vm.viewingGroup.name))]), _c('p', [_vm._v("Instellingen van de klas")])] : [_c('h1', [_vm._v("Nieuwe klas")]), _c('p', [_vm._v("Maak een nieuwe klas voor " + _vm._s(_vm.school.name))])]], 2), _c('div', {
    staticClass: "settings-links tag"
  }, [_c('a', {
    class: {
      'is-active': _vm.isGeneralActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewGeneral($event)
      }
    }
  }, [_vm._v("Algemeen")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isPlanningActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPlanning($event)
      }
    }
  }, [_vm._v("Planning")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isAssignmentsActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewAssignments($event)
      }
    }
  }, [_vm._v("Opdrachten")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isInviteActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewInvite($event)
      }
    }
  }, [_vm._v("Leerlingen")])]), _c(_vm.view, {
    ref: "step",
    tag: "component",
    staticClass: "settings-modal-content",
    attrs: {
      "group": _vm.viewingGroup,
      "school": _vm.school,
      "isDemo": _vm.isDemo,
      "isAdmin": _vm.isAdmin,
      "isCreating": _vm.isCreating,
      "isCreated": _vm.isCreated
    },
    on: {
      "done": _vm.done,
      "changed": function($event) {
        _vm.dirtyModal(true)
      },
      "saved": _vm.savedStep
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "sgep":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("vE5+")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("pLjf"),
  /* template */
  __webpack_require__("dajq"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "skod":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "reflectiontips"
  }, [(!_vm.reflectiontips) ? _c('loading') : _vm._e(), (_vm.reflectiontips) ? _c('div', [_c('h1', [_vm._v("Reflecteren & werk bespreken")]), _c('div', {
    staticClass: "reflectiontips-content",
    domProps: {
      "innerHTML": _vm._s(_vm.reflectiontips.content)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "ssCn":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("GZmB")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2Buy"),
  /* template */
  __webpack_require__("qr67"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "swdy":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "teachertips"
  }, [(!_vm.teachertips) ? _c('loading') : _vm._e(), (_vm.teachertips) ? _c('div', [_c('h1', [_vm._v("Tips")]), _c('div', {
    staticClass: "teachertips-content",
    domProps: {
      "innerHTML": _vm._s(_vm.teachertips.content)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "tWtg":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("EKLQ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("FU/g"),
  /* template */
  __webpack_require__("N+K9"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "tXOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _touchMixin = __webpack_require__("QCwT");

var _touchMixin2 = _interopRequireDefault(_touchMixin);

var _auth = __webpack_require__("JOmw");

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _Notifications = __webpack_require__("BA8R");

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Modal = __webpack_require__("OJLX");

var _Modal2 = _interopRequireDefault(_Modal);

var _Alerter = __webpack_require__("BWHz");

var _Alerter2 = _interopRequireDefault(_Alerter);

var _DemoMessage = __webpack_require__("cBIN");

var _DemoMessage2 = _interopRequireDefault(_DemoMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'Main',
    components: { Loading: _Loading2.default, Notifications: _Notifications2.default, Modal: _Modal2.default, Alerter: _Alerter2.default, DemoMessage: _DemoMessage2.default },
    mixins: [_notificationsMixin2.default, _touchMixin2.default],
    data: function data() {
        return {
            down: false
        };
    },
    vuex: {
        getters: {
            loading: function loading(state) {
                return state.loading.user;
            }
        }
    },

    computed: {

        isDemo: function isDemo() {
            return this.$store.state.users.current && (0, _auth.isDemo)(this.$store.state.users.current);
        }

    },

    created: function created() {
        var _this = this;

        _vue2.default.http.interceptors.push(function (request, next) {

            next(function (response) {

                if (response.status === 401) {

                    // if a 401 comes through here, that means we've tried everything to authenticate, but could not get it to work
                    if (_this.$route.matched.some(function (record) {
                        return record.meta.auth;
                    })) {
                        _this.$error('Je sessie is verlopen en je bent uitgelogd. Log opnieuw in om je werkmap te openen.', { id: 'auth' });
                        _this.$router.push({ name: 'logout', params: { _internal: true, _immediate: true } });
                    }
                } else if (response.status === 410) {

                    _this.$warn('De app wordt geüpdate naar een nieuwe versie...', { id: 'update' });
                } else if (response.status === 429) {

                    _this.$warn('Je hebt deze actie te vaak uitgevoerd. Probeer het na een minuut nog eens.');
                } else if (response.status === 503) {

                    _this.$error('Je werkmap is tijdelijk niet beschikbaar wegens onderhoud. Probeer het later nog eens.');
                } else if (response.status >= 500) {

                    _this.$error('Er is iets misgegaan.');
                } else if (response.status === 0 || response.status === 1) {

                    _this.$error('Er kan geen verbinding worden gemaakt met de server. Probeer het later nog eens.', { id: 'connection' });
                }

                _this.down = [0, 1, 503].indexOf(response.status) >= 0;
            });
        });
    }
};

/***/ }),

/***/ "tkiJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("ELb+");

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _Question = __webpack_require__("haHN");

var _Question2 = _interopRequireDefault(_Question);

var _Upload = __webpack_require__("DBjH");

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { Question: _Question2.default, Upload: _Upload2.default, Loading: _Loading2.default },
    props: {
        partial: {},
        progress: {}
    },

    data: function data() {
        return {
            loading: false,
            submissions: null,
            user: null
        };
    },

    vuex: {
        getters: {},
        actions: {
            setValidation: _actions.setValidation
        }
    },

    computed: {
        type: function type() {

            var submission = this.submissions[0];

            if (submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null) {
                return 'Upload';
            }

            return 'Question';
        }
    },

    methods: {
        flush: function flush() {
            return Promise.resolve();
        }
    },

    created: function created() {
        var _this = this;

        this.loading = true;

        var getter = this.progress.fake ? _resources2.default.getFallbackReflectionSubmission(this.progress.assignment) : _resources2.default.getReflectionSubmission(this.progress.id);

        getter.then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            _this.submissions = result.submissions;
            _this.user = result.users[0];
        }).then(function () {
            return _this.setValidation(_this.partial.id, true);
        }).catch(function (err) {
            return _analytics2.default.exception('Can\'t load reflection ', err);
        }).then(function () {
            return _this.loading = false;
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "tqcc":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("G1JX")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("bGdJ"),
  /* template */
  __webpack_require__("YknS"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "tt5A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__("x3kM");

var initialState = function initialState() {
    return {
        currentId: null,
        storage: {
            /*id: {
                id: 0,
                image: 'http://placehold.it/150?text=opdracht',
                title: 'Voordoen, nadoen',
                intro: 'Wist je dat voor het kleuren van verf vroeger pigmenten van planten en dieren gebruikt werden? Zo werd Sepia (een bruin-grijze kleur) van de inkt van een zeekat gemaakt. ',
                started: date
                finished: date
                steps: [
                    { title: 'Stap 1', content: 'Dit is de eerste stap', submissions: [] },
                    { title: 'Stap 2', content: 'Dit is stap twee!', submissions: [] },
                    { title: 'Stap 3', content: 'Dit is stap drie!', submissions: [] }
                ]
            },*/
        },
        reflectiontips: {}
    };
};

var mutations = {
    SET_CURRENT_ASSIGNMENT: function SET_CURRENT_ASSIGNMENT(state, assignment) {
        state.currentId = assignment.id;
    },
    RESET_CURRENT_ASSIGNMENT: function RESET_CURRENT_ASSIGNMENT(state) {
        state.currentId = null;
    },
    ADD_ASSIGNMENTS: function ADD_ASSIGNMENTS(state, assignments) {
        (0, _helpers.setObjects)(assignments, state.storage, { progress: [], goals: [], remarks: [], compliments: [], predecessors: [], successors: [] });
    },
    ADD_PROGRESS_TO_ASSIGNMENT: function ADD_PROGRESS_TO_ASSIGNMENT(state, assignmentId, progressId) {
        state.storage[assignmentId].progress.push(progressId);
    },
    ADD_REFLECTIONTIPS: function ADD_REFLECTIONTIPS(state, reflectiontips) {
        (0, _helpers.setObjects)(reflectiontips, state.reflectiontips);
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "uVal":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "notification",
    class: _vm.notification.type ? _vm.notification.type : 'secondary',
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [(_vm.notification.title) ? _c('h5', [_vm._v(_vm._s(_vm.notification.title))]) : _vm._e(), (!_vm.isArray) ? _c('p', [_vm._v(_vm._s(_vm.notification.text))]) : _vm._e(), (_vm.isArray) ? _c('ul', _vm._l((_vm.notification.text), function(content) {
    return _c('li', [_vm._v(_vm._s(content))])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "vE5+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vMzw":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("aHZq")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("fg22"),
  /* template */
  __webpack_require__("AyOA"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "vQBA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vRyo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vW+O":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "alerter"
  }, [_c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "alerter__wrap overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getAttention($event)
      }
    }
  }, [_c('div', {
    staticClass: "alerter__dialog",
    class: {
      attention: _vm.needsAttention
    }
  }, [_c('div', {
    staticClass: "alerter__content"
  }, [_vm._t("default", [(_vm.title) ? _c('h2', {
    staticClass: "alerter__first-child"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.message) ? _c('p', {
    class: _vm.title ? '' : 'alerter__first-child'
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])], 2), _c('div', {
    staticClass: "alerter__actions"
  }, _vm._l((_vm.actions), function(action) {
    return _c(action.primary ? 'primary-button' : 'a', {
      key: action.name,
      tag: "component",
      class: {
        'tag': !action.primary, 'button-timid': !action.primary, 'button-timid--warning': action.danger
      },
      attrs: {
        "href": "#"
      },
      on: {
        "clicked": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.fire(action)
        },
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.fire(action)
        }
      }
    }, [_vm._v(_vm._s(action.name))])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "vWFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXh7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// FROM https://github.com/tmorehouse/vue-transfer-dom
// FROM https://github.com/rhyzx/vue-transfer-dom

exports.default = {

    install: function install(Vue, options) {

        var name = options && options.name || 'transferDom';

        // Define the directive
        Vue.directive(name, {
            inserted: function inserted(el, bindings) {
                // default append to <body>
                var container = bindings.value ? document.getElementById(bindings.value) : document.body;

                if (container) {
                    bindings.modifiers.prepend && container.firstChild ? container.insertBefore(el, container.firstChild) // top of target
                    : container.appendChild(el); // bottom of target
                } else {
                    console.warn('v-' + name + ' target element id "' + bindings.arg + '" not found.');
                }
            },

            unbind: function unbind(el) {
                if (el.parentNode != null) {
                    el.parentNode.removeChild(el);
                }
            }

        });
    }

};

/***/ }),

/***/ "wGR8":
/***/ (function(module, exports) {

module.exports = {
	"sprite-horizontal.png": "sprite-horizontal-59104f599c.png",
	"sprite-horizontal@2x.png": "sprite-horizontal@2x-6431f32557.png",
	"sprite-main.png": "sprite-main-1a14b1eb81.png",
	"sprite-main@2x.png": "sprite-main@2x-db41995d4a.png"
};

/***/ }),

/***/ "wNLN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wTqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVh7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wyNJ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.isLoading) ? _c('loading') : _c('div', [_c('p', [_vm._v("De planning bestaat uit " + _vm._s(_vm.availableTerms.length) + " periodes: "), _c('em', [_vm._v(_vm._s(_vm.termNames))]), _vm._v(". Elke periode is verdeeld in vier blokken met 1 tot 4 opdrachten per blok.")]), _c('p', [_vm._v("U kunt de planning ook later nog aanpassen, zolang de periodes en blokken nog niet zijn begonnen.")]), _c('p', [_c('a', {
    staticClass: "tag",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInfoVisible = !_vm.isInfoVisible
      }
    }
  }, [_vm._v("Hoe pas ik de planning aan?")])]), (_vm.isInfoVisible) ? _c('div', [_c('h3', [_vm._v("Periode verplaatsen, blokken verlengen")]), _c('p', [_vm._v("Standaard duren de periodes 8 weken (2 weken voor elk blok, uitgaande van 100 lesminuten per week) en wordt er rekening gehouden met vakanties.")]), _c('p', [_vm._v("U kunt een periode eerder of later in het jaar laten beginnen door de titel van de periode omhoog en omlaag te verslepen.")]), _c('p', [_vm._v("Als u langer over een blok wilt doen (u wilt bijvoorbeeld tussendoor eigen opdrachten doen) kunt u het verlengen/verkorten door de pijltjes van het blok respectievelijk omlaag/omhoog te verslepen.")]), _c('p', [_c('img', {
    staticStyle: {
      "width": "296px",
      "margin": "2em auto"
    },
    attrs: {
      "src": "/build/img/planner.gif",
      "alt": "Planning aanpassen",
      "width": "296"
    }
  })]), _c('div', {
    staticClass: "note note--info"
  }, [_c('p', [_c('strong', [_vm._v("Let op:")]), _vm._v(" als een periode al is begonnen, kan deze niet meer versleept worden. U kunt nog wel de lengte van de blokken aanpassen, mits die blokken nog niet afgelopen zijn.")]), _c('p', [_vm._v("Houd er ook rekening mee dat de laatste periode moet eindigen binnen 54 weken na het begin van de eerste periode. Zie de nummering aan de linkerkant.")])]), _c('h3', [_vm._v("Periode verbergen")]), _c('p', [_vm._v("Er is ook de mogelijkheid om een hele periode te verbergen. Dit kunt u doen door op het oogje te klikken onderaan de periode. De leerlingen slaan de opdrachten van die periode dan over en kunnen met de volgende periode aan de slag.")]), _c('hr')]) : _vm._e(), _c('week-planner', {
    staticClass: "planner--kiempunt",
    attrs: {
      "allowMovingSelectedPeriods": false,
      "relativeToPeriods": true,
      "minWeeksInPast": _vm.isAdmin ? 10 : 1,
      "maxWeeksInFuture": 70,
      "classForWeek": _vm.classForWeek,
      "labelForWeek": _vm.labelForWeek,
      "allowEditInPast": _vm.isAdmin
    },
    on: {
      "clickedDate": _vm.chooseStartDate
    },
    model: {
      value: (_vm.plannerPeriods),
      callback: function($$v) {
        _vm.plannerPeriods = $$v
      },
      expression: "plannerPeriods"
    }
  }), _c('primary-button', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    attrs: {
      "loading": _vm.isSaving
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "x/SM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x20n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _ProgressBar = __webpack_require__("Io5y");

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { PrimaryButton: _PrimaryButton2.default, ProgressBar: _ProgressBar2.default },
    props: {
        assignment: {},
        user: {},
        progress: {},
        disableIfUnfinished: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        ignoreProgress: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        steps: function steps() {
            var _this = this;

            // prevent exception when steps have not been loaded yet
            if (this.assignment.steps == null) {
                return [];
            }
            return this.assignment.steps.map(function (id) {
                return _this.$store.state.steps.storage[id];
            });
        },
        link: function link() {
            if (this.isDisabled) return this.$route.path;
            return { name: 'assignment', params: { assignmentId: this.assignment.id } };
        },
        isRetaking: function isRetaking() {
            return this.progress && this.progress.isRetaking;
        },
        finished: function finished() {
            return this.progress && this.progress.finished;
        },
        isDisabled: function isDisabled() {
            return this.disable || !this.finished && this.disableIfUnfinished;
        },
        icon: function icon() {
            return '/img/icon-' + this.assignment.type + '@2x.png';
        },
        type_class: function type_class() {
            return 'icon-' + this.assignment.type;
        },
        buttonText: function buttonText() {

            if (this.disable) {
                return 'Niet in demo';
            }

            if (this.disableIfUnfinished) {

                if (this.finished) {
                    return 'Bekijk';
                }

                return 'Bezig';
            }

            if (this.ignoreProgress) {
                return 'Bekijk';
            }

            if (this.isRetaking) {
                return 'Opnieuw inleveren!';
            }

            if (this.finished) {
                return 'Klaar';
            }

            if (this.progress) {
                return 'Verder';
            }

            return 'Begin';
        },
        groupSize: function groupSize() {
            switch (this.assignment.group_size) {
                case 1:
                    return {
                        class: 'assignment__group-size--individual',
                        title: 'Individueel'
                    };
                case 2:
                    return {
                        class: 'assignment__group-size--pair',
                        title: 'Groepjes van twee'
                    };
                case 3:
                    return {
                        class: 'assignment__group-size--trio',
                        title: 'Groepjes van drie'
                    };
                default:
                    {
                        var numbers = ['nul', 'een', 'twee', 'drie', 'vier', 'vijf', 'zes', 'zeven', 'acht', 'negen', 'tien'];
                        return {
                            class: 'assignment__group-size--multi',
                            title: 'Groupjes van ' + numbers[this.assignment.group_size]
                        };
                    }}
        }
    }
};

/***/ }),

/***/ "x3kM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setObjects = setObjects;
exports.removeObject = removeObject;
exports.transform = transform;
exports.debounceSyncMem = debounceSyncMem;
exports.debounceSync = debounceSync;
exports.guid = guid;
exports.timestamp = timestamp;
exports.logreject = logreject;

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _memoize2 = __webpack_require__("zGZ6");

var _memoize3 = _interopRequireDefault(_memoize2);

var _debounce2 = __webpack_require__("O4Lo");

var _debounce3 = _interopRequireDefault(_debounce2);

var _cloneDeep2 = __webpack_require__("kvU2");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sets an object to the vuex storage
 * @param objects the objects to add (required to have an id attribute)
 * @param storage the vuex store
 * @param default props to set if they don't exist in object
 */
function setObjects(objects, storage, defaults, identifier) {

    defaults = defaults || {};
    identifier = identifier || 'id';

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = objects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var obj = _step.value;


            if (storage[obj[identifier]] != undefined) {
                // don't replace, update all properties
                // otherwise this object is considered a totally new object
                // note that defaults are not set here, they should not overwrite already set values
                for (var prop in obj) {
                    storage[obj[identifier]][prop] = obj[prop];
                }
            } else {
                _vue2.default.set(storage, obj[identifier], Object.assign({}, (0, _cloneDeep3.default)(defaults), obj));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

/**
 * Reactively deletes the given id from the storage
 * @param  id
 * @param  storage
 */
function removeObject(id, storage) {
    _vue2.default.delete(storage, id);
}

/**
 * Transforms JSON API response to vuex storage objects
 * => {
 *       { module_name }: [
 *          { data }
 *        ]
 *    }

 * @param  {JSON API RESPONSE OBJECT} response
 * @return {Flattened vuex model}
 */
function transform(response) {

    var result = {};
    var data = response.data instanceof Array ? response.data : [response.data];
    var resources = data.concat(response.included || []);

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = resources[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var res = _step2.value;


            var _data = res.attributes;
            _data.id = res.id;

            for (var relation in res.relationships) {

                var rel = res.relationships[relation].data;

                if (rel instanceof Array) {
                    _data[relation] = rel.map(function (r) {
                        return r.id;
                    });
                } else if (rel == null) {
                    _data[relation] = null;
                } else {
                    _data[relation] = [rel.id]; // TODO: remove array here?
                }
            }

            result[res.type] = result[res.type] || [];
            result[res.type].push(_data);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return result;
}

/**
 * Memoizes `debounceSync` for multiple arguments, resolved with given resolver
 *
 * @param  {Function} func      function that returns a promise
 * @param  {Function} resolver  function that is used to resolve a memoized `debounceSync`
 * @param  {Int} delay          debounce delay
 * @param  {Object} opts        debounce options
 * @return {Function}           memoized debounced function that returns a promise
 */
function debounceSyncMem(func, resolver, delay, opts) {
    var _this = this;

    var memoize = (0, _memoize3.default)(function () {
        return debounceSync(func, delay, opts);
    }, resolver);

    function sync() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // first apply to resolve, second to call debounceSync
        return memoize.apply(this, args).apply(this, args);
    }

    // proxy flush and cancel
    sync.flush = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return memoize.apply(_this, args).flush();
    };
    sync.cancel = function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return memoize.apply(_this, args).cancel();
    };
    sync.reset = function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return memoize.apply(_this, args).reset();
    };
    sync.retry = function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return memoize.apply(_this, args).retry();
    };

    return sync;
}

/**
 * Debounces the given function, but makes sure it waits for `func` to be
 * completed before calling next `func`
 *
 * @param  {Function} func  function that returns a promise
 * @param  {Int} delay      debounce delay
 * @param  {Object} opts    debounce options
 * @return {Function}       debounced function that returns a promise
 */
function debounceSync(func, delay, opts) {
    var _this4 = this;

    var previousSync = Promise.resolve();
    var lastCall = Promise.resolve();
    var lastArgs = null;
    var scheduledFlush = null;

    var debounced = (0, _debounce3.default)(function (resolve, reject) {
        for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
            args[_key6 - 2] = arguments[_key6];
        }

        var _this2 = this;

        // chain sync after previous
        return previousSync = previousSync.then(function () {
            return func.apply(_this2, args);
        }).then(resolve, reject); // proxy to given resolve + reject functions
    }, delay, opts);

    // returned promise only gets resolved/rejected when the debounced function is called
    function debouncedWrap() {
        var _this3 = this;

        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        lastArgs = args.slice(); // copy arguments for `retry`

        return lastCall = new Promise(function (resolve, reject) {

            args.unshift(resolve, reject); // prepend
            debounced.apply(_this3, args);
        });
    }

    // flushes as soon as previous sync has finished
    debouncedWrap.flush = function () {

        // can only schedule one flush
        if (scheduledFlush) return scheduledFlush;

        return scheduledFlush = previousSync.then(debounced.flush).then(function () {
            return scheduledFlush = null;
        }) // cleanup
        .then(function () {
            return lastCall;
        }); // return lastCall promise which proxies resolve/reject
    };

    debouncedWrap.retry = function () {
        return debouncedWrap.apply(_this4, lastArgs);
    };
    debouncedWrap.cancel = debounced.cancel;
    debouncedWrap.reset = function () {
        return previousSync = Promise.resolve();
    };

    return debouncedWrap;
}

/**
 * Generates GUID
 * @return GUID
 */
function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 * Generates current UNIX timestamp
 * @return {Int} the current timestamp
 */
function timestamp() {
    return Math.floor(Date.now() / 1000);
}

function logreject(reason, error) {
    for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
    }

    console.error(reason, error, args);
    return Promise.reject(error);
}

/***/ }),

/***/ "xZZD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xfBg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fireworks = __webpack_require__("PtN4");

var fireworks = _interopRequireWildcard(_fireworks);

var _confetti = __webpack_require__("aKA1");

var confetti = _interopRequireWildcard(_confetti);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    props: {
        color: {
            type: String,
            required: false,
            default: 'default'
        },
        delay: {
            type: Number,
            required: false,
            default: 100
        },
        type: {
            type: String,
            required: false,
            default: 'confetti'
        }
    },
    vuex: {
        getters: {},
        actions: {}
    },
    directives: {
        celebration: {
            bind: function bind(el, binding) {

                // Start delay
                setTimeout(function () {
                    if (binding.value.type === 'confetti') {
                        confetti.start(el, binding.value.color);
                    } else {
                        fireworks.start(el);
                    }
                }, binding.value.delay || 100);

                // Finish delay
                setTimeout(function () {
                    if (binding.value.type === 'confetti') {
                        confetti.stop();
                    } else {
                        fireworks.stop();
                    }
                    if (el != null) {
                        el.style.opacity = 0;
                    }
                }, 10000);
            }

        }

    }

};

/***/ }),

/***/ "y46E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("/baE");

var _moment2 = _interopRequireDefault(_moment);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _holidaysMixin = __webpack_require__("+Mtz");

var _holidaysMixin2 = _interopRequireDefault(_holidaysMixin);

var _WeekPlanner = __webpack_require__("Z+dW");

var _WeekPlanner2 = _interopRequireDefault(_WeekPlanner);

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _Loading = __webpack_require__("0RUa");

var _Loading2 = _interopRequireDefault(_Loading);

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _helpers = __webpack_require__("x3kM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'GroupSettingsPlanning',
    mixins: [_notificationsMixin2.default, _validationMixin2.default, _holidaysMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default, WeekPlanner: _WeekPlanner2.default, Loading: _Loading2.default },
    props: {
        group: {},
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            plannerPeriods: [],
            holidays: [],
            weeksBetweenPeriods: 2,
            isSaving: false,
            isLoading: true,
            availableTerms: [],
            isInfoVisible: false
        };
    },

    vuex: {
        actions: {
            updatePlanning: function updatePlanning(_ref, group, data) {
                var dispatch = _ref.dispatch;

                return _resources2.default.patchPlanning(group.id, data).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    dispatch('ADD_TERMS', result.terms);
                    dispatch('ADD_PERIODS', result.periods);
                    dispatch('ADD_GROUP_TERMS', result.groupterms);
                    dispatch('ADD_GROUP_PERIODS', result.groupperiods);
                    dispatch('SET_GROUP_TERMS_FOR_GROUP', group.id, result.groupterms);
                });
            }
        }
    },

    computed: {

        groupTerms: function groupTerms() {
            var _this = this;

            return this.group.groupTerms.map(function (id) {
                return _this.$store.state.groups.terms[id];
            });
        },

        termNames: function termNames() {
            var titles = this.availableTerms.map(function (t) {
                return t.title;
            });

            if (titles.length < 2) {
                return titles[0];
            }

            return titles.slice(0, titles.length - 1).join(', ') + ' en ' + titles[titles.length - 1];
        }

    },

    methods: {

        termForGroupTerm: function termForGroupTerm(groupTerm) {
            return this.$store.state.terms.storage[groupTerm.term[0]];
        },

        classForWeek: function classForWeek(date) {

            var classes = this.holidaysForDate(date).map(function (h) {
                return 'holiday-' + h.title.toLowerCase();
            });

            if (classes.length) {
                classes.push('holiday');
            }

            return classes.map(function (c) {
                return 'planner__week--' + c;
            });
        },

        labelForWeek: function labelForWeek(date) {
            return this.holidaysForDate(date).map(function (h) {
                return h.title;
            })[0];
        },

        chooseStartDate: function chooseStartDate(date) {

            if (date.isSameOrAfter((0, _moment2.default)()) && this.plannerPeriods.length && this.plannerPeriods[0].start == null) {
                this.setInitialPeriods(date);
            }
        },

        defaultPlannerPeriod: function defaultPlannerPeriod(term, start) {

            var blocks = term.periods.map(function (p, i) {
                return {
                    title: i + 1,
                    duration: 2
                };
            });

            return {
                title: term.title,
                start: start ? start.clone() : (0, _moment2.default)().add(1, 'week'),
                enabled: true,
                blocks: blocks
            };
        },

        scheduleHolidays: function scheduleHolidays() {

            var previousPeriod = null;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.plannerPeriods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var thisPeriod = _step.value;


                    if (previousPeriod != null) {
                        var previousPeriodDuration = previousPeriod.blocks.reduce(function (sum, b) {
                            return sum + b.duration;
                        }, 0);
                        var previousPeriodEnd = previousPeriod.start.clone().add(previousPeriodDuration, 'weeks');
                        var shiftedWeeksBetween = this.holidayShiftDuration(previousPeriodEnd, this.weeksBetweenPeriods);

                        thisPeriod.start = previousPeriodEnd.clone().add(shiftedWeeksBetween, 'weeks');
                    }

                    this.holidayShift(thisPeriod);
                    previousPeriod = thisPeriod;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },

        setPlannerPeriods: function setPlannerPeriods() {
            var _this2 = this;

            var lastPeriodEnd = null;
            // map over year terms, find in groupTerms, if not add default, disabled
            this.plannerPeriods = this.availableTerms.map(function (term) {

                var groupTerm = _this2.groupTerms.find(function (t) {
                    return t.term[0] === term.id;
                });
                if (groupTerm == null) {
                    var period = _this2.defaultPlannerPeriod(term, lastPeriodEnd);
                    period.enabled = false;
                    lastPeriodEnd = period.start.clone();
                    return period;
                }

                var blocks = groupTerm.groupPeriods.map(function (id) {
                    return _this2.$store.state.groups.periods[id];
                }).map(function (gp) {
                    return _moment2.default.unix(gp.end);
                }).map(function (thisEnd, i, endings) {
                    var prevEnd = i === 0 ? _moment2.default.unix(groupTerm.start).subtract(1, 'days') : endings[i - 1];
                    return {
                        title: i + 1,
                        duration: thisEnd.diff(prevEnd, 'weeks')
                    };
                });

                lastPeriodEnd = _moment2.default.unix(groupTerm.start).add(blocks.reduce(function (sum, b) {
                    return sum + b.duration;
                }, 0), 'weeks');

                return {
                    title: _this2.termForGroupTerm(groupTerm).title,
                    start: _moment2.default.unix(groupTerm.start),
                    enabled: true,
                    blocks: blocks
                };
            });
        },

        submit: function submit(e) {
            e.preventDefault();
            this.save().catch(function () {});
        },

        save: function save() {
            var _this3 = this;

            if (this.isDemo) {
                this.$demoSuccessNotification();
                this.$emit('saved');
                return Promise.resolve();
            }

            var data = this.plannerPeriods.map(function (p, i) {
                return {
                    term: _this3.availableTerms[i].id,
                    start: p.start.format('Y-MM-DD'),
                    periods: p.blocks.map(function (b) {
                        return b.duration;
                    }),
                    enabled: p.enabled
                };
            });

            this.isSaving = true;
            var p = this.updatePlanning(this.group, data.filter(function (d) {
                return d.enabled;
            })).then(function () {
                _this3.$emit('saved');
                if (!_this3.isCreating) {
                    _this3.$success('De planning is aangepast');
                }
            }).catch(function (e) {
                _this3.$error('Aanpassen planning is mislukt');
                return Promise.reject(e);
            });

            // finally
            p.catch(function () {}).then(function () {
                return _this3.isSaving = false;
            });
            return p;
        },

        fetchAvailableTerms: function fetchAvailableTerms(levelId) {
            var _this4 = this;

            return _resources2.default.getTermsForLevel(levelId).then(function (response) {
                return (0, _helpers.transform)(response.body);
            }).then(function (result) {
                _this4.availableTerms = result.terms || [];
            });
        }

    },

    created: function created() {
        var _this5 = this;

        Promise.all([this.fetchAvailableTerms(this.group.level), this.fetchHolidays(this.school.id)]).then(function () {

            _this5.isLoading = false;
            _this5.setPlannerPeriods();

            _this5.$watch('plannerPeriods', function () {
                return _this5.$emit('changed');
            }, { deep: true });

            // if this is the first (active, unstarted) group that is created for the current school
            // the given planning should automatically reschedule based on holidays
            var activeGroupSameLevel = _this5.school.groups.map(function (id) {
                return _this5.$store.state.groups.storage[id];
            }).filter(function (g) {
                return !g.archived && g.level == _this5.group.level && g.groupTerms.length;
            }).filter(function (g) {
                var firstGT = _this5.$store.state.groups.terms[g.groupTerms[0]];
                return firstGT.start > Math.floor(Date.now() / 1000);
            });

            if (_this5.isCreating && activeGroupSameLevel.length === 1) {
                _this5.scheduleHolidays();
            }
        });
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "yJP+":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "loading-container",
    class: {
      'mini': _vm.mini, 'alt': _vm.alt, 'inline': _vm.inline, 'relative': _vm.relative
    }
  }, [_c('span', {
    staticClass: "loader-spinner"
  }, [_vm._v("Laden...")])])
},staticRenderFns: []}

/***/ }),

/***/ "ybDi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var initialState = function initialState() {
    return {
        component: null,
        isDirty: false,
        data: null
    };
};

var mutations = {
    SHOW_MODAL: function SHOW_MODAL(state, component, data) {
        state.component = component;
        state.data = data;
    },
    HIDE_MODAL: function HIDE_MODAL(state) {
        state.component = null;
        state.data = null;
    },
    MODAL_DIRTY: function MODAL_DIRTY(state) {
        state.isDirty = true;
    },
    MODAL_CLEAN: function MODAL_CLEAN(state) {
        state.isDirty = false;
    }
};

exports.default = {
    initialState: initialState,
    state: initialState(),
    mutations: mutations
};

/***/ }),

/***/ "yeX9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _stepMixin = __webpack_require__("Ce1c");

var _stepMixin2 = _interopRequireDefault(_stepMixin);

var _helpers = __webpack_require__("x3kM");

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

var _auth = __webpack_require__("JOmw");

var _GroupSubmissions = __webpack_require__("r5Ke");

var _GroupSubmissions2 = _interopRequireDefault(_GroupSubmissions);

var _TeacherFeedback = __webpack_require__("z1et");

var _TeacherFeedback2 = _interopRequireDefault(_TeacherFeedback);

var _Diligence = __webpack_require__("YyG+");

var _Diligence2 = _interopRequireDefault(_Diligence);

var _Question = __webpack_require__("haHN");

var _Question2 = _interopRequireDefault(_Question);

var _Upload = __webpack_require__("DBjH");

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Overview',
    mixins: [_stepMixin2.default],
    props: {
        group: {},
        isInspectingStudent: {},
        isReviewing: {},
        user: {},
        returnLink: {
            type: Object,
            required: true
        }
    },
    components: { Question: _Question2.default, Upload: _Upload2.default, GroupSubmissions: _GroupSubmissions2.default, TeacherFeedback: _TeacherFeedback2.default, Diligence: _Diligence2.default },

    data: function data() {
        return {
            reflections: null,
            users: null
        };
    },

    vuex: {
        actions: {

            reviewedProgress: function reviewedProgress(_ref, progress) {
                var dispatch = _ref.dispatch;

                return _resources2.default.reviewedProgress(progress.id).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return dispatch('ADD_PROGRESS', result.progress);
                });
            },

            showReflection: function showReflection(_ref2, partial, progress) {
                var dispatch = _ref2.dispatch;

                dispatch('SHOW_MODAL', 'ReflectionPartial', { partial: partial, progress: progress });
            },

            showBadge: function showBadge(_ref3, badge) {
                var dispatch = _ref3.dispatch;

                dispatch('SHOW_ACHIEVEMENT', badge.type, 'red');
            }

        }
    },

    computed: {

        allPartials: function allPartials() {
            var _this = this;

            return this.steps.reduce(function (result, step) {
                var partials = step.partials.map(function (id) {
                    return _this.$store.state.partials.storage[id];
                }).map(function (data) {
                    return _extends({}, data, { isReflection: step.type === 'reflection' });
                });

                return result.concat(partials);
            }, []);
        },

        allInputPartials: function allInputPartials() {
            var _this2 = this;

            return this.allPartials.filter(function (partial) {
                return _this2.isInput(partial.type);
            }).map(function (p) {

                var submissions = _this2.submissionsForPartial(p.id);

                return {
                    id: p.id,
                    type: submissions.length ? _this2.typeOfSubmission(submissions[0]) : p.type,
                    submissions: submissions,
                    title: _this2.title(p),
                    isReflection: p.isReflection
                };
            });
        },

        regularInputPartials: function regularInputPartials() {
            return this.allInputPartials.filter(function (p) {
                return !p.isReflection;
            });
        },

        // all input partials reflecting on work other student
        reflectingInputPartials: function reflectingInputPartials() {
            return this.allInputPartials.filter(function (p) {
                return p.isReflection;
            });
        },

        // all partials that show other student work
        reflectionPartials: function reflectionPartials() {
            return this.allPartials.filter(function (partial) {
                return partial.type === 'Reflection';
            });
        },

        feedback: function feedback() {

            if (this.progress.feedback == null || this.progress.feedback.length === 0) {
                return null;
            }

            return this.$store.state.feedback.storage[this.progress.feedback[0]];
        },

        hasFeedback: function hasFeedback() {
            if (this.feedback == null) {
                return false;
            }

            // at least one must be set
            return this.feedback.content || this.feedback.remarks.length || this.feedback.compliments.length;
        },

        shouldRetake: function shouldRetake() {
            return this.progress.isRetaking;
        },

        hasDiligence: function hasDiligence() {
            return this.progress.diligence != null && this.progress.diligence.length > 0;
        },

        hasBadge: function hasBadge() {
            return this.progress.badge != null && this.progress.badge.length > 0;
        },

        badge: function badge() {
            if (!this.hasBadge) {
                return null;
            }
            return this.$store.state.badges.storage[this.progress.badge[0]];
        },

        isTeacher: function isTeacher() {
            return (0, _auth.canTeach)(this.$store.state.users.current);
        },

        canViewStep: function canViewStep() {
            return this.isProgressFinished(this.progress);
        },

        submissions: function submissions() {
            var _this3 = this;

            return Object.keys(this.$store.state.submissions.storage).map(function (id) {
                return _this3.$store.state.submissions.storage[id];
            }).filter(function (submission) {
                return submission.progress === _this3.progress.id;
            });
        }

    },
    methods: {
        partialForReflection: function partialForReflection(reflection) {
            return this.$store.state.partials.storage[reflection.partial];
        },
        userForReflection: function userForReflection(reflection) {
            return this.users.find(function (user) {
                return user.id == reflection.user[0];
            });
        },
        isInput: function isInput(type) {
            // TODO: replace arr with this.components?
            var inputs = ['Question', 'Upload'];
            return inputs.indexOf(type) !== -1;
        },
        submissionsForPartial: function submissionsForPartial(partialId) {
            return this.submissions.filter(function (submission) {
                return submission.partial === partialId;
            });
        },
        typeOfSubmission: function typeOfSubmission(submission) {
            return submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null ? 'Upload' : 'Question';
        },
        title: function title(partial) {
            if ('title' in partial.data) {
                return partial.data.title;
            }

            return '';
        },
        checkRoute: function checkRoute() {

            if (!this.canViewStep) {
                this.autoRedirectStep(this.progress);
                return false;
            }

            return true;
        }
    },
    created: function created() {
        var _this4 = this;

        if (!this.checkRoute()) {
            return;
        }

        if (!this.isInspectingStudent && this.hasBadge) {
            setTimeout(function () {
                console.log('show', _this4.badge);
                _this4.showBadge(_this4.badge);
            }, 1000);
        }

        _resources2.default.getReflections(this.progress.id).then(function (response) {
            return (0, _helpers.transform)(response.body);
        }).then(function (result) {
            _this4.reflections = result.submissions;
            _this4.users = result.users;
        }).then(function () {
            if (_this4.isReviewing && !_this4.progress.isReviewed) {
                _this4.reviewedProgress(_this4.progress).catch(function (err) {
                    return _analytics2.default.exception('Can\'t mark progress reviewed', err);
                });
            }
        }).catch(function (err) {
            _analytics2.default.exception('Can\'t load reflection ', err);
        });
    }
};

/***/ }),

/***/ "ywaP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SidebarWorkspace = __webpack_require__("PwNb");

var _SidebarWorkspace2 = _interopRequireDefault(_SidebarWorkspace);

var _Achievement = __webpack_require__("R5Qg");

var _Achievement2 = _interopRequireDefault(_Achievement);

var _auth = __webpack_require__("JOmw");

var _getters = __webpack_require__("olIF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    name: 'WorkspaceManager',
    components: { SidebarWorkspace: _SidebarWorkspace2.default, Achievement: _Achievement2.default },

    vuex: {
        getters: {
            getGroupIdForCurrentUser: _getters.getGroupIdForCurrentUser,
            getGroup: _getters.getGroup
        },
        actions: {
            showGroupArchivedModal: function showGroupArchivedModal(_ref, user) {
                var dispatch = _ref.dispatch;

                dispatch('SHOW_MODAL', 'GroupArchived', { user: user });
            }
        }
    },

    computed: {
        viewKey: function viewKey() {

            var key = this.$route.name.split('.').slice(0, 2).join('.');

            if (this.$route.params.periodId != null) key += '-period-' + this.$route.params.periodId;
            if (this.$route.params.assignmentId != null) key += '-assignment-' + this.$route.params.assignmentId;

            return key;
        },

        currentGroup: function currentGroup() {
            var currentGroupId = this.$route.params.groupId == null ? this.getGroupIdForCurrentUser : this.$route.params.groupId;
            return this.getGroup(currentGroupId);
        },

        loggedInUser: function loggedInUser() {
            return this.$store.state.users.current;
        }

    },

    methods: {
        afterPageViewLeave: function afterPageViewLeave() {
            document.getElementById('main-view').scrollTop = 0;
        }
    },

    created: function created() {

        if ((0, _auth.canTeach)(this.loggedInUser)) {
            this.$router.replace({ name: 'root' });
            return;
        }

        if (this.currentGroup.archived) {
            this.showGroupArchivedModal(this.loggedInUser);
        }
    }

};

/***/ }),

/***/ "z1et":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("vQBA")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/JNg"),
  /* template */
  __webpack_require__("F/CF"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "zDmV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition-group', {
    staticClass: "accordion transition-wrapper",
    attrs: {
      "name": "accordion-transition",
      "tag": "div"
    },
    on: {
      "after-leave": _vm.expandingEnded
    }
  }, _vm._l((_vm.visibleCollections), function(collection) {
    return _c('collection', {
      key: collection.id,
      attrs: {
        "collection": collection,
        "isExpanded": collection.id === _vm.expandedCollection,
        "isLoading": _vm.isLoading,
        "isExpanding": _vm.isExpanding,
        "isActive": _vm.isActive(collection)
      },
      on: {
        "expand": _vm.expand,
        "collapse": _vm.collapse
      }
    }, [_vm._t("default", null, null, collection)], 2)
  }))
},staticRenderFns: []}

/***/ }),

/***/ "zGxd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__("r8sI");

var _vuex2 = _interopRequireDefault(_vuex);

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _loading = __webpack_require__("3fRB");

var _loading2 = _interopRequireDefault(_loading);

var _breadcrumbs = __webpack_require__("++Pe");

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

var _notifications = __webpack_require__("Yzb3");

var _notifications2 = _interopRequireDefault(_notifications);

var _modal = __webpack_require__("ybDi");

var _modal2 = _interopRequireDefault(_modal);

var _achievements = __webpack_require__("nDbn");

var _achievements2 = _interopRequireDefault(_achievements);

var _glossary = __webpack_require__("8mrf");

var _glossary2 = _interopRequireDefault(_glossary);

var _users = __webpack_require__("GuYm");

var _users2 = _interopRequireDefault(_users);

var _terms = __webpack_require__("PT2r");

var _terms2 = _interopRequireDefault(_terms);

var _periods = __webpack_require__("CzE/");

var _periods2 = _interopRequireDefault(_periods);

var _feedback = __webpack_require__("UCHq");

var _feedback2 = _interopRequireDefault(_feedback);

var _diligence = __webpack_require__("T7Rh");

var _diligence2 = _interopRequireDefault(_diligence);

var _badges = __webpack_require__("DT6f");

var _badges2 = _interopRequireDefault(_badges);

var _assignments = __webpack_require__("tt5A");

var _assignments2 = _interopRequireDefault(_assignments);

var _steps = __webpack_require__("kyBm");

var _steps2 = _interopRequireDefault(_steps);

var _partials = __webpack_require__("WlIq");

var _partials2 = _interopRequireDefault(_partials);

var _submissions = __webpack_require__("3IWE");

var _submissions2 = _interopRequireDefault(_submissions);

var _progress = __webpack_require__("m42C");

var _progress2 = _interopRequireDefault(_progress);

var _images = __webpack_require__("SzmP");

var _images2 = _interopRequireDefault(_images);

var _groups = __webpack_require__("Ge9X");

var _groups2 = _interopRequireDefault(_groups);

var _schools = __webpack_require__("TOWi");

var _schools2 = _interopRequireDefault(_schools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vuex data store

_vue2.default.use(_vuex2.default);

var modules = {
    loading: _loading2.default,
    breadcrumbs: _breadcrumbs2.default,
    notifications: _notifications2.default,
    modal: _modal2.default,
    achievements: _achievements2.default,
    glossary: _glossary2.default,
    users: _users2.default,
    terms: _terms2.default,
    periods: _periods2.default,
    feedback: _feedback2.default,
    diligence: _diligence2.default,
    badges: _badges2.default,
    assignments: _assignments2.default,
    steps: _steps2.default,
    partials: _partials2.default,
    submissions: _submissions2.default,
    progress: _progress2.default,
    images: _images2.default,
    groups: _groups2.default,
    schools: _schools2.default
};

exports.default = new _vuex2.default.Store({
    modules: modules,
    mutations: {
        RESET_ALL: function RESET_ALL(state) {

            for (var module in modules) {
                if ('initialState' in modules[module]) {
                    _vue2.default.set(state, module, modules[module].initialState());
                }
            }
        }
    }
});

/***/ }),

/***/ "zO49":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "timeline__hoverable"
  }, [_c('header', {
    staticClass: "timeline__header",
    on: {
      "click": _vm.goToPeriod
    }
  }, [_c('h3', {
    staticClass: "timeline__title"
  }, [_vm._v(_vm._s(_vm.period.title))]), _c('span', {
    staticClass: "timeline__meta"
  }, [_c('span', {
    staticClass: "timeline__date"
  }, [_vm._v(_vm._s(_vm.periodDates))])])])]), _c('ul', {
    staticClass: "timeline__content timeline__content--list"
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('li', {
      staticClass: "timeline__subitem",
      class: {
        'is-active': _vm.isActiveAssignment(assignment), 'is-disabled': _vm.isDisabledAssignment(assignment)
      },
      on: {
        "click": function($event) {
          _vm.goToAssignment($event, assignment)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(assignment.title))])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ "zQYW":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("hhDQ")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("rrv1"),
  /* template */
  __webpack_require__("1Dk2"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "zUcP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _BasicTemplate = __webpack_require__("T85f");

var _BasicTemplate2 = _interopRequireDefault(_BasicTemplate);

var _WorkspaceManager = __webpack_require__("I6u0");

var _WorkspaceManager2 = _interopRequireDefault(_WorkspaceManager);

var _GroupManager = __webpack_require__("YOpM");

var _GroupManager2 = _interopRequireDefault(_GroupManager);

var _Login = __webpack_require__("XZTz");

var _Login2 = _interopRequireDefault(_Login);

var _Logout = __webpack_require__("QngU");

var _Logout2 = _interopRequireDefault(_Logout);

var _Register = __webpack_require__("qrTR");

var _Register2 = _interopRequireDefault(_Register);

var _RegisterVerify = __webpack_require__("9mrJ");

var _RegisterVerify2 = _interopRequireDefault(_RegisterVerify);

var _ForgotPassword = __webpack_require__("ssCn");

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _ResetPassword = __webpack_require__("Cmgu");

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _EmailConfirm = __webpack_require__("oGel");

var _EmailConfirm2 = _interopRequireDefault(_EmailConfirm);

var _Period = __webpack_require__("8ZaV");

var _Period2 = _interopRequireDefault(_Period);

var _TermOverview = __webpack_require__("9m/f");

var _TermOverview2 = _interopRequireDefault(_TermOverview);

var _Assignment = __webpack_require__("iouj");

var _Assignment2 = _interopRequireDefault(_Assignment);

var _Step = __webpack_require__("mWFA");

var _Step2 = _interopRequireDefault(_Step);

var _StepDone = __webpack_require__("dGP0");

var _StepDone2 = _interopRequireDefault(_StepDone);

var _StepOverview = __webpack_require__("jkxs");

var _StepOverview2 = _interopRequireDefault(_StepOverview);

var _StepGroup = __webpack_require__("X0RP");

var _StepGroup2 = _interopRequireDefault(_StepGroup);

var _Groups = __webpack_require__("Sueq");

var _Groups2 = _interopRequireDefault(_Groups);

var _Students = __webpack_require__("WM40");

var _Students2 = _interopRequireDefault(_Students);

var _Lobby = __webpack_require__("O/tW");

var _Lobby2 = _interopRequireDefault(_Lobby);

var _NotFound = __webpack_require__("TPCG");

var _NotFound2 = _interopRequireDefault(_NotFound);

var _auth = __webpack_require__("JOmw");

var _actions = __webpack_require__("ELb+");

var _analytics = __webpack_require__("N0nv");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// vue router

_vue2.default.use(_vueRouter2.default);

function prefix(route) {
    if (route != null && route.params.groupId != null) {
        return route.params.studentId != null ? 'students' : 'group';
    }
    return 'student';
}

function autoRedirect(name) {
    return function (to) {
        var current = router.history.current;
        var next = { name: prefix(current) + '.' + name, params: to.params, query: to.query };
        return router.match(next, current);
    };
}

var routes = [{
    path: '/',
    name: 'root',
    meta: {
        auth: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
        var user = router.app.$store.state.users.current;
        if ((0, _auth.canTeach)(user)) {
            return next({ name: 'groups' });
        }

        if (user.groups != null && user.groups.length > 0) {
            return next({ name: 'student.period' });
        }

        return next({ name: 'lobby' });
    }
}, {
    path: '/login',
    name: 'login',
    component: _Login2.default
}, {
    path: '/logout',
    name: 'logout',
    component: _Logout2.default
}, {
    path: '/register',
    name: 'register',
    component: _Register2.default
}, {
    path: '/register/verify/:token(.*)',
    name: 'register.verify',
    component: _RegisterVerify2.default
}, {
    path: '/password/forgot',
    name: 'forgot',
    component: _ForgotPassword2.default
}, {
    path: '/password/reset/:resetToken',
    name: 'reset',
    component: _ResetPassword2.default
}, {
    path: '/email/confirm/:token',
    name: 'email.confirm',
    component: _EmailConfirm2.default
},

// automatic redirects based on current state
{
    path: '/r',
    children: [{
        path: 'period/:periodId(\\d+)?',
        name: 'period',
        redirect: autoRedirect('period')
    }, {
        path: 'assignment/:assignmentId(\\d+)',
        name: 'assignment',
        redirect: autoRedirect('assignment'),
        children: [{
            path: 'done',
            name: 'assignment.done',
            redirect: autoRedirect('assignment.done')
        }, {
            path: 'overview',
            name: 'assignment.overview',
            redirect: autoRedirect('assignment.overview')
        }, {
            path: 'group',
            name: 'assignment.group',
            redirect: autoRedirect('assignment.group')
        }, {
            path: ':stepIdx',
            name: 'assignment.step',
            redirect: autoRedirect('assignment.step')
        }]
    }]

}, {
    // Students
    path: '/workspace',
    component: _WorkspaceManager2.default,
    redirect: { name: 'root' },
    meta: {
        auth: true
    },

    beforeEnter: function beforeEnter(to, from, next) {
        var user = router.app.$store.state.users.current;
        return (0, _auth.canTeach)(user) || user.groups == null || user.groups.length === 0 ? next({ name: 'root' }) : next();
    },

    children: [{
        path: '/overview',
        name: 'student.overview',
        component: _TermOverview2.default,
        meta: {
            breadcrumb: 'Overzicht'
        }
    }, {
        path: '/period/:periodId(\\d+)?',
        name: 'student.period',
        component: _Period2.default,
        meta: {
            breadcrumb: 'Opdrachten'
        }
    }, {
        path: '/assignment/:assignmentId(\\d+)',
        name: 'student.assignment',
        component: _Assignment2.default,
        props: true,
        children: [{
            path: 'done',
            name: 'student.assignment.done',
            component: _StepDone2.default
        }, {
            path: 'overview',
            name: 'student.assignment.overview',
            component: _StepOverview2.default
        }, {
            path: 'group',
            name: 'student.assignment.group',
            component: _StepGroup2.default
        }, {
            path: ':stepIdx',
            name: 'student.assignment.step',
            component: _Step2.default
        }]
    }]
}, {
    // Teachers
    path: '/group/:groupId(\\d+)',
    component: _GroupManager2.default,
    redirect: { name: 'root' },
    meta: {
        auth: true
    },
    children: [{
        path: 'overview',
        name: 'group.overview',
        component: _TermOverview2.default,
        meta: {
            breadcrumb: 'Overzicht'
        }
    }, {
        path: ':groupTermId(\\d+)?',
        name: 'students.overview',
        props: true,
        component: _Students2.default,
        meta: {
            breadcrumb: 'Voortgang'
        }
    }, {
        path: 'period/:periodId(\\d+)',
        name: 'group.period',
        component: _Period2.default,
        meta: {
            breadcrumb: 'Blok'
        }
    }, {
        path: 'period/:periodId(\\d+)/assignment/:assignmentId(\\d+)',
        name: 'group.assignment',
        component: _Assignment2.default,
        props: true,
        children: [{
            path: 'done',
            name: 'group.assignment.done',
            component: _StepGroup2.default
        }, {
            path: 'overview',
            name: 'group.assignment.overview',
            redirect: { name: 'group.assignment.done' }
        }, {
            path: 'group',
            name: 'group.assignment.group',
            redirect: { name: 'group.assignment.done' }
        }, {
            path: ':stepIdx',
            name: 'group.assignment.step',
            component: _Step2.default
        }]

    }, {
        path: 'student/:studentId(\\d+)/period/:periodId(\\d+)?',
        name: 'students.period',
        component: _Period2.default,
        meta: {
            breadcrumb: 'Opdrachten leerling'
        }
    }, {
        path: 'student/:studentId(\\d+)/assignment/:assignmentId(\\d+)',
        name: 'students.assignment',
        component: _Assignment2.default,
        props: true,
        children: [{
            path: 'done',
            name: 'students.assignment.done',
            redirect: { name: 'students.assignment.overview' }
        }, {
            path: 'overview',
            name: 'students.assignment.overview',
            component: _StepOverview2.default
        }, {
            path: 'group',
            name: 'students.assignment.group',
            component: _StepGroup2.default
        }, {
            path: ':stepIdx',
            name: 'students.assignment.step',
            component: _Step2.default
        }]
    }]

}, {
    path: '/basictemplate',
    component: _BasicTemplate2.default,
    name: 'template',
    redirect: { name: 'root' },
    meta: {
        auth: true
    },
    children: [{
        path: '/groups',
        name: 'groups',
        component: _Groups2.default
    }]

}, {
    path: '/lobby',
    name: 'lobby',
    component: _Lobby2.default,
    meta: {
        auth: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
        var user = router.app.$store.state.users.current;
        return (0, _auth.canTeach)(user) || user.groups != null && user.groups.length > 0 ? next({ name: 'root' }) : next();
    }
}, {
    path: '*',
    name: 'not-found',
    component: _NotFound2.default,
    beforeEnter: function beforeEnter(to, from, next) {
        _analytics2.default.event('router', '404', to.path + '[' + from.path + ']');
        next();
    }
}];

var router = new _vueRouter2.default({
    base: '/app',
    mode: 'history',
    routes: routes,
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

/**
 * Breadcrumbs return
 */
router.beforeEach(function (to, from, next) {
    if (to.meta && to.meta.breadcrumb != null) {
        router.app.$store.dispatch('SET_BREADCRUMB', { route: to.fullPath, name: to.meta.breadcrumb });
    }
    next();
});

/**
 * Analytics tracking
 */
router.beforeEach(function (to, from, next) {
    console.log('>>> navigate', to);
    _analytics2.default.pageview(to.path);
    next();
});

/**
 * Authentication check
 * User must be authenticated before he can access
 * routes that have auth activated
 */
router.beforeEach(function (to, from, next) {

    if (to.matched.some(function (record) {
        return record.meta.auth;
    })) {

        // called when we need to actually fetch the user, this triggers loading indicator in Main.vue
        var beforeFetchHook = function beforeFetchHook() {
            return router.app.$store.dispatch('LOADING_USER');
        };

        (0, _auth.checkAuthentication)().then(function (id) {
            _analytics2.default.user(id);return id;
        }).then(function (id) {
            return (0, _actions.fetchUser)({ dispatch: router.app.$store.dispatch, state: router.app.$store.state }, id, true, beforeFetchHook);
        }).then(function (user) {
            return (0, _auth.checkAuthorization)(to, user);
        }).then(function (authorized) {

            if (!authorized) {
                console.error('Unauthorized');
                return from ? next(false) : next({ name: 'root', replace: true });
            }

            next();
        }, function (error) {
            console.error('Authentication error', error);
            next({ name: 'logout', replace: true, params: { _internal: true } });
        });
    } else {
        next();
    }
});

router.afterEach(function (to, from) {
    if (router.app.$store.state.loading.user) {
        // called in afterEach to make sure the router view is actually changed
        // otherwise the previous router view could be rendered again, before switching to new view
        router.app.$store.dispatch('FINISHED_LOADING_USER');
    }
});

exports.default = router;

/***/ }),

/***/ "zVE9":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "progress-bar",
    class: {
      mini: _vm.mini
    }
  }, [_vm._l((_vm.progressSteps), function(step) {
    return _c('li', [_c('router-link', {
      class: [step.type, {
        'completed': step.isCompleted,
        'active': step.isActive
      }],
      attrs: {
        "to": step.link
      }
    }, [_c('span', [_vm._v(_vm._s(step.precedence))])])], 1)
  }), _c('li', [_c('router-link', {
    staticClass: "done",
    class: {
      'active': _vm.isDoneStepActive
    },
    attrs: {
      "to": _vm.doneLink
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ "zXGb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Glossary = __webpack_require__("vMzw");

var _Glossary2 = _interopRequireDefault(_Glossary);

var _Goals = __webpack_require__("dGh2");

var _Goals2 = _interopRequireDefault(_Goals);

var _Image = __webpack_require__("EP3o");

var _Image2 = _interopRequireDefault(_Image);

var _Teachertips = __webpack_require__("o9Mb");

var _Teachertips2 = _interopRequireDefault(_Teachertips);

var _Reflectiontips = __webpack_require__("ozB2");

var _Reflectiontips2 = _interopRequireDefault(_Reflectiontips);

var _Term = __webpack_require__("HBXz");

var _Term2 = _interopRequireDefault(_Term);

var _School = __webpack_require__("Z9Px");

var _School2 = _interopRequireDefault(_School);

var _Settings = __webpack_require__("crAn");

var _Settings2 = _interopRequireDefault(_Settings);

var _Settings3 = __webpack_require__("mJuH");

var _Settings4 = _interopRequireDefault(_Settings3);

var _Archived = __webpack_require__("NtfJ");

var _Archived2 = _interopRequireDefault(_Archived);

var _ReflectionPartial = __webpack_require__("gyY9");

var _ReflectionPartial2 = _interopRequireDefault(_ReflectionPartial);

var _Legal = __webpack_require__("6rWd");

var _Legal2 = _interopRequireDefault(_Legal);

var _ImageUpload = __webpack_require__("Mz4J");

var _ImageUpload2 = _interopRequireDefault(_ImageUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },

    components: { Glossary: _Glossary2.default, Goals: _Goals2.default, Term: _Term2.default, ImageContainer: _Image2.default, Teachertips: _Teachertips2.default, Reflectiontips: _Reflectiontips2.default, ReflectionPartial: _ReflectionPartial2.default, SchoolGroups: _School2.default, Settings: _Settings2.default, GroupSettings: _Settings4.default, GroupArchived: _Archived2.default, ImageUpload: _ImageUpload2.default, Legal: _Legal2.default },

    vuex: {
        getters: {
            component: function component(state) {
                return state.modal.component;
            },
            isDirty: function isDirty(state) {
                return state.modal.isDirty;
            },
            data: function data(state) {
                return state.modal.data || {};
            }
        },
        actions: {
            closeModal: function closeModal(_ref) {
                var dispatch = _ref.dispatch;

                dispatch('HIDE_MODAL');
                dispatch('MODAL_CLEAN');
            }
        }
    },

    methods: {
        close: function close() {
            var _this = this;

            var continueClosing = function continueClosing() {
                _this.closeModal();
                _this.$emit('close');
            };

            if (!this.isDirty) {
                return continueClosing();
            }

            if (!this.$refs.content.confirmDirty) {
                console.error('Modal content can\'t confirm dirty');
                return continueClosing();
            }

            this.$refs.content.confirmDirty().then(function () {
                return continueClosing();
            }, function () {});
        }
    },

    computed: {
        isVisible: function isVisible() {
            return this.show && (!!this.component || this.$slots.default);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "zm7V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _resources = __webpack_require__("cn/v");

var _resources2 = _interopRequireDefault(_resources);

var _notificationsMixin = __webpack_require__("2WB3");

var _notificationsMixin2 = _interopRequireDefault(_notificationsMixin);

var _validationMixin = __webpack_require__("c+iA");

var _validationMixin2 = _interopRequireDefault(_validationMixin);

var _helpers = __webpack_require__("x3kM");

var _PrimaryButton = __webpack_require__("8gYt");

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SettingsUser',
    mixins: [_notificationsMixin2.default, _validationMixin2.default],
    components: { PrimaryButton: _PrimaryButton2.default },
    props: {
        user: {}
    },
    data: function data() {
        return {
            password: null,
            new_email: null,
            loading: false,
            errors: [],
            errorFields: []
        };
    },
    vuex: {
        getters: {
            isDemo: function isDemo(state) {
                return state.users.current.role === 'demo';
            }
        },
        actions: {
            storeUser: function storeUser(_ref, user) {
                var dispatch = _ref.dispatch;
                return dispatch('SET_CURRENT_USER', user);
            }
        }
    },
    computed: {

        email: {
            get: function get() {
                return this.new_email == null ? this.user.email : this.new_email;
            },
            set: function set(value) {
                this.new_email = value;
            }
        }

    },
    methods: {
        submit: function submit(e) {
            var _this = this;

            e.preventDefault();

            if (this.validate()) {

                if (this.isDemo) {
                    this.$demoSuccessNotification();
                    this.reset();
                    return;
                }

                if (this.email.trim() === this.user.email) {
                    this.$success('E-mailadres blijft ' + this.email, { id: 'validation' });
                    this.reset();
                    return;
                }

                this.loading = true;

                _resources2.default.editUserEmail(this.user.id, this.email, this.password).then(function (response) {
                    return (0, _helpers.transform)(response.body);
                }).then(function (result) {
                    return _this.storeUser(result.users[0]);
                }).then(function () {
                    _this.$success('Je e-mailadres is aangepast. Er is een mail verstuurd naar ' + _this.email + ' met instructies om je nieuwe adres te bevestigen.', { id: 'validation' });
                }).catch(function (response) {
                    if (response.status === 403) {
                        _this.addError('password', 'Je huidige wachtwoord klopt niet.');
                        _this.showErrors();
                    } else {
                        _this.handleErrorResponse(response, 'Gegevens aanpassen is mislukt.');
                    }
                }).then(function () {
                    _this.loading = false;
                    _this.reset();
                });
            }
        },
        reset: function reset() {
            this.password = '';
        },
        validateFields: function validateFields() {
            this.validatePasswordLength(this.password);
            this.validateEmail(this.email);
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "zu0v":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    staticClass: "page-view--assignment"
  }, [_c('header', {
    staticClass: "page-header assignment-header"
  }, [_c('router-link', {
    staticClass: "back tag button-timid left button-backward",
    attrs: {
      "to": _vm.returnLink.route
    }
  }, [_vm._v(_vm._s(_vm.returnLink.name))]), _c('a', {
    staticClass: "assignment-goals tag button-timid right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGoals(_vm.assignment)
      }
    }
  }, [_vm._v("Doelstellingen")]), _c('h1', [_c('span', {
    staticClass: "assignment-icon",
    class: _vm.type_class
  }), _vm._v(" " + _vm._s(_vm.assignment.title))]), _c('progress-bar', {
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "current-step": _vm.currentStepIdx
    }
  }), _c('hr')], 1), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "after-enter": _vm.viewChange
    }
  }, [_c('router-view', {
    key: _vm.$route.params.stepIdx,
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "group": _vm.group,
      "isInspectingStudent": _vm.isInspectingStudent,
      "isInspecting": _vm.isInspecting,
      "isReviewing": _vm.isReviewing,
      "user": _vm.user,
      "returnLink": _vm.returnLink
    }
  })], 1), (_vm.isReviewing) ? _c('teacher-feedback', {
    attrs: {
      "assignment": _vm.assignment,
      "progress": _vm.progress,
      "group": _vm.group,
      "isDemo": _vm.isDemo,
      "reviewee": _vm.user,
      "returnLink": _vm.returnLink
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

},["sV/x"]);


// WEBPACK FOOTER //
// app-fffa7313.js